//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IActivityLogClient {
    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, start: Date | undefined, end: Date | undefined, company: string | null | undefined, userName: string | null | undefined, requestBody: string | null | undefined): Observable<ActivityLogVm>;
    create(command: CreateActivityLogsCommand): Observable<boolean>;
    getAllInTable(command: GetAllActivityLogs): Observable<ActivityLogVm>;
}

@Injectable({
    providedIn: 'root'
})
export class ActivityLogClient implements IActivityLogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, start: Date | undefined, end: Date | undefined, company: string | null | undefined, userName: string | null | undefined, requestBody: string | null | undefined): Observable<ActivityLogVm> {
        let url_ = this.baseUrl + "/system/ActivityLog?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAsc === null)
            throw new Error("The parameter 'sortAsc' cannot be null.");
        else if (sortAsc !== undefined)
            url_ += "sortAsc=" + encodeURIComponent("" + sortAsc) + "&";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (company !== undefined && company !== null)
            url_ += "company=" + encodeURIComponent("" + company) + "&";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (requestBody !== undefined && requestBody !== null)
            url_ += "requestBody=" + encodeURIComponent("" + requestBody) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityLogVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityLogVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ActivityLogVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityLogVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateActivityLogsCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/ActivityLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllInTable(command: GetAllActivityLogs): Observable<ActivityLogVm> {
        let url_ = this.baseUrl + "/system/ActivityLog/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityLogVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityLogVm>;
        }));
    }

    protected processGetAllInTable(response: HttpResponseBase): Observable<ActivityLogVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityLogVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAgentClient {
    getAll(command: GetAgentsListQuery): Observable<AgentsListVm>;
    get(id: number): Observable<AgentDetailVm>;
    update(id: number, command: UpdateAgentCommand): Observable<boolean>;
    delete(id: number): Observable<boolean>;
    getByExtension(extension: string | null): Observable<AgentDetailVm>;
    getSipAccount(): Observable<SipAgentDto>;
    create(command: CreateAgentCommand): Observable<CreateAgentModel>;
    disable(command: DisableAgentCommand): Observable<boolean>;
    createSip(command: CreateSipAccountCommand): Observable<boolean>;
    changeStatus(command: ChangeStatusCommand): Observable<boolean>;
    changeFollowMe(command: ChangeFollowMeCommand): Observable<boolean>;
    checkExistUserName(command: CheckUserNameExistQuery): Observable<boolean>;
    checkExistExtension(command: CheckExtensionExistQuery): Observable<boolean>;
    checkExistEmail(command: CheckEmailExistQuery): Observable<boolean>;
    checkExistNumber(command: CheckNumberExistQuery): Observable<boolean>;
    getCompanyId(): Observable<number>;
    getSummary(): Observable<AgentSummaryVm>;
    getAgentInfo(): Observable<AgentInfoVm>;
    pauseAgentInQueue(command: PauseAgentCommand): Observable<boolean>;
    getAgentInQueueDetailQuery(id: number): Observable<AgentInQueueSummary>;
}

@Injectable({
    providedIn: 'root'
})
export class AgentClient implements IAgentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(command: GetAgentsListQuery): Observable<AgentsListVm> {
        let url_ = this.baseUrl + "/system/Agent/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentsListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentsListVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AgentsListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentsListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: number): Observable<AgentDetailVm> {
        let url_ = this.baseUrl + "/system/Agent/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentDetailVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentDetailVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AgentDetailVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentDetailVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: number, command: UpdateAgentCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Agent/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Agent/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByExtension(extension: string | null): Observable<AgentDetailVm> {
        let url_ = this.baseUrl + "/system/Agent/extension={extension}";
        if (extension === undefined || extension === null)
            throw new Error("The parameter 'extension' must be defined.");
        url_ = url_.replace("{extension}", encodeURIComponent("" + extension));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByExtension(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByExtension(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentDetailVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentDetailVm>;
        }));
    }

    protected processGetByExtension(response: HttpResponseBase): Observable<AgentDetailVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentDetailVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSipAccount(): Observable<SipAgentDto> {
        let url_ = this.baseUrl + "/system/Agent/getsip";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSipAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSipAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SipAgentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SipAgentDto>;
        }));
    }

    protected processGetSipAccount(response: HttpResponseBase): Observable<SipAgentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SipAgentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateAgentCommand): Observable<CreateAgentModel> {
        let url_ = this.baseUrl + "/system/Agent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateAgentModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateAgentModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateAgentModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAgentModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    disable(command: DisableAgentCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Agent/disable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDisable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSip(command: CreateSipAccountCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Agent/createsip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateSip(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeStatus(command: ChangeStatusCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Agent/changestatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangeStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeFollowMe(command: ChangeFollowMeCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Agent/changefollowme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeFollowMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeFollowMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangeFollowMe(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkExistUserName(command: CheckUserNameExistQuery): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Agent/existusername";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExistUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExistUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckExistUserName(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkExistExtension(command: CheckExtensionExistQuery): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Agent/existextension";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExistExtension(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExistExtension(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckExistExtension(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkExistEmail(command: CheckEmailExistQuery): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Agent/existemail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExistEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExistEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckExistEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkExistNumber(command: CheckNumberExistQuery): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Agent/existphonenumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExistNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExistNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckExistNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCompanyId(): Observable<number> {
        let url_ = this.baseUrl + "/system/Agent/incompany";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCompanyId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSummary(): Observable<AgentSummaryVm> {
        let url_ = this.baseUrl + "/system/Agent/summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentSummaryVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentSummaryVm>;
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<AgentSummaryVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentSummaryVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAgentInfo(): Observable<AgentInfoVm> {
        let url_ = this.baseUrl + "/system/Agent/getagentinfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentInfoVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentInfoVm>;
        }));
    }

    protected processGetAgentInfo(response: HttpResponseBase): Observable<AgentInfoVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentInfoVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pauseAgentInQueue(command: PauseAgentCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Agent/agentpause";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPauseAgentInQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPauseAgentInQueue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPauseAgentInQueue(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAgentInQueueDetailQuery(id: number): Observable<AgentInQueueSummary> {
        let url_ = this.baseUrl + "/system/Agent/detail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentInQueueDetailQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentInQueueDetailQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentInQueueSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentInQueueSummary>;
        }));
    }

    protected processGetAgentInQueueDetailQuery(response: HttpResponseBase): Observable<AgentInQueueSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentInQueueSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAudioClient {
    get(): Observable<AudiosListVm>;
    create(command: CreateAudioCommand): Observable<number>;
    getLanguage(service: ServiceTTS | undefined): Observable<GetLanguageVm>;
    getLanguageGoogle(): Observable<string>;
    getAllLanguage(): Observable<GetLanguageVm>;
    getAllVoice(query: LanguageAllService): Observable<ListAllVoiceDto>;
    getVoiceByLanguage(service: ServiceTTS | undefined, language: string | null): Observable<GetVoiceVm>;
    convert(command: ConvertAudioCommand): Observable<string>;
    delete(id: number): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class AudioClient implements IAudioClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Observable<AudiosListVm> {
        let url_ = this.baseUrl + "/system/Audio";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AudiosListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AudiosListVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AudiosListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AudiosListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateAudioCommand): Observable<number> {
        let url_ = this.baseUrl + "/system/Audio";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLanguage(service: ServiceTTS | undefined): Observable<GetLanguageVm> {
        let url_ = this.baseUrl + "/system/Audio/language?";
        if (service === null)
            throw new Error("The parameter 'service' cannot be null.");
        else if (service !== undefined)
            url_ += "service=" + encodeURIComponent("" + service) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguageVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguageVm>;
        }));
    }

    protected processGetLanguage(response: HttpResponseBase): Observable<GetLanguageVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguageVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLanguageGoogle(): Observable<string> {
        let url_ = this.baseUrl + "/system/Audio/language/google";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageGoogle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageGoogle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLanguageGoogle(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllLanguage(): Observable<GetLanguageVm> {
        let url_ = this.baseUrl + "/system/Audio/alllanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguageVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguageVm>;
        }));
    }

    protected processGetAllLanguage(response: HttpResponseBase): Observable<GetLanguageVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguageVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllVoice(query: LanguageAllService): Observable<ListAllVoiceDto> {
        let url_ = this.baseUrl + "/system/Audio/allvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllVoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllVoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListAllVoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListAllVoiceDto>;
        }));
    }

    protected processGetAllVoice(response: HttpResponseBase): Observable<ListAllVoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListAllVoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVoiceByLanguage(service: ServiceTTS | undefined, language: string | null): Observable<GetVoiceVm> {
        let url_ = this.baseUrl + "/system/Audio/getvoice/{language}?";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        if (service === null)
            throw new Error("The parameter 'service' cannot be null.");
        else if (service !== undefined)
            url_ += "service=" + encodeURIComponent("" + service) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoiceByLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoiceByLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetVoiceVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetVoiceVm>;
        }));
    }

    protected processGetVoiceByLanguage(response: HttpResponseBase): Observable<GetVoiceVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetVoiceVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    convert(command: ConvertAudioCommand): Observable<string> {
        let url_ = this.baseUrl + "/system/Audio/convert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConvert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processConvert(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Audio/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAudioLanguageClient {
    getCountry(): Observable<string>;
    create(command: CreateAudioLanguageCommand): Observable<number>;
    update(command: UpdateAudioLanguageCommand): Observable<number>;
    getAudioLanguage(): Observable<AudioLanguageListVm>;
}

@Injectable({
    providedIn: 'root'
})
export class AudioLanguageClient implements IAudioLanguageClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCountry(): Observable<string> {
        let url_ = this.baseUrl + "/system/AudioLanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCountry(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateAudioLanguageCommand): Observable<number> {
        let url_ = this.baseUrl + "/system/AudioLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(command: UpdateAudioLanguageCommand): Observable<number> {
        let url_ = this.baseUrl + "/system/AudioLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAudioLanguage(): Observable<AudioLanguageListVm> {
        let url_ = this.baseUrl + "/system/AudioLanguage/audio";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAudioLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAudioLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AudioLanguageListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AudioLanguageListVm>;
        }));
    }

    protected processGetAudioLanguage(response: HttpResponseBase): Observable<AudioLanguageListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AudioLanguageListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAuthClient {
    login(model: AuthenticateModel): Observable<FileResponse>;
    register(model: AuthenticateModel): Observable<FileResponse>;
    requestPassword(email: string): Observable<FileResponse>;
    forgotPassword(email: string): Observable<FileResponse>;
    resetPassword(token: string | null | undefined, password: string | null | undefined): Observable<FileResponse>;
    loginWithSocialAccount(token: string | null | undefined, provider: string | null | undefined): Observable<string>;
    impersonate(userName: string): Observable<string>;
    refreshToken(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class AuthClient implements IAuthClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    login(model: AuthenticateModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/system/Auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    register(model: AuthenticateModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/system/Auth/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestPassword(email: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/system/Auth/request-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(email);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRequestPassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    forgotPassword(email: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/system/Auth/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(email);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPassword(token: string | null | undefined, password: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/system/Auth/reset-password?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    loginWithSocialAccount(token: string | null | undefined, provider: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/system/Auth/loginwithsocial?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (provider !== undefined && provider !== null)
            url_ += "provider=" + encodeURIComponent("" + provider) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginWithSocialAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginWithSocialAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processLoginWithSocialAccount(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    impersonate(userName: string): Observable<string> {
        let url_ = this.baseUrl + "/system/Auth/impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userName);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImpersonate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshToken(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/system/Auth/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBillingClient {
    getAllCost(): Observable<CostsListVm>;
    updateCurrentCost(command: UpdateCurrentCostCommand): Observable<boolean>;
    getCurrentCost(companyId: number): Observable<CurrentCostVm>;
    getAllInvoice(): Observable<InvoiceListVm>;
    getDetailInvoice(id: number): Observable<InvoiceDetail>;
    getCurrentInvoice(): Observable<InvoiceDetail>;
}

@Injectable({
    providedIn: 'root'
})
export class BillingClient implements IBillingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllCost(): Observable<CostsListVm> {
        let url_ = this.baseUrl + "/system/Billing/cost";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostsListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostsListVm>;
        }));
    }

    protected processGetAllCost(response: HttpResponseBase): Observable<CostsListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostsListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCurrentCost(command: UpdateCurrentCostCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Billing/cost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentCost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentCost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateCurrentCost(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentCost(companyId: number): Observable<CurrentCostVm> {
        let url_ = this.baseUrl + "/system/Billing/currentcost/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentCost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentCost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentCostVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentCostVm>;
        }));
    }

    protected processGetCurrentCost(response: HttpResponseBase): Observable<CurrentCostVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentCostVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllInvoice(): Observable<InvoiceListVm> {
        let url_ = this.baseUrl + "/system/Billing/invoice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceListVm>;
        }));
    }

    protected processGetAllInvoice(response: HttpResponseBase): Observable<InvoiceListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDetailInvoice(id: number): Observable<InvoiceDetail> {
        let url_ = this.baseUrl + "/system/Billing/invoice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDetail>;
        }));
    }

    protected processGetDetailInvoice(response: HttpResponseBase): Observable<InvoiceDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentInvoice(): Observable<InvoiceDetail> {
        let url_ = this.baseUrl + "/system/Billing/currentinvoice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDetail>;
        }));
    }

    protected processGetCurrentInvoice(response: HttpResponseBase): Observable<InvoiceDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICallDataClient {
    getAll(getAllCallDataQuery: GetAllCallDataQuery): Observable<CallDataList>;
    export(command: ExportCallDataCommand): Observable<boolean>;
    create(command: CreateCallDataCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class CallDataClient implements ICallDataClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(getAllCallDataQuery: GetAllCallDataQuery): Observable<CallDataList> {
        let url_ = this.baseUrl + "/system/CallData/calldatafilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getAllCallDataQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallDataList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallDataList>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CallDataList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallDataList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    export(command: ExportCallDataCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CallData/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateCallDataCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CallData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICallerResponseTrainClient {
    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, gmType: string | null | undefined, gmName: string | null | undefined, searchText: string | null | undefined): Observable<CallerResponseTrainListVm>;
    create(command: CreateCallerResponseTrainCommand): Observable<boolean>;
    getAllInTable(command: GetAllCallerResponseTrainQuery): Observable<CallerResponseTrainListVm>;
    export(request: ExportCallerResponseTrain): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CallerResponseTrainClient implements ICallerResponseTrainClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, gmType: string | null | undefined, gmName: string | null | undefined, searchText: string | null | undefined): Observable<CallerResponseTrainListVm> {
        let url_ = this.baseUrl + "/system/CallerResponseTrain?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAsc === null)
            throw new Error("The parameter 'sortAsc' cannot be null.");
        else if (sortAsc !== undefined)
            url_ += "sortAsc=" + encodeURIComponent("" + sortAsc) + "&";
        if (gmType !== undefined && gmType !== null)
            url_ += "gmType=" + encodeURIComponent("" + gmType) + "&";
        if (gmName !== undefined && gmName !== null)
            url_ += "gmName=" + encodeURIComponent("" + gmName) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallerResponseTrainListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallerResponseTrainListVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CallerResponseTrainListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallerResponseTrainListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateCallerResponseTrainCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CallerResponseTrain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllInTable(command: GetAllCallerResponseTrainQuery): Observable<CallerResponseTrainListVm> {
        let url_ = this.baseUrl + "/system/CallerResponseTrain/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallerResponseTrainListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallerResponseTrainListVm>;
        }));
    }

    protected processGetAllInTable(response: HttpResponseBase): Observable<CallerResponseTrainListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallerResponseTrainListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    export(request: ExportCallerResponseTrain): Observable<string> {
        let url_ = this.baseUrl + "/system/CallerResponseTrain/exportcallerresponsetrain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICallFlowClient {
    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, tags: string | null | undefined, searchText: string | null | undefined): Observable<CallFlowsListVm>;
    create(request: CreateCallFlowCommand): Observable<CallFlowDto>;
    update(request: UpdateCallFlowCommand): Observable<boolean>;
    getAllInTable(request: GetCallFlowsListQuery): Observable<CallFlowsListVm>;
    getAllAction(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined): Observable<CallFlowsListVm>;
    get(id: number | undefined): Observable<CallFlowDto>;
    getFlowByPhone(phone: string | null | undefined, bot: string | null | undefined): Observable<CallFlowDto>;
    getAllCategory(): Observable<CategoryListVm>;
    updateCategory(request: UpdateCategoryCommand): Observable<boolean>;
    duplicate(request: DuplicateCallFlowCommand): Observable<CallFlowDto>;
    run(request: MakeTestCallCommand): Observable<TestCallResult>;
    exportPrompt(id: number | undefined, tag: string | null | undefined): Observable<string>;
    export(request: ExportCallFlowCommand): Observable<string>;
    import(request: ImportCallFlowCommand): Observable<CallFlowImportReponseData>;
    checkFileImport(request: CheckFileImportCallFlowCommand): Observable<PathDto[]>;
    outReach(id: number, request: OutreachFlowCommand): Observable<FileResponse>;
    hangup(command: HangupFlowCommand): Observable<boolean>;
    delete(id: number): Observable<boolean>;
    disable(request: DisableCallFlowCommand): Observable<CallFlowDto>;
    setAgentFlow(request: SetAgentFlowCommand): Observable<boolean>;
    unsetAgentFlow(request: UnsetAgentFlowCommand): Observable<boolean>;
    getSubFlow(): Observable<CallFlowsListVm>;
    contactFlowUsing(id: number): Observable<CompanyNumberListVm>;
    checkUserIsDesigning(id: number | undefined): Observable<string>;
    outCallFlow(id: number | undefined): Observable<boolean>;
    checkExistCallFlowName(command: CheckCallFlowNameCommand): Observable<boolean>;
    requestModificationFlow(command: RequestModificationFlowCommand): Observable<boolean>;
    testRequest(command: TestRequestCommand): Observable<TestRequestResult>;
    uploadImage(command: UploadImageCommand): Observable<string>;
    renameFlow(command: RenameCallFlowCommand): Observable<boolean>;
    differentFlow(id: number | undefined): Observable<DifferentCallFlowList>;
}

@Injectable({
    providedIn: 'root'
})
export class CallFlowClient implements ICallFlowClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, tags: string | null | undefined, searchText: string | null | undefined): Observable<CallFlowsListVm> {
        let url_ = this.baseUrl + "/system/CallFlow?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAsc === null)
            throw new Error("The parameter 'sortAsc' cannot be null.");
        else if (sortAsc !== undefined)
            url_ += "sortAsc=" + encodeURIComponent("" + sortAsc) + "&";
        if (tags !== undefined && tags !== null)
            url_ += "tags=" + encodeURIComponent("" + tags) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallFlowsListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallFlowsListVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CallFlowsListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallFlowsListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(request: CreateCallFlowCommand): Observable<CallFlowDto> {
        let url_ = this.baseUrl + "/system/CallFlow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallFlowDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallFlowDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CallFlowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallFlowDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(request: UpdateCallFlowCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CallFlow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllInTable(request: GetCallFlowsListQuery): Observable<CallFlowsListVm> {
        let url_ = this.baseUrl + "/system/CallFlow/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallFlowsListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallFlowsListVm>;
        }));
    }

    protected processGetAllInTable(response: HttpResponseBase): Observable<CallFlowsListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallFlowsListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllAction(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined): Observable<CallFlowsListVm> {
        let url_ = this.baseUrl + "/system/CallFlow/action?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAsc === null)
            throw new Error("The parameter 'sortAsc' cannot be null.");
        else if (sortAsc !== undefined)
            url_ += "sortAsc=" + encodeURIComponent("" + sortAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallFlowsListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallFlowsListVm>;
        }));
    }

    protected processGetAllAction(response: HttpResponseBase): Observable<CallFlowsListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallFlowsListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: number | undefined): Observable<CallFlowDto> {
        let url_ = this.baseUrl + "/system/CallFlow/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallFlowDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallFlowDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CallFlowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallFlowDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFlowByPhone(phone: string | null | undefined, bot: string | null | undefined): Observable<CallFlowDto> {
        let url_ = this.baseUrl + "/system/CallFlow/getflow?";
        if (phone !== undefined && phone !== null)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        if (bot !== undefined && bot !== null)
            url_ += "bot=" + encodeURIComponent("" + bot) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlowByPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlowByPhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallFlowDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallFlowDto>;
        }));
    }

    protected processGetFlowByPhone(response: HttpResponseBase): Observable<CallFlowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallFlowDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllCategory(): Observable<CategoryListVm> {
        let url_ = this.baseUrl + "/system/CallFlow/category";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryListVm>;
        }));
    }

    protected processGetAllCategory(response: HttpResponseBase): Observable<CategoryListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCategory(request: UpdateCategoryCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CallFlow/category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateCategory(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    duplicate(request: DuplicateCallFlowCommand): Observable<CallFlowDto> {
        let url_ = this.baseUrl + "/system/CallFlow/duplicate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallFlowDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallFlowDto>;
        }));
    }

    protected processDuplicate(response: HttpResponseBase): Observable<CallFlowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallFlowDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    run(request: MakeTestCallCommand): Observable<TestCallResult> {
        let url_ = this.baseUrl + "/system/CallFlow/run";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TestCallResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TestCallResult>;
        }));
    }

    protected processRun(response: HttpResponseBase): Observable<TestCallResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TestCallResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPrompt(id: number | undefined, tag: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/system/CallFlow/export-prompt?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (tag !== undefined && tag !== null)
            url_ += "tag=" + encodeURIComponent("" + tag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPrompt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPrompt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportPrompt(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    export(request: ExportCallFlowCommand): Observable<string> {
        let url_ = this.baseUrl + "/system/CallFlow/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    import(request: ImportCallFlowCommand): Observable<CallFlowImportReponseData> {
        let url_ = this.baseUrl + "/system/CallFlow/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallFlowImportReponseData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallFlowImportReponseData>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<CallFlowImportReponseData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallFlowImportReponseData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkFileImport(request: CheckFileImportCallFlowCommand): Observable<PathDto[]> {
        let url_ = this.baseUrl + "/system/CallFlow/check-file-import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckFileImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckFileImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PathDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PathDto[]>;
        }));
    }

    protected processCheckFileImport(response: HttpResponseBase): Observable<PathDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PathDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    outReach(id: number, request: OutreachFlowCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/system/CallFlow/outreach/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOutReach(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOutReach(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processOutReach(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hangup(command: HangupFlowCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CallFlow/hangup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHangup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHangup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHangup(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CallFlow/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    disable(request: DisableCallFlowCommand): Observable<CallFlowDto> {
        let url_ = this.baseUrl + "/system/CallFlow/disable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallFlowDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallFlowDto>;
        }));
    }

    protected processDisable(response: HttpResponseBase): Observable<CallFlowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallFlowDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setAgentFlow(request: SetAgentFlowCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CallFlow/setagentflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAgentFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAgentFlow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetAgentFlow(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unsetAgentFlow(request: UnsetAgentFlowCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CallFlow/unsetagentflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnsetAgentFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnsetAgentFlow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUnsetAgentFlow(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSubFlow(): Observable<CallFlowsListVm> {
        let url_ = this.baseUrl + "/system/CallFlow/subflow";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubFlow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallFlowsListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallFlowsListVm>;
        }));
    }

    protected processGetSubFlow(response: HttpResponseBase): Observable<CallFlowsListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallFlowsListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contactFlowUsing(id: number): Observable<CompanyNumberListVm> {
        let url_ = this.baseUrl + "/system/CallFlow/{id}/contactusing";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactFlowUsing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactFlowUsing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyNumberListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyNumberListVm>;
        }));
    }

    protected processContactFlowUsing(response: HttpResponseBase): Observable<CompanyNumberListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyNumberListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkUserIsDesigning(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/system/CallFlow/checkcallflow?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUserIsDesigning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUserIsDesigning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckUserIsDesigning(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    outCallFlow(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CallFlow/out?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOutCallFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOutCallFlow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processOutCallFlow(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkExistCallFlowName(command: CheckCallFlowNameCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CallFlow/existcallflowname";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExistCallFlowName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExistCallFlowName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckExistCallFlowName(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestModificationFlow(command: RequestModificationFlowCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CallFlow/requestmodificationflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestModificationFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestModificationFlow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRequestModificationFlow(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    testRequest(command: TestRequestCommand): Observable<TestRequestResult> {
        let url_ = this.baseUrl + "/system/CallFlow/testrequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TestRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TestRequestResult>;
        }));
    }

    protected processTestRequest(response: HttpResponseBase): Observable<TestRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TestRequestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadImage(command: UploadImageCommand): Observable<string> {
        let url_ = this.baseUrl + "/system/CallFlow/upload-image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadImage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    renameFlow(command: RenameCallFlowCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CallFlow/renameflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenameFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenameFlow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRenameFlow(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    differentFlow(id: number | undefined): Observable<DifferentCallFlowList> {
        let url_ = this.baseUrl + "/system/CallFlow/different-flow?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDifferentFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDifferentFlow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DifferentCallFlowList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DifferentCallFlowList>;
        }));
    }

    protected processDifferentFlow(response: HttpResponseBase): Observable<DifferentCallFlowList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DifferentCallFlowList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICallSettingClient {
    get(id: number | undefined): Observable<CallSettingDto>;
    update(request: CallSettingDto): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class CallSettingClient implements ICallSettingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: number | undefined): Observable<CallSettingDto> {
        let url_ = this.baseUrl + "/system/CallSetting?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallSettingDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CallSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(request: CallSettingDto): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CallSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICdrClient {
    getRecordFile(command: GetCallRecordQuery): Observable<FileResponse>;
    getRecordFileAsterisk(command: GetCallRecordAsteriskQuery): Observable<string>;
    getAll(query: GetCallListQuery): Observable<CallsListVm>;
    exportCDR(command: ExportReportCommand): Observable<string>;
    getNumberFilter(): Observable<NumberFilter>;
    getAllCallReport(): Observable<CallReportListVm>;
    getCallDetail(id: number): Observable<CallVm>;
    getCallDetailByCallID(callid: string | null): Observable<CallVm>;
    getAllVoiceMail(): Observable<VoiceMailListVm>;
    readVoiceMail(command: ReadVoiceMailCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class CdrClient implements ICdrClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getRecordFile(command: GetCallRecordQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/system/Cdr/GetRecordFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecordFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecordFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetRecordFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRecordFileAsterisk(command: GetCallRecordAsteriskQuery): Observable<string> {
        let url_ = this.baseUrl + "/system/Cdr/GetRecordFileAsterisk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecordFileAsterisk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecordFileAsterisk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetRecordFileAsterisk(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(query: GetCallListQuery): Observable<CallsListVm> {
        let url_ = this.baseUrl + "/system/Cdr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallsListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallsListVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CallsListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallsListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCDR(command: ExportReportCommand): Observable<string> {
        let url_ = this.baseUrl + "/system/Cdr/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCDR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCDR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportCDR(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNumberFilter(): Observable<NumberFilter> {
        let url_ = this.baseUrl + "/system/Cdr/numberfilter";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NumberFilter>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NumberFilter>;
        }));
    }

    protected processGetNumberFilter(response: HttpResponseBase): Observable<NumberFilter> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NumberFilter.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllCallReport(): Observable<CallReportListVm> {
        let url_ = this.baseUrl + "/system/Cdr/report";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCallReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCallReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallReportListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallReportListVm>;
        }));
    }

    protected processGetAllCallReport(response: HttpResponseBase): Observable<CallReportListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallReportListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCallDetail(id: number): Observable<CallVm> {
        let url_ = this.baseUrl + "/system/Cdr/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCallDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCallDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallVm>;
        }));
    }

    protected processGetCallDetail(response: HttpResponseBase): Observable<CallVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCallDetailByCallID(callid: string | null): Observable<CallVm> {
        let url_ = this.baseUrl + "/system/Cdr/callid/{callid}";
        if (callid === undefined || callid === null)
            throw new Error("The parameter 'callid' must be defined.");
        url_ = url_.replace("{callid}", encodeURIComponent("" + callid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCallDetailByCallID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCallDetailByCallID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallVm>;
        }));
    }

    protected processGetCallDetailByCallID(response: HttpResponseBase): Observable<CallVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllVoiceMail(): Observable<VoiceMailListVm> {
        let url_ = this.baseUrl + "/system/Cdr/voicemail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllVoiceMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllVoiceMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoiceMailListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoiceMailListVm>;
        }));
    }

    protected processGetAllVoiceMail(response: HttpResponseBase): Observable<VoiceMailListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoiceMailListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    readVoiceMail(command: ReadVoiceMailCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Cdr/voicemail/read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadVoiceMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadVoiceMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processReadVoiceMail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IChatClient {
    receiveMessage(conversationId: string | null, activityId: string | null, chatMessage: ChatMessage): Observable<FileResponse>;
    receiveMessageAntother(conversationId: string | null, chatMessage: ChatMessage): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ChatClient implements IChatClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    receiveMessage(conversationId: string | null, activityId: string | null, chatMessage: ChatMessage): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v3/conversations/{conversationId}/activities/{activityId}";
        if (conversationId === undefined || conversationId === null)
            throw new Error("The parameter 'conversationId' must be defined.");
        url_ = url_.replace("{conversationId}", encodeURIComponent("" + conversationId));
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chatMessage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReceiveMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReceiveMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReceiveMessage(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    receiveMessageAntother(conversationId: string | null, chatMessage: ChatMessage): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v3/conversations/{conversationId}/activities";
        if (conversationId === undefined || conversationId === null)
            throw new Error("The parameter 'conversationId' must be defined.");
        url_ = url_.replace("{conversationId}", encodeURIComponent("" + conversationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chatMessage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReceiveMessageAntother(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReceiveMessageAntother(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReceiveMessageAntother(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IChatGPTClient {
    getAllDataSet(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined): Observable<GPTDataListVm>;
    create(id: number | null | undefined, name: string | null | undefined, description: string | null | undefined, type: string | null | undefined, dataTrain: string | null | undefined, retrainTime: string | null | undefined, files: FileParameter[] | null | undefined): Observable<boolean>;
    getAllDataSetInTable(command: GetAllDataSetQuery): Observable<GPTDataListVm>;
    updateStatusGPT(id: number, command: UpdateStatusGPTCommand): Observable<boolean>;
    delete(id: number): Observable<boolean>;
    extractURL(command: ExtractURLCommand): Observable<string[]>;
    getDocumentData(command: GetDocumentDataQuery): Observable<ListDocumentQuery>;
    getAll(): Observable<GPTDataListVm>;
    testLLM(command: MakeTestModelLLMCommand): Observable<string>;
    testVirtualAgent(command: MakeTestVirtualAgentCommand): Observable<VirtualAgentResult>;
    testIntentEntityLLM(command: DetectIntentEntityLLMCommand): Observable<IntentEnityResponse>;
    get(id: number | undefined): Observable<GPTDataDto>;
    getDirectory(id: number | undefined): Observable<string>;
    checkExistedGPT(command: CheckExistedGPTCommand): Observable<boolean>;
    save(id: number | null | undefined, name: string | null | undefined, description: string | null | undefined, type: string | null | undefined, dataTrain: string | null | undefined, retrainTime: string | null | undefined, files: FileParameter[] | null | undefined): Observable<number>;
    train(id: number | null | undefined, name: string | null | undefined, description: string | null | undefined, type: string | null | undefined, dataTrain: string | null | undefined, retrainTime: string | null | undefined, files: FileParameter[] | null | undefined): Observable<number>;
    retrieveURL(command: RetrieveURLCommand): Observable<RetrieveURLResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ChatGPTClient implements IChatGPTClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllDataSet(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined): Observable<GPTDataListVm> {
        let url_ = this.baseUrl + "/system/ChatGPT?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAsc === null)
            throw new Error("The parameter 'sortAsc' cannot be null.");
        else if (sortAsc !== undefined)
            url_ += "sortAsc=" + encodeURIComponent("" + sortAsc) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDataSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDataSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GPTDataListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GPTDataListVm>;
        }));
    }

    protected processGetAllDataSet(response: HttpResponseBase): Observable<GPTDataListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GPTDataListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(id: number | null | undefined, name: string | null | undefined, description: string | null | undefined, type: string | null | undefined, dataTrain: string | null | undefined, retrainTime: string | null | undefined, files: FileParameter[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/system/ChatGPT";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (type !== null && type !== undefined)
            content_.append("Type", type.toString());
        if (dataTrain !== null && dataTrain !== undefined)
            content_.append("DataTrain", dataTrain.toString());
        if (retrainTime !== null && retrainTime !== undefined)
            content_.append("RetrainTime", retrainTime.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllDataSetInTable(command: GetAllDataSetQuery): Observable<GPTDataListVm> {
        let url_ = this.baseUrl + "/system/ChatGPT/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDataSetInTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDataSetInTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GPTDataListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GPTDataListVm>;
        }));
    }

    protected processGetAllDataSetInTable(response: HttpResponseBase): Observable<GPTDataListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GPTDataListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStatusGPT(id: number, command: UpdateStatusGPTCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/ChatGPT/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusGPT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusGPT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateStatusGPT(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/system/ChatGPT/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    extractURL(command: ExtractURLCommand): Observable<string[]> {
        let url_ = this.baseUrl + "/system/ChatGPT/extracturl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtractURL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtractURL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processExtractURL(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentData(command: GetDocumentDataQuery): Observable<ListDocumentQuery> {
        let url_ = this.baseUrl + "/system/ChatGPT/document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListDocumentQuery>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListDocumentQuery>;
        }));
    }

    protected processGetDocumentData(response: HttpResponseBase): Observable<ListDocumentQuery> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListDocumentQuery.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<GPTDataListVm> {
        let url_ = this.baseUrl + "/system/ChatGPT/by-company";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GPTDataListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GPTDataListVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GPTDataListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GPTDataListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    testLLM(command: MakeTestModelLLMCommand): Observable<string> {
        let url_ = this.baseUrl + "/system/ChatGPT/llm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestLLM(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestLLM(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTestLLM(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    testVirtualAgent(command: MakeTestVirtualAgentCommand): Observable<VirtualAgentResult> {
        let url_ = this.baseUrl + "/system/ChatGPT/virtualagent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestVirtualAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestVirtualAgent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VirtualAgentResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VirtualAgentResult>;
        }));
    }

    protected processTestVirtualAgent(response: HttpResponseBase): Observable<VirtualAgentResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VirtualAgentResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    testIntentEntityLLM(command: DetectIntentEntityLLMCommand): Observable<IntentEnityResponse> {
        let url_ = this.baseUrl + "/system/ChatGPT/intent-entity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestIntentEntityLLM(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestIntentEntityLLM(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntentEnityResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntentEnityResponse>;
        }));
    }

    protected processTestIntentEntityLLM(response: HttpResponseBase): Observable<IntentEnityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntentEnityResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: number | undefined): Observable<GPTDataDto> {
        let url_ = this.baseUrl + "/system/ChatGPT/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GPTDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GPTDataDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GPTDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GPTDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDirectory(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/system/ChatGPT/directory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDirectory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDirectory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDirectory(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkExistedGPT(command: CheckExistedGPTCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/ChatGPT/existedgpt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExistedGPT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExistedGPT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckExistedGPT(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(id: number | null | undefined, name: string | null | undefined, description: string | null | undefined, type: string | null | undefined, dataTrain: string | null | undefined, retrainTime: string | null | undefined, files: FileParameter[] | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/system/ChatGPT/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (type !== null && type !== undefined)
            content_.append("Type", type.toString());
        if (dataTrain !== null && dataTrain !== undefined)
            content_.append("DataTrain", dataTrain.toString());
        if (retrainTime !== null && retrainTime !== undefined)
            content_.append("RetrainTime", retrainTime.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    train(id: number | null | undefined, name: string | null | undefined, description: string | null | undefined, type: string | null | undefined, dataTrain: string | null | undefined, retrainTime: string | null | undefined, files: FileParameter[] | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/system/ChatGPT/training-dataset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (type !== null && type !== undefined)
            content_.append("Type", type.toString());
        if (dataTrain !== null && dataTrain !== undefined)
            content_.append("DataTrain", dataTrain.toString());
        if (retrainTime !== null && retrainTime !== undefined)
            content_.append("RetrainTime", retrainTime.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTrain(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveURL(command: RetrieveURLCommand): Observable<RetrieveURLResponse> {
        let url_ = this.baseUrl + "/system/ChatGPT/retrieveurl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveURL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveURL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RetrieveURLResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RetrieveURLResponse>;
        }));
    }

    protected processRetrieveURL(response: HttpResponseBase): Observable<RetrieveURLResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RetrieveURLResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICMSClient {
    getAllInTable(command: GetAllCMSQuery): Observable<CMSListVm>;
    update(command: UpdateCMSCommand): Observable<boolean>;
    disable(request: DisableCMSCommand): Observable<boolean>;
    withEntity(): Observable<CMSWithEntityDto[]>;
    get(id: number | undefined, getData: boolean | undefined): Observable<CMSDetailsDto>;
    getDetailsWithData(command: GetCMSDetailsWithDataQuery): Observable<CMSDetailsDto>;
    delete(id: number): Observable<boolean>;
    updateEntity(command: UpdateCMSEntitiesCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class CMSClient implements ICMSClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllInTable(command: GetAllCMSQuery): Observable<CMSListVm> {
        let url_ = this.baseUrl + "/system/CMS/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CMSListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CMSListVm>;
        }));
    }

    protected processGetAllInTable(response: HttpResponseBase): Observable<CMSListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CMSListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(command: UpdateCMSCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CMS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    disable(request: DisableCMSCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CMS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDisable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    withEntity(): Observable<CMSWithEntityDto[]> {
        let url_ = this.baseUrl + "/system/CMS/with-entity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CMSWithEntityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CMSWithEntityDto[]>;
        }));
    }

    protected processWithEntity(response: HttpResponseBase): Observable<CMSWithEntityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CMSWithEntityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: number | undefined, getData: boolean | undefined): Observable<CMSDetailsDto> {
        let url_ = this.baseUrl + "/system/CMS/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (getData === null)
            throw new Error("The parameter 'getData' cannot be null.");
        else if (getData !== undefined)
            url_ += "getData=" + encodeURIComponent("" + getData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CMSDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CMSDetailsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CMSDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CMSDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDetailsWithData(command: GetCMSDetailsWithDataQuery): Observable<CMSDetailsDto> {
        let url_ = this.baseUrl + "/system/CMS/details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailsWithData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailsWithData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CMSDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CMSDetailsDto>;
        }));
    }

    protected processGetDetailsWithData(response: HttpResponseBase): Observable<CMSDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CMSDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CMS/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEntity(command: UpdateCMSEntitiesCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CMS/update-entity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateEntity(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICMSDataClient {
    create(command: CreateCMSDataCommand): Observable<boolean>;
    query(command: CMSDataActionQuery): Observable<string>;
    update(command: UpdateCMSDataCommand): Observable<boolean>;
    import(command: ImportCMSDataCommand): Observable<boolean>;
    export(id: number | undefined): Observable<string>;
    delete(id: number): Observable<boolean>;
    sampleFile(request: SampleFileCMSDataCommand): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CMSDataClient implements ICMSDataClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(command: CreateCMSDataCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CMSData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    query(command: CMSDataActionQuery): Observable<string> {
        let url_ = this.baseUrl + "/system/CMSData/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processQuery(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(command: UpdateCMSDataCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CMSData/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    import(command: ImportCMSDataCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CMSData/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    export(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/system/CMSData/export?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CMSData/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sampleFile(request: SampleFileCMSDataCommand): Observable<string> {
        let url_ = this.baseUrl + "/system/CMSData/samplefile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSampleFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSampleFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSampleFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IConfigurationClient {
    getAll(): Observable<Configuration>;
    update(command: UpdateConfigurationCommand): Observable<boolean>;
    getUserSetting(): Observable<ListUserSettingVm>;
    updateUserSetting(command: UpdateConfigurationUserCommand): Observable<boolean>;
    setSupportFlow(command: UpdateSupportFlowURL): Observable<boolean>;
    getSupportFlow(): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ConfigurationClient implements IConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<Configuration> {
        let url_ = this.baseUrl + "/system/Configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Configuration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Configuration>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Configuration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Configuration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(command: UpdateConfigurationCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserSetting(): Observable<ListUserSettingVm> {
        let url_ = this.baseUrl + "/system/Configuration/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListUserSettingVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListUserSettingVm>;
        }));
    }

    protected processGetUserSetting(response: HttpResponseBase): Observable<ListUserSettingVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListUserSettingVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserSetting(command: UpdateConfigurationUserCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Configuration/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateUserSetting(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setSupportFlow(command: UpdateSupportFlowURL): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Configuration/support-flow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSupportFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSupportFlow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetSupportFlow(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSupportFlow(): Observable<string> {
        let url_ = this.baseUrl + "/system/Configuration/get-support-flow";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupportFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupportFlow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSupportFlow(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomerClient {
    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined, company: string | null | undefined): Observable<CustomersListVm>;
    create(command: CreateCustomerCommand): Observable<boolean>;
    update(command: UpdateCustomerCommand): Observable<boolean>;
    getAllInTable(command: GetCustomersListQuery): Observable<CustomersListVm>;
    getAllCompany(): Observable<CompanyListVm>;
    getCustomerInCompany(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined): Observable<CustomersListVm>;
    createCustomerInCompany(command: CreateCustomerInCompanyCommand): Observable<boolean>;
    updateCustomerInCompany(command: UpdateCustomerInCompanyCommand): Observable<boolean>;
    get(id: string | null): Observable<CustomerVm>;
    delete(id: string | null): Observable<boolean>;
    disable(command: DisableCustomerCommand): Observable<boolean[]>;
    disableInCompany(command: DisableCustomerInCompanyCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomerClient implements ICustomerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined, company: string | null | undefined): Observable<CustomersListVm> {
        let url_ = this.baseUrl + "/system/Customer?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAsc === null)
            throw new Error("The parameter 'sortAsc' cannot be null.");
        else if (sortAsc !== undefined)
            url_ += "sortAsc=" + encodeURIComponent("" + sortAsc) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (company !== undefined && company !== null)
            url_ += "company=" + encodeURIComponent("" + company) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomersListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomersListVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomersListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomersListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateCustomerCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(command: UpdateCustomerCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllInTable(command: GetCustomersListQuery): Observable<CustomersListVm> {
        let url_ = this.baseUrl + "/system/Customer/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomersListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomersListVm>;
        }));
    }

    protected processGetAllInTable(response: HttpResponseBase): Observable<CustomersListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomersListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllCompany(): Observable<CompanyListVm> {
        let url_ = this.baseUrl + "/system/Customer/allcompany";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyListVm>;
        }));
    }

    protected processGetAllCompany(response: HttpResponseBase): Observable<CompanyListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomerInCompany(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined): Observable<CustomersListVm> {
        let url_ = this.baseUrl + "/system/Customer/incompany?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAsc === null)
            throw new Error("The parameter 'sortAsc' cannot be null.");
        else if (sortAsc !== undefined)
            url_ += "sortAsc=" + encodeURIComponent("" + sortAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerInCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerInCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomersListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomersListVm>;
        }));
    }

    protected processGetCustomerInCompany(response: HttpResponseBase): Observable<CustomersListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomersListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCustomerInCompany(command: CreateCustomerInCompanyCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Customer/incompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomerInCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomerInCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateCustomerInCompany(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCustomerInCompany(command: UpdateCustomerInCompanyCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Customer/incompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerInCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerInCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateCustomerInCompany(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: string | null): Observable<CustomerVm> {
        let url_ = this.baseUrl + "/system/Customer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomerVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string | null): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Customer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    disable(command: DisableCustomerCommand): Observable<boolean[]> {
        let url_ = this.baseUrl + "/system/Customer/disable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean[]>;
        }));
    }

    protected processDisable(response: HttpResponseBase): Observable<boolean[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    disableInCompany(command: DisableCustomerInCompanyCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Customer/disable/incompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableInCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableInCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDisableInCompany(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomFunctionClient {
    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined): Observable<CustomFunctionListVm>;
    create(request: CreateCustomFunctionCommand): Observable<CustomFunctionDto>;
    update(request: UpdateCustomFunctionCommand): Observable<string>;
    getAllInTable(request: GetFunctionListQuery): Observable<CustomFunctionListVm>;
    getAllFunctionByCompany(language: string | null | undefined): Observable<CustomFunctionDto[]>;
    getAllFunctionBuildIn(): Observable<CustomFunctionListVm>;
    getBuildInByName(name: string | null | undefined): Observable<CustomFunctionDto>;
    get(id: number | undefined): Observable<CustomFunctionDto>;
    getByName(name: string | null | undefined): Observable<CustomFunctionDto>;
    getByNameAndCompany(name: string | null | undefined, companyId: number | undefined): Observable<CustomFunctionDto>;
    checkExistName(command: CheckNameExistQuery): Observable<boolean>;
    run(request: MakeTestCustomFunctionCommand): Observable<string>;
    delete(id: number): Observable<boolean>;
    export(request: ExportFunctionCommand): Observable<string>;
    import(request: ImportFunctionCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomFunctionClient implements ICustomFunctionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined): Observable<CustomFunctionListVm> {
        let url_ = this.baseUrl + "/system/CustomFunction?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAsc === null)
            throw new Error("The parameter 'sortAsc' cannot be null.");
        else if (sortAsc !== undefined)
            url_ += "sortAsc=" + encodeURIComponent("" + sortAsc) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFunctionListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFunctionListVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomFunctionListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomFunctionListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(request: CreateCustomFunctionCommand): Observable<CustomFunctionDto> {
        let url_ = this.baseUrl + "/system/CustomFunction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFunctionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFunctionDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomFunctionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomFunctionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(request: UpdateCustomFunctionCommand): Observable<string> {
        let url_ = this.baseUrl + "/system/CustomFunction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllInTable(request: GetFunctionListQuery): Observable<CustomFunctionListVm> {
        let url_ = this.baseUrl + "/system/CustomFunction/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFunctionListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFunctionListVm>;
        }));
    }

    protected processGetAllInTable(response: HttpResponseBase): Observable<CustomFunctionListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomFunctionListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllFunctionByCompany(language: string | null | undefined): Observable<CustomFunctionDto[]> {
        let url_ = this.baseUrl + "/system/CustomFunction/by-company?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFunctionByCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFunctionByCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFunctionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFunctionDto[]>;
        }));
    }

    protected processGetAllFunctionByCompany(response: HttpResponseBase): Observable<CustomFunctionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomFunctionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllFunctionBuildIn(): Observable<CustomFunctionListVm> {
        let url_ = this.baseUrl + "/system/CustomFunction/build-in";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFunctionBuildIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFunctionBuildIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFunctionListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFunctionListVm>;
        }));
    }

    protected processGetAllFunctionBuildIn(response: HttpResponseBase): Observable<CustomFunctionListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomFunctionListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBuildInByName(name: string | null | undefined): Observable<CustomFunctionDto> {
        let url_ = this.baseUrl + "/system/CustomFunction/built-in-name?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuildInByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuildInByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFunctionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFunctionDto>;
        }));
    }

    protected processGetBuildInByName(response: HttpResponseBase): Observable<CustomFunctionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomFunctionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: number | undefined): Observable<CustomFunctionDto> {
        let url_ = this.baseUrl + "/system/CustomFunction/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFunctionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFunctionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomFunctionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomFunctionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByName(name: string | null | undefined): Observable<CustomFunctionDto> {
        let url_ = this.baseUrl + "/system/CustomFunction/name?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFunctionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFunctionDto>;
        }));
    }

    protected processGetByName(response: HttpResponseBase): Observable<CustomFunctionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomFunctionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByNameAndCompany(name: string | null | undefined, companyId: number | undefined): Observable<CustomFunctionDto> {
        let url_ = this.baseUrl + "/system/CustomFunction/namebycompany?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByNameAndCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByNameAndCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFunctionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFunctionDto>;
        }));
    }

    protected processGetByNameAndCompany(response: HttpResponseBase): Observable<CustomFunctionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomFunctionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkExistName(command: CheckNameExistQuery): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CustomFunction/existname";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExistName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExistName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckExistName(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    run(request: MakeTestCustomFunctionCommand): Observable<string> {
        let url_ = this.baseUrl + "/system/CustomFunction/run";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRun(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CustomFunction/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    export(request: ExportFunctionCommand): Observable<string> {
        let url_ = this.baseUrl + "/system/CustomFunction/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    import(request: ImportFunctionCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/CustomFunction/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDataSetClient {
    getAll(): Observable<DatasetDtoList>;
    create(command: CreateDatasetCommand): Observable<string>;
    delete(id: number): Observable<boolean>;
    getDatasetDashboard(command: GetDatasetDashboardQuery): Observable<DatasetDtoList>;
    checkExistedDatasetName(command: CheckDatasetNameCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class DataSetClient implements IDataSetClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<DatasetDtoList> {
        let url_ = this.baseUrl + "/system/DataSet";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DatasetDtoList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DatasetDtoList>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DatasetDtoList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DatasetDtoList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateDatasetCommand): Observable<string> {
        let url_ = this.baseUrl + "/system/DataSet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/system/DataSet/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDatasetDashboard(command: GetDatasetDashboardQuery): Observable<DatasetDtoList> {
        let url_ = this.baseUrl + "/system/DataSet/filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDatasetDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDatasetDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DatasetDtoList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DatasetDtoList>;
        }));
    }

    protected processGetDatasetDashboard(response: HttpResponseBase): Observable<DatasetDtoList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DatasetDtoList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkExistedDatasetName(command: CheckDatasetNameCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/DataSet/existeddatasetname";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExistedDatasetName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExistedDatasetName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckExistedDatasetName(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDraftClient {
    getAll(): Observable<DraftsListVm>;
    create(request: CreateDraftCommand): Observable<DraftDto>;
    update(request: UpdateDraftCommand): Observable<boolean>;
    get(id: number | undefined): Observable<DraftDto>;
    getByCallflow(callflowId: number): Observable<CurrentDraftsListVm>;
    createDefaultDraft(request: CreateDraftDefaultCommand): Observable<DraftDto>;
    updateReversion(request: UpdateReversionCommand): Observable<boolean>;
    publish(request: PublishDraftCommand): Observable<boolean>;
    getNewestVersion(callflowId: number): Observable<DraftDto>;
    updateAttributeNewestVersion(command: UpdateAttributeNewestVersion): Observable<DraftDto>;
    getPublicVersion(callflowId: number): Observable<DraftDto>;
}

@Injectable({
    providedIn: 'root'
})
export class DraftClient implements IDraftClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<DraftsListVm> {
        let url_ = this.baseUrl + "/system/Draft";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DraftsListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DraftsListVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DraftsListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DraftsListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(request: CreateDraftCommand): Observable<DraftDto> {
        let url_ = this.baseUrl + "/system/Draft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DraftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DraftDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DraftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DraftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(request: UpdateDraftCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Draft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: number | undefined): Observable<DraftDto> {
        let url_ = this.baseUrl + "/system/Draft/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DraftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DraftDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DraftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DraftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByCallflow(callflowId: number): Observable<CurrentDraftsListVm> {
        let url_ = this.baseUrl + "/system/Draft/callflow/{callflowId}";
        if (callflowId === undefined || callflowId === null)
            throw new Error("The parameter 'callflowId' must be defined.");
        url_ = url_.replace("{callflowId}", encodeURIComponent("" + callflowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCallflow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCallflow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentDraftsListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentDraftsListVm>;
        }));
    }

    protected processGetByCallflow(response: HttpResponseBase): Observable<CurrentDraftsListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentDraftsListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createDefaultDraft(request: CreateDraftDefaultCommand): Observable<DraftDto> {
        let url_ = this.baseUrl + "/system/Draft/createDefaultDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDefaultDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDefaultDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DraftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DraftDto>;
        }));
    }

    protected processCreateDefaultDraft(response: HttpResponseBase): Observable<DraftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DraftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateReversion(request: UpdateReversionCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Draft/update-reversion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReversion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReversion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateReversion(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    publish(request: PublishDraftCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Draft/publish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPublish(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNewestVersion(callflowId: number): Observable<DraftDto> {
        let url_ = this.baseUrl + "/system/Draft/newestversion/{callflowId}";
        if (callflowId === undefined || callflowId === null)
            throw new Error("The parameter 'callflowId' must be defined.");
        url_ = url_.replace("{callflowId}", encodeURIComponent("" + callflowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewestVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewestVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DraftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DraftDto>;
        }));
    }

    protected processGetNewestVersion(response: HttpResponseBase): Observable<DraftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DraftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAttributeNewestVersion(command: UpdateAttributeNewestVersion): Observable<DraftDto> {
        let url_ = this.baseUrl + "/system/Draft/update-attribute-newestversion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAttributeNewestVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAttributeNewestVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DraftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DraftDto>;
        }));
    }

    protected processUpdateAttributeNewestVersion(response: HttpResponseBase): Observable<DraftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DraftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPublicVersion(callflowId: number): Observable<DraftDto> {
        let url_ = this.baseUrl + "/system/Draft/publicversion/{callflowId}";
        if (callflowId === undefined || callflowId === null)
            throw new Error("The parameter 'callflowId' must be defined.");
        url_ = url_.replace("{callflowId}", encodeURIComponent("" + callflowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DraftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DraftDto>;
        }));
    }

    protected processGetPublicVersion(response: HttpResponseBase): Observable<DraftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DraftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmailClient {
    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined): Observable<EmailReportListVm>;
    update(command: UpdateEmailReportCommand): Observable<boolean>;
    disable(request: DisableEmailReportCommand): Observable<boolean>;
    getAllInTable(command: GetListEmailReportQuery): Observable<EmailReportListVm>;
    makeTestSendMail(command: MakeTestSendMailCommand): Observable<boolean>;
    sendMail(command: SendMailHandlerCommand): Observable<boolean>;
    get(id: number | undefined): Observable<EmailReportDto>;
    delete(id: number): Observable<boolean>;
    duplicate(request: DuplicateEmailReportCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class EmailClient implements IEmailClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined): Observable<EmailReportListVm> {
        let url_ = this.baseUrl + "/system/Email?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAsc === null)
            throw new Error("The parameter 'sortAsc' cannot be null.");
        else if (sortAsc !== undefined)
            url_ += "sortAsc=" + encodeURIComponent("" + sortAsc) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailReportListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailReportListVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EmailReportListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailReportListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(command: UpdateEmailReportCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    disable(request: DisableEmailReportCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDisable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllInTable(command: GetListEmailReportQuery): Observable<EmailReportListVm> {
        let url_ = this.baseUrl + "/system/Email/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailReportListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailReportListVm>;
        }));
    }

    protected processGetAllInTable(response: HttpResponseBase): Observable<EmailReportListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailReportListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    makeTestSendMail(command: MakeTestSendMailCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Email/sendtestreport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMakeTestSendMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMakeTestSendMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMakeTestSendMail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendMail(command: SendMailHandlerCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Email/sendmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendMail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: number | undefined): Observable<EmailReportDto> {
        let url_ = this.baseUrl + "/system/Email/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailReportDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EmailReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Email/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    duplicate(request: DuplicateEmailReportCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Email/duplicate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDuplicate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmailLogClient {
    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined, emailReportId: number | undefined): Observable<EmailLogListVm>;
}

@Injectable({
    providedIn: 'root'
})
export class EmailLogClient implements IEmailLogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined, emailReportId: number | undefined): Observable<EmailLogListVm> {
        let url_ = this.baseUrl + "/system/EmailLog?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAsc === null)
            throw new Error("The parameter 'sortAsc' cannot be null.");
        else if (sortAsc !== undefined)
            url_ += "sortAsc=" + encodeURIComponent("" + sortAsc) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (emailReportId === null)
            throw new Error("The parameter 'emailReportId' cannot be null.");
        else if (emailReportId !== undefined)
            url_ += "emailReportId=" + encodeURIComponent("" + emailReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailLogListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailLogListVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EmailLogListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailLogListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmailTemplateClient {
    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined): Observable<EmailTemplateListVm>;
    update(command: UpdateEmailTemplateCommand): Observable<boolean>;
    getAllInTable(command: GetAllEmailTemplateQuery): Observable<EmailTemplateListVm>;
    get(id: number | undefined): Observable<EmailTemplateDto>;
    delete(id: number): Observable<boolean>;
    duplicate(request: DuplicateEmailTemplateCommand): Observable<boolean>;
    export(request: ExportEmailTemplateCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class EmailTemplateClient implements IEmailTemplateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined): Observable<EmailTemplateListVm> {
        let url_ = this.baseUrl + "/system/EmailTemplate?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAsc === null)
            throw new Error("The parameter 'sortAsc' cannot be null.");
        else if (sortAsc !== undefined)
            url_ += "sortAsc=" + encodeURIComponent("" + sortAsc) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailTemplateListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailTemplateListVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EmailTemplateListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailTemplateListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(command: UpdateEmailTemplateCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/EmailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllInTable(command: GetAllEmailTemplateQuery): Observable<EmailTemplateListVm> {
        let url_ = this.baseUrl + "/system/EmailTemplate/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailTemplateListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailTemplateListVm>;
        }));
    }

    protected processGetAllInTable(response: HttpResponseBase): Observable<EmailTemplateListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailTemplateListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: number | undefined): Observable<EmailTemplateDto> {
        let url_ = this.baseUrl + "/system/EmailTemplate/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailTemplateDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EmailTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/system/EmailTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    duplicate(request: DuplicateEmailTemplateCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/EmailTemplate/duplicate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDuplicate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    export(request: ExportEmailTemplateCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/EmailTemplate/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IExtensionClient {
    getAllInTable(command: GetExtensionListQuery): Observable<ExtensionListVm>;
    getAllExtension(): Observable<AllExtensionList>;
    createExtension(command: CreateExtensionCommand): Observable<string>;
    updateExtension(command: UpdateExtensionCommand): Observable<boolean>;
    deleteExtension(command: DeleteExtensionCommand): Observable<boolean>;
    disableExtension(command: DisableExtensionCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class ExtensionClient implements IExtensionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllInTable(command: GetExtensionListQuery): Observable<ExtensionListVm> {
        let url_ = this.baseUrl + "/system/Extension/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtensionListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtensionListVm>;
        }));
    }

    protected processGetAllInTable(response: HttpResponseBase): Observable<ExtensionListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtensionListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllExtension(): Observable<AllExtensionList> {
        let url_ = this.baseUrl + "/system/Extension/all-extension";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExtension(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExtension(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllExtensionList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllExtensionList>;
        }));
    }

    protected processGetAllExtension(response: HttpResponseBase): Observable<AllExtensionList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllExtensionList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createExtension(command: CreateExtensionCommand): Observable<string> {
        let url_ = this.baseUrl + "/system/Extension/createsip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExtension(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExtension(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateExtension(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateExtension(command: UpdateExtensionCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Extension/updatesip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExtension(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExtension(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateExtension(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteExtension(command: DeleteExtensionCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Extension/deletesip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExtension(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExtension(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteExtension(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    disableExtension(command: DisableExtensionCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Extension/disablesip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableExtension(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableExtension(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDisableExtension(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IGrammarClient {
    getAll(): Observable<GrammarDtoList>;
    create(command: CreateGrammarCommand): Observable<string>;
    getAllGrammar(): Observable<GrammarFunctionDto[]>;
    get(id: number | undefined): Observable<GrammarDto>;
    getByType(type: string | null | undefined): Observable<GrammarDtoList>;
    getIntentList(command: GetAllIntentValueQuery): Observable<IntentsDto>;
    getDetails(type: string | null | undefined, name: string | null | undefined): Observable<GrammarDto>;
    checkGrammar(command: CheckGrammarQuery): Observable<boolean>;
    updateStatusGrammar(id: number, command: UpdateStatusGrammarCommand): Observable<boolean>;
    delete(id: number): Observable<boolean>;
    checkExistedGrammarName(command: CheckGrammarNameCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class GrammarClient implements IGrammarClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<GrammarDtoList> {
        let url_ = this.baseUrl + "/system/Grammar";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GrammarDtoList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GrammarDtoList>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GrammarDtoList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GrammarDtoList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateGrammarCommand): Observable<string> {
        let url_ = this.baseUrl + "/system/Grammar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllGrammar(): Observable<GrammarFunctionDto[]> {
        let url_ = this.baseUrl + "/system/Grammar/withfunction";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGrammar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGrammar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GrammarFunctionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GrammarFunctionDto[]>;
        }));
    }

    protected processGetAllGrammar(response: HttpResponseBase): Observable<GrammarFunctionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GrammarFunctionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: number | undefined): Observable<GrammarDto> {
        let url_ = this.baseUrl + "/system/Grammar/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GrammarDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GrammarDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GrammarDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GrammarDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByType(type: string | null | undefined): Observable<GrammarDtoList> {
        let url_ = this.baseUrl + "/system/Grammar/byType?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GrammarDtoList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GrammarDtoList>;
        }));
    }

    protected processGetByType(response: HttpResponseBase): Observable<GrammarDtoList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GrammarDtoList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIntentList(command: GetAllIntentValueQuery): Observable<IntentsDto> {
        let url_ = this.baseUrl + "/system/Grammar/intentlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntentList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntentList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntentsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntentsDto>;
        }));
    }

    protected processGetIntentList(response: HttpResponseBase): Observable<IntentsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntentsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDetails(type: string | null | undefined, name: string | null | undefined): Observable<GrammarDto> {
        let url_ = this.baseUrl + "/system/Grammar/details?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GrammarDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GrammarDto>;
        }));
    }

    protected processGetDetails(response: HttpResponseBase): Observable<GrammarDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GrammarDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkGrammar(command: CheckGrammarQuery): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Grammar/CheckGrammar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckGrammar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckGrammar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckGrammar(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStatusGrammar(id: number, command: UpdateStatusGrammarCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Grammar/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusGrammar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusGrammar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateStatusGrammar(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Grammar/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkExistedGrammarName(command: CheckGrammarNameCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Grammar/existedgrammarname";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExistedGrammarName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExistedGrammarName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckExistedGrammarName(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMediaClient {
    getAll(type: string | null | undefined, searchText: string | null | undefined, startTime: string | null | undefined, endTime: string | null | undefined): Observable<MediaDtoList>;
    create(name: string | null | undefined, size: number | undefined, length: string | null | undefined, type: string | null | undefined, imageWidth: number | undefined, imageHeight: number | undefined, sourceFile: FileParameter | null | undefined): Observable<MediaDto>;
    delete(ids: number[]): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class MediaClient implements IMediaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(type: string | null | undefined, searchText: string | null | undefined, startTime: string | null | undefined, endTime: string | null | undefined): Observable<MediaDtoList> {
        let url_ = this.baseUrl + "/system/Media?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent("" + startTime) + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent("" + endTime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaDtoList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaDtoList>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MediaDtoList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaDtoList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(name: string | null | undefined, size: number | undefined, length: string | null | undefined, type: string | null | undefined, imageWidth: number | undefined, imageHeight: number | undefined, sourceFile: FileParameter | null | undefined): Observable<MediaDto> {
        let url_ = this.baseUrl + "/system/Media";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (size === null || size === undefined)
            throw new Error("The parameter 'size' cannot be null.");
        else
            content_.append("Size", size.toString());
        if (length !== null && length !== undefined)
            content_.append("Length", length.toString());
        if (type !== null && type !== undefined)
            content_.append("Type", type.toString());
        if (imageWidth === null || imageWidth === undefined)
            throw new Error("The parameter 'imageWidth' cannot be null.");
        else
            content_.append("ImageWidth", imageWidth.toString());
        if (imageHeight === null || imageHeight === undefined)
            throw new Error("The parameter 'imageHeight' cannot be null.");
        else
            content_.append("ImageHeight", imageHeight.toString());
        if (sourceFile !== null && sourceFile !== undefined)
            content_.append("SourceFile", sourceFile.data, sourceFile.fileName ? sourceFile.fileName : "SourceFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MediaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(ids: number[]): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Media";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMusicOnHoldClient {
    getAll(): Observable<MusicOnHoldDtoList>;
    create(command: UploadMusicOnHoldCommand): Observable<number>;
    update(command: UpdateMusicOnHoldCommand): Observable<number>;
    delete(id: number): Observable<boolean>;
    checkExistMOHName(command: CheckMusicOnHoldCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class MusicOnHoldClient implements IMusicOnHoldClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<MusicOnHoldDtoList> {
        let url_ = this.baseUrl + "/system/MusicOnHold";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MusicOnHoldDtoList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MusicOnHoldDtoList>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MusicOnHoldDtoList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MusicOnHoldDtoList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: UploadMusicOnHoldCommand): Observable<number> {
        let url_ = this.baseUrl + "/system/MusicOnHold";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(command: UpdateMusicOnHoldCommand): Observable<number> {
        let url_ = this.baseUrl + "/system/MusicOnHold";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/system/MusicOnHold/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkExistMOHName(command: CheckMusicOnHoldCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/MusicOnHold/existmohname";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExistMOHName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExistMOHName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckExistMOHName(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INumberClient {
    get(id: number): Observable<NumberDetailVm>;
    pickPhoneNumber(id: number): Observable<boolean>;
    getAllList(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined, providerId: string | null | undefined, trunkId: string | null | undefined): Observable<PhoneNumbersListVm>;
    getAllAdminInTable(command: GetAllNumberQuery): Observable<PhoneNumbersListVm>;
    getAll(command: GetAllNumbersListQuery): Observable<PhoneNumbersListVm>;
    getAvailableNumber(): Observable<CompanyNumberListVm>;
    getNumbersByCompany(): Observable<CompanyNumberListVm>;
    getContactConfig(id: number): Observable<CompanyNumberListVm>;
    disable(command: DisableNumberCommand): Observable<boolean>;
    delete(command: DeleteNumberCommand): Observable<boolean>;
    update(command: UpdateNumberCommand): Observable<boolean>;
    disAllow(command: DisAllowNumberCommand): Observable<boolean>;
    assignCallFlow(command: AssignCallFlowCommand): Observable<boolean>;
    cancelNumber(command: CancelNumberCommand): Observable<boolean>;
    import(command: ImportOtherPhoneNumber): Observable<boolean>;
    updateNumberSetting(command: UpdateNumberSettingCommand): Observable<boolean>;
    getNumberSetting(id: number): Observable<string[]>;
    upload(command: UploadPhoneNumberCommand): Observable<PhoneNumberUploadResult>;
    exportNumber(): Observable<string>;
    export(request: ExportFileErrorPhoneNumber): Observable<string>;
    checkNumber(request: CheckNumber): Observable<CheckNumberResult>;
}

@Injectable({
    providedIn: 'root'
})
export class NumberClient implements INumberClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: number): Observable<NumberDetailVm> {
        let url_ = this.baseUrl + "/system/Number/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NumberDetailVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NumberDetailVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NumberDetailVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NumberDetailVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pickPhoneNumber(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Number/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPickPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPickPhoneNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPickPhoneNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllList(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined, providerId: string | null | undefined, trunkId: string | null | undefined): Observable<PhoneNumbersListVm> {
        let url_ = this.baseUrl + "/system/Number/allNumbersListAdmin?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAsc === null)
            throw new Error("The parameter 'sortAsc' cannot be null.");
        else if (sortAsc !== undefined)
            url_ += "sortAsc=" + encodeURIComponent("" + sortAsc) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (providerId !== undefined && providerId !== null)
            url_ += "ProviderId=" + encodeURIComponent("" + providerId) + "&";
        if (trunkId !== undefined && trunkId !== null)
            url_ += "TrunkId=" + encodeURIComponent("" + trunkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneNumbersListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneNumbersListVm>;
        }));
    }

    protected processGetAllList(response: HttpResponseBase): Observable<PhoneNumbersListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhoneNumbersListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllAdminInTable(command: GetAllNumberQuery): Observable<PhoneNumbersListVm> {
        let url_ = this.baseUrl + "/system/Number/allAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdminInTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdminInTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneNumbersListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneNumbersListVm>;
        }));
    }

    protected processGetAllAdminInTable(response: HttpResponseBase): Observable<PhoneNumbersListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhoneNumbersListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(command: GetAllNumbersListQuery): Observable<PhoneNumbersListVm> {
        let url_ = this.baseUrl + "/system/Number/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneNumbersListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneNumbersListVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PhoneNumbersListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhoneNumbersListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAvailableNumber(): Observable<CompanyNumberListVm> {
        let url_ = this.baseUrl + "/system/Number/availablenumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyNumberListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyNumberListVm>;
        }));
    }

    protected processGetAvailableNumber(response: HttpResponseBase): Observable<CompanyNumberListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyNumberListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNumbersByCompany(): Observable<CompanyNumberListVm> {
        let url_ = this.baseUrl + "/system/Number/mynumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumbersByCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumbersByCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyNumberListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyNumberListVm>;
        }));
    }

    protected processGetNumbersByCompany(response: HttpResponseBase): Observable<CompanyNumberListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyNumberListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getContactConfig(id: number): Observable<CompanyNumberListVm> {
        let url_ = this.baseUrl + "/system/Number/{id}/contact";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyNumberListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyNumberListVm>;
        }));
    }

    protected processGetContactConfig(response: HttpResponseBase): Observable<CompanyNumberListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyNumberListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    disable(command: DisableNumberCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Number/disable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDisable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(command: DeleteNumberCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Number";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(command: UpdateNumberCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Number";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    disAllow(command: DisAllowNumberCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Number/disallow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisAllow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisAllow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDisAllow(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignCallFlow(command: AssignCallFlowCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Number/assigncallflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignCallFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignCallFlow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAssignCallFlow(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelNumber(command: CancelNumberCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Number/cancelnumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCancelNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    import(command: ImportOtherPhoneNumber): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Number/importphonenumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateNumberSetting(command: UpdateNumberSettingCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Number/setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNumberSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNumberSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateNumberSetting(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNumberSetting(id: number): Observable<string[]> {
        let url_ = this.baseUrl + "/system/Number/setting/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetNumberSetting(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upload(command: UploadPhoneNumberCommand): Observable<PhoneNumberUploadResult> {
        let url_ = this.baseUrl + "/system/Number/uploadphonenumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneNumberUploadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneNumberUploadResult>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<PhoneNumberUploadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhoneNumberUploadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportNumber(): Observable<string> {
        let url_ = this.baseUrl + "/system/Number/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportNumber(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    export(request: ExportFileErrorPhoneNumber): Observable<string> {
        let url_ = this.baseUrl + "/system/Number/exporterrorphone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkNumber(request: CheckNumber): Observable<CheckNumberResult> {
        let url_ = this.baseUrl + "/system/Number/checknumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckNumberResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckNumberResult>;
        }));
    }

    protected processCheckNumber(response: HttpResponseBase): Observable<CheckNumberResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckNumberResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPermissionClient {
    getDetails(type: string | null | undefined): Observable<PermissionListVm>;
}

@Injectable({
    providedIn: 'root'
})
export class PermissionClient implements IPermissionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getDetails(type: string | null | undefined): Observable<PermissionListVm> {
        let url_ = this.baseUrl + "/system/Permission/type?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionListVm>;
        }));
    }

    protected processGetDetails(response: HttpResponseBase): Observable<PermissionListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IQueueClient {
    create(command: CreateQueueCommand): Observable<boolean>;
    delete(id: number): Observable<boolean>;
    get(id: number): Observable<QueueDetailVm>;
    update(id: number, command: UpdateQueueCommand): Observable<boolean>;
    disable(command: DisableQueueCommand): Observable<boolean>;
    getQueueStatus(id: number): Observable<AgentInQueueSummary>;
    getQueueRecord(query: GetQueueRecordingQuery): Observable<RecordingQueueVm>;
    getAll(command: GetQueuesListQuery): Observable<QueuesListVm>;
    updateTranscription(command: UpdateTranscriptionCommand): Observable<boolean>;
    getSummary(): Observable<QueueSummary>;
}

@Injectable({
    providedIn: 'root'
})
export class QueueClient implements IQueueClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(command: CreateQueueCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Queue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Queue/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: number): Observable<QueueDetailVm> {
        let url_ = this.baseUrl + "/system/Queue/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueueDetailVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueueDetailVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<QueueDetailVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueueDetailVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: number, command: UpdateQueueCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Queue/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    disable(command: DisableQueueCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Queue/disable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDisable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getQueueStatus(id: number): Observable<AgentInQueueSummary> {
        let url_ = this.baseUrl + "/system/Queue/status/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQueueStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQueueStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentInQueueSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentInQueueSummary>;
        }));
    }

    protected processGetQueueStatus(response: HttpResponseBase): Observable<AgentInQueueSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentInQueueSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getQueueRecord(query: GetQueueRecordingQuery): Observable<RecordingQueueVm> {
        let url_ = this.baseUrl + "/system/Queue/recording";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQueueRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQueueRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecordingQueueVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecordingQueueVm>;
        }));
    }

    protected processGetQueueRecord(response: HttpResponseBase): Observable<RecordingQueueVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecordingQueueVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(command: GetQueuesListQuery): Observable<QueuesListVm> {
        let url_ = this.baseUrl + "/system/Queue/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueuesListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueuesListVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<QueuesListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueuesListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateTranscription(command: UpdateTranscriptionCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Queue/transcription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTranscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTranscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTranscription(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSummary(): Observable<QueueSummary> {
        let url_ = this.baseUrl + "/system/Queue/summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueueSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueueSummary>;
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<QueueSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueueSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportClient {
    getTotalCallVolume(fromDate: Date | undefined, toDate: Date | undefined): Observable<CallVolumeData>;
    getReportDataByQueue(fromDate: Date | undefined, toDate: Date | undefined): Observable<QueueReportData>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportClient implements IReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTotalCallVolume(fromDate: Date | undefined, toDate: Date | undefined): Observable<CallVolumeData> {
        let url_ = this.baseUrl + "/system/Report/totalcallvolume?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalCallVolume(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalCallVolume(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallVolumeData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallVolumeData>;
        }));
    }

    protected processGetTotalCallVolume(response: HttpResponseBase): Observable<CallVolumeData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallVolumeData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportDataByQueue(fromDate: Date | undefined, toDate: Date | undefined): Observable<QueueReportData> {
        let url_ = this.baseUrl + "/system/Report/byqueue?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportDataByQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportDataByQueue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueueReportData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueueReportData>;
        }));
    }

    protected processGetReportDataByQueue(response: HttpResponseBase): Observable<QueueReportData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueueReportData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRoleClient {
    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined, type: string | null | undefined): Observable<RolesListVm>;
    update(command: UpdateRoleCommand): Observable<boolean>;
    getAllInTable(request: GetAllRoleQuery): Observable<RolesListVm>;
    getDetails(id: string | null | undefined): Observable<RoleDto>;
    deleteRole(id: string | null | undefined): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class RoleClient implements IRoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined, type: string | null | undefined): Observable<RolesListVm> {
        let url_ = this.baseUrl + "/system/Role?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAsc === null)
            throw new Error("The parameter 'sortAsc' cannot be null.");
        else if (sortAsc !== undefined)
            url_ += "sortAsc=" + encodeURIComponent("" + sortAsc) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolesListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolesListVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RolesListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RolesListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(command: UpdateRoleCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllInTable(request: GetAllRoleQuery): Observable<RolesListVm> {
        let url_ = this.baseUrl + "/system/Role/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolesListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolesListVm>;
        }));
    }

    protected processGetAllInTable(response: HttpResponseBase): Observable<RolesListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RolesListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDetails(id: string | null | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/system/Role/id?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGetDetails(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteRole(id: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Role/id?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISecurityClient {
    getAllSetting(): Observable<{ [key: string]: string; }>;
    saveAllSetting(setting: any): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class SecurityClient implements ISecurityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllSetting(): Observable<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/system/Security";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string; }>;
        }));
    }

    protected processGetAllSetting(response: HttpResponseBase): Observable<{ [key: string]: string; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveAllSetting(setting: any): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Security";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setting);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAllSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAllSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveAllSetting(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IServerClient {
    restartAsterisk(): Observable<string>;
    restartAsteriskConnector(): Observable<string>;
    restartAeap(): Observable<string>;
    codeAsteriskConnector(code: string | null | undefined): Observable<string>;
    syncDevice(command: SyncDeviceCommand): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ServerClient implements IServerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    restartAsterisk(): Observable<string> {
        let url_ = this.baseUrl + "/system/Server";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestartAsterisk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestartAsterisk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRestartAsterisk(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    restartAsteriskConnector(): Observable<string> {
        let url_ = this.baseUrl + "/system/Server/asteriskconnector";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestartAsteriskConnector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestartAsteriskConnector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRestartAsteriskConnector(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    restartAeap(): Observable<string> {
        let url_ = this.baseUrl + "/system/Server/aeap";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestartAeap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestartAeap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRestartAeap(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    codeAsteriskConnector(code: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/system/Server/code?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCodeAsteriskConnector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCodeAsteriskConnector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCodeAsteriskConnector(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    syncDevice(command: SyncDeviceCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/system/Server/syncdevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSyncDevice(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISettingsClient {
    getValues(request: GetSettingValuesCompanyQuery): Observable<Common[]>;
    updateLogo(request: UpdateLogoCommand): Observable<boolean>;
    getLatestVersion(): Observable<string>;
    getNewsVersion(currentVersion: string | null | undefined): Observable<{ [key: string]: string[]; }>;
    upgradeVersion(currentVersion: string | null | undefined, id: string | null | undefined): Observable<string>;
    reset(): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class SettingsClient implements ISettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getValues(request: GetSettingValuesCompanyQuery): Observable<Common[]> {
        let url_ = this.baseUrl + "/system/Settings/getByKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Common[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Common[]>;
        }));
    }

    protected processGetValues(response: HttpResponseBase): Observable<Common[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Common.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateLogo(request: UpdateLogoCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Settings/updateLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateLogo(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLatestVersion(): Observable<string> {
        let url_ = this.baseUrl + "/system/Settings/latestversion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLatestVersion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNewsVersion(currentVersion: string | null | undefined): Observable<{ [key: string]: string[]; }> {
        let url_ = this.baseUrl + "/system/Settings/getnewsversion?";
        if (currentVersion !== undefined && currentVersion !== null)
            url_ += "currentVersion=" + encodeURIComponent("" + currentVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewsVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewsVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string[]; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string[]; }>;
        }));
    }

    protected processGetNewsVersion(response: HttpResponseBase): Observable<{ [key: string]: string[]; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : [];
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upgradeVersion(currentVersion: string | null | undefined, id: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/system/Settings/upgradeversion?";
        if (currentVersion !== undefined && currentVersion !== null)
            url_ += "currentVersion=" + encodeURIComponent("" + currentVersion) + "&";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpgradeVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpgradeVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpgradeVersion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reset(): Observable<string> {
        let url_ = this.baseUrl + "/system/Settings/reset";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processReset(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISystemLogClient {
    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, start: Date | undefined, end: Date | undefined, source: string | null | undefined, logLevel: string | null | undefined, message: string | null | undefined): Observable<SystemLogVm>;
    create(command: CreateSystemLogsCommand): Observable<boolean>;
    getAllInTable(command: GetAllSystemLogs): Observable<SystemLogVm>;
}

@Injectable({
    providedIn: 'root'
})
export class SystemLogClient implements ISystemLogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, start: Date | undefined, end: Date | undefined, source: string | null | undefined, logLevel: string | null | undefined, message: string | null | undefined): Observable<SystemLogVm> {
        let url_ = this.baseUrl + "/system/SystemLog?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAsc === null)
            throw new Error("The parameter 'sortAsc' cannot be null.");
        else if (sortAsc !== undefined)
            url_ += "sortAsc=" + encodeURIComponent("" + sortAsc) + "&";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (source !== undefined && source !== null)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        if (logLevel !== undefined && logLevel !== null)
            url_ += "logLevel=" + encodeURIComponent("" + logLevel) + "&";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemLogVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemLogVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SystemLogVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemLogVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateSystemLogsCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/SystemLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllInTable(command: GetAllSystemLogs): Observable<SystemLogVm> {
        let url_ = this.baseUrl + "/system/SystemLog/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemLogVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemLogVm>;
        }));
    }

    protected processGetAllInTable(response: HttpResponseBase): Observable<SystemLogVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemLogVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITemplateFlowClient {
    getAllCategory(): Observable<CategoryListVm>;
    getAllInTable(command: GetAllTemplateFlow): Observable<TemplateFlowDto[]>;
    getAllTemplatePublish(command: GetAllTemplateFlowPublish): Observable<TemplateFlowPublishDto[]>;
    update(command: UpdateTemplateFlowCommand): Observable<boolean>;
    disable(request: DisableTemplateFlow): Observable<boolean>;
    clone(command: UseTemplateFlowCommand): Observable<CallFlowDto>;
    preview(command: PreviewTemplateFlow): Observable<PreviewTemplateDto>;
    delete(id: number): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class TemplateFlowClient implements ITemplateFlowClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllCategory(): Observable<CategoryListVm> {
        let url_ = this.baseUrl + "/system/TemplateFlow/category";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryListVm>;
        }));
    }

    protected processGetAllCategory(response: HttpResponseBase): Observable<CategoryListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllInTable(command: GetAllTemplateFlow): Observable<TemplateFlowDto[]> {
        let url_ = this.baseUrl + "/system/TemplateFlow/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateFlowDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateFlowDto[]>;
        }));
    }

    protected processGetAllInTable(response: HttpResponseBase): Observable<TemplateFlowDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateFlowDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllTemplatePublish(command: GetAllTemplateFlowPublish): Observable<TemplateFlowPublishDto[]> {
        let url_ = this.baseUrl + "/system/TemplateFlow/all-publish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTemplatePublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTemplatePublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateFlowPublishDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateFlowPublishDto[]>;
        }));
    }

    protected processGetAllTemplatePublish(response: HttpResponseBase): Observable<TemplateFlowPublishDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateFlowPublishDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(command: UpdateTemplateFlowCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/TemplateFlow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    disable(request: DisableTemplateFlow): Observable<boolean> {
        let url_ = this.baseUrl + "/system/TemplateFlow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDisable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clone(command: UseTemplateFlowCommand): Observable<CallFlowDto> {
        let url_ = this.baseUrl + "/system/TemplateFlow/clone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallFlowDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallFlowDto>;
        }));
    }

    protected processClone(response: HttpResponseBase): Observable<CallFlowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallFlowDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    preview(command: PreviewTemplateFlow): Observable<PreviewTemplateDto> {
        let url_ = this.baseUrl + "/system/TemplateFlow/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreviewTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreviewTemplateDto>;
        }));
    }

    protected processPreview(response: HttpResponseBase): Observable<PreviewTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreviewTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/system/TemplateFlow/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITraceLogClient {
    getAll(id: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, callId: string | null | undefined, searchText: string | null | undefined, fromNumber: string | null | undefined): Observable<CallLogListVm>;
    traceLog(command: InsertLogCommands): Observable<boolean>;
    getAllInTable(command: GetListCallLog): Observable<CallLogListVm>;
    getAllCallId(id: number | undefined): Observable<CallIdListVm>;
    getVariable(id: number | undefined): Observable<string>;
    deleteAll(flowId: string | null): Observable<boolean>;
    export(request: ExportLogCommands): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class TraceLogClient implements ITraceLogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(id: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, callId: string | null | undefined, searchText: string | null | undefined, fromNumber: string | null | undefined): Observable<CallLogListVm> {
        let url_ = this.baseUrl + "/system/TraceLog?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAsc === null)
            throw new Error("The parameter 'sortAsc' cannot be null.");
        else if (sortAsc !== undefined)
            url_ += "sortAsc=" + encodeURIComponent("" + sortAsc) + "&";
        if (callId !== undefined && callId !== null)
            url_ += "callId=" + encodeURIComponent("" + callId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (fromNumber !== undefined && fromNumber !== null)
            url_ += "fromNumber=" + encodeURIComponent("" + fromNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallLogListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallLogListVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CallLogListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallLogListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    traceLog(command: InsertLogCommands): Observable<boolean> {
        let url_ = this.baseUrl + "/system/TraceLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTraceLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTraceLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processTraceLog(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllInTable(command: GetListCallLog): Observable<CallLogListVm> {
        let url_ = this.baseUrl + "/system/TraceLog/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallLogListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallLogListVm>;
        }));
    }

    protected processGetAllInTable(response: HttpResponseBase): Observable<CallLogListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallLogListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllCallId(id: number | undefined): Observable<CallIdListVm> {
        let url_ = this.baseUrl + "/system/TraceLog/callId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCallId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCallId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallIdListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallIdListVm>;
        }));
    }

    protected processGetAllCallId(response: HttpResponseBase): Observable<CallIdListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallIdListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVariable(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/system/TraceLog/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVariable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVariable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetVariable(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAll(flowId: string | null): Observable<boolean> {
        let url_ = this.baseUrl + "/system/TraceLog/{flowId}";
        if (flowId === undefined || flowId === null)
            throw new Error("The parameter 'flowId' must be defined.");
        url_ = url_.replace("{flowId}", encodeURIComponent("" + flowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteAll(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    export(request: ExportLogCommands): Observable<string> {
        let url_ = this.baseUrl + "/system/TraceLog/exportlog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITranscribeClient {
    transcribe(service: ServiceTranscribe | undefined, audio: FileParameter | null | undefined, audioCaller: FileParameter | null | undefined, speakerList: string | null | undefined, isConversation: boolean | undefined, language: string | null | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class TranscribeClient implements ITranscribeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    transcribe(service: ServiceTranscribe | undefined, audio: FileParameter | null | undefined, audioCaller: FileParameter | null | undefined, speakerList: string | null | undefined, isConversation: boolean | undefined, language: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/system/Transcribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (service === null || service === undefined)
            throw new Error("The parameter 'service' cannot be null.");
        else
            content_.append("Service", service.toString());
        if (audio !== null && audio !== undefined)
            content_.append("Audio", audio.data, audio.fileName ? audio.fileName : "Audio");
        if (audioCaller !== null && audioCaller !== undefined)
            content_.append("AudioCaller", audioCaller.data, audioCaller.fileName ? audioCaller.fileName : "AudioCaller");
        if (speakerList !== null && speakerList !== undefined)
            content_.append("SpeakerList", speakerList.toString());
        if (isConversation === null || isConversation === undefined)
            throw new Error("The parameter 'isConversation' cannot be null.");
        else
            content_.append("IsConversation", isConversation.toString());
        if (language !== null && language !== undefined)
            content_.append("Language", language.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTranscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTranscribe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTranscribe(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITranslateClient {
    translate(command: TranslateCommand): Observable<string>;
    translateTest(command: TestTranslateCommand): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class TranslateClient implements ITranslateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    translate(command: TranslateCommand): Observable<string> {
        let url_ = this.baseUrl + "/system/Translate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTranslate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTranslate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTranslate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    translateTest(command: TestTranslateCommand): Observable<string> {
        let url_ = this.baseUrl + "/system/Translate/test";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTranslateTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTranslateTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTranslateTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITrunkClient {
    get(id: number): Observable<TrunkDetailVm>;
    getAll(): Observable<TrunkListVm>;
    delete(command: DeleteTrunkCommand): Observable<boolean>;
    update(command: UpdateTrunkCommand): Observable<ResponseValue>;
    getAllTrunk(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined, providerId: string | null | undefined): Observable<TrunkListVm>;
    getAllInTable(command: GetAllTrunkQuery): Observable<TrunkListVm>;
    getAllProvider(): Observable<TrunkProviderDto[]>;
    disable(command: DisableTrunkCommand): Observable<boolean>;
    reload(command: ReloadTrunkCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class TrunkClient implements ITrunkClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: number): Observable<TrunkDetailVm> {
        let url_ = this.baseUrl + "/system/Trunk/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrunkDetailVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrunkDetailVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TrunkDetailVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrunkDetailVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<TrunkListVm> {
        let url_ = this.baseUrl + "/system/Trunk";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrunkListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrunkListVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TrunkListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrunkListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(command: DeleteTrunkCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Trunk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(command: UpdateTrunkCommand): Observable<ResponseValue> {
        let url_ = this.baseUrl + "/system/Trunk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseValue>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseValue>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResponseValue> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseValue.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllTrunk(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortAsc: boolean | undefined, searchText: string | null | undefined, providerId: string | null | undefined): Observable<TrunkListVm> {
        let url_ = this.baseUrl + "/listTrunk?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAsc === null)
            throw new Error("The parameter 'sortAsc' cannot be null.");
        else if (sortAsc !== undefined)
            url_ += "sortAsc=" + encodeURIComponent("" + sortAsc) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (providerId !== undefined && providerId !== null)
            url_ += "ProviderId=" + encodeURIComponent("" + providerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrunk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrunk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrunkListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrunkListVm>;
        }));
    }

    protected processGetAllTrunk(response: HttpResponseBase): Observable<TrunkListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrunkListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllInTable(command: GetAllTrunkQuery): Observable<TrunkListVm> {
        let url_ = this.baseUrl + "/system/Trunk/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrunkListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrunkListVm>;
        }));
    }

    protected processGetAllInTable(response: HttpResponseBase): Observable<TrunkListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrunkListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllProvider(): Observable<TrunkProviderDto[]> {
        let url_ = this.baseUrl + "/system/Trunk/all-provider";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrunkProviderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrunkProviderDto[]>;
        }));
    }

    protected processGetAllProvider(response: HttpResponseBase): Observable<TrunkProviderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrunkProviderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    disable(command: DisableTrunkCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Trunk/disable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDisable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reload(command: ReloadTrunkCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/Trunk/reload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processReload(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserActionClient {
    getAll(): Observable<UserActionListVm>;
    create(command: CreateUserActionCommand): Observable<UserActionDto>;
    update(command: UpdateUserActionCommand): Observable<UserActionDto>;
    delete(id: number): Observable<boolean>;
    checkExitsUserActionName(command: CheckExitsUserActionCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class UserActionClient implements IUserActionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<UserActionListVm> {
        let url_ = this.baseUrl + "/system/UserAction";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserActionListVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserActionListVm>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserActionListVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserActionListVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateUserActionCommand): Observable<UserActionDto> {
        let url_ = this.baseUrl + "/system/UserAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserActionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserActionDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserActionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserActionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(command: UpdateUserActionCommand): Observable<UserActionDto> {
        let url_ = this.baseUrl + "/system/UserAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserActionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserActionDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserActionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserActionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/system/UserAction/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkExitsUserActionName(command: CheckExitsUserActionCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/UserAction/existUserAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExitsUserActionName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExitsUserActionName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckExitsUserActionName(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserClient {
    getUserAccount(): Observable<UserInformation>;
    updateUserAccount(command: UpdateUserInformationCommand): Observable<boolean>;
    getUserAccountSetting(): Observable<UserSettingDto>;
    updateUserAccountSetting(command: UpdateUserSettingCommand): Observable<boolean>;
    changePassword(command: ChangePasswordCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class UserClient implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUserAccount(): Observable<UserInformation> {
        let url_ = this.baseUrl + "/system/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInformation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInformation>;
        }));
    }

    protected processGetUserAccount(response: HttpResponseBase): Observable<UserInformation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInformation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserAccount(command: UpdateUserInformationCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateUserAccount(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserAccountSetting(): Observable<UserSettingDto> {
        let url_ = this.baseUrl + "/system/User/setting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAccountSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAccountSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSettingDto>;
        }));
    }

    protected processGetUserAccountSetting(response: HttpResponseBase): Observable<UserSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserAccountSetting(command: UpdateUserSettingCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/User/setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserAccountSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserAccountSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateUserAccountSetting(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changePassword(command: ChangePasswordCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/User/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVoiceMailClient {
    getVoiceMailList(query: GetVoiceMailListQuery): Observable<VoiceMailListVm2>;
    getVoiceMailDetail(id: number): Observable<VoiceMailDetailVm>;
    exportVoicemail(command: ExportVoicemailCommand): Observable<string>;
    updateVoicemailStatus(command: UpdateVoicemailStatusCommand): Observable<boolean>;
    updateVoicemailTranscription(command: UpdateVoicemailTranscriptionCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class VoiceMailClient implements IVoiceMailClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getVoiceMailList(query: GetVoiceMailListQuery): Observable<VoiceMailListVm2> {
        let url_ = this.baseUrl + "/system/VoiceMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoiceMailList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoiceMailList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoiceMailListVm2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoiceMailListVm2>;
        }));
    }

    protected processGetVoiceMailList(response: HttpResponseBase): Observable<VoiceMailListVm2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoiceMailListVm2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVoiceMailDetail(id: number): Observable<VoiceMailDetailVm> {
        let url_ = this.baseUrl + "/system/VoiceMail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoiceMailDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoiceMailDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoiceMailDetailVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoiceMailDetailVm>;
        }));
    }

    protected processGetVoiceMailDetail(response: HttpResponseBase): Observable<VoiceMailDetailVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoiceMailDetailVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportVoicemail(command: ExportVoicemailCommand): Observable<string> {
        let url_ = this.baseUrl + "/system/VoiceMail/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportVoicemail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportVoicemail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportVoicemail(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateVoicemailStatus(command: UpdateVoicemailStatusCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/VoiceMail/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVoicemailStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVoicemailStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateVoicemailStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateVoicemailTranscription(command: UpdateVoicemailTranscriptionCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/system/VoiceMail/transcription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVoicemailTranscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVoicemailTranscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateVoicemailTranscription(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ActivityLogVm implements IActivityLogVm {
    activityLogs?: ActivityLogDto[] | undefined;
    page?: Page | undefined;

    constructor(data?: IActivityLogVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activityLogs"])) {
                this.activityLogs = [] as any;
                for (let item of _data["activityLogs"])
                    this.activityLogs!.push(ActivityLogDto.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityLogVm {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activityLogs)) {
            data["activityLogs"] = [];
            for (let item of this.activityLogs)
                data["activityLogs"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface IActivityLogVm {
    activityLogs?: ActivityLogDto[] | undefined;
    page?: Page | undefined;
}

export class ActivityLogDto implements IActivityLogDto {
    id?: number;
    method?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    remoteIp?: string | undefined;
    request?: string | undefined;
    companyId?: number;
    requestName?: string | undefined;
    response?: string | undefined;
    status?: string | undefined;
    created?: Date;

    constructor(data?: IActivityLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.method = _data["method"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.remoteIp = _data["remoteIp"];
            this.request = _data["request"];
            this.companyId = _data["companyId"];
            this.requestName = _data["requestName"];
            this.response = _data["response"];
            this.status = _data["status"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["method"] = this.method;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["remoteIp"] = this.remoteIp;
        data["request"] = this.request;
        data["companyId"] = this.companyId;
        data["requestName"] = this.requestName;
        data["response"] = this.response;
        data["status"] = this.status;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IActivityLogDto {
    id?: number;
    method?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    remoteIp?: string | undefined;
    request?: string | undefined;
    companyId?: number;
    requestName?: string | undefined;
    response?: string | undefined;
    status?: string | undefined;
    created?: Date;
}

export class Page implements IPage {
    size?: number;
    totalElements?: number;
    totalPages?: number;
    pageNumber?: number;
    sortBy?: string | undefined;
    sortAsc?: boolean;

    constructor(data?: IPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.size = _data["size"];
            this.totalElements = _data["totalElements"];
            this.totalPages = _data["totalPages"];
            this.pageNumber = _data["pageNumber"];
            this.sortBy = _data["sortBy"];
            this.sortAsc = _data["sortAsc"];
        }
    }

    static fromJS(data: any): Page {
        data = typeof data === 'object' ? data : {};
        let result = new Page();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["size"] = this.size;
        data["totalElements"] = this.totalElements;
        data["totalPages"] = this.totalPages;
        data["pageNumber"] = this.pageNumber;
        data["sortBy"] = this.sortBy;
        data["sortAsc"] = this.sortAsc;
        return data;
    }
}

export interface IPage {
    size?: number;
    totalElements?: number;
    totalPages?: number;
    pageNumber?: number;
    sortBy?: string | undefined;
    sortAsc?: boolean;
}

export class GetAllActivityLogs implements IGetAllActivityLogs {
    page?: Page | undefined;
    start?: Date;
    end?: Date;
    company?: string | undefined;
    userName?: string | undefined;
    requestBody?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetAllActivityLogs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.company = _data["company"];
            this.userName = _data["userName"];
            this.requestBody = _data["requestBody"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllActivityLogs {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllActivityLogs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["company"] = this.company;
        data["userName"] = this.userName;
        data["requestBody"] = this.requestBody;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllActivityLogs {
    page?: Page | undefined;
    start?: Date;
    end?: Date;
    company?: string | undefined;
    userName?: string | undefined;
    requestBody?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class FilterData implements IFilterData {
    prop?: string | undefined;
    value?: string | undefined;
    filter?: string | undefined;
    type?: string | undefined;

    constructor(data?: IFilterData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prop = _data["prop"];
            this.value = _data["value"];
            this.filter = _data["filter"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): FilterData {
        data = typeof data === 'object' ? data : {};
        let result = new FilterData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prop"] = this.prop;
        data["value"] = this.value;
        data["filter"] = this.filter;
        data["type"] = this.type;
        return data;
    }
}

export interface IFilterData {
    prop?: string | undefined;
    value?: string | undefined;
    filter?: string | undefined;
    type?: string | undefined;
}

export class CreateActivityLogsCommand implements ICreateActivityLogsCommand {
    method?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    request?: string | undefined;
    requestName?: string | undefined;
    response?: string | undefined;
    status?: string | undefined;
    remoteIP?: string | undefined;

    constructor(data?: ICreateActivityLogsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.method = _data["method"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.request = _data["request"];
            this.requestName = _data["requestName"];
            this.response = _data["response"];
            this.status = _data["status"];
            this.remoteIP = _data["remoteIP"];
        }
    }

    static fromJS(data: any): CreateActivityLogsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityLogsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["request"] = this.request;
        data["requestName"] = this.requestName;
        data["response"] = this.response;
        data["status"] = this.status;
        data["remoteIP"] = this.remoteIP;
        return data;
    }
}

export interface ICreateActivityLogsCommand {
    method?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    request?: string | undefined;
    requestName?: string | undefined;
    response?: string | undefined;
    status?: string | undefined;
    remoteIP?: string | undefined;
}

export class AgentsListVm implements IAgentsListVm {
    agents?: AgentLookupDto[] | undefined;
    page?: Page | undefined;

    constructor(data?: IAgentsListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(AgentLookupDto.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AgentsListVm {
        data = typeof data === 'object' ? data : {};
        let result = new AgentsListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAgentsListVm {
    agents?: AgentLookupDto[] | undefined;
    page?: Page | undefined;
}

export class AgentLookupDto implements IAgentLookupDto {
    id?: number;
    fullName?: string | undefined;
    avatar?: string | undefined;
    extension?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    queueId?: number;
    listQueue?: string | undefined;
    disable?: boolean;
    isOnline?: boolean;

    constructor(data?: IAgentLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.avatar = _data["avatar"];
            this.extension = _data["extension"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.queueId = _data["queueId"];
            this.listQueue = _data["listQueue"];
            this.disable = _data["disable"];
            this.isOnline = _data["isOnline"];
        }
    }

    static fromJS(data: any): AgentLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["avatar"] = this.avatar;
        data["extension"] = this.extension;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["queueId"] = this.queueId;
        data["listQueue"] = this.listQueue;
        data["disable"] = this.disable;
        data["isOnline"] = this.isOnline;
        return data;
    }
}

export interface IAgentLookupDto {
    id?: number;
    fullName?: string | undefined;
    avatar?: string | undefined;
    extension?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    queueId?: number;
    listQueue?: string | undefined;
    disable?: boolean;
    isOnline?: boolean;
}

export class GetAgentsListQuery implements IGetAgentsListQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    queueId?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetAgentsListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.searchText = _data["searchText"];
            this.queueId = _data["queueId"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAgentsListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgentsListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["searchText"] = this.searchText;
        data["queueId"] = this.queueId;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAgentsListQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    queueId?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class AgentDetailVm implements IAgentDetailVm {
    agent?: AgentDto | undefined;
    userName?: string | undefined;

    constructor(data?: IAgentDetailVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agent = _data["agent"] ? AgentDto.fromJS(_data["agent"]) : <any>undefined;
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): AgentDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IAgentDetailVm {
    agent?: AgentDto | undefined;
    userName?: string | undefined;
}

export class AgentDto implements IAgentDto {
    id?: number;
    fullName?: string | undefined;
    avatar?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    extension?: string | undefined;
    enableOutCalling?: boolean;
    followMe?: boolean;
    agentType?: string | undefined;
    sipType?: string | undefined;
    email?: string | undefined;
    dob?: Date | undefined;
    phoneNumber?: string | undefined;
    userId?: string | undefined;
    listQueueAgentIn?: string | undefined;
    agentInQueues?: AgentInQueue[] | undefined;
    disable?: boolean;
    isOnline?: boolean;

    constructor(data?: IAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.avatar = _data["avatar"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.extension = _data["extension"];
            this.enableOutCalling = _data["enableOutCalling"];
            this.followMe = _data["followMe"];
            this.agentType = _data["agentType"];
            this.sipType = _data["sipType"];
            this.email = _data["email"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.userId = _data["userId"];
            this.listQueueAgentIn = _data["listQueueAgentIn"];
            if (Array.isArray(_data["agentInQueues"])) {
                this.agentInQueues = [] as any;
                for (let item of _data["agentInQueues"])
                    this.agentInQueues!.push(AgentInQueue.fromJS(item));
            }
            this.disable = _data["disable"];
            this.isOnline = _data["isOnline"];
        }
    }

    static fromJS(data: any): AgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["avatar"] = this.avatar;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["extension"] = this.extension;
        data["enableOutCalling"] = this.enableOutCalling;
        data["followMe"] = this.followMe;
        data["agentType"] = this.agentType;
        data["sipType"] = this.sipType;
        data["email"] = this.email;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["userId"] = this.userId;
        data["listQueueAgentIn"] = this.listQueueAgentIn;
        if (Array.isArray(this.agentInQueues)) {
            data["agentInQueues"] = [];
            for (let item of this.agentInQueues)
                data["agentInQueues"].push(item.toJSON());
        }
        data["disable"] = this.disable;
        data["isOnline"] = this.isOnline;
        return data;
    }
}

export interface IAgentDto {
    id?: number;
    fullName?: string | undefined;
    avatar?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    extension?: string | undefined;
    enableOutCalling?: boolean;
    followMe?: boolean;
    agentType?: string | undefined;
    sipType?: string | undefined;
    email?: string | undefined;
    dob?: Date | undefined;
    phoneNumber?: string | undefined;
    userId?: string | undefined;
    listQueueAgentIn?: string | undefined;
    agentInQueues?: AgentInQueue[] | undefined;
    disable?: boolean;
    isOnline?: boolean;
}

export abstract class AuditableEntity implements IAuditableEntity {
    createdBy?: string | undefined;
    created?: Date;
    lastModifiedBy?: string | undefined;
    lastModified?: Date | undefined;

    constructor(data?: IAuditableEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuditableEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AuditableEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuditableEntity {
    createdBy?: string | undefined;
    created?: Date;
    lastModifiedBy?: string | undefined;
    lastModified?: Date | undefined;
}

export class AgentInQueue extends AuditableEntity implements IAgentInQueue {
    agentId?: number;
    agent?: Agent | undefined;
    queueId?: number;
    queue?: Queue | undefined;
    priority?: boolean;
    delete?: boolean;
    isPaused?: boolean;

    constructor(data?: IAgentInQueue) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : <any>undefined;
            this.queueId = _data["queueId"];
            this.queue = _data["queue"] ? Queue.fromJS(_data["queue"]) : <any>undefined;
            this.priority = _data["priority"];
            this.delete = _data["delete"];
            this.isPaused = _data["isPaused"];
        }
    }

    static override fromJS(data: any): AgentInQueue {
        data = typeof data === 'object' ? data : {};
        let result = new AgentInQueue();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["queueId"] = this.queueId;
        data["queue"] = this.queue ? this.queue.toJSON() : <any>undefined;
        data["priority"] = this.priority;
        data["delete"] = this.delete;
        data["isPaused"] = this.isPaused;
        super.toJSON(data);
        return data;
    }
}

export interface IAgentInQueue extends IAuditableEntity {
    agentId?: number;
    agent?: Agent | undefined;
    queueId?: number;
    queue?: Queue | undefined;
    priority?: boolean;
    delete?: boolean;
    isPaused?: boolean;
}

export class Agent extends AuditableEntity implements IAgent {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    dob?: Date | undefined;
    avatar?: string | undefined;
    extension?: string | undefined;
    company?: Company | undefined;
    userId?: string | undefined;
    agentInQueues?: AgentInQueue[] | undefined;
    disable?: boolean;
    isOnline?: boolean;
    enableOutCalling?: boolean;
    followMe?: boolean;
    agentType?: string | undefined;
    sipType?: string | undefined;

    constructor(data?: IAgent) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.avatar = _data["avatar"];
            this.extension = _data["extension"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.userId = _data["userId"];
            if (Array.isArray(_data["agentInQueues"])) {
                this.agentInQueues = [] as any;
                for (let item of _data["agentInQueues"])
                    this.agentInQueues!.push(AgentInQueue.fromJS(item));
            }
            this.disable = _data["disable"];
            this.isOnline = _data["isOnline"];
            this.enableOutCalling = _data["enableOutCalling"];
            this.followMe = _data["followMe"];
            this.agentType = _data["agentType"];
            this.sipType = _data["sipType"];
        }
    }

    static override fromJS(data: any): Agent {
        data = typeof data === 'object' ? data : {};
        let result = new Agent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["avatar"] = this.avatar;
        data["extension"] = this.extension;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        if (Array.isArray(this.agentInQueues)) {
            data["agentInQueues"] = [];
            for (let item of this.agentInQueues)
                data["agentInQueues"].push(item.toJSON());
        }
        data["disable"] = this.disable;
        data["isOnline"] = this.isOnline;
        data["enableOutCalling"] = this.enableOutCalling;
        data["followMe"] = this.followMe;
        data["agentType"] = this.agentType;
        data["sipType"] = this.sipType;
        super.toJSON(data);
        return data;
    }
}

export interface IAgent extends IAuditableEntity {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    dob?: Date | undefined;
    avatar?: string | undefined;
    extension?: string | undefined;
    company?: Company | undefined;
    userId?: string | undefined;
    agentInQueues?: AgentInQueue[] | undefined;
    disable?: boolean;
    isOnline?: boolean;
    enableOutCalling?: boolean;
    followMe?: boolean;
    agentType?: string | undefined;
    sipType?: string | undefined;
}

export class Company extends AuditableEntity implements ICompany {
    id?: number;
    name?: string | undefined;
    address?: string | undefined;
    costs?: Cost[] | undefined;
    agents?: Agent[] | undefined;
    billingsJob?: BillingJob[] | undefined;
    callFlows?: CallFlow[] | undefined;
    queues?: Queue[] | undefined;
    phoneNumbers?: PhoneNumber[] | undefined;
    audios?: Audio[] | undefined;
    functions?: CustomFunctions[] | undefined;
    audioLanguages?: AudioLanguage[] | undefined;
    callSettings?: CallSetting[] | undefined;
    grammars?: Grammar[] | undefined;
    traceLogs?: TraceLog[] | undefined;
    userActions?: UserAction[] | undefined;
    datasets?: Dataset[] | undefined;
    chatGPTs?: ChatGPT[] | undefined;
    activityLogs?: ActivityLog[] | undefined;
    callerResponseTrains?: CallerResponseTrain[] | undefined;
    emailReports?: EmailReport[] | undefined;
    emailTemplates?: EmailTemplate[] | undefined;
    cmSs?: CMS[] | undefined;
    templateFlows?: TemplateFlow[] | undefined;
    disable?: boolean;
    delete?: boolean;

    constructor(data?: ICompany) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            if (Array.isArray(_data["costs"])) {
                this.costs = [] as any;
                for (let item of _data["costs"])
                    this.costs!.push(Cost.fromJS(item));
            }
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(Agent.fromJS(item));
            }
            if (Array.isArray(_data["billingsJob"])) {
                this.billingsJob = [] as any;
                for (let item of _data["billingsJob"])
                    this.billingsJob!.push(BillingJob.fromJS(item));
            }
            if (Array.isArray(_data["callFlows"])) {
                this.callFlows = [] as any;
                for (let item of _data["callFlows"])
                    this.callFlows!.push(CallFlow.fromJS(item));
            }
            if (Array.isArray(_data["queues"])) {
                this.queues = [] as any;
                for (let item of _data["queues"])
                    this.queues!.push(Queue.fromJS(item));
            }
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(PhoneNumber.fromJS(item));
            }
            if (Array.isArray(_data["audios"])) {
                this.audios = [] as any;
                for (let item of _data["audios"])
                    this.audios!.push(Audio.fromJS(item));
            }
            if (Array.isArray(_data["functions"])) {
                this.functions = [] as any;
                for (let item of _data["functions"])
                    this.functions!.push(CustomFunctions.fromJS(item));
            }
            if (Array.isArray(_data["audioLanguages"])) {
                this.audioLanguages = [] as any;
                for (let item of _data["audioLanguages"])
                    this.audioLanguages!.push(AudioLanguage.fromJS(item));
            }
            if (Array.isArray(_data["callSettings"])) {
                this.callSettings = [] as any;
                for (let item of _data["callSettings"])
                    this.callSettings!.push(CallSetting.fromJS(item));
            }
            if (Array.isArray(_data["grammars"])) {
                this.grammars = [] as any;
                for (let item of _data["grammars"])
                    this.grammars!.push(Grammar.fromJS(item));
            }
            if (Array.isArray(_data["traceLogs"])) {
                this.traceLogs = [] as any;
                for (let item of _data["traceLogs"])
                    this.traceLogs!.push(TraceLog.fromJS(item));
            }
            if (Array.isArray(_data["userActions"])) {
                this.userActions = [] as any;
                for (let item of _data["userActions"])
                    this.userActions!.push(UserAction.fromJS(item));
            }
            if (Array.isArray(_data["datasets"])) {
                this.datasets = [] as any;
                for (let item of _data["datasets"])
                    this.datasets!.push(Dataset.fromJS(item));
            }
            if (Array.isArray(_data["chatGPTs"])) {
                this.chatGPTs = [] as any;
                for (let item of _data["chatGPTs"])
                    this.chatGPTs!.push(ChatGPT.fromJS(item));
            }
            if (Array.isArray(_data["activityLogs"])) {
                this.activityLogs = [] as any;
                for (let item of _data["activityLogs"])
                    this.activityLogs!.push(ActivityLog.fromJS(item));
            }
            if (Array.isArray(_data["callerResponseTrains"])) {
                this.callerResponseTrains = [] as any;
                for (let item of _data["callerResponseTrains"])
                    this.callerResponseTrains!.push(CallerResponseTrain.fromJS(item));
            }
            if (Array.isArray(_data["emailReports"])) {
                this.emailReports = [] as any;
                for (let item of _data["emailReports"])
                    this.emailReports!.push(EmailReport.fromJS(item));
            }
            if (Array.isArray(_data["emailTemplates"])) {
                this.emailTemplates = [] as any;
                for (let item of _data["emailTemplates"])
                    this.emailTemplates!.push(EmailTemplate.fromJS(item));
            }
            if (Array.isArray(_data["cmSs"])) {
                this.cmSs = [] as any;
                for (let item of _data["cmSs"])
                    this.cmSs!.push(CMS.fromJS(item));
            }
            if (Array.isArray(_data["templateFlows"])) {
                this.templateFlows = [] as any;
                for (let item of _data["templateFlows"])
                    this.templateFlows!.push(TemplateFlow.fromJS(item));
            }
            this.disable = _data["disable"];
            this.delete = _data["delete"];
        }
    }

    static override fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        if (Array.isArray(this.costs)) {
            data["costs"] = [];
            for (let item of this.costs)
                data["costs"].push(item.toJSON());
        }
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        if (Array.isArray(this.billingsJob)) {
            data["billingsJob"] = [];
            for (let item of this.billingsJob)
                data["billingsJob"].push(item.toJSON());
        }
        if (Array.isArray(this.callFlows)) {
            data["callFlows"] = [];
            for (let item of this.callFlows)
                data["callFlows"].push(item.toJSON());
        }
        if (Array.isArray(this.queues)) {
            data["queues"] = [];
            for (let item of this.queues)
                data["queues"].push(item.toJSON());
        }
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.audios)) {
            data["audios"] = [];
            for (let item of this.audios)
                data["audios"].push(item.toJSON());
        }
        if (Array.isArray(this.functions)) {
            data["functions"] = [];
            for (let item of this.functions)
                data["functions"].push(item.toJSON());
        }
        if (Array.isArray(this.audioLanguages)) {
            data["audioLanguages"] = [];
            for (let item of this.audioLanguages)
                data["audioLanguages"].push(item.toJSON());
        }
        if (Array.isArray(this.callSettings)) {
            data["callSettings"] = [];
            for (let item of this.callSettings)
                data["callSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.grammars)) {
            data["grammars"] = [];
            for (let item of this.grammars)
                data["grammars"].push(item.toJSON());
        }
        if (Array.isArray(this.traceLogs)) {
            data["traceLogs"] = [];
            for (let item of this.traceLogs)
                data["traceLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.userActions)) {
            data["userActions"] = [];
            for (let item of this.userActions)
                data["userActions"].push(item.toJSON());
        }
        if (Array.isArray(this.datasets)) {
            data["datasets"] = [];
            for (let item of this.datasets)
                data["datasets"].push(item.toJSON());
        }
        if (Array.isArray(this.chatGPTs)) {
            data["chatGPTs"] = [];
            for (let item of this.chatGPTs)
                data["chatGPTs"].push(item.toJSON());
        }
        if (Array.isArray(this.activityLogs)) {
            data["activityLogs"] = [];
            for (let item of this.activityLogs)
                data["activityLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.callerResponseTrains)) {
            data["callerResponseTrains"] = [];
            for (let item of this.callerResponseTrains)
                data["callerResponseTrains"].push(item.toJSON());
        }
        if (Array.isArray(this.emailReports)) {
            data["emailReports"] = [];
            for (let item of this.emailReports)
                data["emailReports"].push(item.toJSON());
        }
        if (Array.isArray(this.emailTemplates)) {
            data["emailTemplates"] = [];
            for (let item of this.emailTemplates)
                data["emailTemplates"].push(item.toJSON());
        }
        if (Array.isArray(this.cmSs)) {
            data["cmSs"] = [];
            for (let item of this.cmSs)
                data["cmSs"].push(item.toJSON());
        }
        if (Array.isArray(this.templateFlows)) {
            data["templateFlows"] = [];
            for (let item of this.templateFlows)
                data["templateFlows"].push(item.toJSON());
        }
        data["disable"] = this.disable;
        data["delete"] = this.delete;
        super.toJSON(data);
        return data;
    }
}

export interface ICompany extends IAuditableEntity {
    id?: number;
    name?: string | undefined;
    address?: string | undefined;
    costs?: Cost[] | undefined;
    agents?: Agent[] | undefined;
    billingsJob?: BillingJob[] | undefined;
    callFlows?: CallFlow[] | undefined;
    queues?: Queue[] | undefined;
    phoneNumbers?: PhoneNumber[] | undefined;
    audios?: Audio[] | undefined;
    functions?: CustomFunctions[] | undefined;
    audioLanguages?: AudioLanguage[] | undefined;
    callSettings?: CallSetting[] | undefined;
    grammars?: Grammar[] | undefined;
    traceLogs?: TraceLog[] | undefined;
    userActions?: UserAction[] | undefined;
    datasets?: Dataset[] | undefined;
    chatGPTs?: ChatGPT[] | undefined;
    activityLogs?: ActivityLog[] | undefined;
    callerResponseTrains?: CallerResponseTrain[] | undefined;
    emailReports?: EmailReport[] | undefined;
    emailTemplates?: EmailTemplate[] | undefined;
    cmSs?: CMS[] | undefined;
    templateFlows?: TemplateFlow[] | undefined;
    disable?: boolean;
    delete?: boolean;
}

export class Cost extends AuditableEntity implements ICost {
    id?: number;
    monthYear?: string | undefined;
    monthlyFlatCost?: number;
    perMinuteCost?: number;
    storageCost?: number;
    extensionCost?: number;
    tax?: number;
    sendStatus?: boolean;
    invoice?: Invoice | undefined;
    company?: Company | undefined;

    constructor(data?: ICost) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.monthYear = _data["monthYear"];
            this.monthlyFlatCost = _data["monthlyFlatCost"];
            this.perMinuteCost = _data["perMinuteCost"];
            this.storageCost = _data["storageCost"];
            this.extensionCost = _data["extensionCost"];
            this.tax = _data["tax"];
            this.sendStatus = _data["sendStatus"];
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): Cost {
        data = typeof data === 'object' ? data : {};
        let result = new Cost();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["monthYear"] = this.monthYear;
        data["monthlyFlatCost"] = this.monthlyFlatCost;
        data["perMinuteCost"] = this.perMinuteCost;
        data["storageCost"] = this.storageCost;
        data["extensionCost"] = this.extensionCost;
        data["tax"] = this.tax;
        data["sendStatus"] = this.sendStatus;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICost extends IAuditableEntity {
    id?: number;
    monthYear?: string | undefined;
    monthlyFlatCost?: number;
    perMinuteCost?: number;
    storageCost?: number;
    extensionCost?: number;
    tax?: number;
    sendStatus?: boolean;
    invoice?: Invoice | undefined;
    company?: Company | undefined;
}

export class Invoice extends AuditableEntity implements IInvoice {
    id?: number;
    extensionTotal?: number;
    storageTotal?: number;
    didTotal?: number;
    perMinuteTotal?: number;
    monthlyFlatCostAmount?: number;
    extensionAmount?: number;
    storageAmount?: number;
    didAmount?: number;
    perMinuteAmount?: number;
    subTotal?: number;
    taxAmount?: number;
    total?: number;
    paid?: number;
    sendStatus?: boolean;
    dueDate?: Date;
    cost?: Cost | undefined;
    costId?: number;

    constructor(data?: IInvoice) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.extensionTotal = _data["extensionTotal"];
            this.storageTotal = _data["storageTotal"];
            this.didTotal = _data["didTotal"];
            this.perMinuteTotal = _data["perMinuteTotal"];
            this.monthlyFlatCostAmount = _data["monthlyFlatCostAmount"];
            this.extensionAmount = _data["extensionAmount"];
            this.storageAmount = _data["storageAmount"];
            this.didAmount = _data["didAmount"];
            this.perMinuteAmount = _data["perMinuteAmount"];
            this.subTotal = _data["subTotal"];
            this.taxAmount = _data["taxAmount"];
            this.total = _data["total"];
            this.paid = _data["paid"];
            this.sendStatus = _data["sendStatus"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.cost = _data["cost"] ? Cost.fromJS(_data["cost"]) : <any>undefined;
            this.costId = _data["costId"];
        }
    }

    static override fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["extensionTotal"] = this.extensionTotal;
        data["storageTotal"] = this.storageTotal;
        data["didTotal"] = this.didTotal;
        data["perMinuteTotal"] = this.perMinuteTotal;
        data["monthlyFlatCostAmount"] = this.monthlyFlatCostAmount;
        data["extensionAmount"] = this.extensionAmount;
        data["storageAmount"] = this.storageAmount;
        data["didAmount"] = this.didAmount;
        data["perMinuteAmount"] = this.perMinuteAmount;
        data["subTotal"] = this.subTotal;
        data["taxAmount"] = this.taxAmount;
        data["total"] = this.total;
        data["paid"] = this.paid;
        data["sendStatus"] = this.sendStatus;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["cost"] = this.cost ? this.cost.toJSON() : <any>undefined;
        data["costId"] = this.costId;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoice extends IAuditableEntity {
    id?: number;
    extensionTotal?: number;
    storageTotal?: number;
    didTotal?: number;
    perMinuteTotal?: number;
    monthlyFlatCostAmount?: number;
    extensionAmount?: number;
    storageAmount?: number;
    didAmount?: number;
    perMinuteAmount?: number;
    subTotal?: number;
    taxAmount?: number;
    total?: number;
    paid?: number;
    sendStatus?: boolean;
    dueDate?: Date;
    cost?: Cost | undefined;
    costId?: number;
}

export class BillingJob extends AuditableEntity implements IBillingJob {
    id?: number;
    monthYear?: string | undefined;
    extensionTotal?: number;
    storageTotal?: number;
    didTotal?: string | undefined;
    perMinuteTotal?: number;
    company?: Company | undefined;

    constructor(data?: IBillingJob) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.monthYear = _data["monthYear"];
            this.extensionTotal = _data["extensionTotal"];
            this.storageTotal = _data["storageTotal"];
            this.didTotal = _data["didTotal"];
            this.perMinuteTotal = _data["perMinuteTotal"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): BillingJob {
        data = typeof data === 'object' ? data : {};
        let result = new BillingJob();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["monthYear"] = this.monthYear;
        data["extensionTotal"] = this.extensionTotal;
        data["storageTotal"] = this.storageTotal;
        data["didTotal"] = this.didTotal;
        data["perMinuteTotal"] = this.perMinuteTotal;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBillingJob extends IAuditableEntity {
    id?: number;
    monthYear?: string | undefined;
    extensionTotal?: number;
    storageTotal?: number;
    didTotal?: string | undefined;
    perMinuteTotal?: number;
    company?: Company | undefined;
}

export class CallFlow extends AuditableEntity implements ICallFlow {
    id?: number | undefined;
    name?: string | undefined;
    attribute?: string | undefined;
    data?: string | undefined;
    jsonFormat?: string | undefined;
    company?: Company | undefined;
    isSubFlow?: boolean;
    designedBy?: string | undefined;
    lastPublishedBy?: string | undefined;
    lastPublished?: Date | undefined;
    tags?: string | undefined;
    phoneNumbers?: PhoneNumber[] | undefined;
    traceLogs?: TraceLog[] | undefined;
    callerResponseTrains?: CallerResponseTrain[] | undefined;
    drafts?: Draft[] | undefined;
    callSettings?: CallSetting[] | undefined;
    callDatas?: CallData[] | undefined;
    templateFlows?: TemplateFlow[] | undefined;
    delete?: boolean;
    disable?: boolean;
    defaultAgent?: boolean;

    constructor(data?: ICallFlow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.attribute = _data["attribute"];
            this.data = _data["data"];
            this.jsonFormat = _data["jsonFormat"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.isSubFlow = _data["isSubFlow"];
            this.designedBy = _data["designedBy"];
            this.lastPublishedBy = _data["lastPublishedBy"];
            this.lastPublished = _data["lastPublished"] ? new Date(_data["lastPublished"].toString()) : <any>undefined;
            this.tags = _data["tags"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(PhoneNumber.fromJS(item));
            }
            if (Array.isArray(_data["traceLogs"])) {
                this.traceLogs = [] as any;
                for (let item of _data["traceLogs"])
                    this.traceLogs!.push(TraceLog.fromJS(item));
            }
            if (Array.isArray(_data["callerResponseTrains"])) {
                this.callerResponseTrains = [] as any;
                for (let item of _data["callerResponseTrains"])
                    this.callerResponseTrains!.push(CallerResponseTrain.fromJS(item));
            }
            if (Array.isArray(_data["drafts"])) {
                this.drafts = [] as any;
                for (let item of _data["drafts"])
                    this.drafts!.push(Draft.fromJS(item));
            }
            if (Array.isArray(_data["callSettings"])) {
                this.callSettings = [] as any;
                for (let item of _data["callSettings"])
                    this.callSettings!.push(CallSetting.fromJS(item));
            }
            if (Array.isArray(_data["callDatas"])) {
                this.callDatas = [] as any;
                for (let item of _data["callDatas"])
                    this.callDatas!.push(CallData.fromJS(item));
            }
            if (Array.isArray(_data["templateFlows"])) {
                this.templateFlows = [] as any;
                for (let item of _data["templateFlows"])
                    this.templateFlows!.push(TemplateFlow.fromJS(item));
            }
            this.delete = _data["delete"];
            this.disable = _data["disable"];
            this.defaultAgent = _data["defaultAgent"];
        }
    }

    static override fromJS(data: any): CallFlow {
        data = typeof data === 'object' ? data : {};
        let result = new CallFlow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["attribute"] = this.attribute;
        data["data"] = this.data;
        data["jsonFormat"] = this.jsonFormat;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["isSubFlow"] = this.isSubFlow;
        data["designedBy"] = this.designedBy;
        data["lastPublishedBy"] = this.lastPublishedBy;
        data["lastPublished"] = this.lastPublished ? this.lastPublished.toISOString() : <any>undefined;
        data["tags"] = this.tags;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.traceLogs)) {
            data["traceLogs"] = [];
            for (let item of this.traceLogs)
                data["traceLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.callerResponseTrains)) {
            data["callerResponseTrains"] = [];
            for (let item of this.callerResponseTrains)
                data["callerResponseTrains"].push(item.toJSON());
        }
        if (Array.isArray(this.drafts)) {
            data["drafts"] = [];
            for (let item of this.drafts)
                data["drafts"].push(item.toJSON());
        }
        if (Array.isArray(this.callSettings)) {
            data["callSettings"] = [];
            for (let item of this.callSettings)
                data["callSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.callDatas)) {
            data["callDatas"] = [];
            for (let item of this.callDatas)
                data["callDatas"].push(item.toJSON());
        }
        if (Array.isArray(this.templateFlows)) {
            data["templateFlows"] = [];
            for (let item of this.templateFlows)
                data["templateFlows"].push(item.toJSON());
        }
        data["delete"] = this.delete;
        data["disable"] = this.disable;
        data["defaultAgent"] = this.defaultAgent;
        super.toJSON(data);
        return data;
    }
}

export interface ICallFlow extends IAuditableEntity {
    id?: number | undefined;
    name?: string | undefined;
    attribute?: string | undefined;
    data?: string | undefined;
    jsonFormat?: string | undefined;
    company?: Company | undefined;
    isSubFlow?: boolean;
    designedBy?: string | undefined;
    lastPublishedBy?: string | undefined;
    lastPublished?: Date | undefined;
    tags?: string | undefined;
    phoneNumbers?: PhoneNumber[] | undefined;
    traceLogs?: TraceLog[] | undefined;
    callerResponseTrains?: CallerResponseTrain[] | undefined;
    drafts?: Draft[] | undefined;
    callSettings?: CallSetting[] | undefined;
    callDatas?: CallData[] | undefined;
    templateFlows?: TemplateFlow[] | undefined;
    delete?: boolean;
    disable?: boolean;
    defaultAgent?: boolean;
}

export class PhoneNumber extends AuditableEntity implements IPhoneNumber {
    id?: number;
    patternMatching?: string | undefined;
    number?: string | undefined;
    price?: number;
    company?: Company | undefined;
    callFlow?: CallFlow | undefined;
    trunk?: Trunk | undefined;
    disAllow?: boolean;
    delete?: boolean;
    disable?: boolean;

    constructor(data?: IPhoneNumber) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.patternMatching = _data["patternMatching"];
            this.number = _data["number"];
            this.price = _data["price"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.callFlow = _data["callFlow"] ? CallFlow.fromJS(_data["callFlow"]) : <any>undefined;
            this.trunk = _data["trunk"] ? Trunk.fromJS(_data["trunk"]) : <any>undefined;
            this.disAllow = _data["disAllow"];
            this.delete = _data["delete"];
            this.disable = _data["disable"];
        }
    }

    static override fromJS(data: any): PhoneNumber {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneNumber();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patternMatching"] = this.patternMatching;
        data["number"] = this.number;
        data["price"] = this.price;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["callFlow"] = this.callFlow ? this.callFlow.toJSON() : <any>undefined;
        data["trunk"] = this.trunk ? this.trunk.toJSON() : <any>undefined;
        data["disAllow"] = this.disAllow;
        data["delete"] = this.delete;
        data["disable"] = this.disable;
        super.toJSON(data);
        return data;
    }
}

export interface IPhoneNumber extends IAuditableEntity {
    id?: number;
    patternMatching?: string | undefined;
    number?: string | undefined;
    price?: number;
    company?: Company | undefined;
    callFlow?: CallFlow | undefined;
    trunk?: Trunk | undefined;
    disAllow?: boolean;
    delete?: boolean;
    disable?: boolean;
}

export class Trunk extends AuditableEntity implements ITrunk {
    id?: number;
    name?: string | undefined;
    context?: string | undefined;
    registerString?: string | undefined;
    config?: string | undefined;
    status?: boolean;
    disable?: boolean;
    delete?: boolean;
    reloadCount?: number;
    lastReload?: Date;
    phoneNumbers?: PhoneNumber[] | undefined;
    phoneNumberProvider?: PhoneNumberProvider | undefined;

    constructor(data?: ITrunk) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.context = _data["context"];
            this.registerString = _data["registerString"];
            this.config = _data["config"];
            this.status = _data["status"];
            this.disable = _data["disable"];
            this.delete = _data["delete"];
            this.reloadCount = _data["reloadCount"];
            this.lastReload = _data["lastReload"] ? new Date(_data["lastReload"].toString()) : <any>undefined;
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(PhoneNumber.fromJS(item));
            }
            this.phoneNumberProvider = _data["phoneNumberProvider"] ? PhoneNumberProvider.fromJS(_data["phoneNumberProvider"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): Trunk {
        data = typeof data === 'object' ? data : {};
        let result = new Trunk();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["context"] = this.context;
        data["registerString"] = this.registerString;
        data["config"] = this.config;
        data["status"] = this.status;
        data["disable"] = this.disable;
        data["delete"] = this.delete;
        data["reloadCount"] = this.reloadCount;
        data["lastReload"] = this.lastReload ? this.lastReload.toISOString() : <any>undefined;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        data["phoneNumberProvider"] = this.phoneNumberProvider ? this.phoneNumberProvider.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITrunk extends IAuditableEntity {
    id?: number;
    name?: string | undefined;
    context?: string | undefined;
    registerString?: string | undefined;
    config?: string | undefined;
    status?: boolean;
    disable?: boolean;
    delete?: boolean;
    reloadCount?: number;
    lastReload?: Date;
    phoneNumbers?: PhoneNumber[] | undefined;
    phoneNumberProvider?: PhoneNumberProvider | undefined;
}

export class PhoneNumberProvider extends AuditableEntity implements IPhoneNumberProvider {
    id?: number;
    name?: string | undefined;
    trunks?: Trunk[] | undefined;
    delete?: boolean;

    constructor(data?: IPhoneNumberProvider) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["trunks"])) {
                this.trunks = [] as any;
                for (let item of _data["trunks"])
                    this.trunks!.push(Trunk.fromJS(item));
            }
            this.delete = _data["delete"];
        }
    }

    static override fromJS(data: any): PhoneNumberProvider {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneNumberProvider();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.trunks)) {
            data["trunks"] = [];
            for (let item of this.trunks)
                data["trunks"].push(item.toJSON());
        }
        data["delete"] = this.delete;
        super.toJSON(data);
        return data;
    }
}

export interface IPhoneNumberProvider extends IAuditableEntity {
    id?: number;
    name?: string | undefined;
    trunks?: Trunk[] | undefined;
    delete?: boolean;
}

export class TraceLog extends AuditableEntity implements ITraceLog {
    id?: number;
    callFlowId?: number;
    company?: Company | undefined;
    callFlow?: CallFlow | undefined;
    callId?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    logContent?: string | undefined;
    attribute?: string | undefined;
    type?: string | undefined;
    logType?: string | undefined;
    actionName?: string | undefined;
    actionKey?: string | undefined;
    currentFlowId?: number;
    jsonRefData?: string | undefined;

    constructor(data?: ITraceLog) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.callFlowId = _data["callFlowId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.callFlow = _data["callFlow"] ? CallFlow.fromJS(_data["callFlow"]) : <any>undefined;
            this.callId = _data["callId"];
            this.fromNumber = _data["fromNumber"];
            this.toNumber = _data["toNumber"];
            this.logContent = _data["logContent"];
            this.attribute = _data["attribute"];
            this.type = _data["type"];
            this.logType = _data["logType"];
            this.actionName = _data["actionName"];
            this.actionKey = _data["actionKey"];
            this.currentFlowId = _data["currentFlowId"];
            this.jsonRefData = _data["jsonRefData"];
        }
    }

    static override fromJS(data: any): TraceLog {
        data = typeof data === 'object' ? data : {};
        let result = new TraceLog();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["callFlowId"] = this.callFlowId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["callFlow"] = this.callFlow ? this.callFlow.toJSON() : <any>undefined;
        data["callId"] = this.callId;
        data["fromNumber"] = this.fromNumber;
        data["toNumber"] = this.toNumber;
        data["logContent"] = this.logContent;
        data["attribute"] = this.attribute;
        data["type"] = this.type;
        data["logType"] = this.logType;
        data["actionName"] = this.actionName;
        data["actionKey"] = this.actionKey;
        data["currentFlowId"] = this.currentFlowId;
        data["jsonRefData"] = this.jsonRefData;
        super.toJSON(data);
        return data;
    }
}

export interface ITraceLog extends IAuditableEntity {
    id?: number;
    callFlowId?: number;
    company?: Company | undefined;
    callFlow?: CallFlow | undefined;
    callId?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    logContent?: string | undefined;
    attribute?: string | undefined;
    type?: string | undefined;
    logType?: string | undefined;
    actionName?: string | undefined;
    actionKey?: string | undefined;
    currentFlowId?: number;
    jsonRefData?: string | undefined;
}

export class CallerResponseTrain extends AuditableEntity implements ICallerResponseTrain {
    id?: number;
    company?: Company | undefined;
    callFlow?: CallFlow | undefined;
    callId?: string | undefined;
    text?: string | undefined;
    voice?: string | undefined;
    grammarType?: string | undefined;
    grammarName?: string | undefined;
    source?: string | undefined;
    count?: number;
    serverFile?: string | undefined;

    constructor(data?: ICallerResponseTrain) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.callFlow = _data["callFlow"] ? CallFlow.fromJS(_data["callFlow"]) : <any>undefined;
            this.callId = _data["callId"];
            this.text = _data["text"];
            this.voice = _data["voice"];
            this.grammarType = _data["grammarType"];
            this.grammarName = _data["grammarName"];
            this.source = _data["source"];
            this.count = _data["count"];
            this.serverFile = _data["serverFile"];
        }
    }

    static override fromJS(data: any): CallerResponseTrain {
        data = typeof data === 'object' ? data : {};
        let result = new CallerResponseTrain();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["callFlow"] = this.callFlow ? this.callFlow.toJSON() : <any>undefined;
        data["callId"] = this.callId;
        data["text"] = this.text;
        data["voice"] = this.voice;
        data["grammarType"] = this.grammarType;
        data["grammarName"] = this.grammarName;
        data["source"] = this.source;
        data["count"] = this.count;
        data["serverFile"] = this.serverFile;
        super.toJSON(data);
        return data;
    }
}

export interface ICallerResponseTrain extends IAuditableEntity {
    id?: number;
    company?: Company | undefined;
    callFlow?: CallFlow | undefined;
    callId?: string | undefined;
    text?: string | undefined;
    voice?: string | undefined;
    grammarType?: string | undefined;
    grammarName?: string | undefined;
    source?: string | undefined;
    count?: number;
    serverFile?: string | undefined;
}

export class Draft extends AuditableEntity implements IDraft {
    id?: number;
    name?: string | undefined;
    attribute?: string | undefined;
    data?: string | undefined;
    jsonFormat?: string | undefined;
    callFlow?: CallFlow | undefined;
    version?: number;
    image?: string | undefined;
    tag?: string | undefined;
    note?: string | undefined;
    isPublished?: boolean;
    changedBy?: string | undefined;
    changedDate?: Date;

    constructor(data?: IDraft) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.attribute = _data["attribute"];
            this.data = _data["data"];
            this.jsonFormat = _data["jsonFormat"];
            this.callFlow = _data["callFlow"] ? CallFlow.fromJS(_data["callFlow"]) : <any>undefined;
            this.version = _data["version"];
            this.image = _data["image"];
            this.tag = _data["tag"];
            this.note = _data["note"];
            this.isPublished = _data["isPublished"];
            this.changedBy = _data["changedBy"];
            this.changedDate = _data["changedDate"] ? new Date(_data["changedDate"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): Draft {
        data = typeof data === 'object' ? data : {};
        let result = new Draft();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["attribute"] = this.attribute;
        data["data"] = this.data;
        data["jsonFormat"] = this.jsonFormat;
        data["callFlow"] = this.callFlow ? this.callFlow.toJSON() : <any>undefined;
        data["version"] = this.version;
        data["image"] = this.image;
        data["tag"] = this.tag;
        data["note"] = this.note;
        data["isPublished"] = this.isPublished;
        data["changedBy"] = this.changedBy;
        data["changedDate"] = this.changedDate ? this.changedDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDraft extends IAuditableEntity {
    id?: number;
    name?: string | undefined;
    attribute?: string | undefined;
    data?: string | undefined;
    jsonFormat?: string | undefined;
    callFlow?: CallFlow | undefined;
    version?: number;
    image?: string | undefined;
    tag?: string | undefined;
    note?: string | undefined;
    isPublished?: boolean;
    changedBy?: string | undefined;
    changedDate?: Date;
}

export class CallSetting extends AuditableEntity implements ICallSetting {
    id?: number;
    callFlow?: CallFlow | undefined;
    company?: Company | undefined;
    enableRecording?: boolean;
    languageSetting?: string | undefined;
    defaultLanguage?: string | undefined;
    speechToTextService?: string | undefined;
    transcribeService?: string | undefined;
    detectLanguage?: boolean;
    botContact?: string | undefined;
    media?: string | undefined;
    botName?: string | undefined;
    botGreetingMessages?: string | undefined;
    botLogo?: string | undefined;
    allowLogInfo?: boolean;
    prompts?: string | undefined;
    translateService?: ServiceTranslate;

    constructor(data?: ICallSetting) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.callFlow = _data["callFlow"] ? CallFlow.fromJS(_data["callFlow"]) : <any>undefined;
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.enableRecording = _data["enableRecording"];
            this.languageSetting = _data["languageSetting"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.speechToTextService = _data["speechToTextService"];
            this.transcribeService = _data["transcribeService"];
            this.detectLanguage = _data["detectLanguage"];
            this.botContact = _data["botContact"];
            this.media = _data["media"];
            this.botName = _data["botName"];
            this.botGreetingMessages = _data["botGreetingMessages"];
            this.botLogo = _data["botLogo"];
            this.allowLogInfo = _data["allowLogInfo"];
            this.prompts = _data["prompts"];
            this.translateService = _data["translateService"];
        }
    }

    static override fromJS(data: any): CallSetting {
        data = typeof data === 'object' ? data : {};
        let result = new CallSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["callFlow"] = this.callFlow ? this.callFlow.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["enableRecording"] = this.enableRecording;
        data["languageSetting"] = this.languageSetting;
        data["defaultLanguage"] = this.defaultLanguage;
        data["speechToTextService"] = this.speechToTextService;
        data["transcribeService"] = this.transcribeService;
        data["detectLanguage"] = this.detectLanguage;
        data["botContact"] = this.botContact;
        data["media"] = this.media;
        data["botName"] = this.botName;
        data["botGreetingMessages"] = this.botGreetingMessages;
        data["botLogo"] = this.botLogo;
        data["allowLogInfo"] = this.allowLogInfo;
        data["prompts"] = this.prompts;
        data["translateService"] = this.translateService;
        super.toJSON(data);
        return data;
    }
}

export interface ICallSetting extends IAuditableEntity {
    id?: number;
    callFlow?: CallFlow | undefined;
    company?: Company | undefined;
    enableRecording?: boolean;
    languageSetting?: string | undefined;
    defaultLanguage?: string | undefined;
    speechToTextService?: string | undefined;
    transcribeService?: string | undefined;
    detectLanguage?: boolean;
    botContact?: string | undefined;
    media?: string | undefined;
    botName?: string | undefined;
    botGreetingMessages?: string | undefined;
    botLogo?: string | undefined;
    allowLogInfo?: boolean;
    prompts?: string | undefined;
    translateService?: ServiceTranslate;
}

export enum ServiceTranslate {
    Google = 0,
    Amazon = 1,
    Azure = 2,
}

export class CallData extends AuditableEntity implements ICallData {
    id?: number;
    callID?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    label?: string | undefined;
    note?: string | undefined;
    callFlow?: CallFlow | undefined;
    dataSet?: Dataset | undefined;

    constructor(data?: ICallData) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.callID = _data["callID"];
            this.fromNumber = _data["fromNumber"];
            this.toNumber = _data["toNumber"];
            this.label = _data["label"];
            this.note = _data["note"];
            this.callFlow = _data["callFlow"] ? CallFlow.fromJS(_data["callFlow"]) : <any>undefined;
            this.dataSet = _data["dataSet"] ? Dataset.fromJS(_data["dataSet"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CallData {
        data = typeof data === 'object' ? data : {};
        let result = new CallData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["callID"] = this.callID;
        data["fromNumber"] = this.fromNumber;
        data["toNumber"] = this.toNumber;
        data["label"] = this.label;
        data["note"] = this.note;
        data["callFlow"] = this.callFlow ? this.callFlow.toJSON() : <any>undefined;
        data["dataSet"] = this.dataSet ? this.dataSet.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICallData extends IAuditableEntity {
    id?: number;
    callID?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    label?: string | undefined;
    note?: string | undefined;
    callFlow?: CallFlow | undefined;
    dataSet?: Dataset | undefined;
}

export class Dataset extends AuditableEntity implements IDataset {
    id?: number;
    name?: string | undefined;
    labels?: string | undefined;
    company?: Company | undefined;
    chartType?: string | undefined;
    lastResult?: boolean;
    isDelete?: boolean;
    callDatas?: CallData[] | undefined;

    constructor(data?: IDataset) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.labels = _data["labels"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.chartType = _data["chartType"];
            this.lastResult = _data["lastResult"];
            this.isDelete = _data["isDelete"];
            if (Array.isArray(_data["callDatas"])) {
                this.callDatas = [] as any;
                for (let item of _data["callDatas"])
                    this.callDatas!.push(CallData.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Dataset {
        data = typeof data === 'object' ? data : {};
        let result = new Dataset();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["labels"] = this.labels;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["chartType"] = this.chartType;
        data["lastResult"] = this.lastResult;
        data["isDelete"] = this.isDelete;
        if (Array.isArray(this.callDatas)) {
            data["callDatas"] = [];
            for (let item of this.callDatas)
                data["callDatas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDataset extends IAuditableEntity {
    id?: number;
    name?: string | undefined;
    labels?: string | undefined;
    company?: Company | undefined;
    chartType?: string | undefined;
    lastResult?: boolean;
    isDelete?: boolean;
    callDatas?: CallData[] | undefined;
}

export class TemplateFlow extends AuditableEntity implements ITemplateFlow {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    introduction?: string | undefined;
    image?: string | undefined;
    version?: string | undefined;
    callFlow?: CallFlow | undefined;
    company?: Company | undefined;
    category?: string | undefined;
    fileName?: string | undefined;
    flowType?: number;
    isDelete?: boolean;
    isDisable?: boolean;
    isPublish?: boolean;

    constructor(data?: ITemplateFlow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.introduction = _data["introduction"];
            this.image = _data["image"];
            this.version = _data["version"];
            this.callFlow = _data["callFlow"] ? CallFlow.fromJS(_data["callFlow"]) : <any>undefined;
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.category = _data["category"];
            this.fileName = _data["fileName"];
            this.flowType = _data["flowType"];
            this.isDelete = _data["isDelete"];
            this.isDisable = _data["isDisable"];
            this.isPublish = _data["isPublish"];
        }
    }

    static override fromJS(data: any): TemplateFlow {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateFlow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["introduction"] = this.introduction;
        data["image"] = this.image;
        data["version"] = this.version;
        data["callFlow"] = this.callFlow ? this.callFlow.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["category"] = this.category;
        data["fileName"] = this.fileName;
        data["flowType"] = this.flowType;
        data["isDelete"] = this.isDelete;
        data["isDisable"] = this.isDisable;
        data["isPublish"] = this.isPublish;
        super.toJSON(data);
        return data;
    }
}

export interface ITemplateFlow extends IAuditableEntity {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    introduction?: string | undefined;
    image?: string | undefined;
    version?: string | undefined;
    callFlow?: CallFlow | undefined;
    company?: Company | undefined;
    category?: string | undefined;
    fileName?: string | undefined;
    flowType?: number;
    isDelete?: boolean;
    isDisable?: boolean;
    isPublish?: boolean;
}

export class Queue extends AuditableEntity implements IQueue {
    id?: number;
    queueId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    vdn?: string | undefined;
    timeOut?: number;
    retry?: number;
    wrapUp?: number;
    priorityQueue?: string | undefined;
    announcePosition?: boolean;
    announceFrequency?: number;
    musicOnHold?: string | undefined;
    joinEmpty?: boolean;
    leaveWhenEmpty?: boolean;
    ringInUse?: boolean;
    strategy?: string | undefined;
    company?: Company | undefined;
    agentInQueues?: AgentInQueue[] | undefined;
    disable?: boolean;
    recording?: boolean;
    musicOnHoldId?: number;
    maxContacts?: string | undefined;
    periodicAnnounceId?: number;
    periodicAnnounce?: string | undefined;
    periodicAnnounceFrequency?: number;

    constructor(data?: IQueue) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.queueId = _data["queueId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.vdn = _data["vdn"];
            this.timeOut = _data["timeOut"];
            this.retry = _data["retry"];
            this.wrapUp = _data["wrapUp"];
            this.priorityQueue = _data["priorityQueue"];
            this.announcePosition = _data["announcePosition"];
            this.announceFrequency = _data["announceFrequency"];
            this.musicOnHold = _data["musicOnHold"];
            this.joinEmpty = _data["joinEmpty"];
            this.leaveWhenEmpty = _data["leaveWhenEmpty"];
            this.ringInUse = _data["ringInUse"];
            this.strategy = _data["strategy"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            if (Array.isArray(_data["agentInQueues"])) {
                this.agentInQueues = [] as any;
                for (let item of _data["agentInQueues"])
                    this.agentInQueues!.push(AgentInQueue.fromJS(item));
            }
            this.disable = _data["disable"];
            this.recording = _data["recording"];
            this.musicOnHoldId = _data["musicOnHoldId"];
            this.maxContacts = _data["maxContacts"];
            this.periodicAnnounceId = _data["periodicAnnounceId"];
            this.periodicAnnounce = _data["periodicAnnounce"];
            this.periodicAnnounceFrequency = _data["periodicAnnounceFrequency"];
        }
    }

    static override fromJS(data: any): Queue {
        data = typeof data === 'object' ? data : {};
        let result = new Queue();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["queueId"] = this.queueId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["vdn"] = this.vdn;
        data["timeOut"] = this.timeOut;
        data["retry"] = this.retry;
        data["wrapUp"] = this.wrapUp;
        data["priorityQueue"] = this.priorityQueue;
        data["announcePosition"] = this.announcePosition;
        data["announceFrequency"] = this.announceFrequency;
        data["musicOnHold"] = this.musicOnHold;
        data["joinEmpty"] = this.joinEmpty;
        data["leaveWhenEmpty"] = this.leaveWhenEmpty;
        data["ringInUse"] = this.ringInUse;
        data["strategy"] = this.strategy;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.agentInQueues)) {
            data["agentInQueues"] = [];
            for (let item of this.agentInQueues)
                data["agentInQueues"].push(item.toJSON());
        }
        data["disable"] = this.disable;
        data["recording"] = this.recording;
        data["musicOnHoldId"] = this.musicOnHoldId;
        data["maxContacts"] = this.maxContacts;
        data["periodicAnnounceId"] = this.periodicAnnounceId;
        data["periodicAnnounce"] = this.periodicAnnounce;
        data["periodicAnnounceFrequency"] = this.periodicAnnounceFrequency;
        super.toJSON(data);
        return data;
    }
}

export interface IQueue extends IAuditableEntity {
    id?: number;
    queueId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    vdn?: string | undefined;
    timeOut?: number;
    retry?: number;
    wrapUp?: number;
    priorityQueue?: string | undefined;
    announcePosition?: boolean;
    announceFrequency?: number;
    musicOnHold?: string | undefined;
    joinEmpty?: boolean;
    leaveWhenEmpty?: boolean;
    ringInUse?: boolean;
    strategy?: string | undefined;
    company?: Company | undefined;
    agentInQueues?: AgentInQueue[] | undefined;
    disable?: boolean;
    recording?: boolean;
    musicOnHoldId?: number;
    maxContacts?: string | undefined;
    periodicAnnounceId?: number;
    periodicAnnounce?: string | undefined;
    periodicAnnounceFrequency?: number;
}

export class Audio extends AuditableEntity implements IAudio {
    id?: number;
    name?: string | undefined;
    content?: string | undefined;
    isUpload?: boolean;
    company?: Company | undefined;
    audioLanguages?: AudioLanguage[] | undefined;
    service?: ServiceTTS;
    language?: string | undefined;
    voiceId?: string | undefined;
    path?: string | undefined;
    pathAsterisk?: string | undefined;
    delete?: boolean;

    constructor(data?: IAudio) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.isUpload = _data["isUpload"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            if (Array.isArray(_data["audioLanguages"])) {
                this.audioLanguages = [] as any;
                for (let item of _data["audioLanguages"])
                    this.audioLanguages!.push(AudioLanguage.fromJS(item));
            }
            this.service = _data["service"];
            this.language = _data["language"];
            this.voiceId = _data["voiceId"];
            this.path = _data["path"];
            this.pathAsterisk = _data["pathAsterisk"];
            this.delete = _data["delete"];
        }
    }

    static override fromJS(data: any): Audio {
        data = typeof data === 'object' ? data : {};
        let result = new Audio();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["content"] = this.content;
        data["isUpload"] = this.isUpload;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.audioLanguages)) {
            data["audioLanguages"] = [];
            for (let item of this.audioLanguages)
                data["audioLanguages"].push(item.toJSON());
        }
        data["service"] = this.service;
        data["language"] = this.language;
        data["voiceId"] = this.voiceId;
        data["path"] = this.path;
        data["pathAsterisk"] = this.pathAsterisk;
        data["delete"] = this.delete;
        super.toJSON(data);
        return data;
    }
}

export interface IAudio extends IAuditableEntity {
    id?: number;
    name?: string | undefined;
    content?: string | undefined;
    isUpload?: boolean;
    company?: Company | undefined;
    audioLanguages?: AudioLanguage[] | undefined;
    service?: ServiceTTS;
    language?: string | undefined;
    voiceId?: string | undefined;
    path?: string | undefined;
    pathAsterisk?: string | undefined;
    delete?: boolean;
}

export class AudioLanguage extends AuditableEntity implements IAudioLanguage {
    id?: number;
    audio?: Audio | undefined;
    company?: Company | undefined;
    name?: string | undefined;
    content?: string | undefined;
    fileName?: string | undefined;
    isUpload?: boolean;
    service?: ServiceTTS;
    countryCode?: string | undefined;
    countryName?: string | undefined;
    language?: string | undefined;
    languageName?: string | undefined;
    voiceId?: string | undefined;
    gender?: string | undefined;
    path?: string | undefined;
    pathAsterisk?: string | undefined;
    delete?: boolean;

    constructor(data?: IAudioLanguage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.audio = _data["audio"] ? Audio.fromJS(_data["audio"]) : <any>undefined;
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.name = _data["name"];
            this.content = _data["content"];
            this.fileName = _data["fileName"];
            this.isUpload = _data["isUpload"];
            this.service = _data["service"];
            this.countryCode = _data["countryCode"];
            this.countryName = _data["countryName"];
            this.language = _data["language"];
            this.languageName = _data["languageName"];
            this.voiceId = _data["voiceId"];
            this.gender = _data["gender"];
            this.path = _data["path"];
            this.pathAsterisk = _data["pathAsterisk"];
            this.delete = _data["delete"];
        }
    }

    static override fromJS(data: any): AudioLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new AudioLanguage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["audio"] = this.audio ? this.audio.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["content"] = this.content;
        data["fileName"] = this.fileName;
        data["isUpload"] = this.isUpload;
        data["service"] = this.service;
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName;
        data["language"] = this.language;
        data["languageName"] = this.languageName;
        data["voiceId"] = this.voiceId;
        data["gender"] = this.gender;
        data["path"] = this.path;
        data["pathAsterisk"] = this.pathAsterisk;
        data["delete"] = this.delete;
        super.toJSON(data);
        return data;
    }
}

export interface IAudioLanguage extends IAuditableEntity {
    id?: number;
    audio?: Audio | undefined;
    company?: Company | undefined;
    name?: string | undefined;
    content?: string | undefined;
    fileName?: string | undefined;
    isUpload?: boolean;
    service?: ServiceTTS;
    countryCode?: string | undefined;
    countryName?: string | undefined;
    language?: string | undefined;
    languageName?: string | undefined;
    voiceId?: string | undefined;
    gender?: string | undefined;
    path?: string | undefined;
    pathAsterisk?: string | undefined;
    delete?: boolean;
}

export enum ServiceTTS {
    Primas = 0,
    Soundhound = 1,
    AmazonPolly = 2,
    Google = 3,
    Azure = 4,
}

export class CustomFunctions extends AuditableEntity implements ICustomFunctions {
    id?: number;
    name?: string | undefined;
    language?: string | undefined;
    code?: string | undefined;
    company?: Company | undefined;
    param?: string | undefined;
    codeFormat?: string | undefined;

    constructor(data?: ICustomFunctions) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.language = _data["language"];
            this.code = _data["code"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.param = _data["param"];
            this.codeFormat = _data["codeFormat"];
        }
    }

    static override fromJS(data: any): CustomFunctions {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFunctions();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["language"] = this.language;
        data["code"] = this.code;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["param"] = this.param;
        data["codeFormat"] = this.codeFormat;
        super.toJSON(data);
        return data;
    }
}

export interface ICustomFunctions extends IAuditableEntity {
    id?: number;
    name?: string | undefined;
    language?: string | undefined;
    code?: string | undefined;
    company?: Company | undefined;
    param?: string | undefined;
    codeFormat?: string | undefined;
}

export class Grammar extends AuditableEntity implements IGrammar {
    id?: number;
    name?: string | undefined;
    pattern?: string | undefined;
    company?: Company | undefined;
    type?: string | undefined;
    entity?: string | undefined;
    autoTranslate?: boolean;
    engine?: boolean;
    engineType?: string | undefined;
    extenData?: string | undefined;
    status?: string | undefined;

    constructor(data?: IGrammar) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pattern = _data["pattern"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.type = _data["type"];
            this.entity = _data["entity"];
            this.autoTranslate = _data["autoTranslate"];
            this.engine = _data["engine"];
            this.engineType = _data["engineType"];
            this.extenData = _data["extenData"];
            this.status = _data["status"];
        }
    }

    static override fromJS(data: any): Grammar {
        data = typeof data === 'object' ? data : {};
        let result = new Grammar();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pattern"] = this.pattern;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["entity"] = this.entity;
        data["autoTranslate"] = this.autoTranslate;
        data["engine"] = this.engine;
        data["engineType"] = this.engineType;
        data["extenData"] = this.extenData;
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IGrammar extends IAuditableEntity {
    id?: number;
    name?: string | undefined;
    pattern?: string | undefined;
    company?: Company | undefined;
    type?: string | undefined;
    entity?: string | undefined;
    autoTranslate?: boolean;
    engine?: boolean;
    engineType?: string | undefined;
    extenData?: string | undefined;
    status?: string | undefined;
}

export class UserAction extends AuditableEntity implements IUserAction {
    id?: number;
    applicationId?: string | undefined;
    name?: string | undefined;
    iconImage?: string | undefined;
    data?: string | undefined;
    company?: Company | undefined;

    constructor(data?: IUserAction) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.applicationId = _data["applicationId"];
            this.name = _data["name"];
            this.iconImage = _data["iconImage"];
            this.data = _data["data"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): UserAction {
        data = typeof data === 'object' ? data : {};
        let result = new UserAction();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationId"] = this.applicationId;
        data["name"] = this.name;
        data["iconImage"] = this.iconImage;
        data["data"] = this.data;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUserAction extends IAuditableEntity {
    id?: number;
    applicationId?: string | undefined;
    name?: string | undefined;
    iconImage?: string | undefined;
    data?: string | undefined;
    company?: Company | undefined;
}

export class ChatGPT extends AuditableEntity implements IChatGPT {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    dataTrain?: string | undefined;
    company?: Company | undefined;
    extenData?: string | undefined;
    status?: string | undefined;
    retrainTime?: string | undefined;

    constructor(data?: IChatGPT) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.dataTrain = _data["dataTrain"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.extenData = _data["extenData"];
            this.status = _data["status"];
            this.retrainTime = _data["retrainTime"];
        }
    }

    static override fromJS(data: any): ChatGPT {
        data = typeof data === 'object' ? data : {};
        let result = new ChatGPT();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        data["dataTrain"] = this.dataTrain;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["extenData"] = this.extenData;
        data["status"] = this.status;
        data["retrainTime"] = this.retrainTime;
        super.toJSON(data);
        return data;
    }
}

export interface IChatGPT extends IAuditableEntity {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    dataTrain?: string | undefined;
    company?: Company | undefined;
    extenData?: string | undefined;
    status?: string | undefined;
    retrainTime?: string | undefined;
}

export class ActivityLog extends AuditableEntity implements IActivityLog {
    id?: number;
    method?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    remoteIp?: string | undefined;
    request?: string | undefined;
    company?: Company | undefined;
    requestName?: string | undefined;
    response?: string | undefined;
    status?: string | undefined;

    constructor(data?: IActivityLog) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.method = _data["method"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.remoteIp = _data["remoteIp"];
            this.request = _data["request"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.requestName = _data["requestName"];
            this.response = _data["response"];
            this.status = _data["status"];
        }
    }

    static override fromJS(data: any): ActivityLog {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLog();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["method"] = this.method;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["remoteIp"] = this.remoteIp;
        data["request"] = this.request;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["requestName"] = this.requestName;
        data["response"] = this.response;
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IActivityLog extends IAuditableEntity {
    id?: number;
    method?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    remoteIp?: string | undefined;
    request?: string | undefined;
    company?: Company | undefined;
    requestName?: string | undefined;
    response?: string | undefined;
    status?: string | undefined;
}

export class EmailReport extends AuditableEntity implements IEmailReport {
    id?: number;
    name?: string | undefined;
    type?: string | undefined;
    day?: string | undefined;
    time?: string | undefined;
    reportDayRange?: string | undefined;
    company?: Company | undefined;
    senderName?: string | undefined;
    emailName?: string | undefined;
    emailSubject?: string | undefined;
    emailRecipients?: string | undefined;
    template?: number;
    report?: string | undefined;
    callFlow?: string | undefined;
    phoneNumber?: string | undefined;
    isDelete?: boolean;
    isDisable?: boolean;
    emailLogs?: EmailLog[] | undefined;
    lastSend?: Date;

    constructor(data?: IEmailReport) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.day = _data["day"];
            this.time = _data["time"];
            this.reportDayRange = _data["reportDayRange"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.senderName = _data["senderName"];
            this.emailName = _data["emailName"];
            this.emailSubject = _data["emailSubject"];
            this.emailRecipients = _data["emailRecipients"];
            this.template = _data["template"];
            this.report = _data["report"];
            this.callFlow = _data["callFlow"];
            this.phoneNumber = _data["phoneNumber"];
            this.isDelete = _data["isDelete"];
            this.isDisable = _data["isDisable"];
            if (Array.isArray(_data["emailLogs"])) {
                this.emailLogs = [] as any;
                for (let item of _data["emailLogs"])
                    this.emailLogs!.push(EmailLog.fromJS(item));
            }
            this.lastSend = _data["lastSend"] ? new Date(_data["lastSend"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): EmailReport {
        data = typeof data === 'object' ? data : {};
        let result = new EmailReport();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["day"] = this.day;
        data["time"] = this.time;
        data["reportDayRange"] = this.reportDayRange;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["senderName"] = this.senderName;
        data["emailName"] = this.emailName;
        data["emailSubject"] = this.emailSubject;
        data["emailRecipients"] = this.emailRecipients;
        data["template"] = this.template;
        data["report"] = this.report;
        data["callFlow"] = this.callFlow;
        data["phoneNumber"] = this.phoneNumber;
        data["isDelete"] = this.isDelete;
        data["isDisable"] = this.isDisable;
        if (Array.isArray(this.emailLogs)) {
            data["emailLogs"] = [];
            for (let item of this.emailLogs)
                data["emailLogs"].push(item.toJSON());
        }
        data["lastSend"] = this.lastSend ? this.lastSend.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IEmailReport extends IAuditableEntity {
    id?: number;
    name?: string | undefined;
    type?: string | undefined;
    day?: string | undefined;
    time?: string | undefined;
    reportDayRange?: string | undefined;
    company?: Company | undefined;
    senderName?: string | undefined;
    emailName?: string | undefined;
    emailSubject?: string | undefined;
    emailRecipients?: string | undefined;
    template?: number;
    report?: string | undefined;
    callFlow?: string | undefined;
    phoneNumber?: string | undefined;
    isDelete?: boolean;
    isDisable?: boolean;
    emailLogs?: EmailLog[] | undefined;
    lastSend?: Date;
}

export class EmailLog extends AuditableEntity implements IEmailLog {
    id?: number;
    emailReport?: EmailReport | undefined;
    sendTo?: string | undefined;
    timeSent?: Date;
    lastSend?: Date;
    message?: string | undefined;
    resolution?: string | undefined;
    reason?: string | undefined;
    status?: string | undefined;

    constructor(data?: IEmailLog) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.emailReport = _data["emailReport"] ? EmailReport.fromJS(_data["emailReport"]) : <any>undefined;
            this.sendTo = _data["sendTo"];
            this.timeSent = _data["timeSent"] ? new Date(_data["timeSent"].toString()) : <any>undefined;
            this.lastSend = _data["lastSend"] ? new Date(_data["lastSend"].toString()) : <any>undefined;
            this.message = _data["message"];
            this.resolution = _data["resolution"];
            this.reason = _data["reason"];
            this.status = _data["status"];
        }
    }

    static override fromJS(data: any): EmailLog {
        data = typeof data === 'object' ? data : {};
        let result = new EmailLog();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emailReport"] = this.emailReport ? this.emailReport.toJSON() : <any>undefined;
        data["sendTo"] = this.sendTo;
        data["timeSent"] = this.timeSent ? this.timeSent.toISOString() : <any>undefined;
        data["lastSend"] = this.lastSend ? this.lastSend.toISOString() : <any>undefined;
        data["message"] = this.message;
        data["resolution"] = this.resolution;
        data["reason"] = this.reason;
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IEmailLog extends IAuditableEntity {
    id?: number;
    emailReport?: EmailReport | undefined;
    sendTo?: string | undefined;
    timeSent?: Date;
    lastSend?: Date;
    message?: string | undefined;
    resolution?: string | undefined;
    reason?: string | undefined;
    status?: string | undefined;
}

export class EmailTemplate extends AuditableEntity implements IEmailTemplate {
    id?: number;
    name?: string | undefined;
    company?: Company | undefined;
    content?: string | undefined;
    design?: string | undefined;
    isDelete?: boolean;

    constructor(data?: IEmailTemplate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.content = _data["content"];
            this.design = _data["design"];
            this.isDelete = _data["isDelete"];
        }
    }

    static override fromJS(data: any): EmailTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["content"] = this.content;
        data["design"] = this.design;
        data["isDelete"] = this.isDelete;
        super.toJSON(data);
        return data;
    }
}

export interface IEmailTemplate extends IAuditableEntity {
    id?: number;
    name?: string | undefined;
    company?: Company | undefined;
    content?: string | undefined;
    design?: string | undefined;
    isDelete?: boolean;
}

export class CMS extends AuditableEntity implements ICMS {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    company?: Company | undefined;
    cmsEntities?: CMSEntity[] | undefined;
    cmsDatas?: CMSData[] | undefined;
    isDelete?: boolean;
    isDisable?: boolean;

    constructor(data?: ICMS) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            if (Array.isArray(_data["cmsEntities"])) {
                this.cmsEntities = [] as any;
                for (let item of _data["cmsEntities"])
                    this.cmsEntities!.push(CMSEntity.fromJS(item));
            }
            if (Array.isArray(_data["cmsDatas"])) {
                this.cmsDatas = [] as any;
                for (let item of _data["cmsDatas"])
                    this.cmsDatas!.push(CMSData.fromJS(item));
            }
            this.isDelete = _data["isDelete"];
            this.isDisable = _data["isDisable"];
        }
    }

    static override fromJS(data: any): CMS {
        data = typeof data === 'object' ? data : {};
        let result = new CMS();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.cmsEntities)) {
            data["cmsEntities"] = [];
            for (let item of this.cmsEntities)
                data["cmsEntities"].push(item.toJSON());
        }
        if (Array.isArray(this.cmsDatas)) {
            data["cmsDatas"] = [];
            for (let item of this.cmsDatas)
                data["cmsDatas"].push(item.toJSON());
        }
        data["isDelete"] = this.isDelete;
        data["isDisable"] = this.isDisable;
        super.toJSON(data);
        return data;
    }
}

export interface ICMS extends IAuditableEntity {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    company?: Company | undefined;
    cmsEntities?: CMSEntity[] | undefined;
    cmsDatas?: CMSData[] | undefined;
    isDelete?: boolean;
    isDisable?: boolean;
}

export class CMSEntity extends AuditableEntity implements ICMSEntity {
    id?: number;
    cms?: CMS | undefined;
    fieldName?: string | undefined;
    uniqueName?: string | undefined;
    dataType?: string | undefined;
    maxLength?: string | undefined;
    isDelete?: boolean;

    constructor(data?: ICMSEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.cms = _data["cms"] ? CMS.fromJS(_data["cms"]) : <any>undefined;
            this.fieldName = _data["fieldName"];
            this.uniqueName = _data["uniqueName"];
            this.dataType = _data["dataType"];
            this.maxLength = _data["maxLength"];
            this.isDelete = _data["isDelete"];
        }
    }

    static override fromJS(data: any): CMSEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CMSEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cms"] = this.cms ? this.cms.toJSON() : <any>undefined;
        data["fieldName"] = this.fieldName;
        data["uniqueName"] = this.uniqueName;
        data["dataType"] = this.dataType;
        data["maxLength"] = this.maxLength;
        data["isDelete"] = this.isDelete;
        super.toJSON(data);
        return data;
    }
}

export interface ICMSEntity extends IAuditableEntity {
    id?: number;
    cms?: CMS | undefined;
    fieldName?: string | undefined;
    uniqueName?: string | undefined;
    dataType?: string | undefined;
    maxLength?: string | undefined;
    isDelete?: boolean;
}

export class CMSData extends AuditableEntity implements ICMSData {
    id?: number;
    cms?: CMS | undefined;
    data?: string | undefined;
    isDelete?: boolean;

    constructor(data?: ICMSData) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.cms = _data["cms"] ? CMS.fromJS(_data["cms"]) : <any>undefined;
            this.data = _data["data"];
            this.isDelete = _data["isDelete"];
        }
    }

    static override fromJS(data: any): CMSData {
        data = typeof data === 'object' ? data : {};
        let result = new CMSData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cms"] = this.cms ? this.cms.toJSON() : <any>undefined;
        data["data"] = this.data;
        data["isDelete"] = this.isDelete;
        super.toJSON(data);
        return data;
    }
}

export interface ICMSData extends IAuditableEntity {
    id?: number;
    cms?: CMS | undefined;
    data?: string | undefined;
    isDelete?: boolean;
}

export class SipAgentDto implements ISipAgentDto {
    userName?: string | undefined;
    password?: string | undefined;
    server?: string | undefined;
    sipPort?: string | undefined;
    sipType?: string | undefined;
    webSocketType?: string | undefined;

    constructor(data?: ISipAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.server = _data["server"];
            this.sipPort = _data["sipPort"];
            this.sipType = _data["sipType"];
            this.webSocketType = _data["webSocketType"];
        }
    }

    static fromJS(data: any): SipAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SipAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["server"] = this.server;
        data["sipPort"] = this.sipPort;
        data["sipType"] = this.sipType;
        data["webSocketType"] = this.webSocketType;
        return data;
    }
}

export interface ISipAgentDto {
    userName?: string | undefined;
    password?: string | undefined;
    server?: string | undefined;
    sipPort?: string | undefined;
    sipType?: string | undefined;
    webSocketType?: string | undefined;
}

export class CreateAgentModel implements ICreateAgentModel {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dob?: Date | undefined;
    password?: string | undefined;
    avatarPath?: string | undefined;
    enableOutCalling?: boolean;
    followMe?: boolean;
    agentType?: string | undefined;
    sipType?: string | undefined;
    avatar?: string | undefined;
    extension!: string;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    companyId?: number;
    companyName?: string | undefined;

    constructor(data?: ICreateAgentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.password = _data["password"];
            this.avatarPath = _data["avatarPath"];
            this.enableOutCalling = _data["enableOutCalling"];
            this.followMe = _data["followMe"];
            this.agentType = _data["agentType"];
            this.sipType = _data["sipType"];
            this.avatar = _data["avatar"];
            this.extension = _data["extension"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): CreateAgentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAgentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["password"] = this.password;
        data["avatarPath"] = this.avatarPath;
        data["enableOutCalling"] = this.enableOutCalling;
        data["followMe"] = this.followMe;
        data["agentType"] = this.agentType;
        data["sipType"] = this.sipType;
        data["avatar"] = this.avatar;
        data["extension"] = this.extension;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface ICreateAgentModel {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dob?: Date | undefined;
    password?: string | undefined;
    avatarPath?: string | undefined;
    enableOutCalling?: boolean;
    followMe?: boolean;
    agentType?: string | undefined;
    sipType?: string | undefined;
    avatar?: string | undefined;
    extension: string;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    companyId?: number;
    companyName?: string | undefined;
}

export class CreateAgentCommand extends CreateAgentModel implements ICreateAgentCommand {

    constructor(data?: ICreateAgentCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateAgentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAgentCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateAgentCommand extends ICreateAgentModel {
}

export class UpdateAgentModel implements IUpdateAgentModel {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dob?: Date;
    avatarPath?: string | undefined;
    avatar?: string | undefined;
    password?: string | undefined;
    extension!: string;
    followMe?: boolean;
    agentType?: string | undefined;
    sipType?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    disable?: boolean;
    enableOutCalling?: boolean;
    companyId?: number;

    constructor(data?: IUpdateAgentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.avatarPath = _data["avatarPath"];
            this.avatar = _data["avatar"];
            this.password = _data["password"];
            this.extension = _data["extension"];
            this.followMe = _data["followMe"];
            this.agentType = _data["agentType"];
            this.sipType = _data["sipType"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.disable = _data["disable"];
            this.enableOutCalling = _data["enableOutCalling"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): UpdateAgentModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["avatarPath"] = this.avatarPath;
        data["avatar"] = this.avatar;
        data["password"] = this.password;
        data["extension"] = this.extension;
        data["followMe"] = this.followMe;
        data["agentType"] = this.agentType;
        data["sipType"] = this.sipType;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["disable"] = this.disable;
        data["enableOutCalling"] = this.enableOutCalling;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IUpdateAgentModel {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dob?: Date;
    avatarPath?: string | undefined;
    avatar?: string | undefined;
    password?: string | undefined;
    extension: string;
    followMe?: boolean;
    agentType?: string | undefined;
    sipType?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    disable?: boolean;
    enableOutCalling?: boolean;
    companyId?: number;
}

export class UpdateAgentCommand extends UpdateAgentModel implements IUpdateAgentCommand {

    constructor(data?: IUpdateAgentCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateAgentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgentCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateAgentCommand extends IUpdateAgentModel {
}

export class DisableAgentCommand implements IDisableAgentCommand {
    disable?: boolean;
    agentId?: number;

    constructor(data?: IDisableAgentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disable = _data["disable"];
            this.agentId = _data["agentId"];
        }
    }

    static fromJS(data: any): DisableAgentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DisableAgentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disable"] = this.disable;
        data["agentId"] = this.agentId;
        return data;
    }
}

export interface IDisableAgentCommand {
    disable?: boolean;
    agentId?: number;
}

export class CreateSipAccountCommand implements ICreateSipAccountCommand {
    number?: string | undefined;
    context?: string | undefined;
    password?: string | undefined;
    companyId?: string | undefined;

    constructor(data?: ICreateSipAccountCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.context = _data["context"];
            this.password = _data["password"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): CreateSipAccountCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSipAccountCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["context"] = this.context;
        data["password"] = this.password;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface ICreateSipAccountCommand {
    number?: string | undefined;
    context?: string | undefined;
    password?: string | undefined;
    companyId?: string | undefined;
}

export class ChangeStatusCommand implements IChangeStatusCommand {
    isOnline?: boolean;
    agentId?: number;

    constructor(data?: IChangeStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOnline = _data["isOnline"];
            this.agentId = _data["agentId"];
        }
    }

    static fromJS(data: any): ChangeStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOnline"] = this.isOnline;
        data["agentId"] = this.agentId;
        return data;
    }
}

export interface IChangeStatusCommand {
    isOnline?: boolean;
    agentId?: number;
}

export class ChangeFollowMeCommand implements IChangeFollowMeCommand {
    followMe?: boolean;
    agentId?: number;

    constructor(data?: IChangeFollowMeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.followMe = _data["followMe"];
            this.agentId = _data["agentId"];
        }
    }

    static fromJS(data: any): ChangeFollowMeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeFollowMeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["followMe"] = this.followMe;
        data["agentId"] = this.agentId;
        return data;
    }
}

export interface IChangeFollowMeCommand {
    followMe?: boolean;
    agentId?: number;
}

export class CheckUserNameExistQuery implements ICheckUserNameExistQuery {
    userName?: string | undefined;

    constructor(data?: ICheckUserNameExistQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): CheckUserNameExistQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CheckUserNameExistQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        return data;
    }
}

export interface ICheckUserNameExistQuery {
    userName?: string | undefined;
}

export class CheckExtensionExistQuery implements ICheckExtensionExistQuery {
    id?: number;
    extension?: string | undefined;
    companyId?: number;

    constructor(data?: ICheckExtensionExistQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.extension = _data["extension"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): CheckExtensionExistQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CheckExtensionExistQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["extension"] = this.extension;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface ICheckExtensionExistQuery {
    id?: number;
    extension?: string | undefined;
    companyId?: number;
}

export class CheckEmailExistQuery implements ICheckEmailExistQuery {
    id?: number;
    email?: string | undefined;
    companyId?: number;

    constructor(data?: ICheckEmailExistQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): CheckEmailExistQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CheckEmailExistQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface ICheckEmailExistQuery {
    id?: number;
    email?: string | undefined;
    companyId?: number;
}

export class CheckNumberExistQuery implements ICheckNumberExistQuery {
    id?: number;
    number?: string | undefined;
    companyId?: number;

    constructor(data?: ICheckNumberExistQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): CheckNumberExistQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CheckNumberExistQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface ICheckNumberExistQuery {
    id?: number;
    number?: string | undefined;
    companyId?: number;
}

export class AgentSummaryVm implements IAgentSummaryVm {
    total?: number;
    online?: number;
    paused?: number;

    constructor(data?: IAgentSummaryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.online = _data["online"];
            this.paused = _data["paused"];
        }
    }

    static fromJS(data: any): AgentSummaryVm {
        data = typeof data === 'object' ? data : {};
        let result = new AgentSummaryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["online"] = this.online;
        data["paused"] = this.paused;
        return data;
    }
}

export interface IAgentSummaryVm {
    total?: number;
    online?: number;
    paused?: number;
}

export class AgentInfoVm implements IAgentInfoVm {
    agentInfo?: AgentInfoDto | undefined;
    queues?: AgentInQueueSummary[] | undefined;

    constructor(data?: IAgentInfoVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentInfo = _data["agentInfo"] ? AgentInfoDto.fromJS(_data["agentInfo"]) : <any>undefined;
            if (Array.isArray(_data["queues"])) {
                this.queues = [] as any;
                for (let item of _data["queues"])
                    this.queues!.push(AgentInQueueSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgentInfoVm {
        data = typeof data === 'object' ? data : {};
        let result = new AgentInfoVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentInfo"] = this.agentInfo ? this.agentInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.queues)) {
            data["queues"] = [];
            for (let item of this.queues)
                data["queues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgentInfoVm {
    agentInfo?: AgentInfoDto | undefined;
    queues?: AgentInQueueSummary[] | undefined;
}

export class AgentInfoDto implements IAgentInfoDto {
    id?: number;
    fullName?: string | undefined;
    extension?: string | undefined;
    email?: string | undefined;
    followMe?: boolean;
    agentType?: string | undefined;
    sipType?: string | undefined;
    isOnline?: boolean;
    companyId?: number;
    phoneNumber?: string | undefined;
    avatar?: string | undefined;
    isPause?: boolean;

    constructor(data?: IAgentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.extension = _data["extension"];
            this.email = _data["email"];
            this.followMe = _data["followMe"];
            this.agentType = _data["agentType"];
            this.sipType = _data["sipType"];
            this.isOnline = _data["isOnline"];
            this.companyId = _data["companyId"];
            this.phoneNumber = _data["phoneNumber"];
            this.avatar = _data["avatar"];
            this.isPause = _data["isPause"];
        }
    }

    static fromJS(data: any): AgentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["extension"] = this.extension;
        data["email"] = this.email;
        data["followMe"] = this.followMe;
        data["agentType"] = this.agentType;
        data["sipType"] = this.sipType;
        data["isOnline"] = this.isOnline;
        data["companyId"] = this.companyId;
        data["phoneNumber"] = this.phoneNumber;
        data["avatar"] = this.avatar;
        data["isPause"] = this.isPause;
        return data;
    }
}

export interface IAgentInfoDto {
    id?: number;
    fullName?: string | undefined;
    extension?: string | undefined;
    email?: string | undefined;
    followMe?: boolean;
    agentType?: string | undefined;
    sipType?: string | undefined;
    isOnline?: boolean;
    companyId?: number;
    phoneNumber?: string | undefined;
    avatar?: string | undefined;
    isPause?: boolean;
}

export class AgentInQueueSummary implements IAgentInQueueSummary {
    queueId?: number;
    queueName?: string | undefined;
    queueIdAsterisk?: string | undefined;
    information?: string | undefined;
    isAgentPaused?: boolean;
    total?: number;
    online?: number;
    offline?: number;
    paused?: number;
    agents?: AgentInfoDto[] | undefined;

    constructor(data?: IAgentInQueueSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queueId = _data["queueId"];
            this.queueName = _data["queueName"];
            this.queueIdAsterisk = _data["queueIdAsterisk"];
            this.information = _data["information"];
            this.isAgentPaused = _data["isAgentPaused"];
            this.total = _data["total"];
            this.online = _data["online"];
            this.offline = _data["offline"];
            this.paused = _data["paused"];
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(AgentInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgentInQueueSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AgentInQueueSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queueId"] = this.queueId;
        data["queueName"] = this.queueName;
        data["queueIdAsterisk"] = this.queueIdAsterisk;
        data["information"] = this.information;
        data["isAgentPaused"] = this.isAgentPaused;
        data["total"] = this.total;
        data["online"] = this.online;
        data["offline"] = this.offline;
        data["paused"] = this.paused;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgentInQueueSummary {
    queueId?: number;
    queueName?: string | undefined;
    queueIdAsterisk?: string | undefined;
    information?: string | undefined;
    isAgentPaused?: boolean;
    total?: number;
    online?: number;
    offline?: number;
    paused?: number;
    agents?: AgentInfoDto[] | undefined;
}

export class PauseAgentCommand implements IPauseAgentCommand {
    isPause?: boolean;
    queueId?: number;

    constructor(data?: IPauseAgentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPause = _data["isPause"];
            this.queueId = _data["queueId"];
        }
    }

    static fromJS(data: any): PauseAgentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PauseAgentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPause"] = this.isPause;
        data["queueId"] = this.queueId;
        return data;
    }
}

export interface IPauseAgentCommand {
    isPause?: boolean;
    queueId?: number;
}

export class AudiosListVm implements IAudiosListVm {
    audios?: AudioDto[] | undefined;

    constructor(data?: IAudiosListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["audios"])) {
                this.audios = [] as any;
                for (let item of _data["audios"])
                    this.audios!.push(AudioDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AudiosListVm {
        data = typeof data === 'object' ? data : {};
        let result = new AudiosListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.audios)) {
            data["audios"] = [];
            for (let item of this.audios)
                data["audios"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAudiosListVm {
    audios?: AudioDto[] | undefined;
}

export class AudioDto implements IAudioDto {
    id?: number;
    name?: string | undefined;
    audioLanguages?: AudioLanguageDto[] | undefined;
    path?: string | undefined;
    pathAsterisk?: string | undefined;

    constructor(data?: IAudioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["audioLanguages"])) {
                this.audioLanguages = [] as any;
                for (let item of _data["audioLanguages"])
                    this.audioLanguages!.push(AudioLanguageDto.fromJS(item));
            }
            this.path = _data["path"];
            this.pathAsterisk = _data["pathAsterisk"];
        }
    }

    static fromJS(data: any): AudioDto {
        data = typeof data === 'object' ? data : {};
        let result = new AudioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.audioLanguages)) {
            data["audioLanguages"] = [];
            for (let item of this.audioLanguages)
                data["audioLanguages"].push(item.toJSON());
        }
        data["path"] = this.path;
        data["pathAsterisk"] = this.pathAsterisk;
        return data;
    }
}

export interface IAudioDto {
    id?: number;
    name?: string | undefined;
    audioLanguages?: AudioLanguageDto[] | undefined;
    path?: string | undefined;
    pathAsterisk?: string | undefined;
}

export class AudioLanguageDto implements IAudioLanguageDto {
    id?: number;
    name?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;
    languageName?: string | undefined;
    voiceId?: string | undefined;
    service?: string | undefined;
    gender?: string | undefined;
    path?: string | undefined;
    delete?: boolean;
    pathAsterisk?: string | undefined;
    isUpload?: boolean;
    fileName?: string | undefined;

    constructor(data?: IAudioLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.language = _data["language"];
            this.languageName = _data["languageName"];
            this.voiceId = _data["voiceId"];
            this.service = _data["service"];
            this.gender = _data["gender"];
            this.path = _data["path"];
            this.delete = _data["delete"];
            this.pathAsterisk = _data["pathAsterisk"];
            this.isUpload = _data["isUpload"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): AudioLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new AudioLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["content"] = this.content;
        data["language"] = this.language;
        data["languageName"] = this.languageName;
        data["voiceId"] = this.voiceId;
        data["service"] = this.service;
        data["gender"] = this.gender;
        data["path"] = this.path;
        data["delete"] = this.delete;
        data["pathAsterisk"] = this.pathAsterisk;
        data["isUpload"] = this.isUpload;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IAudioLanguageDto {
    id?: number;
    name?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;
    languageName?: string | undefined;
    voiceId?: string | undefined;
    service?: string | undefined;
    gender?: string | undefined;
    path?: string | undefined;
    delete?: boolean;
    pathAsterisk?: string | undefined;
    isUpload?: boolean;
    fileName?: string | undefined;
}

export class GetLanguageVm implements IGetLanguageVm {
    languages?: LanguageDto[] | undefined;

    constructor(data?: IGetLanguageVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(LanguageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageVm {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguageVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguageVm {
    languages?: LanguageDto[] | undefined;
}

export class LanguageDto implements ILanguageDto {
    name?: string | undefined;
    code?: string | undefined;

    constructor(data?: ILanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): LanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface ILanguageDto {
    name?: string | undefined;
    code?: string | undefined;
}

export class ListAllVoiceDto implements IListAllVoiceDto {
    allVoiceDtos?: AllVoiceDto[] | undefined;

    constructor(data?: IListAllVoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allVoiceDtos"])) {
                this.allVoiceDtos = [] as any;
                for (let item of _data["allVoiceDtos"])
                    this.allVoiceDtos!.push(AllVoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListAllVoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListAllVoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allVoiceDtos)) {
            data["allVoiceDtos"] = [];
            for (let item of this.allVoiceDtos)
                data["allVoiceDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListAllVoiceDto {
    allVoiceDtos?: AllVoiceDto[] | undefined;
}

export class AllVoiceDto implements IAllVoiceDto {
    name?: string | undefined;
    code?: string | undefined;
    language?: string | undefined;
    languageName?: string | undefined;
    voice?: VoiceList[] | undefined;

    constructor(data?: IAllVoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.language = _data["language"];
            this.languageName = _data["languageName"];
            if (Array.isArray(_data["voice"])) {
                this.voice = [] as any;
                for (let item of _data["voice"])
                    this.voice!.push(VoiceList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllVoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllVoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["language"] = this.language;
        data["languageName"] = this.languageName;
        if (Array.isArray(this.voice)) {
            data["voice"] = [];
            for (let item of this.voice)
                data["voice"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAllVoiceDto {
    name?: string | undefined;
    code?: string | undefined;
    language?: string | undefined;
    languageName?: string | undefined;
    voice?: VoiceList[] | undefined;
}

export class VoiceList implements IVoiceList {
    voiceId?: string | undefined;
    gender?: string | undefined;

    constructor(data?: IVoiceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voiceId = _data["voiceId"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): VoiceList {
        data = typeof data === 'object' ? data : {};
        let result = new VoiceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voiceId"] = this.voiceId;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IVoiceList {
    voiceId?: string | undefined;
    gender?: string | undefined;
}

export class LanguageAllService implements ILanguageAllService {
    name?: string | undefined;
    code?: Code | undefined;

    constructor(data?: ILanguageAllService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"] ? Code.fromJS(_data["code"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LanguageAllService {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageAllService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code ? this.code.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILanguageAllService {
    name?: string | undefined;
    code?: Code | undefined;
}

export class Code implements ICode {
    amazon?: string | undefined;
    google?: string | undefined;
    azure?: string | undefined;
    primas?: string | undefined;
    soundhound?: string | undefined;

    constructor(data?: ICode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amazon = _data["amazon"];
            this.google = _data["google"];
            this.azure = _data["azure"];
            this.primas = _data["primas"];
            this.soundhound = _data["soundhound"];
        }
    }

    static fromJS(data: any): Code {
        data = typeof data === 'object' ? data : {};
        let result = new Code();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amazon"] = this.amazon;
        data["google"] = this.google;
        data["azure"] = this.azure;
        data["primas"] = this.primas;
        data["soundhound"] = this.soundhound;
        return data;
    }
}

export interface ICode {
    amazon?: string | undefined;
    google?: string | undefined;
    azure?: string | undefined;
    primas?: string | undefined;
    soundhound?: string | undefined;
}

export class GetVoiceVm implements IGetVoiceVm {
    voices?: VoiceDto[] | undefined;

    constructor(data?: IGetVoiceVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["voices"])) {
                this.voices = [] as any;
                for (let item of _data["voices"])
                    this.voices!.push(VoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetVoiceVm {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoiceVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.voices)) {
            data["voices"] = [];
            for (let item of this.voices)
                data["voices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetVoiceVm {
    voices?: VoiceDto[] | undefined;
}

export class VoiceDto implements IVoiceDto {
    id?: string | undefined;
    name?: string | undefined;
    gender?: string | undefined;

    constructor(data?: IVoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): VoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IVoiceDto {
    id?: string | undefined;
    name?: string | undefined;
    gender?: string | undefined;
}

export class CreateAudioCommand implements ICreateAudioCommand {
    name?: string | undefined;
    audioFile?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;
    voiceId?: string | undefined;
    service?: ServiceTTS;
    path?: string | undefined;
    pathAsterisk?: string | undefined;
    companyId?: number;
    isUpload?: boolean;

    constructor(data?: ICreateAudioCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.audioFile = _data["audioFile"];
            this.content = _data["content"];
            this.language = _data["language"];
            this.voiceId = _data["voiceId"];
            this.service = _data["service"];
            this.path = _data["path"];
            this.pathAsterisk = _data["pathAsterisk"];
            this.companyId = _data["companyId"];
            this.isUpload = _data["isUpload"];
        }
    }

    static fromJS(data: any): CreateAudioCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAudioCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["audioFile"] = this.audioFile;
        data["content"] = this.content;
        data["language"] = this.language;
        data["voiceId"] = this.voiceId;
        data["service"] = this.service;
        data["path"] = this.path;
        data["pathAsterisk"] = this.pathAsterisk;
        data["companyId"] = this.companyId;
        data["isUpload"] = this.isUpload;
        return data;
    }
}

export interface ICreateAudioCommand {
    name?: string | undefined;
    audioFile?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;
    voiceId?: string | undefined;
    service?: ServiceTTS;
    path?: string | undefined;
    pathAsterisk?: string | undefined;
    companyId?: number;
    isUpload?: boolean;
}

export class ConvertAudioCommand implements IConvertAudioCommand {
    content?: string | undefined;
    service?: ServiceTTS;
    language?: string | undefined;
    voiceId?: string | undefined;

    constructor(data?: IConvertAudioCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.service = _data["service"];
            this.language = _data["language"];
            this.voiceId = _data["voiceId"];
        }
    }

    static fromJS(data: any): ConvertAudioCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConvertAudioCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["service"] = this.service;
        data["language"] = this.language;
        data["voiceId"] = this.voiceId;
        return data;
    }
}

export interface IConvertAudioCommand {
    content?: string | undefined;
    service?: ServiceTTS;
    language?: string | undefined;
    voiceId?: string | undefined;
}

export class AudioLanguageListVm implements IAudioLanguageListVm {
    audioLanguages?: AudioLanguageDto[] | undefined;

    constructor(data?: IAudioLanguageListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["audioLanguages"])) {
                this.audioLanguages = [] as any;
                for (let item of _data["audioLanguages"])
                    this.audioLanguages!.push(AudioLanguageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AudioLanguageListVm {
        data = typeof data === 'object' ? data : {};
        let result = new AudioLanguageListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.audioLanguages)) {
            data["audioLanguages"] = [];
            for (let item of this.audioLanguages)
                data["audioLanguages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAudioLanguageListVm {
    audioLanguages?: AudioLanguageDto[] | undefined;
}

export class CreateAudioLanguageCommand implements ICreateAudioLanguageCommand {
    name?: string | undefined;
    content?: string | undefined;
    audioId?: number;
    audioFile?: string | undefined;
    fileName?: string | undefined;
    language?: string | undefined;
    languageName?: string | undefined;
    voiceId?: string | undefined;
    gender?: string | undefined;
    service?: ServiceTTS;
    path?: string | undefined;
    pathAsterisk?: string | undefined;
    companyId?: number;
    isUpload?: boolean;

    constructor(data?: ICreateAudioLanguageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.content = _data["content"];
            this.audioId = _data["audioId"];
            this.audioFile = _data["audioFile"];
            this.fileName = _data["fileName"];
            this.language = _data["language"];
            this.languageName = _data["languageName"];
            this.voiceId = _data["voiceId"];
            this.gender = _data["gender"];
            this.service = _data["service"];
            this.path = _data["path"];
            this.pathAsterisk = _data["pathAsterisk"];
            this.companyId = _data["companyId"];
            this.isUpload = _data["isUpload"];
        }
    }

    static fromJS(data: any): CreateAudioLanguageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAudioLanguageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["content"] = this.content;
        data["audioId"] = this.audioId;
        data["audioFile"] = this.audioFile;
        data["fileName"] = this.fileName;
        data["language"] = this.language;
        data["languageName"] = this.languageName;
        data["voiceId"] = this.voiceId;
        data["gender"] = this.gender;
        data["service"] = this.service;
        data["path"] = this.path;
        data["pathAsterisk"] = this.pathAsterisk;
        data["companyId"] = this.companyId;
        data["isUpload"] = this.isUpload;
        return data;
    }
}

export interface ICreateAudioLanguageCommand {
    name?: string | undefined;
    content?: string | undefined;
    audioId?: number;
    audioFile?: string | undefined;
    fileName?: string | undefined;
    language?: string | undefined;
    languageName?: string | undefined;
    voiceId?: string | undefined;
    gender?: string | undefined;
    service?: ServiceTTS;
    path?: string | undefined;
    pathAsterisk?: string | undefined;
    companyId?: number;
    isUpload?: boolean;
}

export class UpdateAudioLanguageCommand implements IUpdateAudioLanguageCommand {
    name?: string | undefined;
    content?: string | undefined;
    audioId?: number;
    audioFile?: string | undefined;
    fileName?: string | undefined;
    language?: string | undefined;
    languageName?: string | undefined;
    voiceId?: string | undefined;
    gender?: string | undefined;
    service?: ServiceTTS;
    path?: string | undefined;
    pathAsterisk?: string | undefined;
    companyId?: number;
    isUpload?: boolean;

    constructor(data?: IUpdateAudioLanguageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.content = _data["content"];
            this.audioId = _data["audioId"];
            this.audioFile = _data["audioFile"];
            this.fileName = _data["fileName"];
            this.language = _data["language"];
            this.languageName = _data["languageName"];
            this.voiceId = _data["voiceId"];
            this.gender = _data["gender"];
            this.service = _data["service"];
            this.path = _data["path"];
            this.pathAsterisk = _data["pathAsterisk"];
            this.companyId = _data["companyId"];
            this.isUpload = _data["isUpload"];
        }
    }

    static fromJS(data: any): UpdateAudioLanguageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAudioLanguageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["content"] = this.content;
        data["audioId"] = this.audioId;
        data["audioFile"] = this.audioFile;
        data["fileName"] = this.fileName;
        data["language"] = this.language;
        data["languageName"] = this.languageName;
        data["voiceId"] = this.voiceId;
        data["gender"] = this.gender;
        data["service"] = this.service;
        data["path"] = this.path;
        data["pathAsterisk"] = this.pathAsterisk;
        data["companyId"] = this.companyId;
        data["isUpload"] = this.isUpload;
        return data;
    }
}

export interface IUpdateAudioLanguageCommand {
    name?: string | undefined;
    content?: string | undefined;
    audioId?: number;
    audioFile?: string | undefined;
    fileName?: string | undefined;
    language?: string | undefined;
    languageName?: string | undefined;
    voiceId?: string | undefined;
    gender?: string | undefined;
    service?: ServiceTTS;
    path?: string | undefined;
    pathAsterisk?: string | undefined;
    companyId?: number;
    isUpload?: boolean;
}

export class AuthenticateModel implements IAuthenticateModel {
    email?: string | undefined;
    password?: string | undefined;
    companyName?: string | undefined;
    phoneNumber?: string | undefined;
    sample?: boolean;
    companyAddress?: string | undefined;
    sendMail?: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.companyName = _data["companyName"];
            this.phoneNumber = _data["phoneNumber"];
            this.sample = _data["sample"];
            this.companyAddress = _data["companyAddress"];
            this.sendMail = _data["sendMail"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["companyName"] = this.companyName;
        data["phoneNumber"] = this.phoneNumber;
        data["sample"] = this.sample;
        data["companyAddress"] = this.companyAddress;
        data["sendMail"] = this.sendMail;
        return data;
    }
}

export interface IAuthenticateModel {
    email?: string | undefined;
    password?: string | undefined;
    companyName?: string | undefined;
    phoneNumber?: string | undefined;
    sample?: boolean;
    companyAddress?: string | undefined;
    sendMail?: boolean;
}

export class CostsListVm implements ICostsListVm {
    costVm?: CostLookup[] | undefined;

    constructor(data?: ICostsListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["costVm"])) {
                this.costVm = [] as any;
                for (let item of _data["costVm"])
                    this.costVm!.push(CostLookup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CostsListVm {
        data = typeof data === 'object' ? data : {};
        let result = new CostsListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costVm)) {
            data["costVm"] = [];
            for (let item of this.costVm)
                data["costVm"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICostsListVm {
    costVm?: CostLookup[] | undefined;
}

export class CostLookup implements ICostLookup {
    monthYear?: string | undefined;
    monthlyFlatCost?: number;
    perMinuteCost?: number;
    storageCost?: number;
    extensionCost?: number;
    tax?: number;
    companyName?: string | undefined;
    companyId?: number;
    sendStatus?: boolean;

    constructor(data?: ICostLookup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthYear = _data["monthYear"];
            this.monthlyFlatCost = _data["monthlyFlatCost"];
            this.perMinuteCost = _data["perMinuteCost"];
            this.storageCost = _data["storageCost"];
            this.extensionCost = _data["extensionCost"];
            this.tax = _data["tax"];
            this.companyName = _data["companyName"];
            this.companyId = _data["companyId"];
            this.sendStatus = _data["sendStatus"];
        }
    }

    static fromJS(data: any): CostLookup {
        data = typeof data === 'object' ? data : {};
        let result = new CostLookup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthYear"] = this.monthYear;
        data["monthlyFlatCost"] = this.monthlyFlatCost;
        data["perMinuteCost"] = this.perMinuteCost;
        data["storageCost"] = this.storageCost;
        data["extensionCost"] = this.extensionCost;
        data["tax"] = this.tax;
        data["companyName"] = this.companyName;
        data["companyId"] = this.companyId;
        data["sendStatus"] = this.sendStatus;
        return data;
    }
}

export interface ICostLookup {
    monthYear?: string | undefined;
    monthlyFlatCost?: number;
    perMinuteCost?: number;
    storageCost?: number;
    extensionCost?: number;
    tax?: number;
    companyName?: string | undefined;
    companyId?: number;
    sendStatus?: boolean;
}

export class UpdateCurrentCostCommand implements IUpdateCurrentCostCommand {
    companyId?: number;
    monthlyFlatCost?: number;
    perMinuteCost?: number;
    storageCost?: number;
    extensionCost?: number;
    tax?: number;
    emailBilling?: string | undefined;

    constructor(data?: IUpdateCurrentCostCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.monthlyFlatCost = _data["monthlyFlatCost"];
            this.perMinuteCost = _data["perMinuteCost"];
            this.storageCost = _data["storageCost"];
            this.extensionCost = _data["extensionCost"];
            this.tax = _data["tax"];
            this.emailBilling = _data["emailBilling"];
        }
    }

    static fromJS(data: any): UpdateCurrentCostCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCurrentCostCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["monthlyFlatCost"] = this.monthlyFlatCost;
        data["perMinuteCost"] = this.perMinuteCost;
        data["storageCost"] = this.storageCost;
        data["extensionCost"] = this.extensionCost;
        data["tax"] = this.tax;
        data["emailBilling"] = this.emailBilling;
        return data;
    }
}

export interface IUpdateCurrentCostCommand {
    companyId?: number;
    monthlyFlatCost?: number;
    perMinuteCost?: number;
    storageCost?: number;
    extensionCost?: number;
    tax?: number;
    emailBilling?: string | undefined;
}

export class CurrentCostVm implements ICurrentCostVm {
    costVm?: CostLookup | undefined;
    emailBilling?: string | undefined;

    constructor(data?: ICurrentCostVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costVm = _data["costVm"] ? CostLookup.fromJS(_data["costVm"]) : <any>undefined;
            this.emailBilling = _data["emailBilling"];
        }
    }

    static fromJS(data: any): CurrentCostVm {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentCostVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costVm"] = this.costVm ? this.costVm.toJSON() : <any>undefined;
        data["emailBilling"] = this.emailBilling;
        return data;
    }
}

export interface ICurrentCostVm {
    costVm?: CostLookup | undefined;
    emailBilling?: string | undefined;
}

export class InvoiceListVm implements IInvoiceListVm {
    invoiceVm?: InvoiceVm[] | undefined;

    constructor(data?: IInvoiceListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoiceVm"])) {
                this.invoiceVm = [] as any;
                for (let item of _data["invoiceVm"])
                    this.invoiceVm!.push(InvoiceVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceListVm {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoiceVm)) {
            data["invoiceVm"] = [];
            for (let item of this.invoiceVm)
                data["invoiceVm"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvoiceListVm {
    invoiceVm?: InvoiceVm[] | undefined;
}

export class InvoiceVm implements IInvoiceVm {
    id?: number;
    invoiceNumber?: string | undefined;
    monthYear?: string | undefined;
    companyId?: number;
    companyName?: string | undefined;
    total?: number;
    status?: boolean;
    dueDate?: string | undefined;
    sendStatus?: boolean;

    constructor(data?: IInvoiceVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.monthYear = _data["monthYear"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.total = _data["total"];
            this.status = _data["status"];
            this.dueDate = _data["dueDate"];
            this.sendStatus = _data["sendStatus"];
        }
    }

    static fromJS(data: any): InvoiceVm {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["monthYear"] = this.monthYear;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["total"] = this.total;
        data["status"] = this.status;
        data["dueDate"] = this.dueDate;
        data["sendStatus"] = this.sendStatus;
        return data;
    }
}

export interface IInvoiceVm {
    id?: number;
    invoiceNumber?: string | undefined;
    monthYear?: string | undefined;
    companyId?: number;
    companyName?: string | undefined;
    total?: number;
    status?: boolean;
    dueDate?: string | undefined;
    sendStatus?: boolean;
}

export class InvoiceDetail implements IInvoiceDetail {
    invoiceNumber?: string | undefined;
    monthYear?: string | undefined;
    companyName?: string | undefined;
    monthlyFlatCostAmount?: number;
    extensionAmount?: number;
    storageAmount?: number;
    didAmount?: number;
    perMinuteAmount?: number;
    subTotal?: number;
    taxAmount?: number;
    tax?: number;
    total?: number;
    dueDate?: string | undefined;
    extensionTotal?: number;
    storageTotal?: number;
    status?: boolean;
    didTotal?: string | undefined;
    perMinuteTotal?: number;

    constructor(data?: IInvoiceDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNumber = _data["invoiceNumber"];
            this.monthYear = _data["monthYear"];
            this.companyName = _data["companyName"];
            this.monthlyFlatCostAmount = _data["monthlyFlatCostAmount"];
            this.extensionAmount = _data["extensionAmount"];
            this.storageAmount = _data["storageAmount"];
            this.didAmount = _data["didAmount"];
            this.perMinuteAmount = _data["perMinuteAmount"];
            this.subTotal = _data["subTotal"];
            this.taxAmount = _data["taxAmount"];
            this.tax = _data["tax"];
            this.total = _data["total"];
            this.dueDate = _data["dueDate"];
            this.extensionTotal = _data["extensionTotal"];
            this.storageTotal = _data["storageTotal"];
            this.status = _data["status"];
            this.didTotal = _data["didTotal"];
            this.perMinuteTotal = _data["perMinuteTotal"];
        }
    }

    static fromJS(data: any): InvoiceDetail {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["monthYear"] = this.monthYear;
        data["companyName"] = this.companyName;
        data["monthlyFlatCostAmount"] = this.monthlyFlatCostAmount;
        data["extensionAmount"] = this.extensionAmount;
        data["storageAmount"] = this.storageAmount;
        data["didAmount"] = this.didAmount;
        data["perMinuteAmount"] = this.perMinuteAmount;
        data["subTotal"] = this.subTotal;
        data["taxAmount"] = this.taxAmount;
        data["tax"] = this.tax;
        data["total"] = this.total;
        data["dueDate"] = this.dueDate;
        data["extensionTotal"] = this.extensionTotal;
        data["storageTotal"] = this.storageTotal;
        data["status"] = this.status;
        data["didTotal"] = this.didTotal;
        data["perMinuteTotal"] = this.perMinuteTotal;
        return data;
    }
}

export interface IInvoiceDetail {
    invoiceNumber?: string | undefined;
    monthYear?: string | undefined;
    companyName?: string | undefined;
    monthlyFlatCostAmount?: number;
    extensionAmount?: number;
    storageAmount?: number;
    didAmount?: number;
    perMinuteAmount?: number;
    subTotal?: number;
    taxAmount?: number;
    tax?: number;
    total?: number;
    dueDate?: string | undefined;
    extensionTotal?: number;
    storageTotal?: number;
    status?: boolean;
    didTotal?: string | undefined;
    perMinuteTotal?: number;
}

export class CallDataList implements ICallDataList {
    callDataDtos?: CallDataDto[] | undefined;

    constructor(data?: ICallDataList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["callDataDtos"])) {
                this.callDataDtos = [] as any;
                for (let item of _data["callDataDtos"])
                    this.callDataDtos!.push(CallDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CallDataList {
        data = typeof data === 'object' ? data : {};
        let result = new CallDataList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.callDataDtos)) {
            data["callDataDtos"] = [];
            for (let item of this.callDataDtos)
                data["callDataDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICallDataList {
    callDataDtos?: CallDataDto[] | undefined;
}

export class CallDataDto implements ICallDataDto {
    id?: number;
    callID?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    callFlowId?: string | undefined;
    callFlowName?: string | undefined;
    label?: string | undefined;
    note?: string | undefined;
    created?: Date;

    constructor(data?: ICallDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.callID = _data["callID"];
            this.fromNumber = _data["fromNumber"];
            this.toNumber = _data["toNumber"];
            this.callFlowId = _data["callFlowId"];
            this.callFlowName = _data["callFlowName"];
            this.label = _data["label"];
            this.note = _data["note"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CallDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["callID"] = this.callID;
        data["fromNumber"] = this.fromNumber;
        data["toNumber"] = this.toNumber;
        data["callFlowId"] = this.callFlowId;
        data["callFlowName"] = this.callFlowName;
        data["label"] = this.label;
        data["note"] = this.note;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICallDataDto {
    id?: number;
    callID?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    callFlowId?: string | undefined;
    callFlowName?: string | undefined;
    label?: string | undefined;
    note?: string | undefined;
    created?: Date;
}

export class GetAllCallDataQuery implements IGetAllCallDataQuery {
    phoneNumber?: string | undefined;
    datasetId?: number;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    type?: string | undefined;

    constructor(data?: IGetAllCallDataQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.datasetId = _data["datasetId"];
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GetAllCallDataQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCallDataQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["datasetId"] = this.datasetId;
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["type"] = this.type;
        return data;
    }
}

export interface IGetAllCallDataQuery {
    phoneNumber?: string | undefined;
    datasetId?: number;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    type?: string | undefined;
}

export class ExportCallDataCommand implements IExportCallDataCommand {
    callDataDtos?: CallDataDto[] | undefined;
    name?: string | undefined;
    id?: number;

    constructor(data?: IExportCallDataCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["callDataDtos"])) {
                this.callDataDtos = [] as any;
                for (let item of _data["callDataDtos"])
                    this.callDataDtos!.push(CallDataDto.fromJS(item));
            }
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExportCallDataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportCallDataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.callDataDtos)) {
            data["callDataDtos"] = [];
            for (let item of this.callDataDtos)
                data["callDataDtos"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IExportCallDataCommand {
    callDataDtos?: CallDataDto[] | undefined;
    name?: string | undefined;
    id?: number;
}

export class CreateCallDataCommand implements ICreateCallDataCommand {
    callID?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    label?: string | undefined;
    datasetId?: number;
    callFlowId?: number;
    note?: string | undefined;

    constructor(data?: ICreateCallDataCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callID = _data["callID"];
            this.fromNumber = _data["fromNumber"];
            this.toNumber = _data["toNumber"];
            this.label = _data["label"];
            this.datasetId = _data["datasetId"];
            this.callFlowId = _data["callFlowId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateCallDataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCallDataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callID"] = this.callID;
        data["fromNumber"] = this.fromNumber;
        data["toNumber"] = this.toNumber;
        data["label"] = this.label;
        data["datasetId"] = this.datasetId;
        data["callFlowId"] = this.callFlowId;
        data["note"] = this.note;
        return data;
    }
}

export interface ICreateCallDataCommand {
    callID?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    label?: string | undefined;
    datasetId?: number;
    callFlowId?: number;
    note?: string | undefined;
}

export class CallerResponseTrainListVm implements ICallerResponseTrainListVm {
    callerResponseTrainDtos?: CallerResponseTrainDto[] | undefined;
    page?: Page | undefined;

    constructor(data?: ICallerResponseTrainListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["callerResponseTrainDtos"])) {
                this.callerResponseTrainDtos = [] as any;
                for (let item of _data["callerResponseTrainDtos"])
                    this.callerResponseTrainDtos!.push(CallerResponseTrainDto.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CallerResponseTrainListVm {
        data = typeof data === 'object' ? data : {};
        let result = new CallerResponseTrainListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.callerResponseTrainDtos)) {
            data["callerResponseTrainDtos"] = [];
            for (let item of this.callerResponseTrainDtos)
                data["callerResponseTrainDtos"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICallerResponseTrainListVm {
    callerResponseTrainDtos?: CallerResponseTrainDto[] | undefined;
    page?: Page | undefined;
}

export class CallerResponseTrainDto implements ICallerResponseTrainDto {
    id?: number;
    companyId?: number;
    callFlowName?: string | undefined;
    callFlowId?: number;
    callId?: string | undefined;
    text?: string | undefined;
    voice?: string | undefined;
    grammarType?: string | undefined;
    grammarName?: string | undefined;
    source?: string | undefined;
    count?: number;
    created?: Date;
    serverFile?: string | undefined;

    constructor(data?: ICallerResponseTrainDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.callFlowName = _data["callFlowName"];
            this.callFlowId = _data["callFlowId"];
            this.callId = _data["callId"];
            this.text = _data["text"];
            this.voice = _data["voice"];
            this.grammarType = _data["grammarType"];
            this.grammarName = _data["grammarName"];
            this.source = _data["source"];
            this.count = _data["count"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.serverFile = _data["serverFile"];
        }
    }

    static fromJS(data: any): CallerResponseTrainDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallerResponseTrainDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["callFlowName"] = this.callFlowName;
        data["callFlowId"] = this.callFlowId;
        data["callId"] = this.callId;
        data["text"] = this.text;
        data["voice"] = this.voice;
        data["grammarType"] = this.grammarType;
        data["grammarName"] = this.grammarName;
        data["source"] = this.source;
        data["count"] = this.count;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["serverFile"] = this.serverFile;
        return data;
    }
}

export interface ICallerResponseTrainDto {
    id?: number;
    companyId?: number;
    callFlowName?: string | undefined;
    callFlowId?: number;
    callId?: string | undefined;
    text?: string | undefined;
    voice?: string | undefined;
    grammarType?: string | undefined;
    grammarName?: string | undefined;
    source?: string | undefined;
    count?: number;
    created?: Date;
    serverFile?: string | undefined;
}

export class GetAllCallerResponseTrainQuery implements IGetAllCallerResponseTrainQuery {
    page?: Page | undefined;
    grammarType?: string | undefined;
    grammarName?: string | undefined;
    searchText?: string | undefined;
    type?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetAllCallerResponseTrainQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.grammarType = _data["grammarType"];
            this.grammarName = _data["grammarName"];
            this.searchText = _data["searchText"];
            this.type = _data["type"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllCallerResponseTrainQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCallerResponseTrainQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["grammarType"] = this.grammarType;
        data["grammarName"] = this.grammarName;
        data["searchText"] = this.searchText;
        data["type"] = this.type;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllCallerResponseTrainQuery {
    page?: Page | undefined;
    grammarType?: string | undefined;
    grammarName?: string | undefined;
    searchText?: string | undefined;
    type?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class CreateCallerResponseTrainCommand implements ICreateCallerResponseTrainCommand {
    companyId?: number;
    callFlowId?: number;
    callId?: string | undefined;
    text?: string | undefined;
    voice?: string | undefined;
    grammarType?: string | undefined;
    grammarName?: string | undefined;
    source?: string | undefined;
    serverFile?: string | undefined;
    responseList?: CallerResponseTrainModel[] | undefined;

    constructor(data?: ICreateCallerResponseTrainCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.callFlowId = _data["callFlowId"];
            this.callId = _data["callId"];
            this.text = _data["text"];
            this.voice = _data["voice"];
            this.grammarType = _data["grammarType"];
            this.grammarName = _data["grammarName"];
            this.source = _data["source"];
            this.serverFile = _data["serverFile"];
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(CallerResponseTrainModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCallerResponseTrainCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCallerResponseTrainCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["callFlowId"] = this.callFlowId;
        data["callId"] = this.callId;
        data["text"] = this.text;
        data["voice"] = this.voice;
        data["grammarType"] = this.grammarType;
        data["grammarName"] = this.grammarName;
        data["source"] = this.source;
        data["serverFile"] = this.serverFile;
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateCallerResponseTrainCommand {
    companyId?: number;
    callFlowId?: number;
    callId?: string | undefined;
    text?: string | undefined;
    voice?: string | undefined;
    grammarType?: string | undefined;
    grammarName?: string | undefined;
    source?: string | undefined;
    serverFile?: string | undefined;
    responseList?: CallerResponseTrainModel[] | undefined;
}

export class CallerResponseTrainModel implements ICallerResponseTrainModel {
    grammarType?: string | undefined;
    grammarName?: string | undefined;

    constructor(data?: ICallerResponseTrainModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grammarType = _data["grammarType"];
            this.grammarName = _data["grammarName"];
        }
    }

    static fromJS(data: any): CallerResponseTrainModel {
        data = typeof data === 'object' ? data : {};
        let result = new CallerResponseTrainModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grammarType"] = this.grammarType;
        data["grammarName"] = this.grammarName;
        return data;
    }
}

export interface ICallerResponseTrainModel {
    grammarType?: string | undefined;
    grammarName?: string | undefined;
}

export class ExportCallerResponseTrain implements IExportCallerResponseTrain {
    callerResponseTrainList?: CallerResponseTrainDto[] | undefined;

    constructor(data?: IExportCallerResponseTrain) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["callerResponseTrainList"])) {
                this.callerResponseTrainList = [] as any;
                for (let item of _data["callerResponseTrainList"])
                    this.callerResponseTrainList!.push(CallerResponseTrainDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportCallerResponseTrain {
        data = typeof data === 'object' ? data : {};
        let result = new ExportCallerResponseTrain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.callerResponseTrainList)) {
            data["callerResponseTrainList"] = [];
            for (let item of this.callerResponseTrainList)
                data["callerResponseTrainList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExportCallerResponseTrain {
    callerResponseTrainList?: CallerResponseTrainDto[] | undefined;
}

export class CallFlowsListVm implements ICallFlowsListVm {
    callFlows?: CallFlowLookupDto[] | undefined;
    page?: Page | undefined;

    constructor(data?: ICallFlowsListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["callFlows"])) {
                this.callFlows = [] as any;
                for (let item of _data["callFlows"])
                    this.callFlows!.push(CallFlowLookupDto.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CallFlowsListVm {
        data = typeof data === 'object' ? data : {};
        let result = new CallFlowsListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.callFlows)) {
            data["callFlows"] = [];
            for (let item of this.callFlows)
                data["callFlows"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICallFlowsListVm {
    callFlows?: CallFlowLookupDto[] | undefined;
    page?: Page | undefined;
}

export class CallFlowLookupDto implements ICallFlowLookupDto {
    id?: number;
    name?: string | undefined;
    listPhoneNumberUse?: string | undefined;
    listBotContactUse?: string | undefined;
    companyId?: number;
    isSubFlow?: boolean;
    tags?: string | undefined;
    category?: string | undefined;
    attribute?: string | undefined;
    chatUrl?: string | undefined;
    defaultAgent?: string | undefined;
    virtualAssistantUrl?: string | undefined;
    lastPublishedBy?: string | undefined;
    lastPublishedName?: string | undefined;
    lastPublishedAvatar?: string | undefined;
    lastPublished?: Date | undefined;
    lastPublishedString?: string | undefined;
    disable?: boolean;

    constructor(data?: ICallFlowLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.listPhoneNumberUse = _data["listPhoneNumberUse"];
            this.listBotContactUse = _data["listBotContactUse"];
            this.companyId = _data["companyId"];
            this.isSubFlow = _data["isSubFlow"];
            this.tags = _data["tags"];
            this.category = _data["category"];
            this.attribute = _data["attribute"];
            this.chatUrl = _data["chatUrl"];
            this.defaultAgent = _data["defaultAgent"];
            this.virtualAssistantUrl = _data["virtualAssistantUrl"];
            this.lastPublishedBy = _data["lastPublishedBy"];
            this.lastPublishedName = _data["lastPublishedName"];
            this.lastPublishedAvatar = _data["lastPublishedAvatar"];
            this.lastPublished = _data["lastPublished"] ? new Date(_data["lastPublished"].toString()) : <any>undefined;
            this.lastPublishedString = _data["lastPublishedString"];
            this.disable = _data["disable"];
        }
    }

    static fromJS(data: any): CallFlowLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallFlowLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["listPhoneNumberUse"] = this.listPhoneNumberUse;
        data["listBotContactUse"] = this.listBotContactUse;
        data["companyId"] = this.companyId;
        data["isSubFlow"] = this.isSubFlow;
        data["tags"] = this.tags;
        data["category"] = this.category;
        data["attribute"] = this.attribute;
        data["chatUrl"] = this.chatUrl;
        data["defaultAgent"] = this.defaultAgent;
        data["virtualAssistantUrl"] = this.virtualAssistantUrl;
        data["lastPublishedBy"] = this.lastPublishedBy;
        data["lastPublishedName"] = this.lastPublishedName;
        data["lastPublishedAvatar"] = this.lastPublishedAvatar;
        data["lastPublished"] = this.lastPublished ? this.lastPublished.toISOString() : <any>undefined;
        data["lastPublishedString"] = this.lastPublishedString;
        data["disable"] = this.disable;
        return data;
    }
}

export interface ICallFlowLookupDto {
    id?: number;
    name?: string | undefined;
    listPhoneNumberUse?: string | undefined;
    listBotContactUse?: string | undefined;
    companyId?: number;
    isSubFlow?: boolean;
    tags?: string | undefined;
    category?: string | undefined;
    attribute?: string | undefined;
    chatUrl?: string | undefined;
    defaultAgent?: string | undefined;
    virtualAssistantUrl?: string | undefined;
    lastPublishedBy?: string | undefined;
    lastPublishedName?: string | undefined;
    lastPublishedAvatar?: string | undefined;
    lastPublished?: Date | undefined;
    lastPublishedString?: string | undefined;
    disable?: boolean;
}

export class GetCallFlowsListQuery implements IGetCallFlowsListQuery {
    companyId?: number;
    tags?: string | undefined;
    searchText?: string | undefined;
    page?: Page | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetCallFlowsListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.tags = _data["tags"];
            this.searchText = _data["searchText"];
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCallFlowsListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCallFlowsListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["tags"] = this.tags;
        data["searchText"] = this.searchText;
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCallFlowsListQuery {
    companyId?: number;
    tags?: string | undefined;
    searchText?: string | undefined;
    page?: Page | undefined;
    filterData?: FilterData[] | undefined;
}

export class CallFlowDto implements ICallFlowDto {
    id?: number;
    data?: string | undefined;
    attribute?: string | undefined;
    listPhoneNumberUse?: string | undefined;
    listBotContactUse?: string | undefined;
    companyId?: number;
    name?: string | undefined;
    jsonFormat?: string | undefined;
    tags?: string | undefined;
    isSubFlow?: boolean;
    callSettings?: CallSettingDto[] | undefined;
    disable?: boolean;
    chatUrl?: string | undefined;
    virtualAssistantUrl?: string | undefined;

    constructor(data?: ICallFlowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.data = _data["data"];
            this.attribute = _data["attribute"];
            this.listPhoneNumberUse = _data["listPhoneNumberUse"];
            this.listBotContactUse = _data["listBotContactUse"];
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.jsonFormat = _data["jsonFormat"];
            this.tags = _data["tags"];
            this.isSubFlow = _data["isSubFlow"];
            if (Array.isArray(_data["callSettings"])) {
                this.callSettings = [] as any;
                for (let item of _data["callSettings"])
                    this.callSettings!.push(CallSettingDto.fromJS(item));
            }
            this.disable = _data["disable"];
            this.chatUrl = _data["chatUrl"];
            this.virtualAssistantUrl = _data["virtualAssistantUrl"];
        }
    }

    static fromJS(data: any): CallFlowDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallFlowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["data"] = this.data;
        data["attribute"] = this.attribute;
        data["listPhoneNumberUse"] = this.listPhoneNumberUse;
        data["listBotContactUse"] = this.listBotContactUse;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["jsonFormat"] = this.jsonFormat;
        data["tags"] = this.tags;
        data["isSubFlow"] = this.isSubFlow;
        if (Array.isArray(this.callSettings)) {
            data["callSettings"] = [];
            for (let item of this.callSettings)
                data["callSettings"].push(item.toJSON());
        }
        data["disable"] = this.disable;
        data["chatUrl"] = this.chatUrl;
        data["virtualAssistantUrl"] = this.virtualAssistantUrl;
        return data;
    }
}

export interface ICallFlowDto {
    id?: number;
    data?: string | undefined;
    attribute?: string | undefined;
    listPhoneNumberUse?: string | undefined;
    listBotContactUse?: string | undefined;
    companyId?: number;
    name?: string | undefined;
    jsonFormat?: string | undefined;
    tags?: string | undefined;
    isSubFlow?: boolean;
    callSettings?: CallSettingDto[] | undefined;
    disable?: boolean;
    chatUrl?: string | undefined;
    virtualAssistantUrl?: string | undefined;
}

export class CallSettingDto implements ICallSettingDto {
    id?: number;
    callFlowId?: number;
    callFlowName?: string | undefined;
    enableRecording?: boolean;
    languageSetting?: string | undefined;
    transcribeService?: string | undefined;
    prompts?: string | undefined;
    defaultLanguage?: string | undefined;
    speechToTextService?: string | undefined;
    detectLanguage?: boolean;
    botContact?: string | undefined;
    selectedPhoneNumbers?: string | undefined;
    media?: string | undefined;
    botName?: string | undefined;
    botGreetingMessages?: string | undefined;
    botLogo?: string | undefined;
    allowLogInfo?: boolean;
    translateService?: ServiceTranslate;

    constructor(data?: ICallSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.callFlowId = _data["callFlowId"];
            this.callFlowName = _data["callFlowName"];
            this.enableRecording = _data["enableRecording"];
            this.languageSetting = _data["languageSetting"];
            this.transcribeService = _data["transcribeService"];
            this.prompts = _data["prompts"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.speechToTextService = _data["speechToTextService"];
            this.detectLanguage = _data["detectLanguage"];
            this.botContact = _data["botContact"];
            this.selectedPhoneNumbers = _data["selectedPhoneNumbers"];
            this.media = _data["media"];
            this.botName = _data["botName"];
            this.botGreetingMessages = _data["botGreetingMessages"];
            this.botLogo = _data["botLogo"];
            this.allowLogInfo = _data["allowLogInfo"];
            this.translateService = _data["translateService"];
        }
    }

    static fromJS(data: any): CallSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["callFlowId"] = this.callFlowId;
        data["callFlowName"] = this.callFlowName;
        data["enableRecording"] = this.enableRecording;
        data["languageSetting"] = this.languageSetting;
        data["transcribeService"] = this.transcribeService;
        data["prompts"] = this.prompts;
        data["defaultLanguage"] = this.defaultLanguage;
        data["speechToTextService"] = this.speechToTextService;
        data["detectLanguage"] = this.detectLanguage;
        data["botContact"] = this.botContact;
        data["selectedPhoneNumbers"] = this.selectedPhoneNumbers;
        data["media"] = this.media;
        data["botName"] = this.botName;
        data["botGreetingMessages"] = this.botGreetingMessages;
        data["botLogo"] = this.botLogo;
        data["allowLogInfo"] = this.allowLogInfo;
        data["translateService"] = this.translateService;
        return data;
    }
}

export interface ICallSettingDto {
    id?: number;
    callFlowId?: number;
    callFlowName?: string | undefined;
    enableRecording?: boolean;
    languageSetting?: string | undefined;
    transcribeService?: string | undefined;
    prompts?: string | undefined;
    defaultLanguage?: string | undefined;
    speechToTextService?: string | undefined;
    detectLanguage?: boolean;
    botContact?: string | undefined;
    selectedPhoneNumbers?: string | undefined;
    media?: string | undefined;
    botName?: string | undefined;
    botGreetingMessages?: string | undefined;
    botLogo?: string | undefined;
    allowLogInfo?: boolean;
    translateService?: ServiceTranslate;
}

export class CategoryListVm implements ICategoryListVm {
    categorys?: CategoryDto[] | undefined;

    constructor(data?: ICategoryListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categorys"])) {
                this.categorys = [] as any;
                for (let item of _data["categorys"])
                    this.categorys!.push(CategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryListVm {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categorys)) {
            data["categorys"] = [];
            for (let item of this.categorys)
                data["categorys"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICategoryListVm {
    categorys?: CategoryDto[] | undefined;
}

export class CategoryDto implements ICategoryDto {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: ICategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ICategoryDto {
    name?: string | undefined;
    value?: string | undefined;
}

export class UpdateCategoryCommand implements IUpdateCategoryCommand {
    companyId?: number;
    id?: number;
    tags?: string | undefined;

    constructor(data?: IUpdateCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.id = _data["id"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): UpdateCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["id"] = this.id;
        data["tags"] = this.tags;
        return data;
    }
}

export interface IUpdateCategoryCommand {
    companyId?: number;
    id?: number;
    tags?: string | undefined;
}

export class CreateCallFlowCommand implements ICreateCallFlowCommand {
    name!: string;
    companyId?: number;
    data?: string | undefined;
    attribute?: string | undefined;
    jsonFormat?: string | undefined;
    enableRecording?: boolean;
    botContact?: string | undefined;
    languageSetting?: string | undefined;
    transcribeService?: string | undefined;
    prompts?: string | undefined;
    media?: string | undefined;
    botName?: string | undefined;
    botLogo?: string | undefined;
    botGreetingMessages?: string | undefined;
    defaultLanguage?: string | undefined;
    speechToTextService?: string | undefined;
    detectLanguage?: boolean;
    isSubFlow?: boolean;
    tags?: string | undefined;
    translateService?: ServiceTranslate;
    allowLogInfo?: boolean;

    constructor(data?: ICreateCallFlowCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.data = _data["data"];
            this.attribute = _data["attribute"];
            this.jsonFormat = _data["jsonFormat"];
            this.enableRecording = _data["enableRecording"];
            this.botContact = _data["botContact"];
            this.languageSetting = _data["languageSetting"];
            this.transcribeService = _data["transcribeService"];
            this.prompts = _data["prompts"];
            this.media = _data["media"];
            this.botName = _data["botName"];
            this.botLogo = _data["botLogo"];
            this.botGreetingMessages = _data["botGreetingMessages"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.speechToTextService = _data["speechToTextService"];
            this.detectLanguage = _data["detectLanguage"];
            this.isSubFlow = _data["isSubFlow"];
            this.tags = _data["tags"];
            this.translateService = _data["translateService"];
            this.allowLogInfo = _data["allowLogInfo"];
        }
    }

    static fromJS(data: any): CreateCallFlowCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCallFlowCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["data"] = this.data;
        data["attribute"] = this.attribute;
        data["jsonFormat"] = this.jsonFormat;
        data["enableRecording"] = this.enableRecording;
        data["botContact"] = this.botContact;
        data["languageSetting"] = this.languageSetting;
        data["transcribeService"] = this.transcribeService;
        data["prompts"] = this.prompts;
        data["media"] = this.media;
        data["botName"] = this.botName;
        data["botLogo"] = this.botLogo;
        data["botGreetingMessages"] = this.botGreetingMessages;
        data["defaultLanguage"] = this.defaultLanguage;
        data["speechToTextService"] = this.speechToTextService;
        data["detectLanguage"] = this.detectLanguage;
        data["isSubFlow"] = this.isSubFlow;
        data["tags"] = this.tags;
        data["translateService"] = this.translateService;
        data["allowLogInfo"] = this.allowLogInfo;
        return data;
    }
}

export interface ICreateCallFlowCommand {
    name: string;
    companyId?: number;
    data?: string | undefined;
    attribute?: string | undefined;
    jsonFormat?: string | undefined;
    enableRecording?: boolean;
    botContact?: string | undefined;
    languageSetting?: string | undefined;
    transcribeService?: string | undefined;
    prompts?: string | undefined;
    media?: string | undefined;
    botName?: string | undefined;
    botLogo?: string | undefined;
    botGreetingMessages?: string | undefined;
    defaultLanguage?: string | undefined;
    speechToTextService?: string | undefined;
    detectLanguage?: boolean;
    isSubFlow?: boolean;
    tags?: string | undefined;
    translateService?: ServiceTranslate;
    allowLogInfo?: boolean;
}

export class DuplicateCallFlowCommand implements IDuplicateCallFlowCommand {
    name!: string;
    companyId?: number;
    data?: string | undefined;
    attribute?: string | undefined;
    jsonFormat?: string | undefined;
    enableRecording?: boolean;
    botContact?: string | undefined;
    languageSetting?: string | undefined;
    transcribeService?: string | undefined;
    prompts?: string | undefined;
    media?: string | undefined;
    botName?: string | undefined;
    botLogo?: string | undefined;
    botGreetingMessages?: string | undefined;
    defaultLanguage?: string | undefined;
    speechToTextService?: string | undefined;
    detectLanguage?: boolean;
    isSubFlow?: boolean;
    tags?: string | undefined;
    translateService?: ServiceTranslate;
    allowLogInfo?: boolean;

    constructor(data?: IDuplicateCallFlowCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.data = _data["data"];
            this.attribute = _data["attribute"];
            this.jsonFormat = _data["jsonFormat"];
            this.enableRecording = _data["enableRecording"];
            this.botContact = _data["botContact"];
            this.languageSetting = _data["languageSetting"];
            this.transcribeService = _data["transcribeService"];
            this.prompts = _data["prompts"];
            this.media = _data["media"];
            this.botName = _data["botName"];
            this.botLogo = _data["botLogo"];
            this.botGreetingMessages = _data["botGreetingMessages"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.speechToTextService = _data["speechToTextService"];
            this.detectLanguage = _data["detectLanguage"];
            this.isSubFlow = _data["isSubFlow"];
            this.tags = _data["tags"];
            this.translateService = _data["translateService"];
            this.allowLogInfo = _data["allowLogInfo"];
        }
    }

    static fromJS(data: any): DuplicateCallFlowCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateCallFlowCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["data"] = this.data;
        data["attribute"] = this.attribute;
        data["jsonFormat"] = this.jsonFormat;
        data["enableRecording"] = this.enableRecording;
        data["botContact"] = this.botContact;
        data["languageSetting"] = this.languageSetting;
        data["transcribeService"] = this.transcribeService;
        data["prompts"] = this.prompts;
        data["media"] = this.media;
        data["botName"] = this.botName;
        data["botLogo"] = this.botLogo;
        data["botGreetingMessages"] = this.botGreetingMessages;
        data["defaultLanguage"] = this.defaultLanguage;
        data["speechToTextService"] = this.speechToTextService;
        data["detectLanguage"] = this.detectLanguage;
        data["isSubFlow"] = this.isSubFlow;
        data["tags"] = this.tags;
        data["translateService"] = this.translateService;
        data["allowLogInfo"] = this.allowLogInfo;
        return data;
    }
}

export interface IDuplicateCallFlowCommand {
    name: string;
    companyId?: number;
    data?: string | undefined;
    attribute?: string | undefined;
    jsonFormat?: string | undefined;
    enableRecording?: boolean;
    botContact?: string | undefined;
    languageSetting?: string | undefined;
    transcribeService?: string | undefined;
    prompts?: string | undefined;
    media?: string | undefined;
    botName?: string | undefined;
    botLogo?: string | undefined;
    botGreetingMessages?: string | undefined;
    defaultLanguage?: string | undefined;
    speechToTextService?: string | undefined;
    detectLanguage?: boolean;
    isSubFlow?: boolean;
    tags?: string | undefined;
    translateService?: ServiceTranslate;
    allowLogInfo?: boolean;
}

export class UpdateCallFlowCommand implements IUpdateCallFlowCommand {
    companyId?: number;
    id?: number;
    name?: string | undefined;
    attribute?: string | undefined;
    data?: string | undefined;
    jsonFormat?: string | undefined;
    tags?: string | undefined;

    constructor(data?: IUpdateCallFlowCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.attribute = _data["attribute"];
            this.data = _data["data"];
            this.jsonFormat = _data["jsonFormat"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): UpdateCallFlowCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCallFlowCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["attribute"] = this.attribute;
        data["data"] = this.data;
        data["jsonFormat"] = this.jsonFormat;
        data["tags"] = this.tags;
        return data;
    }
}

export interface IUpdateCallFlowCommand {
    companyId?: number;
    id?: number;
    name?: string | undefined;
    attribute?: string | undefined;
    data?: string | undefined;
    jsonFormat?: string | undefined;
    tags?: string | undefined;
}

export class TestCallResult implements ITestCallResult {
    status?: boolean;
    uniqueId?: string | undefined;

    constructor(data?: ITestCallResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.uniqueId = _data["uniqueId"];
        }
    }

    static fromJS(data: any): TestCallResult {
        data = typeof data === 'object' ? data : {};
        let result = new TestCallResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["uniqueId"] = this.uniqueId;
        return data;
    }
}

export interface ITestCallResult {
    status?: boolean;
    uniqueId?: string | undefined;
}

export class MakeTestCallCommand implements IMakeTestCallCommand {
    companyId?: number;
    callNumber?: string | undefined;
    phoneNumber?: string | undefined;
    callFlowJson?: string | undefined;
    id?: number;
    callSettings?: string | undefined;
    attribute?: string | undefined;
    isDebug?: boolean;

    constructor(data?: IMakeTestCallCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.callNumber = _data["callNumber"];
            this.phoneNumber = _data["phoneNumber"];
            this.callFlowJson = _data["callFlowJson"];
            this.id = _data["id"];
            this.callSettings = _data["callSettings"];
            this.attribute = _data["attribute"];
            this.isDebug = _data["isDebug"];
        }
    }

    static fromJS(data: any): MakeTestCallCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MakeTestCallCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["callNumber"] = this.callNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["callFlowJson"] = this.callFlowJson;
        data["id"] = this.id;
        data["callSettings"] = this.callSettings;
        data["attribute"] = this.attribute;
        data["isDebug"] = this.isDebug;
        return data;
    }
}

export interface IMakeTestCallCommand {
    companyId?: number;
    callNumber?: string | undefined;
    phoneNumber?: string | undefined;
    callFlowJson?: string | undefined;
    id?: number;
    callSettings?: string | undefined;
    attribute?: string | undefined;
    isDebug?: boolean;
}

export class ExportCallFlowCommand implements IExportCallFlowCommand {
    callFlowScript?: string | undefined;
    audiosId?: number[] | undefined;
    functionId?: number[] | undefined;
    gptList?: string[] | undefined;
    grammarList?: string[] | undefined;
    emailTemplateList?: number[] | undefined;
    attribute?: string | undefined;
    callSetting?: string | undefined;
    subflowList?: number[] | undefined;
    reportList?: number[] | undefined;
    cmsList?: number[] | undefined;
    jsonData?: string | undefined;

    constructor(data?: IExportCallFlowCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callFlowScript = _data["callFlowScript"];
            if (Array.isArray(_data["audiosId"])) {
                this.audiosId = [] as any;
                for (let item of _data["audiosId"])
                    this.audiosId!.push(item);
            }
            if (Array.isArray(_data["functionId"])) {
                this.functionId = [] as any;
                for (let item of _data["functionId"])
                    this.functionId!.push(item);
            }
            if (Array.isArray(_data["gptList"])) {
                this.gptList = [] as any;
                for (let item of _data["gptList"])
                    this.gptList!.push(item);
            }
            if (Array.isArray(_data["grammarList"])) {
                this.grammarList = [] as any;
                for (let item of _data["grammarList"])
                    this.grammarList!.push(item);
            }
            if (Array.isArray(_data["emailTemplateList"])) {
                this.emailTemplateList = [] as any;
                for (let item of _data["emailTemplateList"])
                    this.emailTemplateList!.push(item);
            }
            this.attribute = _data["attribute"];
            this.callSetting = _data["callSetting"];
            if (Array.isArray(_data["subflowList"])) {
                this.subflowList = [] as any;
                for (let item of _data["subflowList"])
                    this.subflowList!.push(item);
            }
            if (Array.isArray(_data["reportList"])) {
                this.reportList = [] as any;
                for (let item of _data["reportList"])
                    this.reportList!.push(item);
            }
            if (Array.isArray(_data["cmsList"])) {
                this.cmsList = [] as any;
                for (let item of _data["cmsList"])
                    this.cmsList!.push(item);
            }
            this.jsonData = _data["jsonData"];
        }
    }

    static fromJS(data: any): ExportCallFlowCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportCallFlowCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callFlowScript"] = this.callFlowScript;
        if (Array.isArray(this.audiosId)) {
            data["audiosId"] = [];
            for (let item of this.audiosId)
                data["audiosId"].push(item);
        }
        if (Array.isArray(this.functionId)) {
            data["functionId"] = [];
            for (let item of this.functionId)
                data["functionId"].push(item);
        }
        if (Array.isArray(this.gptList)) {
            data["gptList"] = [];
            for (let item of this.gptList)
                data["gptList"].push(item);
        }
        if (Array.isArray(this.grammarList)) {
            data["grammarList"] = [];
            for (let item of this.grammarList)
                data["grammarList"].push(item);
        }
        if (Array.isArray(this.emailTemplateList)) {
            data["emailTemplateList"] = [];
            for (let item of this.emailTemplateList)
                data["emailTemplateList"].push(item);
        }
        data["attribute"] = this.attribute;
        data["callSetting"] = this.callSetting;
        if (Array.isArray(this.subflowList)) {
            data["subflowList"] = [];
            for (let item of this.subflowList)
                data["subflowList"].push(item);
        }
        if (Array.isArray(this.reportList)) {
            data["reportList"] = [];
            for (let item of this.reportList)
                data["reportList"].push(item);
        }
        if (Array.isArray(this.cmsList)) {
            data["cmsList"] = [];
            for (let item of this.cmsList)
                data["cmsList"].push(item);
        }
        data["jsonData"] = this.jsonData;
        return data;
    }
}

export interface IExportCallFlowCommand {
    callFlowScript?: string | undefined;
    audiosId?: number[] | undefined;
    functionId?: number[] | undefined;
    gptList?: string[] | undefined;
    grammarList?: string[] | undefined;
    emailTemplateList?: number[] | undefined;
    attribute?: string | undefined;
    callSetting?: string | undefined;
    subflowList?: number[] | undefined;
    reportList?: number[] | undefined;
    cmsList?: number[] | undefined;
    jsonData?: string | undefined;
}

export class CallFlowImportReponseData implements ICallFlowImportReponseData {
    jsonFormat?: string | undefined;
    jsonFormatData?: string | undefined;
    attribute?: string | undefined;
    callSetting?: string | undefined;
    resultImport?: ResultImport[] | undefined;

    constructor(data?: ICallFlowImportReponseData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jsonFormat = _data["jsonFormat"];
            this.jsonFormatData = _data["jsonFormatData"];
            this.attribute = _data["attribute"];
            this.callSetting = _data["callSetting"];
            if (Array.isArray(_data["resultImport"])) {
                this.resultImport = [] as any;
                for (let item of _data["resultImport"])
                    this.resultImport!.push(ResultImport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CallFlowImportReponseData {
        data = typeof data === 'object' ? data : {};
        let result = new CallFlowImportReponseData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jsonFormat"] = this.jsonFormat;
        data["jsonFormatData"] = this.jsonFormatData;
        data["attribute"] = this.attribute;
        data["callSetting"] = this.callSetting;
        if (Array.isArray(this.resultImport)) {
            data["resultImport"] = [];
            for (let item of this.resultImport)
                data["resultImport"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICallFlowImportReponseData {
    jsonFormat?: string | undefined;
    jsonFormatData?: string | undefined;
    attribute?: string | undefined;
    callSetting?: string | undefined;
    resultImport?: ResultImport[] | undefined;
}

export class ResultImport implements IResultImport {
    fileName?: string | undefined;
    isSuccess?: boolean;
    note?: string | undefined;
    path?: string | undefined;

    constructor(data?: IResultImport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.isSuccess = _data["isSuccess"];
            this.note = _data["note"];
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): ResultImport {
        data = typeof data === 'object' ? data : {};
        let result = new ResultImport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["isSuccess"] = this.isSuccess;
        data["note"] = this.note;
        data["path"] = this.path;
        return data;
    }
}

export interface IResultImport {
    fileName?: string | undefined;
    isSuccess?: boolean;
    note?: string | undefined;
    path?: string | undefined;
}

export class ImportCallFlowCommand implements IImportCallFlowCommand {
    callFlowData?: string | undefined;
    companyId?: number;
    path?: PathDto[] | undefined;
    isCloneTemplate?: string | undefined;
    uniqueId?: string | undefined;

    constructor(data?: IImportCallFlowCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callFlowData = _data["callFlowData"];
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(PathDto.fromJS(item));
            }
            this.isCloneTemplate = _data["isCloneTemplate"];
            this.uniqueId = _data["uniqueId"];
        }
    }

    static fromJS(data: any): ImportCallFlowCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCallFlowCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callFlowData"] = this.callFlowData;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item.toJSON());
        }
        data["isCloneTemplate"] = this.isCloneTemplate;
        data["uniqueId"] = this.uniqueId;
        return data;
    }
}

export interface IImportCallFlowCommand {
    callFlowData?: string | undefined;
    companyId?: number;
    path?: PathDto[] | undefined;
    isCloneTemplate?: string | undefined;
    uniqueId?: string | undefined;
}

export class PathDto implements IPathDto {
    path?: string | undefined;
    name?: string | undefined;
    data?: string | undefined;
    isOverride?: boolean;
    isExist?: boolean;

    constructor(data?: IPathDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.isOverride = _data["isOverride"];
            this.isExist = _data["isExist"];
        }
    }

    static fromJS(data: any): PathDto {
        data = typeof data === 'object' ? data : {};
        let result = new PathDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["name"] = this.name;
        data["data"] = this.data;
        data["isOverride"] = this.isOverride;
        data["isExist"] = this.isExist;
        return data;
    }
}

export interface IPathDto {
    path?: string | undefined;
    name?: string | undefined;
    data?: string | undefined;
    isOverride?: boolean;
    isExist?: boolean;
}

export class CheckFileImportCallFlowCommand implements ICheckFileImportCallFlowCommand {
    callFlowData?: string | undefined;
    companyId?: number;

    constructor(data?: ICheckFileImportCallFlowCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callFlowData = _data["callFlowData"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): CheckFileImportCallFlowCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CheckFileImportCallFlowCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callFlowData"] = this.callFlowData;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface ICheckFileImportCallFlowCommand {
    callFlowData?: string | undefined;
    companyId?: number;
}

export class OutreachFlowCommand implements IOutreachFlowCommand {
    phoneNumber?: string | undefined;
    callerId?: string | undefined;
    callerNumber?: string | undefined;
    callFlowId?: number;
    companyId?: number;
    attribute?: string | undefined;
    callFlowAttribute?: string | undefined;
    outreachType?: string | undefined;
    callFlowJson?: string | undefined;
    callSettings?: string | undefined;
    extendData?: any | undefined;
    language?: string | undefined;

    constructor(data?: IOutreachFlowCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.callerId = _data["callerId"];
            this.callerNumber = _data["callerNumber"];
            this.callFlowId = _data["callFlowId"];
            this.companyId = _data["companyId"];
            this.attribute = _data["attribute"];
            this.callFlowAttribute = _data["callFlowAttribute"];
            this.outreachType = _data["outreachType"];
            this.callFlowJson = _data["callFlowJson"];
            this.callSettings = _data["callSettings"];
            this.extendData = _data["extendData"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): OutreachFlowCommand {
        data = typeof data === 'object' ? data : {};
        let result = new OutreachFlowCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["callerId"] = this.callerId;
        data["callerNumber"] = this.callerNumber;
        data["callFlowId"] = this.callFlowId;
        data["companyId"] = this.companyId;
        data["attribute"] = this.attribute;
        data["callFlowAttribute"] = this.callFlowAttribute;
        data["outreachType"] = this.outreachType;
        data["callFlowJson"] = this.callFlowJson;
        data["callSettings"] = this.callSettings;
        data["extendData"] = this.extendData;
        data["language"] = this.language;
        return data;
    }
}

export interface IOutreachFlowCommand {
    phoneNumber?: string | undefined;
    callerId?: string | undefined;
    callerNumber?: string | undefined;
    callFlowId?: number;
    companyId?: number;
    attribute?: string | undefined;
    callFlowAttribute?: string | undefined;
    outreachType?: string | undefined;
    callFlowJson?: string | undefined;
    callSettings?: string | undefined;
    extendData?: any | undefined;
    language?: string | undefined;
}

export class HangupFlowCommand implements IHangupFlowCommand {
    channel?: string | undefined;
    dstchannel?: string | undefined;
    leaveVoiceMail?: boolean;

    constructor(data?: IHangupFlowCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channel = _data["channel"];
            this.dstchannel = _data["dstchannel"];
            this.leaveVoiceMail = _data["leaveVoiceMail"];
        }
    }

    static fromJS(data: any): HangupFlowCommand {
        data = typeof data === 'object' ? data : {};
        let result = new HangupFlowCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channel"] = this.channel;
        data["dstchannel"] = this.dstchannel;
        data["leaveVoiceMail"] = this.leaveVoiceMail;
        return data;
    }
}

export interface IHangupFlowCommand {
    channel?: string | undefined;
    dstchannel?: string | undefined;
    leaveVoiceMail?: boolean;
}

export class DisableCallFlowCommand implements IDisableCallFlowCommand {
    disable?: boolean;
    companyId?: number;
    callFlowId?: number;

    constructor(data?: IDisableCallFlowCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disable = _data["disable"];
            this.companyId = _data["companyId"];
            this.callFlowId = _data["callFlowId"];
        }
    }

    static fromJS(data: any): DisableCallFlowCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DisableCallFlowCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disable"] = this.disable;
        data["companyId"] = this.companyId;
        data["callFlowId"] = this.callFlowId;
        return data;
    }
}

export interface IDisableCallFlowCommand {
    disable?: boolean;
    companyId?: number;
    callFlowId?: number;
}

export class SetAgentFlowCommand implements ISetAgentFlowCommand {
    companyId?: number;
    callFlowId?: number;

    constructor(data?: ISetAgentFlowCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.callFlowId = _data["callFlowId"];
        }
    }

    static fromJS(data: any): SetAgentFlowCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetAgentFlowCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["callFlowId"] = this.callFlowId;
        return data;
    }
}

export interface ISetAgentFlowCommand {
    companyId?: number;
    callFlowId?: number;
}

export class UnsetAgentFlowCommand implements IUnsetAgentFlowCommand {
    companyId?: number;
    callFlowId?: number;

    constructor(data?: IUnsetAgentFlowCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.callFlowId = _data["callFlowId"];
        }
    }

    static fromJS(data: any): UnsetAgentFlowCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UnsetAgentFlowCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["callFlowId"] = this.callFlowId;
        return data;
    }
}

export interface IUnsetAgentFlowCommand {
    companyId?: number;
    callFlowId?: number;
}

export class CompanyNumberListVm implements ICompanyNumberListVm {
    phoneNumbers?: CompanyNumberVm[] | undefined;
    phoneProviders?: PhoneNumberProviderDto[] | undefined;
    botContact?: ContactConfig[] | undefined;
    trunks?: TrunkFilter[] | undefined;

    constructor(data?: ICompanyNumberListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(CompanyNumberVm.fromJS(item));
            }
            if (Array.isArray(_data["phoneProviders"])) {
                this.phoneProviders = [] as any;
                for (let item of _data["phoneProviders"])
                    this.phoneProviders!.push(PhoneNumberProviderDto.fromJS(item));
            }
            if (Array.isArray(_data["botContact"])) {
                this.botContact = [] as any;
                for (let item of _data["botContact"])
                    this.botContact!.push(ContactConfig.fromJS(item));
            }
            if (Array.isArray(_data["trunks"])) {
                this.trunks = [] as any;
                for (let item of _data["trunks"])
                    this.trunks!.push(TrunkFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyNumberListVm {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyNumberListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.phoneProviders)) {
            data["phoneProviders"] = [];
            for (let item of this.phoneProviders)
                data["phoneProviders"].push(item.toJSON());
        }
        if (Array.isArray(this.botContact)) {
            data["botContact"] = [];
            for (let item of this.botContact)
                data["botContact"].push(item.toJSON());
        }
        if (Array.isArray(this.trunks)) {
            data["trunks"] = [];
            for (let item of this.trunks)
                data["trunks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompanyNumberListVm {
    phoneNumbers?: CompanyNumberVm[] | undefined;
    phoneProviders?: PhoneNumberProviderDto[] | undefined;
    botContact?: ContactConfig[] | undefined;
    trunks?: TrunkFilter[] | undefined;
}

export class CompanyNumberVm implements ICompanyNumberVm {
    id?: number;
    number?: string | undefined;
    providerName?: string | undefined;
    providerId?: number;
    trunkName?: string | undefined;
    companyId?: string | undefined;
    trunkId?: number;
    price?: number;
    callFlowId?: number;
    active?: boolean;
    disAllow?: boolean;

    constructor(data?: ICompanyNumberVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.providerName = _data["providerName"];
            this.providerId = _data["providerId"];
            this.trunkName = _data["trunkName"];
            this.companyId = _data["companyId"];
            this.trunkId = _data["trunkId"];
            this.price = _data["price"];
            this.callFlowId = _data["callFlowId"];
            this.active = _data["active"];
            this.disAllow = _data["disAllow"];
        }
    }

    static fromJS(data: any): CompanyNumberVm {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyNumberVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["providerName"] = this.providerName;
        data["providerId"] = this.providerId;
        data["trunkName"] = this.trunkName;
        data["companyId"] = this.companyId;
        data["trunkId"] = this.trunkId;
        data["price"] = this.price;
        data["callFlowId"] = this.callFlowId;
        data["active"] = this.active;
        data["disAllow"] = this.disAllow;
        return data;
    }
}

export interface ICompanyNumberVm {
    id?: number;
    number?: string | undefined;
    providerName?: string | undefined;
    providerId?: number;
    trunkName?: string | undefined;
    companyId?: string | undefined;
    trunkId?: number;
    price?: number;
    callFlowId?: number;
    active?: boolean;
    disAllow?: boolean;
}

export class PhoneNumberProviderDto implements IPhoneNumberProviderDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IPhoneNumberProviderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PhoneNumberProviderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneNumberProviderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPhoneNumberProviderDto {
    id?: number;
    name?: string | undefined;
}

export class ContactConfig implements IContactConfig {
    id?: number;
    contactId?: string | undefined;
    provider?: string | undefined;

    constructor(data?: IContactConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): ContactConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ContactConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["provider"] = this.provider;
        return data;
    }
}

export interface IContactConfig {
    id?: number;
    contactId?: string | undefined;
    provider?: string | undefined;
}

export class TrunkFilter implements ITrunkFilter {
    id?: number;
    name?: string | undefined;
    providerId?: number;
    disable?: boolean;

    constructor(data?: ITrunkFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.providerId = _data["providerId"];
            this.disable = _data["disable"];
        }
    }

    static fromJS(data: any): TrunkFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TrunkFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["providerId"] = this.providerId;
        data["disable"] = this.disable;
        return data;
    }
}

export interface ITrunkFilter {
    id?: number;
    name?: string | undefined;
    providerId?: number;
    disable?: boolean;
}

export class CheckCallFlowNameCommand implements ICheckCallFlowNameCommand {
    callFlowName?: string | undefined;

    constructor(data?: ICheckCallFlowNameCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callFlowName = _data["callFlowName"];
        }
    }

    static fromJS(data: any): CheckCallFlowNameCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CheckCallFlowNameCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callFlowName"] = this.callFlowName;
        return data;
    }
}

export interface ICheckCallFlowNameCommand {
    callFlowName?: string | undefined;
}

export class RequestModificationFlowCommand implements IRequestModificationFlowCommand {
    requestToUser?: string | undefined;
    requestFromUser?: string | undefined;
    type?: string | undefined;
    callFlowId?: number | undefined;

    constructor(data?: IRequestModificationFlowCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestToUser = _data["requestToUser"];
            this.requestFromUser = _data["requestFromUser"];
            this.type = _data["type"];
            this.callFlowId = _data["callFlowId"];
        }
    }

    static fromJS(data: any): RequestModificationFlowCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RequestModificationFlowCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestToUser"] = this.requestToUser;
        data["requestFromUser"] = this.requestFromUser;
        data["type"] = this.type;
        data["callFlowId"] = this.callFlowId;
        return data;
    }
}

export interface IRequestModificationFlowCommand {
    requestToUser?: string | undefined;
    requestFromUser?: string | undefined;
    type?: string | undefined;
    callFlowId?: number | undefined;
}

export class TestRequestResult implements ITestRequestResult {
    response?: string | undefined;
    method?: string | undefined;
    duration?: number;
    size?: number;
    statusCode?: number;

    constructor(data?: ITestRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.response = _data["response"];
            this.method = _data["method"];
            this.duration = _data["duration"];
            this.size = _data["size"];
            this.statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any): TestRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new TestRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["response"] = this.response;
        data["method"] = this.method;
        data["duration"] = this.duration;
        data["size"] = this.size;
        data["statusCode"] = this.statusCode;
        return data;
    }
}

export interface ITestRequestResult {
    response?: string | undefined;
    method?: string | undefined;
    duration?: number;
    size?: number;
    statusCode?: number;
}

export class TestRequestCommand implements ITestRequestCommand {
    name?: string | undefined;
    method?: string | undefined;
    url?: string | undefined;
    headers?: string | undefined;
    body?: string | undefined;
    response?: string | undefined;
    attribute?: string | undefined;
    timeout?: string | undefined;
    params?: string | undefined;
    bodyRaw?: string | undefined;
    option?: number;
    typeRaw?: string | undefined;

    constructor(data?: ITestRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.method = _data["method"];
            this.url = _data["url"];
            this.headers = _data["headers"];
            this.body = _data["body"];
            this.response = _data["response"];
            this.attribute = _data["attribute"];
            this.timeout = _data["timeout"];
            this.params = _data["params"];
            this.bodyRaw = _data["bodyRaw"];
            this.option = _data["option"];
            this.typeRaw = _data["typeRaw"];
        }
    }

    static fromJS(data: any): TestRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TestRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["method"] = this.method;
        data["url"] = this.url;
        data["headers"] = this.headers;
        data["body"] = this.body;
        data["response"] = this.response;
        data["attribute"] = this.attribute;
        data["timeout"] = this.timeout;
        data["params"] = this.params;
        data["bodyRaw"] = this.bodyRaw;
        data["option"] = this.option;
        data["typeRaw"] = this.typeRaw;
        return data;
    }
}

export interface ITestRequestCommand {
    name?: string | undefined;
    method?: string | undefined;
    url?: string | undefined;
    headers?: string | undefined;
    body?: string | undefined;
    response?: string | undefined;
    attribute?: string | undefined;
    timeout?: string | undefined;
    params?: string | undefined;
    bodyRaw?: string | undefined;
    option?: number;
    typeRaw?: string | undefined;
}

export class UploadImageCommand implements IUploadImageCommand {
    image?: string | undefined;

    constructor(data?: IUploadImageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): UploadImageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UploadImageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        return data;
    }
}

export interface IUploadImageCommand {
    image?: string | undefined;
}

export class RenameCallFlowCommand implements IRenameCallFlowCommand {
    id?: number;
    name!: string;

    constructor(data?: IRenameCallFlowCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RenameCallFlowCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RenameCallFlowCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRenameCallFlowCommand {
    id?: number;
    name: string;
}

export class DifferentCallFlowList implements IDifferentCallFlowList {
    callFlows?: DifferentCallFlowDto[] | undefined;

    constructor(data?: IDifferentCallFlowList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["callFlows"])) {
                this.callFlows = [] as any;
                for (let item of _data["callFlows"])
                    this.callFlows!.push(DifferentCallFlowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DifferentCallFlowList {
        data = typeof data === 'object' ? data : {};
        let result = new DifferentCallFlowList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.callFlows)) {
            data["callFlows"] = [];
            for (let item of this.callFlows)
                data["callFlows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDifferentCallFlowList {
    callFlows?: DifferentCallFlowDto[] | undefined;
}

export class DifferentCallFlowDto implements IDifferentCallFlowDto {
    id?: number;
    name?: string | undefined;
    attribute?: string | undefined;

    constructor(data?: IDifferentCallFlowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.attribute = _data["attribute"];
        }
    }

    static fromJS(data: any): DifferentCallFlowDto {
        data = typeof data === 'object' ? data : {};
        let result = new DifferentCallFlowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["attribute"] = this.attribute;
        return data;
    }
}

export interface IDifferentCallFlowDto {
    id?: number;
    name?: string | undefined;
    attribute?: string | undefined;
}

export class GetCallRecordQuery implements IGetCallRecordQuery {
    folderName?: string | undefined;
    fileName?: string | undefined;
    companyId?: number;
    serverFile?: string | undefined;

    constructor(data?: IGetCallRecordQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folderName = _data["folderName"];
            this.fileName = _data["fileName"];
            this.companyId = _data["companyId"];
            this.serverFile = _data["serverFile"];
        }
    }

    static fromJS(data: any): GetCallRecordQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCallRecordQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderName"] = this.folderName;
        data["fileName"] = this.fileName;
        data["companyId"] = this.companyId;
        data["serverFile"] = this.serverFile;
        return data;
    }
}

export interface IGetCallRecordQuery {
    folderName?: string | undefined;
    fileName?: string | undefined;
    companyId?: number;
    serverFile?: string | undefined;
}

export class GetCallRecordAsteriskQuery implements IGetCallRecordAsteriskQuery {
    folderName?: string | undefined;
    fileName?: string | undefined;
    companyId?: number;

    constructor(data?: IGetCallRecordAsteriskQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folderName = _data["folderName"];
            this.fileName = _data["fileName"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): GetCallRecordAsteriskQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCallRecordAsteriskQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderName"] = this.folderName;
        data["fileName"] = this.fileName;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IGetCallRecordAsteriskQuery {
    folderName?: string | undefined;
    fileName?: string | undefined;
    companyId?: number;
}

export class CallsListVm implements ICallsListVm {
    callVm?: CallVm[] | undefined;
    page?: Page | undefined;

    constructor(data?: ICallsListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["callVm"])) {
                this.callVm = [] as any;
                for (let item of _data["callVm"])
                    this.callVm!.push(CallVm.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CallsListVm {
        data = typeof data === 'object' ? data : {};
        let result = new CallsListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.callVm)) {
            data["callVm"] = [];
            for (let item of this.callVm)
                data["callVm"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICallsListVm {
    callVm?: CallVm[] | undefined;
    page?: Page | undefined;
}

export class CallVm implements ICallVm {
    id?: string | undefined;
    companyId?: number;
    startTime?: Date;
    endTime?: Date;
    duration?: number;
    durationDisplay?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    recordFile?: string | undefined;
    serverFile?: string | undefined;
    cost?: number;
    callAction?: string | undefined;
    callProcess?: string | undefined;
    status?: string | undefined;
    callFlowId?: string | undefined;
    lastFlowId?: string | undefined;
    callFlowName?: string | undefined;
    lastFlowName?: string | undefined;
    uniqueId?: string | undefined;
    report?: CallDataCDRDto[] | undefined;
    callActionVm?: any | undefined;
    context?: string | undefined;
    type?: string | undefined;

    constructor(data?: ICallVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.durationDisplay = _data["durationDisplay"];
            this.fromNumber = _data["fromNumber"];
            this.toNumber = _data["toNumber"];
            this.recordFile = _data["recordFile"];
            this.serverFile = _data["serverFile"];
            this.cost = _data["cost"];
            this.callAction = _data["callAction"];
            this.callProcess = _data["callProcess"];
            this.status = _data["status"];
            this.callFlowId = _data["callFlowId"];
            this.lastFlowId = _data["lastFlowId"];
            this.callFlowName = _data["callFlowName"];
            this.lastFlowName = _data["lastFlowName"];
            this.uniqueId = _data["uniqueId"];
            if (Array.isArray(_data["report"])) {
                this.report = [] as any;
                for (let item of _data["report"])
                    this.report!.push(CallDataCDRDto.fromJS(item));
            }
            this.callActionVm = _data["callActionVm"];
            this.context = _data["context"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CallVm {
        data = typeof data === 'object' ? data : {};
        let result = new CallVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["durationDisplay"] = this.durationDisplay;
        data["fromNumber"] = this.fromNumber;
        data["toNumber"] = this.toNumber;
        data["recordFile"] = this.recordFile;
        data["serverFile"] = this.serverFile;
        data["cost"] = this.cost;
        data["callAction"] = this.callAction;
        data["callProcess"] = this.callProcess;
        data["status"] = this.status;
        data["callFlowId"] = this.callFlowId;
        data["lastFlowId"] = this.lastFlowId;
        data["callFlowName"] = this.callFlowName;
        data["lastFlowName"] = this.lastFlowName;
        data["uniqueId"] = this.uniqueId;
        if (Array.isArray(this.report)) {
            data["report"] = [];
            for (let item of this.report)
                data["report"].push(item.toJSON());
        }
        data["callActionVm"] = this.callActionVm;
        data["context"] = this.context;
        data["type"] = this.type;
        return data;
    }
}

export interface ICallVm {
    id?: string | undefined;
    companyId?: number;
    startTime?: Date;
    endTime?: Date;
    duration?: number;
    durationDisplay?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    recordFile?: string | undefined;
    serverFile?: string | undefined;
    cost?: number;
    callAction?: string | undefined;
    callProcess?: string | undefined;
    status?: string | undefined;
    callFlowId?: string | undefined;
    lastFlowId?: string | undefined;
    callFlowName?: string | undefined;
    lastFlowName?: string | undefined;
    uniqueId?: string | undefined;
    report?: CallDataCDRDto[] | undefined;
    callActionVm?: any | undefined;
    context?: string | undefined;
    type?: string | undefined;
}

export class CallDataCDRDto implements ICallDataCDRDto {
    id?: number;
    callID?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    label?: string | undefined;
    note?: string | undefined;
    datasetId?: string | undefined;
    created?: Date;

    constructor(data?: ICallDataCDRDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.callID = _data["callID"];
            this.fromNumber = _data["fromNumber"];
            this.toNumber = _data["toNumber"];
            this.label = _data["label"];
            this.note = _data["note"];
            this.datasetId = _data["datasetId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CallDataCDRDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallDataCDRDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["callID"] = this.callID;
        data["fromNumber"] = this.fromNumber;
        data["toNumber"] = this.toNumber;
        data["label"] = this.label;
        data["note"] = this.note;
        data["datasetId"] = this.datasetId;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICallDataCDRDto {
    id?: number;
    callID?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    label?: string | undefined;
    note?: string | undefined;
    datasetId?: string | undefined;
    created?: Date;
}

export class GetCallListQuery implements IGetCallListQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    startTime?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    endTime?: string | undefined;
    report?: CallDatasetReportDto[] | undefined;
    filterData?: FilterData[] | undefined;
    filterNote?: FilterData | undefined;

    constructor(data?: IGetCallListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.searchText = _data["searchText"];
            this.startTime = _data["startTime"];
            this.fromNumber = _data["fromNumber"];
            this.toNumber = _data["toNumber"];
            this.endTime = _data["endTime"];
            if (Array.isArray(_data["report"])) {
                this.report = [] as any;
                for (let item of _data["report"])
                    this.report!.push(CallDatasetReportDto.fromJS(item));
            }
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
            this.filterNote = _data["filterNote"] ? FilterData.fromJS(_data["filterNote"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCallListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCallListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["searchText"] = this.searchText;
        data["startTime"] = this.startTime;
        data["fromNumber"] = this.fromNumber;
        data["toNumber"] = this.toNumber;
        data["endTime"] = this.endTime;
        if (Array.isArray(this.report)) {
            data["report"] = [];
            for (let item of this.report)
                data["report"].push(item.toJSON());
        }
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        data["filterNote"] = this.filterNote ? this.filterNote.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCallListQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    startTime?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    endTime?: string | undefined;
    report?: CallDatasetReportDto[] | undefined;
    filterData?: FilterData[] | undefined;
    filterNote?: FilterData | undefined;
}

export class CallDatasetReportDto implements ICallDatasetReportDto {
    id?: string | undefined;
    name?: string | undefined;
    labels?: CallDatasetDto[] | undefined;

    constructor(data?: ICallDatasetReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(CallDatasetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CallDatasetReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallDatasetReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICallDatasetReportDto {
    id?: string | undefined;
    name?: string | undefined;
    labels?: CallDatasetDto[] | undefined;
}

export class CallDatasetDto implements ICallDatasetDto {
    label?: string | undefined;
    filter?: boolean;

    constructor(data?: ICallDatasetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): CallDatasetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallDatasetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["filter"] = this.filter;
        return data;
    }
}

export interface ICallDatasetDto {
    label?: string | undefined;
    filter?: boolean;
}

export class ExportReportCommand implements IExportReportCommand {
    searchText?: string | undefined;
    startTime?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    endTime?: string | undefined;
    companyId?: number | undefined;
    callList?: CallVm[] | undefined;
    dataSet?: Dataset[] | undefined;
    callData?: CallData[] | undefined;

    constructor(data?: IExportReportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            this.startTime = _data["startTime"];
            this.fromNumber = _data["fromNumber"];
            this.toNumber = _data["toNumber"];
            this.endTime = _data["endTime"];
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["callList"])) {
                this.callList = [] as any;
                for (let item of _data["callList"])
                    this.callList!.push(CallVm.fromJS(item));
            }
            if (Array.isArray(_data["dataSet"])) {
                this.dataSet = [] as any;
                for (let item of _data["dataSet"])
                    this.dataSet!.push(Dataset.fromJS(item));
            }
            if (Array.isArray(_data["callData"])) {
                this.callData = [] as any;
                for (let item of _data["callData"])
                    this.callData!.push(CallData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportReportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportReportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["startTime"] = this.startTime;
        data["fromNumber"] = this.fromNumber;
        data["toNumber"] = this.toNumber;
        data["endTime"] = this.endTime;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.callList)) {
            data["callList"] = [];
            for (let item of this.callList)
                data["callList"].push(item.toJSON());
        }
        if (Array.isArray(this.dataSet)) {
            data["dataSet"] = [];
            for (let item of this.dataSet)
                data["dataSet"].push(item.toJSON());
        }
        if (Array.isArray(this.callData)) {
            data["callData"] = [];
            for (let item of this.callData)
                data["callData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExportReportCommand {
    searchText?: string | undefined;
    startTime?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    endTime?: string | undefined;
    companyId?: number | undefined;
    callList?: CallVm[] | undefined;
    dataSet?: Dataset[] | undefined;
    callData?: CallData[] | undefined;
}

export class NumberFilter implements INumberFilter {
    fromNumber?: string[] | undefined;
    toNumber?: string[] | undefined;

    constructor(data?: INumberFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fromNumber"])) {
                this.fromNumber = [] as any;
                for (let item of _data["fromNumber"])
                    this.fromNumber!.push(item);
            }
            if (Array.isArray(_data["toNumber"])) {
                this.toNumber = [] as any;
                for (let item of _data["toNumber"])
                    this.toNumber!.push(item);
            }
        }
    }

    static fromJS(data: any): NumberFilter {
        data = typeof data === 'object' ? data : {};
        let result = new NumberFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fromNumber)) {
            data["fromNumber"] = [];
            for (let item of this.fromNumber)
                data["fromNumber"].push(item);
        }
        if (Array.isArray(this.toNumber)) {
            data["toNumber"] = [];
            for (let item of this.toNumber)
                data["toNumber"].push(item);
        }
        return data;
    }
}

export interface INumberFilter {
    fromNumber?: string[] | undefined;
    toNumber?: string[] | undefined;
}

export class CallReportListVm implements ICallReportListVm {
    callReportVm?: CallReportVm[] | undefined;

    constructor(data?: ICallReportListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["callReportVm"])) {
                this.callReportVm = [] as any;
                for (let item of _data["callReportVm"])
                    this.callReportVm!.push(CallReportVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CallReportListVm {
        data = typeof data === 'object' ? data : {};
        let result = new CallReportListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.callReportVm)) {
            data["callReportVm"] = [];
            for (let item of this.callReportVm)
                data["callReportVm"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICallReportListVm {
    callReportVm?: CallReportVm[] | undefined;
}

export class CallReportVm implements ICallReportVm {
    id?: number;
    date?: Date;
    phoneNumber?: string | undefined;
    disposition?: string | undefined;
    duration?: string | undefined;
    fromNumber?: string | undefined;
    callId?: string | undefined;
    error?: string | undefined;
    lastFlowId?: string | undefined;
    callFlowId?: string | undefined;
    lastFlowName?: string | undefined;
    callFlowName?: string | undefined;
    startTime?: Date;
    endTime?: Date;

    constructor(data?: ICallReportVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.disposition = _data["disposition"];
            this.duration = _data["duration"];
            this.fromNumber = _data["fromNumber"];
            this.callId = _data["callId"];
            this.error = _data["error"];
            this.lastFlowId = _data["lastFlowId"];
            this.callFlowId = _data["callFlowId"];
            this.lastFlowName = _data["lastFlowName"];
            this.callFlowName = _data["callFlowName"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CallReportVm {
        data = typeof data === 'object' ? data : {};
        let result = new CallReportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["disposition"] = this.disposition;
        data["duration"] = this.duration;
        data["fromNumber"] = this.fromNumber;
        data["callId"] = this.callId;
        data["error"] = this.error;
        data["lastFlowId"] = this.lastFlowId;
        data["callFlowId"] = this.callFlowId;
        data["lastFlowName"] = this.lastFlowName;
        data["callFlowName"] = this.callFlowName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICallReportVm {
    id?: number;
    date?: Date;
    phoneNumber?: string | undefined;
    disposition?: string | undefined;
    duration?: string | undefined;
    fromNumber?: string | undefined;
    callId?: string | undefined;
    error?: string | undefined;
    lastFlowId?: string | undefined;
    callFlowId?: string | undefined;
    lastFlowName?: string | undefined;
    callFlowName?: string | undefined;
    startTime?: Date;
    endTime?: Date;
}

export class VoiceMailListVm implements IVoiceMailListVm {
    voiceMailVm?: VoiceMailVm[] | undefined;

    constructor(data?: IVoiceMailListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["voiceMailVm"])) {
                this.voiceMailVm = [] as any;
                for (let item of _data["voiceMailVm"])
                    this.voiceMailVm!.push(VoiceMailVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoiceMailListVm {
        data = typeof data === 'object' ? data : {};
        let result = new VoiceMailListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.voiceMailVm)) {
            data["voiceMailVm"] = [];
            for (let item of this.voiceMailVm)
                data["voiceMailVm"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVoiceMailListVm {
    voiceMailVm?: VoiceMailVm[] | undefined;
}

export class VoiceMailVm implements IVoiceMailVm {
    id?: number;
    companyId?: number;
    date?: Date;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    audioFile?: string | undefined;
    serverFile?: string | undefined;
    status?: boolean;

    constructor(data?: IVoiceMailVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.fromNumber = _data["fromNumber"];
            this.toNumber = _data["toNumber"];
            this.audioFile = _data["audioFile"];
            this.serverFile = _data["serverFile"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): VoiceMailVm {
        data = typeof data === 'object' ? data : {};
        let result = new VoiceMailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["fromNumber"] = this.fromNumber;
        data["toNumber"] = this.toNumber;
        data["audioFile"] = this.audioFile;
        data["serverFile"] = this.serverFile;
        data["status"] = this.status;
        return data;
    }
}

export interface IVoiceMailVm {
    id?: number;
    companyId?: number;
    date?: Date;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    audioFile?: string | undefined;
    serverFile?: string | undefined;
    status?: boolean;
}

export class ReadVoiceMailCommand implements IReadVoiceMailCommand {
    id?: number;

    constructor(data?: IReadVoiceMailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReadVoiceMailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReadVoiceMailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IReadVoiceMailCommand {
    id?: number;
}

export class ChatMessage implements IChatMessage {
    type?: string | undefined;
    serviceUrl?: string | undefined;
    channelId?: string | undefined;
    conversation?: BotConversation | undefined;
    from?: BotConversation | undefined;
    recipient?: BotConversation | undefined;
    text?: string | undefined;
    inputHint?: string | undefined;
    extenData?: ExtenData | undefined;
    textFormat?: string | undefined;
    companyId?: string | undefined;
    suggestedActions?: SuggestedActions | undefined;

    constructor(data?: IChatMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.serviceUrl = _data["serviceUrl"];
            this.channelId = _data["channelId"];
            this.conversation = _data["conversation"] ? BotConversation.fromJS(_data["conversation"]) : <any>undefined;
            this.from = _data["from"] ? BotConversation.fromJS(_data["from"]) : <any>undefined;
            this.recipient = _data["recipient"] ? BotConversation.fromJS(_data["recipient"]) : <any>undefined;
            this.text = _data["text"];
            this.inputHint = _data["inputHint"];
            this.extenData = _data["extenData"] ? ExtenData.fromJS(_data["extenData"]) : <any>undefined;
            this.textFormat = _data["textFormat"];
            this.companyId = _data["companyId"];
            this.suggestedActions = _data["suggestedActions"] ? SuggestedActions.fromJS(_data["suggestedActions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["serviceUrl"] = this.serviceUrl;
        data["channelId"] = this.channelId;
        data["conversation"] = this.conversation ? this.conversation.toJSON() : <any>undefined;
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        data["recipient"] = this.recipient ? this.recipient.toJSON() : <any>undefined;
        data["text"] = this.text;
        data["inputHint"] = this.inputHint;
        data["extenData"] = this.extenData ? this.extenData.toJSON() : <any>undefined;
        data["textFormat"] = this.textFormat;
        data["companyId"] = this.companyId;
        data["suggestedActions"] = this.suggestedActions ? this.suggestedActions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChatMessage {
    type?: string | undefined;
    serviceUrl?: string | undefined;
    channelId?: string | undefined;
    conversation?: BotConversation | undefined;
    from?: BotConversation | undefined;
    recipient?: BotConversation | undefined;
    text?: string | undefined;
    inputHint?: string | undefined;
    extenData?: ExtenData | undefined;
    textFormat?: string | undefined;
    companyId?: string | undefined;
    suggestedActions?: SuggestedActions | undefined;
}

export class BotConversation implements IBotConversation {
    id?: string | undefined;

    constructor(data?: IBotConversation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BotConversation {
        data = typeof data === 'object' ? data : {};
        let result = new BotConversation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IBotConversation {
    id?: string | undefined;
}

export class ExtenData implements IExtenData {
    callFlowJson?: string | undefined;
    callSettings?: string | undefined;
    attribute?: string | undefined;

    constructor(data?: IExtenData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callFlowJson = _data["callFlowJson"];
            this.callSettings = _data["callSettings"];
            this.attribute = _data["attribute"];
        }
    }

    static fromJS(data: any): ExtenData {
        data = typeof data === 'object' ? data : {};
        let result = new ExtenData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callFlowJson"] = this.callFlowJson;
        data["callSettings"] = this.callSettings;
        data["attribute"] = this.attribute;
        return data;
    }
}

export interface IExtenData {
    callFlowJson?: string | undefined;
    callSettings?: string | undefined;
    attribute?: string | undefined;
}

export class SuggestedActions implements ISuggestedActions {
    actions?: Action[] | undefined;

    constructor(data?: ISuggestedActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(Action.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SuggestedActions {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestedActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISuggestedActions {
    actions?: Action[] | undefined;
}

export class Action implements IAction {
    type?: string | undefined;
    title?: string | undefined;
    value?: string | undefined;

    constructor(data?: IAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Action {
        data = typeof data === 'object' ? data : {};
        let result = new Action();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["value"] = this.value;
        return data;
    }
}

export interface IAction {
    type?: string | undefined;
    title?: string | undefined;
    value?: string | undefined;
}

export class GPTDataListVm implements IGPTDataListVm {
    gptDataList?: GPTDataDto[] | undefined;
    page?: Page | undefined;

    constructor(data?: IGPTDataListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["gptDataList"])) {
                this.gptDataList = [] as any;
                for (let item of _data["gptDataList"])
                    this.gptDataList!.push(GPTDataDto.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GPTDataListVm {
        data = typeof data === 'object' ? data : {};
        let result = new GPTDataListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.gptDataList)) {
            data["gptDataList"] = [];
            for (let item of this.gptDataList)
                data["gptDataList"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGPTDataListVm {
    gptDataList?: GPTDataDto[] | undefined;
    page?: Page | undefined;
}

export class GPTDataDto implements IGPTDataDto {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    dataTrain?: string | undefined;
    companyId?: number;
    extenData?: string | undefined;
    status?: string | undefined;
    retrainTime?: string | undefined;
    lastModified?: Date | undefined;

    constructor(data?: IGPTDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.dataTrain = _data["dataTrain"];
            this.companyId = _data["companyId"];
            this.extenData = _data["extenData"];
            this.status = _data["status"];
            this.retrainTime = _data["retrainTime"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GPTDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new GPTDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        data["dataTrain"] = this.dataTrain;
        data["companyId"] = this.companyId;
        data["extenData"] = this.extenData;
        data["status"] = this.status;
        data["retrainTime"] = this.retrainTime;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGPTDataDto {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    dataTrain?: string | undefined;
    companyId?: number;
    extenData?: string | undefined;
    status?: string | undefined;
    retrainTime?: string | undefined;
    lastModified?: Date | undefined;
}

export class GetAllDataSetQuery implements IGetAllDataSetQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetAllDataSetQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllDataSetQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDataSetQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["searchText"] = this.searchText;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllDataSetQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class UpdateStatusGPTCommand implements IUpdateStatusGPTCommand {
    id?: number | undefined;
    ref_Id?: string | undefined;
    success?: boolean;

    constructor(data?: IUpdateStatusGPTCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ref_Id = _data["ref_Id"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): UpdateStatusGPTCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatusGPTCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ref_Id"] = this.ref_Id;
        data["success"] = this.success;
        return data;
    }
}

export interface IUpdateStatusGPTCommand {
    id?: number | undefined;
    ref_Id?: string | undefined;
    success?: boolean;
}

export class ExtractURLCommand implements IExtractURLCommand {
    urls?: string[] | undefined;

    constructor(data?: IExtractURLCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["urls"])) {
                this.urls = [] as any;
                for (let item of _data["urls"])
                    this.urls!.push(item);
            }
        }
    }

    static fromJS(data: any): ExtractURLCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExtractURLCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.urls)) {
            data["urls"] = [];
            for (let item of this.urls)
                data["urls"].push(item);
        }
        return data;
    }
}

export interface IExtractURLCommand {
    urls?: string[] | undefined;
}

export class ListDocumentQuery implements IListDocumentQuery {
    documents?: DocumentQuery[] | undefined;

    constructor(data?: IListDocumentQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentQuery.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListDocumentQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ListDocumentQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListDocumentQuery {
    documents?: DocumentQuery[] | undefined;
}

export class DocumentQuery implements IDocumentQuery {
    source?: string | undefined;
    data?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;

    constructor(data?: IDocumentQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.data = _data["data"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): DocumentQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["data"] = this.data;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IDocumentQuery {
    source?: string | undefined;
    data?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
}

export class GetDocumentDataQuery implements IGetDocumentDataQuery {
    path?: string | undefined;

    constructor(data?: IGetDocumentDataQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): GetDocumentDataQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentDataQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        return data;
    }
}

export interface IGetDocumentDataQuery {
    path?: string | undefined;
}

export class MakeTestModelLLMCommand implements IMakeTestModelLLMCommand {
    model?: string | undefined;
    input?: string | undefined;
    prompt?: string | undefined;
    temperature?: number;
    type?: string | undefined;

    constructor(data?: IMakeTestModelLLMCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"];
            this.input = _data["input"];
            this.prompt = _data["prompt"];
            this.temperature = _data["temperature"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): MakeTestModelLLMCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MakeTestModelLLMCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model;
        data["input"] = this.input;
        data["prompt"] = this.prompt;
        data["temperature"] = this.temperature;
        data["type"] = this.type;
        return data;
    }
}

export interface IMakeTestModelLLMCommand {
    model?: string | undefined;
    input?: string | undefined;
    prompt?: string | undefined;
    temperature?: number;
    type?: string | undefined;
}

export class VirtualAgentResult implements IVirtualAgentResult {
    content?: string | undefined;
    type?: string | undefined;

    constructor(data?: IVirtualAgentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): VirtualAgentResult {
        data = typeof data === 'object' ? data : {};
        let result = new VirtualAgentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["type"] = this.type;
        return data;
    }
}

export interface IVirtualAgentResult {
    content?: string | undefined;
    type?: string | undefined;
}

export class MakeTestVirtualAgentCommand implements IMakeTestVirtualAgentCommand {
    id?: number;
    input?: string | undefined;
    prompt?: string | undefined;
    customTrain?: boolean;
    keepContext?: boolean;
    sessionId?: string | undefined;
    lang?: string | undefined;
    temperature?: number;
    numberOutput?: number;
    responseMode?: string | undefined;
    firstPrompt?: string | undefined;

    constructor(data?: IMakeTestVirtualAgentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.input = _data["input"];
            this.prompt = _data["prompt"];
            this.customTrain = _data["customTrain"];
            this.keepContext = _data["keepContext"];
            this.sessionId = _data["sessionId"];
            this.lang = _data["lang"];
            this.temperature = _data["temperature"];
            this.numberOutput = _data["numberOutput"];
            this.responseMode = _data["responseMode"];
            this.firstPrompt = _data["firstPrompt"];
        }
    }

    static fromJS(data: any): MakeTestVirtualAgentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MakeTestVirtualAgentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["input"] = this.input;
        data["prompt"] = this.prompt;
        data["customTrain"] = this.customTrain;
        data["keepContext"] = this.keepContext;
        data["sessionId"] = this.sessionId;
        data["lang"] = this.lang;
        data["temperature"] = this.temperature;
        data["numberOutput"] = this.numberOutput;
        data["responseMode"] = this.responseMode;
        data["firstPrompt"] = this.firstPrompt;
        return data;
    }
}

export interface IMakeTestVirtualAgentCommand {
    id?: number;
    input?: string | undefined;
    prompt?: string | undefined;
    customTrain?: boolean;
    keepContext?: boolean;
    sessionId?: string | undefined;
    lang?: string | undefined;
    temperature?: number;
    numberOutput?: number;
    responseMode?: string | undefined;
    firstPrompt?: string | undefined;
}

export class IntentEnityResponse implements IIntentEnityResponse {
    content?: string | undefined;
    type?: string | undefined;

    constructor(data?: IIntentEnityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): IntentEnityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IntentEnityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["type"] = this.type;
        return data;
    }
}

export interface IIntentEnityResponse {
    content?: string | undefined;
    type?: string | undefined;
}

export class DetectIntentEntityLLMCommand implements IDetectIntentEntityLLMCommand {
    intents?: string[] | undefined;
    entities?: string[] | undefined;
    model?: string | undefined;
    input?: string | undefined;

    constructor(data?: IDetectIntentEntityLLMCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["intents"])) {
                this.intents = [] as any;
                for (let item of _data["intents"])
                    this.intents!.push(item);
            }
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(item);
            }
            this.model = _data["model"];
            this.input = _data["input"];
        }
    }

    static fromJS(data: any): DetectIntentEntityLLMCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DetectIntentEntityLLMCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.intents)) {
            data["intents"] = [];
            for (let item of this.intents)
                data["intents"].push(item);
        }
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item);
        }
        data["model"] = this.model;
        data["input"] = this.input;
        return data;
    }
}

export interface IDetectIntentEntityLLMCommand {
    intents?: string[] | undefined;
    entities?: string[] | undefined;
    model?: string | undefined;
    input?: string | undefined;
}

export class CheckExistedGPTCommand implements ICheckExistedGPTCommand {
    name?: string | undefined;

    constructor(data?: ICheckExistedGPTCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CheckExistedGPTCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CheckExistedGPTCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICheckExistedGPTCommand {
    name?: string | undefined;
}

export class RetrieveURLResponse implements IRetrieveURLResponse {
    retrieveURLs?: RetrieveURLModel[] | undefined;
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: IRetrieveURLResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["retrieveURLs"])) {
                this.retrieveURLs = [] as any;
                for (let item of _data["retrieveURLs"])
                    this.retrieveURLs!.push(RetrieveURLModel.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): RetrieveURLResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveURLResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.retrieveURLs)) {
            data["retrieveURLs"] = [];
            for (let item of this.retrieveURLs)
                data["retrieveURLs"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface IRetrieveURLResponse {
    retrieveURLs?: RetrieveURLModel[] | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
}

export class RetrieveURLModel implements IRetrieveURLModel {
    url?: string | undefined;
    tokens?: number;

    constructor(data?: IRetrieveURLModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.tokens = _data["tokens"];
        }
    }

    static fromJS(data: any): RetrieveURLModel {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveURLModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["tokens"] = this.tokens;
        return data;
    }
}

export interface IRetrieveURLModel {
    url?: string | undefined;
    tokens?: number;
}

export class RetrieveURLCommand implements IRetrieveURLCommand {
    urls?: string[] | undefined;
    isExtract?: boolean;

    constructor(data?: IRetrieveURLCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["urls"])) {
                this.urls = [] as any;
                for (let item of _data["urls"])
                    this.urls!.push(item);
            }
            this.isExtract = _data["isExtract"];
        }
    }

    static fromJS(data: any): RetrieveURLCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveURLCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.urls)) {
            data["urls"] = [];
            for (let item of this.urls)
                data["urls"].push(item);
        }
        data["isExtract"] = this.isExtract;
        return data;
    }
}

export interface IRetrieveURLCommand {
    urls?: string[] | undefined;
    isExtract?: boolean;
}

export class CMSListVm implements ICMSListVm {
    cmsDtos?: CMSDto[] | undefined;
    page?: Page | undefined;

    constructor(data?: ICMSListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cmsDtos"])) {
                this.cmsDtos = [] as any;
                for (let item of _data["cmsDtos"])
                    this.cmsDtos!.push(CMSDto.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CMSListVm {
        data = typeof data === 'object' ? data : {};
        let result = new CMSListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cmsDtos)) {
            data["cmsDtos"] = [];
            for (let item of this.cmsDtos)
                data["cmsDtos"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICMSListVm {
    cmsDtos?: CMSDto[] | undefined;
    page?: Page | undefined;
}

export class CMSDto implements ICMSDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isDisable?: boolean;

    constructor(data?: ICMSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDisable = _data["isDisable"];
        }
    }

    static fromJS(data: any): CMSDto {
        data = typeof data === 'object' ? data : {};
        let result = new CMSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDisable"] = this.isDisable;
        return data;
    }
}

export interface ICMSDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isDisable?: boolean;
}

export class GetAllCMSQuery implements IGetAllCMSQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetAllCMSQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllCMSQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCMSQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["searchText"] = this.searchText;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllCMSQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class UpdateCMSCommand implements IUpdateCMSCommand {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IUpdateCMSCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateCMSCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCMSCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateCMSCommand {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export class CMSWithEntityDto implements ICMSWithEntityDto {
    id?: number;
    name?: string | undefined;
    cmsEntities?: CMSEntitiesDto[] | undefined;
    description?: string | undefined;
    isDisable?: boolean;

    constructor(data?: ICMSWithEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["cmsEntities"])) {
                this.cmsEntities = [] as any;
                for (let item of _data["cmsEntities"])
                    this.cmsEntities!.push(CMSEntitiesDto.fromJS(item));
            }
            this.description = _data["description"];
            this.isDisable = _data["isDisable"];
        }
    }

    static fromJS(data: any): CMSWithEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CMSWithEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.cmsEntities)) {
            data["cmsEntities"] = [];
            for (let item of this.cmsEntities)
                data["cmsEntities"].push(item.toJSON());
        }
        data["description"] = this.description;
        data["isDisable"] = this.isDisable;
        return data;
    }
}

export interface ICMSWithEntityDto {
    id?: number;
    name?: string | undefined;
    cmsEntities?: CMSEntitiesDto[] | undefined;
    description?: string | undefined;
    isDisable?: boolean;
}

export class CMSEntitiesDto implements ICMSEntitiesDto {
    id?: number;
    fieldName?: string | undefined;
    uniqueName?: string | undefined;
    dataType?: string | undefined;
    maxLength?: string | undefined;
    isDelete?: boolean;

    constructor(data?: ICMSEntitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fieldName = _data["fieldName"];
            this.uniqueName = _data["uniqueName"];
            this.dataType = _data["dataType"];
            this.maxLength = _data["maxLength"];
            this.isDelete = _data["isDelete"];
        }
    }

    static fromJS(data: any): CMSEntitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CMSEntitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fieldName"] = this.fieldName;
        data["uniqueName"] = this.uniqueName;
        data["dataType"] = this.dataType;
        data["maxLength"] = this.maxLength;
        data["isDelete"] = this.isDelete;
        return data;
    }
}

export interface ICMSEntitiesDto {
    id?: number;
    fieldName?: string | undefined;
    uniqueName?: string | undefined;
    dataType?: string | undefined;
    maxLength?: string | undefined;
    isDelete?: boolean;
}

export class CMSDetailsDto implements ICMSDetailsDto {
    id?: number;
    name?: string | undefined;
    cmsEntities?: CMSEntitiesDto[] | undefined;
    cmsDatas?: CMSDataDto[] | undefined;
    description?: string | undefined;
    isDisable?: boolean;
    page?: Page | undefined;

    constructor(data?: ICMSDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["cmsEntities"])) {
                this.cmsEntities = [] as any;
                for (let item of _data["cmsEntities"])
                    this.cmsEntities!.push(CMSEntitiesDto.fromJS(item));
            }
            if (Array.isArray(_data["cmsDatas"])) {
                this.cmsDatas = [] as any;
                for (let item of _data["cmsDatas"])
                    this.cmsDatas!.push(CMSDataDto.fromJS(item));
            }
            this.description = _data["description"];
            this.isDisable = _data["isDisable"];
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CMSDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CMSDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.cmsEntities)) {
            data["cmsEntities"] = [];
            for (let item of this.cmsEntities)
                data["cmsEntities"].push(item.toJSON());
        }
        if (Array.isArray(this.cmsDatas)) {
            data["cmsDatas"] = [];
            for (let item of this.cmsDatas)
                data["cmsDatas"].push(item.toJSON());
        }
        data["description"] = this.description;
        data["isDisable"] = this.isDisable;
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICMSDetailsDto {
    id?: number;
    name?: string | undefined;
    cmsEntities?: CMSEntitiesDto[] | undefined;
    cmsDatas?: CMSDataDto[] | undefined;
    description?: string | undefined;
    isDisable?: boolean;
    page?: Page | undefined;
}

export class CMSDataDto implements ICMSDataDto {
    id?: number;
    data?: string | undefined;
    isDelete?: boolean;

    constructor(data?: ICMSDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.data = _data["data"];
            this.isDelete = _data["isDelete"];
        }
    }

    static fromJS(data: any): CMSDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CMSDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["data"] = this.data;
        data["isDelete"] = this.isDelete;
        return data;
    }
}

export interface ICMSDataDto {
    id?: number;
    data?: string | undefined;
    isDelete?: boolean;
}

export class GetCMSDetailsWithDataQuery implements IGetCMSDetailsWithDataQuery {
    page?: Page | undefined;
    filterData?: FilterData[] | undefined;
    id?: number;

    constructor(data?: IGetCMSDetailsWithDataQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCMSDetailsWithDataQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCMSDetailsWithDataQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCMSDetailsWithDataQuery {
    page?: Page | undefined;
    filterData?: FilterData[] | undefined;
    id?: number;
}

export class DisableCMSCommand implements IDisableCMSCommand {
    id?: number;

    constructor(data?: IDisableCMSCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DisableCMSCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DisableCMSCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDisableCMSCommand {
    id?: number;
}

export class UpdateCMSEntitiesCommand implements IUpdateCMSEntitiesCommand {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    cmsDetailsDto?: CMSEntitiesDto[] | undefined;

    constructor(data?: IUpdateCMSEntitiesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["cmsDetailsDto"])) {
                this.cmsDetailsDto = [] as any;
                for (let item of _data["cmsDetailsDto"])
                    this.cmsDetailsDto!.push(CMSEntitiesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateCMSEntitiesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCMSEntitiesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.cmsDetailsDto)) {
            data["cmsDetailsDto"] = [];
            for (let item of this.cmsDetailsDto)
                data["cmsDetailsDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateCMSEntitiesCommand {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    cmsDetailsDto?: CMSEntitiesDto[] | undefined;
}

export class CreateCMSDataCommand implements ICreateCMSDataCommand {
    id?: number;
    data?: string | undefined;
    companyId?: number | undefined;

    constructor(data?: ICreateCMSDataCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.data = _data["data"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): CreateCMSDataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCMSDataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["data"] = this.data;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface ICreateCMSDataCommand {
    id?: number;
    data?: string | undefined;
    companyId?: number | undefined;
}

export class CMSDataActionQuery implements ICMSDataActionQuery {
    id?: number;
    method?: string | undefined;
    dataCMS?: string | undefined;
    dataUpdate?: string | undefined;
    conditions?: string | undefined;
    queryLimit?: string | undefined;
    sortBy?: string | undefined;
    orderBy?: string | undefined;
    conditionsType?: string | undefined;

    constructor(data?: ICMSDataActionQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.method = _data["method"];
            this.dataCMS = _data["dataCMS"];
            this.dataUpdate = _data["dataUpdate"];
            this.conditions = _data["conditions"];
            this.queryLimit = _data["queryLimit"];
            this.sortBy = _data["sortBy"];
            this.orderBy = _data["orderBy"];
            this.conditionsType = _data["conditionsType"];
        }
    }

    static fromJS(data: any): CMSDataActionQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CMSDataActionQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["method"] = this.method;
        data["dataCMS"] = this.dataCMS;
        data["dataUpdate"] = this.dataUpdate;
        data["conditions"] = this.conditions;
        data["queryLimit"] = this.queryLimit;
        data["sortBy"] = this.sortBy;
        data["orderBy"] = this.orderBy;
        data["conditionsType"] = this.conditionsType;
        return data;
    }
}

export interface ICMSDataActionQuery {
    id?: number;
    method?: string | undefined;
    dataCMS?: string | undefined;
    dataUpdate?: string | undefined;
    conditions?: string | undefined;
    queryLimit?: string | undefined;
    sortBy?: string | undefined;
    orderBy?: string | undefined;
    conditionsType?: string | undefined;
}

export class UpdateCMSDataCommand implements IUpdateCMSDataCommand {
    id?: number;
    idData?: number;
    data?: string | undefined;

    constructor(data?: IUpdateCMSDataCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idData = _data["idData"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): UpdateCMSDataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCMSDataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idData"] = this.idData;
        data["data"] = this.data;
        return data;
    }
}

export interface IUpdateCMSDataCommand {
    id?: number;
    idData?: number;
    data?: string | undefined;
}

export class ImportCMSDataCommand implements IImportCMSDataCommand {
    id?: number;
    data?: string[] | undefined;

    constructor(data?: IImportCMSDataCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportCMSDataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCMSDataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }
}

export interface IImportCMSDataCommand {
    id?: number;
    data?: string[] | undefined;
}

export class SampleFileCMSDataCommand implements ISampleFileCMSDataCommand {
    uniqueNameList?: string[] | undefined;

    constructor(data?: ISampleFileCMSDataCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uniqueNameList"])) {
                this.uniqueNameList = [] as any;
                for (let item of _data["uniqueNameList"])
                    this.uniqueNameList!.push(item);
            }
        }
    }

    static fromJS(data: any): SampleFileCMSDataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SampleFileCMSDataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uniqueNameList)) {
            data["uniqueNameList"] = [];
            for (let item of this.uniqueNameList)
                data["uniqueNameList"].push(item);
        }
        return data;
    }
}

export interface ISampleFileCMSDataCommand {
    uniqueNameList?: string[] | undefined;
}

export class Configuration implements IConfiguration {
    apiConnectorPort?: string | undefined;
    textToSpeechKey?: string | undefined;
    azureTTSKey?: string | undefined;
    azureTTSRegion?: string | undefined;
    azureTranslateKey?: string | undefined;
    azureTranslateRegion?: string | undefined;
    azureSTTKey?: string | undefined;
    azureSTTRegion?: string | undefined;
    primasTTSUrl?: string | undefined;
    amazonPollyAccessKey?: string | undefined;
    amazonPollySecretKey?: string | undefined;
    amazonTranslateAccessKey?: string | undefined;
    amazonTranslateSecretKey?: string | undefined;
    googleTTSKey?: string | undefined;
    googleTranslateKey?: string | undefined;
    googleSTTKey?: string | undefined;
    deepgramKey?: string | undefined;
    soundhoundTTSAccessKey?: string | undefined;
    soundhoundTTSSecretKey?: string | undefined;
    soundhoundSTTAccessKey?: string | undefined;
    soundhoundSTTSecretKey?: string | undefined;
    amazonTranscribeAccessKey?: string | undefined;
    amazonTranscribeSecretKey?: string | undefined;
    speechToTextKey?: string | undefined;
    localAsterisk?: string | undefined;
    asteriskServer?: string | undefined;
    asteriskUserName?: string | undefined;
    asteriskPassword?: string | undefined;
    asteriskIdentityFile?: string | undefined;
    mailServer?: string | undefined;
    mailPort?: string | undefined;
    sipPort?: string | undefined;
    webSocketType?: string | undefined;
    senderName?: string | undefined;
    sender?: string | undefined;
    mailUserName?: string | undefined;
    mailPassword?: string | undefined;
    mailTo?: string | undefined;
    dateSendCost?: string | undefined;
    dateSendInvoice?: string | undefined;
    intervalDayClean?: string | undefined;
    contactConfigUrl?: string | undefined;
    chatBotUrl?: string | undefined;
    chatbotOutreachUrl?: string | undefined;
    contactConfigAuth?: string | undefined;
    trainIntentUrl?: string | undefined;
    trainGPTIntentUrl?: string | undefined;
    trainGPTKey?: string | undefined;
    trainGPTAuthenticationToken?: string | undefined;
    chatBotHubUrl?: string | undefined;
    callFlowChatUrl?: string | undefined;
    virtualAssistantUrl?: string | undefined;
    logMaxday?: string | undefined;
    customFunctionUrl?: string | undefined;
    aeapUrl?: string | undefined;
    customFunctionPort?: string | undefined;
    customFunctionPHPUrl?: string | undefined;
    customFunctionPHPPort?: string | undefined;
    callFlowRepo?: string | undefined;
    callFlowBackUpUrl?: string | undefined;
    callFlowBackUpUserName?: string | undefined;
    callFlowBackUpPassword?: string | undefined;
    geminiKey?: string | undefined;
    supportFlowURL?: string | undefined;
    botAuthorizationToken?: string | undefined;
    botErrorEncounterMessage?: string | undefined;
    botFlowMode?: string | undefined;
    botPhoneNumberCountryCode?: string | undefined;
    botEnableTraceLogToCallFlow?: string | undefined;
    botMaxLogSize?: string | undefined;
    botMaxLogFiles?: string | undefined;
    botLogMode?: string | undefined;
    botResendErrorMailAfter?: string | undefined;
    botConnectorUrl?: string | undefined;
    recordingServerUrl?: string | undefined;
    syncServerUrl?: string | undefined;
    botLinkScopeAPIUrl?: string | undefined;
    llmPromptDetectIntent?: string | undefined;
    llmPromptDetectEntity?: string | undefined;

    constructor(data?: IConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiConnectorPort = _data["apiConnectorPort"];
            this.textToSpeechKey = _data["textToSpeechKey"];
            this.azureTTSKey = _data["azureTTSKey"];
            this.azureTTSRegion = _data["azureTTSRegion"];
            this.azureTranslateKey = _data["azureTranslateKey"];
            this.azureTranslateRegion = _data["azureTranslateRegion"];
            this.azureSTTKey = _data["azureSTTKey"];
            this.azureSTTRegion = _data["azureSTTRegion"];
            this.primasTTSUrl = _data["primasTTSUrl"];
            this.amazonPollyAccessKey = _data["amazonPollyAccessKey"];
            this.amazonPollySecretKey = _data["amazonPollySecretKey"];
            this.amazonTranslateAccessKey = _data["amazonTranslateAccessKey"];
            this.amazonTranslateSecretKey = _data["amazonTranslateSecretKey"];
            this.googleTTSKey = _data["googleTTSKey"];
            this.googleTranslateKey = _data["googleTranslateKey"];
            this.googleSTTKey = _data["googleSTTKey"];
            this.deepgramKey = _data["deepgramKey"];
            this.soundhoundTTSAccessKey = _data["soundhoundTTSAccessKey"];
            this.soundhoundTTSSecretKey = _data["soundhoundTTSSecretKey"];
            this.soundhoundSTTAccessKey = _data["soundhoundSTTAccessKey"];
            this.soundhoundSTTSecretKey = _data["soundhoundSTTSecretKey"];
            this.amazonTranscribeAccessKey = _data["amazonTranscribeAccessKey"];
            this.amazonTranscribeSecretKey = _data["amazonTranscribeSecretKey"];
            this.speechToTextKey = _data["speechToTextKey"];
            this.localAsterisk = _data["localAsterisk"];
            this.asteriskServer = _data["asteriskServer"];
            this.asteriskUserName = _data["asteriskUserName"];
            this.asteriskPassword = _data["asteriskPassword"];
            this.asteriskIdentityFile = _data["asteriskIdentityFile"];
            this.mailServer = _data["mailServer"];
            this.mailPort = _data["mailPort"];
            this.sipPort = _data["sipPort"];
            this.webSocketType = _data["webSocketType"];
            this.senderName = _data["senderName"];
            this.sender = _data["sender"];
            this.mailUserName = _data["mailUserName"];
            this.mailPassword = _data["mailPassword"];
            this.mailTo = _data["mailTo"];
            this.dateSendCost = _data["dateSendCost"];
            this.dateSendInvoice = _data["dateSendInvoice"];
            this.intervalDayClean = _data["intervalDayClean"];
            this.contactConfigUrl = _data["contactConfigUrl"];
            this.chatBotUrl = _data["chatBotUrl"];
            this.chatbotOutreachUrl = _data["chatbotOutreachUrl"];
            this.contactConfigAuth = _data["contactConfigAuth"];
            this.trainIntentUrl = _data["trainIntentUrl"];
            this.trainGPTIntentUrl = _data["trainGPTIntentUrl"];
            this.trainGPTKey = _data["trainGPTKey"];
            this.trainGPTAuthenticationToken = _data["trainGPTAuthenticationToken"];
            this.chatBotHubUrl = _data["chatBotHubUrl"];
            this.callFlowChatUrl = _data["callFlowChatUrl"];
            this.virtualAssistantUrl = _data["virtualAssistantUrl"];
            this.logMaxday = _data["logMaxday"];
            this.customFunctionUrl = _data["customFunctionUrl"];
            this.aeapUrl = _data["aeapUrl"];
            this.customFunctionPort = _data["customFunctionPort"];
            this.customFunctionPHPUrl = _data["customFunctionPHPUrl"];
            this.customFunctionPHPPort = _data["customFunctionPHPPort"];
            this.callFlowRepo = _data["callFlowRepo"];
            this.callFlowBackUpUrl = _data["callFlowBackUpUrl"];
            this.callFlowBackUpUserName = _data["callFlowBackUpUserName"];
            this.callFlowBackUpPassword = _data["callFlowBackUpPassword"];
            this.geminiKey = _data["geminiKey"];
            this.supportFlowURL = _data["supportFlowURL"];
            this.botAuthorizationToken = _data["botAuthorizationToken"];
            this.botErrorEncounterMessage = _data["botErrorEncounterMessage"];
            this.botFlowMode = _data["botFlowMode"];
            this.botPhoneNumberCountryCode = _data["botPhoneNumberCountryCode"];
            this.botEnableTraceLogToCallFlow = _data["botEnableTraceLogToCallFlow"];
            this.botMaxLogSize = _data["botMaxLogSize"];
            this.botMaxLogFiles = _data["botMaxLogFiles"];
            this.botLogMode = _data["botLogMode"];
            this.botResendErrorMailAfter = _data["botResendErrorMailAfter"];
            this.botConnectorUrl = _data["botConnectorUrl"];
            this.recordingServerUrl = _data["recordingServerUrl"];
            this.syncServerUrl = _data["syncServerUrl"];
            this.botLinkScopeAPIUrl = _data["botLinkScopeAPIUrl"];
            this.llmPromptDetectIntent = _data["llmPromptDetectIntent"];
            this.llmPromptDetectEntity = _data["llmPromptDetectEntity"];
        }
    }

    static fromJS(data: any): Configuration {
        data = typeof data === 'object' ? data : {};
        let result = new Configuration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiConnectorPort"] = this.apiConnectorPort;
        data["textToSpeechKey"] = this.textToSpeechKey;
        data["azureTTSKey"] = this.azureTTSKey;
        data["azureTTSRegion"] = this.azureTTSRegion;
        data["azureTranslateKey"] = this.azureTranslateKey;
        data["azureTranslateRegion"] = this.azureTranslateRegion;
        data["azureSTTKey"] = this.azureSTTKey;
        data["azureSTTRegion"] = this.azureSTTRegion;
        data["primasTTSUrl"] = this.primasTTSUrl;
        data["amazonPollyAccessKey"] = this.amazonPollyAccessKey;
        data["amazonPollySecretKey"] = this.amazonPollySecretKey;
        data["amazonTranslateAccessKey"] = this.amazonTranslateAccessKey;
        data["amazonTranslateSecretKey"] = this.amazonTranslateSecretKey;
        data["googleTTSKey"] = this.googleTTSKey;
        data["googleTranslateKey"] = this.googleTranslateKey;
        data["googleSTTKey"] = this.googleSTTKey;
        data["deepgramKey"] = this.deepgramKey;
        data["soundhoundTTSAccessKey"] = this.soundhoundTTSAccessKey;
        data["soundhoundTTSSecretKey"] = this.soundhoundTTSSecretKey;
        data["soundhoundSTTAccessKey"] = this.soundhoundSTTAccessKey;
        data["soundhoundSTTSecretKey"] = this.soundhoundSTTSecretKey;
        data["amazonTranscribeAccessKey"] = this.amazonTranscribeAccessKey;
        data["amazonTranscribeSecretKey"] = this.amazonTranscribeSecretKey;
        data["speechToTextKey"] = this.speechToTextKey;
        data["localAsterisk"] = this.localAsterisk;
        data["asteriskServer"] = this.asteriskServer;
        data["asteriskUserName"] = this.asteriskUserName;
        data["asteriskPassword"] = this.asteriskPassword;
        data["asteriskIdentityFile"] = this.asteriskIdentityFile;
        data["mailServer"] = this.mailServer;
        data["mailPort"] = this.mailPort;
        data["sipPort"] = this.sipPort;
        data["webSocketType"] = this.webSocketType;
        data["senderName"] = this.senderName;
        data["sender"] = this.sender;
        data["mailUserName"] = this.mailUserName;
        data["mailPassword"] = this.mailPassword;
        data["mailTo"] = this.mailTo;
        data["dateSendCost"] = this.dateSendCost;
        data["dateSendInvoice"] = this.dateSendInvoice;
        data["intervalDayClean"] = this.intervalDayClean;
        data["contactConfigUrl"] = this.contactConfigUrl;
        data["chatBotUrl"] = this.chatBotUrl;
        data["chatbotOutreachUrl"] = this.chatbotOutreachUrl;
        data["contactConfigAuth"] = this.contactConfigAuth;
        data["trainIntentUrl"] = this.trainIntentUrl;
        data["trainGPTIntentUrl"] = this.trainGPTIntentUrl;
        data["trainGPTKey"] = this.trainGPTKey;
        data["trainGPTAuthenticationToken"] = this.trainGPTAuthenticationToken;
        data["chatBotHubUrl"] = this.chatBotHubUrl;
        data["callFlowChatUrl"] = this.callFlowChatUrl;
        data["virtualAssistantUrl"] = this.virtualAssistantUrl;
        data["logMaxday"] = this.logMaxday;
        data["customFunctionUrl"] = this.customFunctionUrl;
        data["aeapUrl"] = this.aeapUrl;
        data["customFunctionPort"] = this.customFunctionPort;
        data["customFunctionPHPUrl"] = this.customFunctionPHPUrl;
        data["customFunctionPHPPort"] = this.customFunctionPHPPort;
        data["callFlowRepo"] = this.callFlowRepo;
        data["callFlowBackUpUrl"] = this.callFlowBackUpUrl;
        data["callFlowBackUpUserName"] = this.callFlowBackUpUserName;
        data["callFlowBackUpPassword"] = this.callFlowBackUpPassword;
        data["geminiKey"] = this.geminiKey;
        data["supportFlowURL"] = this.supportFlowURL;
        data["botAuthorizationToken"] = this.botAuthorizationToken;
        data["botErrorEncounterMessage"] = this.botErrorEncounterMessage;
        data["botFlowMode"] = this.botFlowMode;
        data["botPhoneNumberCountryCode"] = this.botPhoneNumberCountryCode;
        data["botEnableTraceLogToCallFlow"] = this.botEnableTraceLogToCallFlow;
        data["botMaxLogSize"] = this.botMaxLogSize;
        data["botMaxLogFiles"] = this.botMaxLogFiles;
        data["botLogMode"] = this.botLogMode;
        data["botResendErrorMailAfter"] = this.botResendErrorMailAfter;
        data["botConnectorUrl"] = this.botConnectorUrl;
        data["recordingServerUrl"] = this.recordingServerUrl;
        data["syncServerUrl"] = this.syncServerUrl;
        data["botLinkScopeAPIUrl"] = this.botLinkScopeAPIUrl;
        data["llmPromptDetectIntent"] = this.llmPromptDetectIntent;
        data["llmPromptDetectEntity"] = this.llmPromptDetectEntity;
        return data;
    }
}

export interface IConfiguration {
    apiConnectorPort?: string | undefined;
    textToSpeechKey?: string | undefined;
    azureTTSKey?: string | undefined;
    azureTTSRegion?: string | undefined;
    azureTranslateKey?: string | undefined;
    azureTranslateRegion?: string | undefined;
    azureSTTKey?: string | undefined;
    azureSTTRegion?: string | undefined;
    primasTTSUrl?: string | undefined;
    amazonPollyAccessKey?: string | undefined;
    amazonPollySecretKey?: string | undefined;
    amazonTranslateAccessKey?: string | undefined;
    amazonTranslateSecretKey?: string | undefined;
    googleTTSKey?: string | undefined;
    googleTranslateKey?: string | undefined;
    googleSTTKey?: string | undefined;
    deepgramKey?: string | undefined;
    soundhoundTTSAccessKey?: string | undefined;
    soundhoundTTSSecretKey?: string | undefined;
    soundhoundSTTAccessKey?: string | undefined;
    soundhoundSTTSecretKey?: string | undefined;
    amazonTranscribeAccessKey?: string | undefined;
    amazonTranscribeSecretKey?: string | undefined;
    speechToTextKey?: string | undefined;
    localAsterisk?: string | undefined;
    asteriskServer?: string | undefined;
    asteriskUserName?: string | undefined;
    asteriskPassword?: string | undefined;
    asteriskIdentityFile?: string | undefined;
    mailServer?: string | undefined;
    mailPort?: string | undefined;
    sipPort?: string | undefined;
    webSocketType?: string | undefined;
    senderName?: string | undefined;
    sender?: string | undefined;
    mailUserName?: string | undefined;
    mailPassword?: string | undefined;
    mailTo?: string | undefined;
    dateSendCost?: string | undefined;
    dateSendInvoice?: string | undefined;
    intervalDayClean?: string | undefined;
    contactConfigUrl?: string | undefined;
    chatBotUrl?: string | undefined;
    chatbotOutreachUrl?: string | undefined;
    contactConfigAuth?: string | undefined;
    trainIntentUrl?: string | undefined;
    trainGPTIntentUrl?: string | undefined;
    trainGPTKey?: string | undefined;
    trainGPTAuthenticationToken?: string | undefined;
    chatBotHubUrl?: string | undefined;
    callFlowChatUrl?: string | undefined;
    virtualAssistantUrl?: string | undefined;
    logMaxday?: string | undefined;
    customFunctionUrl?: string | undefined;
    aeapUrl?: string | undefined;
    customFunctionPort?: string | undefined;
    customFunctionPHPUrl?: string | undefined;
    customFunctionPHPPort?: string | undefined;
    callFlowRepo?: string | undefined;
    callFlowBackUpUrl?: string | undefined;
    callFlowBackUpUserName?: string | undefined;
    callFlowBackUpPassword?: string | undefined;
    geminiKey?: string | undefined;
    supportFlowURL?: string | undefined;
    botAuthorizationToken?: string | undefined;
    botErrorEncounterMessage?: string | undefined;
    botFlowMode?: string | undefined;
    botPhoneNumberCountryCode?: string | undefined;
    botEnableTraceLogToCallFlow?: string | undefined;
    botMaxLogSize?: string | undefined;
    botMaxLogFiles?: string | undefined;
    botLogMode?: string | undefined;
    botResendErrorMailAfter?: string | undefined;
    botConnectorUrl?: string | undefined;
    recordingServerUrl?: string | undefined;
    syncServerUrl?: string | undefined;
    botLinkScopeAPIUrl?: string | undefined;
    llmPromptDetectIntent?: string | undefined;
    llmPromptDetectEntity?: string | undefined;
}

export class ListUserSettingVm implements IListUserSettingVm {
    userSettings?: UserSettingsDto[] | undefined;

    constructor(data?: IListUserSettingVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userSettings"])) {
                this.userSettings = [] as any;
                for (let item of _data["userSettings"])
                    this.userSettings!.push(UserSettingsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListUserSettingVm {
        data = typeof data === 'object' ? data : {};
        let result = new ListUserSettingVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userSettings)) {
            data["userSettings"] = [];
            for (let item of this.userSettings)
                data["userSettings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListUserSettingVm {
    userSettings?: UserSettingsDto[] | undefined;
}

export class UserSettingsDto implements IUserSettingsDto {
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IUserSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UserSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IUserSettingsDto {
    key?: string | undefined;
    value?: string | undefined;
}

export class UpdateSupportFlowURL implements IUpdateSupportFlowURL {
    url?: string | undefined;

    constructor(data?: IUpdateSupportFlowURL) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): UpdateSupportFlowURL {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSupportFlowURL();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IUpdateSupportFlowURL {
    url?: string | undefined;
}

export class UpdateConfigurationUserCommand implements IUpdateConfigurationUserCommand {
    userSettingDtos?: UserSettingsDto[] | undefined;

    constructor(data?: IUpdateConfigurationUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userSettingDtos"])) {
                this.userSettingDtos = [] as any;
                for (let item of _data["userSettingDtos"])
                    this.userSettingDtos!.push(UserSettingsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateConfigurationUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfigurationUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userSettingDtos)) {
            data["userSettingDtos"] = [];
            for (let item of this.userSettingDtos)
                data["userSettingDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateConfigurationUserCommand {
    userSettingDtos?: UserSettingsDto[] | undefined;
}

export class UpdateConfigurationCommand implements IUpdateConfigurationCommand {
    config?: Configuration | undefined;

    constructor(data?: IUpdateConfigurationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.config = _data["config"] ? Configuration.fromJS(_data["config"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateConfigurationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfigurationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["config"] = this.config ? this.config.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateConfigurationCommand {
    config?: Configuration | undefined;
}

export class CustomersListVm implements ICustomersListVm {
    customerVm?: CustomerVm[] | undefined;
    page?: Page | undefined;

    constructor(data?: ICustomersListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customerVm"])) {
                this.customerVm = [] as any;
                for (let item of _data["customerVm"])
                    this.customerVm!.push(CustomerVm.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomersListVm {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customerVm)) {
            data["customerVm"] = [];
            for (let item of this.customerVm)
                data["customerVm"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomersListVm {
    customerVm?: CustomerVm[] | undefined;
    page?: Page | undefined;
}

export class CustomerVm implements ICustomerVm {
    companyVm?: CompanyLookup | undefined;
    id?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    avatar?: string | undefined;
    companyId?: number;
    companyName?: string | undefined;
    roleNameListDisplay?: string | undefined;
    emailBilling?: string | undefined;
    phoneNumber?: string | undefined;
    disable?: boolean;
    roles?: string[] | undefined;
    roleNameList?: string[] | undefined;
    costVm?: CostLookup | undefined;

    constructor(data?: ICustomerVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyVm = _data["companyVm"] ? CompanyLookup.fromJS(_data["companyVm"]) : <any>undefined;
            this.id = _data["id"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.avatar = _data["avatar"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.roleNameListDisplay = _data["roleNameListDisplay"];
            this.emailBilling = _data["emailBilling"];
            this.phoneNumber = _data["phoneNumber"];
            this.disable = _data["disable"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["roleNameList"])) {
                this.roleNameList = [] as any;
                for (let item of _data["roleNameList"])
                    this.roleNameList!.push(item);
            }
            this.costVm = _data["costVm"] ? CostLookup.fromJS(_data["costVm"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerVm {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyVm"] = this.companyVm ? this.companyVm.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["avatar"] = this.avatar;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["roleNameListDisplay"] = this.roleNameListDisplay;
        data["emailBilling"] = this.emailBilling;
        data["phoneNumber"] = this.phoneNumber;
        data["disable"] = this.disable;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.roleNameList)) {
            data["roleNameList"] = [];
            for (let item of this.roleNameList)
                data["roleNameList"].push(item);
        }
        data["costVm"] = this.costVm ? this.costVm.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomerVm {
    companyVm?: CompanyLookup | undefined;
    id?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    avatar?: string | undefined;
    companyId?: number;
    companyName?: string | undefined;
    roleNameListDisplay?: string | undefined;
    emailBilling?: string | undefined;
    phoneNumber?: string | undefined;
    disable?: boolean;
    roles?: string[] | undefined;
    roleNameList?: string[] | undefined;
    costVm?: CostLookup | undefined;
}

export class CompanyLookup implements ICompanyLookup {
    id?: number;
    name?: string | undefined;
    address?: string | undefined;
    disable?: boolean;

    constructor(data?: ICompanyLookup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.disable = _data["disable"];
        }
    }

    static fromJS(data: any): CompanyLookup {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyLookup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["disable"] = this.disable;
        return data;
    }
}

export interface ICompanyLookup {
    id?: number;
    name?: string | undefined;
    address?: string | undefined;
    disable?: boolean;
}

export class GetCustomersListQuery implements IGetCustomersListQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    company?: string | undefined;
    roles?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetCustomersListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.searchText = _data["searchText"];
            this.company = _data["company"];
            this.roles = _data["roles"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCustomersListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomersListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["searchText"] = this.searchText;
        data["company"] = this.company;
        data["roles"] = this.roles;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCustomersListQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    company?: string | undefined;
    roles?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class CompanyListVm implements ICompanyListVm {
    companyVm?: CompanyDto[] | undefined;

    constructor(data?: ICompanyListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["companyVm"])) {
                this.companyVm = [] as any;
                for (let item of _data["companyVm"])
                    this.companyVm!.push(CompanyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyListVm {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.companyVm)) {
            data["companyVm"] = [];
            for (let item of this.companyVm)
                data["companyVm"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompanyListVm {
    companyVm?: CompanyDto[] | undefined;
}

export class CompanyDto implements ICompanyDto {
    id?: number;
    name?: string | undefined;
    address?: string | undefined;
    disable?: boolean;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.disable = _data["disable"];
        }
    }

    static fromJS(data: any): CompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["disable"] = this.disable;
        return data;
    }
}

export interface ICompanyDto {
    id?: number;
    name?: string | undefined;
    address?: string | undefined;
    disable?: boolean;
}

export class CreateCustomerCommand implements ICreateCustomerCommand {
    name!: string;
    fullName!: string;
    passWord?: string | undefined;
    address?: string | undefined;
    createSample?: boolean;
    email!: string;
    phoneNumber!: string;
    accountType?: AccountType;
    monthlyFlatCost?: number;
    tax?: number;
    perMinuteCost?: number;
    storageCost?: number;
    extensionCost?: number;
    emailBilling?: string | undefined;
    sendMail?: boolean;

    constructor(data?: ICreateCustomerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.passWord = _data["passWord"];
            this.address = _data["address"];
            this.createSample = _data["createSample"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.accountType = _data["accountType"];
            this.monthlyFlatCost = _data["monthlyFlatCost"];
            this.tax = _data["tax"];
            this.perMinuteCost = _data["perMinuteCost"];
            this.storageCost = _data["storageCost"];
            this.extensionCost = _data["extensionCost"];
            this.emailBilling = _data["emailBilling"];
            this.sendMail = _data["sendMail"];
        }
    }

    static fromJS(data: any): CreateCustomerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["passWord"] = this.passWord;
        data["address"] = this.address;
        data["createSample"] = this.createSample;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["accountType"] = this.accountType;
        data["monthlyFlatCost"] = this.monthlyFlatCost;
        data["tax"] = this.tax;
        data["perMinuteCost"] = this.perMinuteCost;
        data["storageCost"] = this.storageCost;
        data["extensionCost"] = this.extensionCost;
        data["emailBilling"] = this.emailBilling;
        data["sendMail"] = this.sendMail;
        return data;
    }
}

export interface ICreateCustomerCommand {
    name: string;
    fullName: string;
    passWord?: string | undefined;
    address?: string | undefined;
    createSample?: boolean;
    email: string;
    phoneNumber: string;
    accountType?: AccountType;
    monthlyFlatCost?: number;
    tax?: number;
    perMinuteCost?: number;
    storageCost?: number;
    extensionCost?: number;
    emailBilling?: string | undefined;
    sendMail?: boolean;
}

export enum AccountType {
    CallFlow = 0,
    CallFlowByAdmin = 1,
    Social = 2,
}

export class CreateCustomerInCompanyCommand implements ICreateCustomerInCompanyCommand {
    fullName!: string;
    passWord?: string | undefined;
    createSample?: boolean;
    email!: string;
    phoneNumber!: string;
    accountType?: AccountType;
    monthlyFlatCost?: number;
    tax?: number;
    perMinuteCost?: number;
    storageCost?: number;
    extensionCost?: number;
    emailBilling?: string | undefined;
    roles?: string[] | undefined;
    sendMail?: boolean;

    constructor(data?: ICreateCustomerInCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.passWord = _data["passWord"];
            this.createSample = _data["createSample"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.accountType = _data["accountType"];
            this.monthlyFlatCost = _data["monthlyFlatCost"];
            this.tax = _data["tax"];
            this.perMinuteCost = _data["perMinuteCost"];
            this.storageCost = _data["storageCost"];
            this.extensionCost = _data["extensionCost"];
            this.emailBilling = _data["emailBilling"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.sendMail = _data["sendMail"];
        }
    }

    static fromJS(data: any): CreateCustomerInCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerInCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["passWord"] = this.passWord;
        data["createSample"] = this.createSample;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["accountType"] = this.accountType;
        data["monthlyFlatCost"] = this.monthlyFlatCost;
        data["tax"] = this.tax;
        data["perMinuteCost"] = this.perMinuteCost;
        data["storageCost"] = this.storageCost;
        data["extensionCost"] = this.extensionCost;
        data["emailBilling"] = this.emailBilling;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["sendMail"] = this.sendMail;
        return data;
    }
}

export interface ICreateCustomerInCompanyCommand {
    fullName: string;
    passWord?: string | undefined;
    createSample?: boolean;
    email: string;
    phoneNumber: string;
    accountType?: AccountType;
    monthlyFlatCost?: number;
    tax?: number;
    perMinuteCost?: number;
    storageCost?: number;
    extensionCost?: number;
    emailBilling?: string | undefined;
    roles?: string[] | undefined;
    sendMail?: boolean;
}

export class UpdateCustomerCommand implements IUpdateCustomerCommand {
    id?: string | undefined;
    name!: string;
    fullName!: string;
    passWord?: string | undefined;
    address?: string | undefined;
    email!: string;
    tax?: number;
    emailBilling?: string | undefined;
    phoneNumber!: string;
    monthlyFlatCost?: number;
    perMinuteCost?: number;
    storageCost?: number;
    extensionCost?: number;

    constructor(data?: IUpdateCustomerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.passWord = _data["passWord"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.tax = _data["tax"];
            this.emailBilling = _data["emailBilling"];
            this.phoneNumber = _data["phoneNumber"];
            this.monthlyFlatCost = _data["monthlyFlatCost"];
            this.perMinuteCost = _data["perMinuteCost"];
            this.storageCost = _data["storageCost"];
            this.extensionCost = _data["extensionCost"];
        }
    }

    static fromJS(data: any): UpdateCustomerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["passWord"] = this.passWord;
        data["address"] = this.address;
        data["email"] = this.email;
        data["tax"] = this.tax;
        data["emailBilling"] = this.emailBilling;
        data["phoneNumber"] = this.phoneNumber;
        data["monthlyFlatCost"] = this.monthlyFlatCost;
        data["perMinuteCost"] = this.perMinuteCost;
        data["storageCost"] = this.storageCost;
        data["extensionCost"] = this.extensionCost;
        return data;
    }
}

export interface IUpdateCustomerCommand {
    id?: string | undefined;
    name: string;
    fullName: string;
    passWord?: string | undefined;
    address?: string | undefined;
    email: string;
    tax?: number;
    emailBilling?: string | undefined;
    phoneNumber: string;
    monthlyFlatCost?: number;
    perMinuteCost?: number;
    storageCost?: number;
    extensionCost?: number;
}

export class UpdateCustomerInCompanyCommand implements IUpdateCustomerInCompanyCommand {
    id?: string | undefined;
    fullName!: string;
    passWord?: string | undefined;
    email!: string;
    phoneNumber!: string;
    roles?: string[] | undefined;

    constructor(data?: IUpdateCustomerInCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.passWord = _data["passWord"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateCustomerInCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerInCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["passWord"] = this.passWord;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUpdateCustomerInCompanyCommand {
    id?: string | undefined;
    fullName: string;
    passWord?: string | undefined;
    email: string;
    phoneNumber: string;
    roles?: string[] | undefined;
}

export class DisableCustomerCommand implements IDisableCustomerCommand {
    id?: string | undefined;
    disable?: boolean;

    constructor(data?: IDisableCustomerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.disable = _data["disable"];
        }
    }

    static fromJS(data: any): DisableCustomerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DisableCustomerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["disable"] = this.disable;
        return data;
    }
}

export interface IDisableCustomerCommand {
    id?: string | undefined;
    disable?: boolean;
}

export class DisableCustomerInCompanyCommand implements IDisableCustomerInCompanyCommand {
    id?: string | undefined;
    disable?: boolean;
    email?: string | undefined;

    constructor(data?: IDisableCustomerInCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.disable = _data["disable"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): DisableCustomerInCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DisableCustomerInCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["disable"] = this.disable;
        data["email"] = this.email;
        return data;
    }
}

export interface IDisableCustomerInCompanyCommand {
    id?: string | undefined;
    disable?: boolean;
    email?: string | undefined;
}

export class CustomFunctionListVm implements ICustomFunctionListVm {
    functions?: CustomFunctionLookupDto[] | undefined;
    page?: Page | undefined;

    constructor(data?: ICustomFunctionListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["functions"])) {
                this.functions = [] as any;
                for (let item of _data["functions"])
                    this.functions!.push(CustomFunctionLookupDto.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomFunctionListVm {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFunctionListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.functions)) {
            data["functions"] = [];
            for (let item of this.functions)
                data["functions"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomFunctionListVm {
    functions?: CustomFunctionLookupDto[] | undefined;
    page?: Page | undefined;
}

export class CustomFunctionLookupDto implements ICustomFunctionLookupDto {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    param?: string | undefined;
    language?: string | undefined;

    constructor(data?: ICustomFunctionLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.param = _data["param"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): CustomFunctionLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFunctionLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["param"] = this.param;
        data["language"] = this.language;
        return data;
    }
}

export interface ICustomFunctionLookupDto {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    param?: string | undefined;
    language?: string | undefined;
}

export class GetFunctionListQuery implements IGetFunctionListQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetFunctionListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFunctionListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFunctionListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["searchText"] = this.searchText;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFunctionListQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class CustomFunctionDto implements ICustomFunctionDto {
    id?: number;
    code?: string | undefined;
    codeFormat?: string | undefined;
    companyId?: number;
    name?: string | undefined;
    language?: string | undefined;
    param?: string | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: ICustomFunctionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.codeFormat = _data["codeFormat"];
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.language = _data["language"];
            this.param = _data["param"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomFunctionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFunctionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["codeFormat"] = this.codeFormat;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["language"] = this.language;
        data["param"] = this.param;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustomFunctionDto {
    id?: number;
    code?: string | undefined;
    codeFormat?: string | undefined;
    companyId?: number;
    name?: string | undefined;
    language?: string | undefined;
    param?: string | undefined;
    created?: Date;
    lastModified?: Date;
}

export class CreateCustomFunctionCommand implements ICreateCustomFunctionCommand {
    id?: number;
    name!: string;
    companyId?: number;
    code?: string | undefined;
    language?: string | undefined;
    param?: string | undefined;

    constructor(data?: ICreateCustomFunctionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.code = _data["code"];
            this.language = _data["language"];
            this.param = _data["param"];
        }
    }

    static fromJS(data: any): CreateCustomFunctionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomFunctionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["code"] = this.code;
        data["language"] = this.language;
        data["param"] = this.param;
        return data;
    }
}

export interface ICreateCustomFunctionCommand {
    id?: number;
    name: string;
    companyId?: number;
    code?: string | undefined;
    language?: string | undefined;
    param?: string | undefined;
}

export class UpdateCustomFunctionCommand implements IUpdateCustomFunctionCommand {
    id?: number;
    name!: string;
    companyId?: number;
    code?: string | undefined;
    language?: string | undefined;
    param?: string | undefined;

    constructor(data?: IUpdateCustomFunctionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.code = _data["code"];
            this.language = _data["language"];
            this.param = _data["param"];
        }
    }

    static fromJS(data: any): UpdateCustomFunctionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomFunctionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["code"] = this.code;
        data["language"] = this.language;
        data["param"] = this.param;
        return data;
    }
}

export interface IUpdateCustomFunctionCommand {
    id?: number;
    name: string;
    companyId?: number;
    code?: string | undefined;
    language?: string | undefined;
    param?: string | undefined;
}

export class CheckNameExistQuery implements ICheckNameExistQuery {
    name?: string | undefined;

    constructor(data?: ICheckNameExistQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CheckNameExistQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CheckNameExistQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICheckNameExistQuery {
    name?: string | undefined;
}

export class MakeTestCustomFunctionCommand implements IMakeTestCustomFunctionCommand {
    companyId?: number;
    callNumber?: string | undefined;
    phoneNumber?: string | undefined;
    functionJson?: string | undefined;
    functionId?: number;
    attributes?: any | undefined;
    params?: any | undefined;
    language?: string | undefined;
    code?: string | undefined;
    functionName?: string | undefined;

    constructor(data?: IMakeTestCustomFunctionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.callNumber = _data["callNumber"];
            this.phoneNumber = _data["phoneNumber"];
            this.functionJson = _data["functionJson"];
            this.functionId = _data["functionId"];
            this.attributes = _data["attributes"];
            this.params = _data["params"];
            this.language = _data["language"];
            this.code = _data["code"];
            this.functionName = _data["functionName"];
        }
    }

    static fromJS(data: any): MakeTestCustomFunctionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MakeTestCustomFunctionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["callNumber"] = this.callNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["functionJson"] = this.functionJson;
        data["functionId"] = this.functionId;
        data["attributes"] = this.attributes;
        data["params"] = this.params;
        data["language"] = this.language;
        data["code"] = this.code;
        data["functionName"] = this.functionName;
        return data;
    }
}

export interface IMakeTestCustomFunctionCommand {
    companyId?: number;
    callNumber?: string | undefined;
    phoneNumber?: string | undefined;
    functionJson?: string | undefined;
    functionId?: number;
    attributes?: any | undefined;
    params?: any | undefined;
    language?: string | undefined;
    code?: string | undefined;
    functionName?: string | undefined;
}

export class ExportFunctionCommand implements IExportFunctionCommand {
    functionId?: number;

    constructor(data?: IExportFunctionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.functionId = _data["functionId"];
        }
    }

    static fromJS(data: any): ExportFunctionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportFunctionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["functionId"] = this.functionId;
        return data;
    }
}

export interface IExportFunctionCommand {
    functionId?: number;
}

export class ImportFunctionCommand implements IImportFunctionCommand {
    functionName?: string | undefined;
    functionData?: string | undefined;

    constructor(data?: IImportFunctionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.functionName = _data["functionName"];
            this.functionData = _data["functionData"];
        }
    }

    static fromJS(data: any): ImportFunctionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportFunctionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["functionName"] = this.functionName;
        data["functionData"] = this.functionData;
        return data;
    }
}

export interface IImportFunctionCommand {
    functionName?: string | undefined;
    functionData?: string | undefined;
}

export class DatasetDtoList implements IDatasetDtoList {
    datasetDtos?: DatasetDto[] | undefined;

    constructor(data?: IDatasetDtoList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["datasetDtos"])) {
                this.datasetDtos = [] as any;
                for (let item of _data["datasetDtos"])
                    this.datasetDtos!.push(DatasetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DatasetDtoList {
        data = typeof data === 'object' ? data : {};
        let result = new DatasetDtoList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datasetDtos)) {
            data["datasetDtos"] = [];
            for (let item of this.datasetDtos)
                data["datasetDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDatasetDtoList {
    datasetDtos?: DatasetDto[] | undefined;
}

export class DatasetDto implements IDatasetDto {
    id?: number;
    name?: string | undefined;
    labels?: string | undefined;
    chartType?: string | undefined;
    companyId?: number;
    lastResult?: boolean;

    constructor(data?: IDatasetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.labels = _data["labels"];
            this.chartType = _data["chartType"];
            this.companyId = _data["companyId"];
            this.lastResult = _data["lastResult"];
        }
    }

    static fromJS(data: any): DatasetDto {
        data = typeof data === 'object' ? data : {};
        let result = new DatasetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["labels"] = this.labels;
        data["chartType"] = this.chartType;
        data["companyId"] = this.companyId;
        data["lastResult"] = this.lastResult;
        return data;
    }
}

export interface IDatasetDto {
    id?: number;
    name?: string | undefined;
    labels?: string | undefined;
    chartType?: string | undefined;
    companyId?: number;
    lastResult?: boolean;
}

export class CreateDatasetCommand implements ICreateDatasetCommand {
    id?: number | undefined;
    name?: string | undefined;
    labels?: string | undefined;
    chartType?: string | undefined;
    lastResult?: boolean;

    constructor(data?: ICreateDatasetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.labels = _data["labels"];
            this.chartType = _data["chartType"];
            this.lastResult = _data["lastResult"];
        }
    }

    static fromJS(data: any): CreateDatasetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDatasetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["labels"] = this.labels;
        data["chartType"] = this.chartType;
        data["lastResult"] = this.lastResult;
        return data;
    }
}

export interface ICreateDatasetCommand {
    id?: number | undefined;
    name?: string | undefined;
    labels?: string | undefined;
    chartType?: string | undefined;
    lastResult?: boolean;
}

export class GetDatasetDashboardQuery implements IGetDatasetDashboardQuery {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    phoneNumber?: string | undefined;
    type?: string | undefined;

    constructor(data?: IGetDatasetDashboardQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.phoneNumber = _data["phoneNumber"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GetDatasetDashboardQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetDatasetDashboardQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["phoneNumber"] = this.phoneNumber;
        data["type"] = this.type;
        return data;
    }
}

export interface IGetDatasetDashboardQuery {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    phoneNumber?: string | undefined;
    type?: string | undefined;
}

export class CheckDatasetNameCommand implements ICheckDatasetNameCommand {
    datasetName?: string | undefined;

    constructor(data?: ICheckDatasetNameCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datasetName = _data["datasetName"];
        }
    }

    static fromJS(data: any): CheckDatasetNameCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDatasetNameCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasetName"] = this.datasetName;
        return data;
    }
}

export interface ICheckDatasetNameCommand {
    datasetName?: string | undefined;
}

export class DraftsListVm implements IDraftsListVm {
    drafts?: DraftLookupDto[] | undefined;

    constructor(data?: IDraftsListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["drafts"])) {
                this.drafts = [] as any;
                for (let item of _data["drafts"])
                    this.drafts!.push(DraftLookupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DraftsListVm {
        data = typeof data === 'object' ? data : {};
        let result = new DraftsListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.drafts)) {
            data["drafts"] = [];
            for (let item of this.drafts)
                data["drafts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDraftsListVm {
    drafts?: DraftLookupDto[] | undefined;
}

export class DraftLookupDto implements IDraftLookupDto {
    id?: number;
    name?: string | undefined;
    version?: number;
    image?: string | undefined;
    callflowId?: number;
    created?: Date;
    isPublished?: boolean;

    constructor(data?: IDraftLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.version = _data["version"];
            this.image = _data["image"];
            this.callflowId = _data["callflowId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.isPublished = _data["isPublished"];
        }
    }

    static fromJS(data: any): DraftLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new DraftLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["version"] = this.version;
        data["image"] = this.image;
        data["callflowId"] = this.callflowId;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["isPublished"] = this.isPublished;
        return data;
    }
}

export interface IDraftLookupDto {
    id?: number;
    name?: string | undefined;
    version?: number;
    image?: string | undefined;
    callflowId?: number;
    created?: Date;
    isPublished?: boolean;
}

export class DraftDto implements IDraftDto {
    id?: number;
    data?: string | undefined;
    attribute?: string | undefined;
    callflowId?: number;
    name?: string | undefined;
    version?: number;
    image?: string | undefined;
    jsonFormat?: string | undefined;
    isPublished?: boolean;
    changedDate?: Date;

    constructor(data?: IDraftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.data = _data["data"];
            this.attribute = _data["attribute"];
            this.callflowId = _data["callflowId"];
            this.name = _data["name"];
            this.version = _data["version"];
            this.image = _data["image"];
            this.jsonFormat = _data["jsonFormat"];
            this.isPublished = _data["isPublished"];
            this.changedDate = _data["changedDate"] ? new Date(_data["changedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DraftDto {
        data = typeof data === 'object' ? data : {};
        let result = new DraftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["data"] = this.data;
        data["attribute"] = this.attribute;
        data["callflowId"] = this.callflowId;
        data["name"] = this.name;
        data["version"] = this.version;
        data["image"] = this.image;
        data["jsonFormat"] = this.jsonFormat;
        data["isPublished"] = this.isPublished;
        data["changedDate"] = this.changedDate ? this.changedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDraftDto {
    id?: number;
    data?: string | undefined;
    attribute?: string | undefined;
    callflowId?: number;
    name?: string | undefined;
    version?: number;
    image?: string | undefined;
    jsonFormat?: string | undefined;
    isPublished?: boolean;
    changedDate?: Date;
}

export class CurrentDraftsListVm implements ICurrentDraftsListVm {
    drafts?: CurrentDraftDto[] | undefined;

    constructor(data?: ICurrentDraftsListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["drafts"])) {
                this.drafts = [] as any;
                for (let item of _data["drafts"])
                    this.drafts!.push(CurrentDraftDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CurrentDraftsListVm {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentDraftsListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.drafts)) {
            data["drafts"] = [];
            for (let item of this.drafts)
                data["drafts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICurrentDraftsListVm {
    drafts?: CurrentDraftDto[] | undefined;
}

export class CurrentDraftDto implements ICurrentDraftDto {
    id?: number;
    name?: string | undefined;
    version?: number;
    image?: string | undefined;
    callflowId?: number;
    tag?: string | undefined;
    note?: string | undefined;
    lastModifiedEmail?: string | undefined;
    lastModifiedAvatar?: string | undefined;
    isPublished?: boolean;
    changedBy?: string | undefined;
    changedDate?: Date;

    constructor(data?: ICurrentDraftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.version = _data["version"];
            this.image = _data["image"];
            this.callflowId = _data["callflowId"];
            this.tag = _data["tag"];
            this.note = _data["note"];
            this.lastModifiedEmail = _data["lastModifiedEmail"];
            this.lastModifiedAvatar = _data["lastModifiedAvatar"];
            this.isPublished = _data["isPublished"];
            this.changedBy = _data["changedBy"];
            this.changedDate = _data["changedDate"] ? new Date(_data["changedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CurrentDraftDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentDraftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["version"] = this.version;
        data["image"] = this.image;
        data["callflowId"] = this.callflowId;
        data["tag"] = this.tag;
        data["note"] = this.note;
        data["lastModifiedEmail"] = this.lastModifiedEmail;
        data["lastModifiedAvatar"] = this.lastModifiedAvatar;
        data["isPublished"] = this.isPublished;
        data["changedBy"] = this.changedBy;
        data["changedDate"] = this.changedDate ? this.changedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICurrentDraftDto {
    id?: number;
    name?: string | undefined;
    version?: number;
    image?: string | undefined;
    callflowId?: number;
    tag?: string | undefined;
    note?: string | undefined;
    lastModifiedEmail?: string | undefined;
    lastModifiedAvatar?: string | undefined;
    isPublished?: boolean;
    changedBy?: string | undefined;
    changedDate?: Date;
}

export class CreateDraftCommand implements ICreateDraftCommand {
    name?: string | undefined;
    callflowId?: number;
    data?: string | undefined;
    attribute?: string | undefined;
    jsonFormat?: string | undefined;
    version?: number;
    image?: string | undefined;

    constructor(data?: ICreateDraftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.callflowId = _data["callflowId"];
            this.data = _data["data"];
            this.attribute = _data["attribute"];
            this.jsonFormat = _data["jsonFormat"];
            this.version = _data["version"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): CreateDraftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDraftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["callflowId"] = this.callflowId;
        data["data"] = this.data;
        data["attribute"] = this.attribute;
        data["jsonFormat"] = this.jsonFormat;
        data["version"] = this.version;
        data["image"] = this.image;
        return data;
    }
}

export interface ICreateDraftCommand {
    name?: string | undefined;
    callflowId?: number;
    data?: string | undefined;
    attribute?: string | undefined;
    jsonFormat?: string | undefined;
    version?: number;
    image?: string | undefined;
}

export class CreateDraftDefaultCommand implements ICreateDraftDefaultCommand {
    name?: string | undefined;
    callflowId?: number;
    data?: string | undefined;
    attribute?: string | undefined;
    jsonFormat?: string | undefined;
    version?: number;
    image?: string | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: ICreateDraftDefaultCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.callflowId = _data["callflowId"];
            this.data = _data["data"];
            this.attribute = _data["attribute"];
            this.jsonFormat = _data["jsonFormat"];
            this.version = _data["version"];
            this.image = _data["image"];
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): CreateDraftDefaultCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDraftDefaultCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["callflowId"] = this.callflowId;
        data["data"] = this.data;
        data["attribute"] = this.attribute;
        data["jsonFormat"] = this.jsonFormat;
        data["version"] = this.version;
        data["image"] = this.image;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface ICreateDraftDefaultCommand {
    name?: string | undefined;
    callflowId?: number;
    data?: string | undefined;
    attribute?: string | undefined;
    jsonFormat?: string | undefined;
    version?: number;
    image?: string | undefined;
    lastModifiedBy?: string | undefined;
}

export class UpdateDraftCommand implements IUpdateDraftCommand {
    id?: number;
    name?: string | undefined;
    callflowId?: number;
    data?: string | undefined;
    attribute?: string | undefined;
    jsonFormat?: string | undefined;
    version?: number;
    image?: string | undefined;

    constructor(data?: IUpdateDraftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.callflowId = _data["callflowId"];
            this.data = _data["data"];
            this.attribute = _data["attribute"];
            this.jsonFormat = _data["jsonFormat"];
            this.version = _data["version"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): UpdateDraftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDraftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["callflowId"] = this.callflowId;
        data["data"] = this.data;
        data["attribute"] = this.attribute;
        data["jsonFormat"] = this.jsonFormat;
        data["version"] = this.version;
        data["image"] = this.image;
        return data;
    }
}

export interface IUpdateDraftCommand {
    id?: number;
    name?: string | undefined;
    callflowId?: number;
    data?: string | undefined;
    attribute?: string | undefined;
    jsonFormat?: string | undefined;
    version?: number;
    image?: string | undefined;
}

export class UpdateReversionCommand implements IUpdateReversionCommand {
    id?: number;
    tag?: string | undefined;
    note?: string | undefined;

    constructor(data?: IUpdateReversionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tag = _data["tag"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateReversionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReversionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tag"] = this.tag;
        data["note"] = this.note;
        return data;
    }
}

export interface IUpdateReversionCommand {
    id?: number;
    tag?: string | undefined;
    note?: string | undefined;
}

export class PublishDraftCommand implements IPublishDraftCommand {
    id?: number;
    callowId?: number;
    isPublished?: boolean;

    constructor(data?: IPublishDraftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.callowId = _data["callowId"];
            this.isPublished = _data["isPublished"];
        }
    }

    static fromJS(data: any): PublishDraftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PublishDraftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["callowId"] = this.callowId;
        data["isPublished"] = this.isPublished;
        return data;
    }
}

export interface IPublishDraftCommand {
    id?: number;
    callowId?: number;
    isPublished?: boolean;
}

export class UpdateAttributeNewestVersion implements IUpdateAttributeNewestVersion {
    callFlowId?: number;
    attribute?: string | undefined;

    constructor(data?: IUpdateAttributeNewestVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callFlowId = _data["callFlowId"];
            this.attribute = _data["attribute"];
        }
    }

    static fromJS(data: any): UpdateAttributeNewestVersion {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAttributeNewestVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callFlowId"] = this.callFlowId;
        data["attribute"] = this.attribute;
        return data;
    }
}

export interface IUpdateAttributeNewestVersion {
    callFlowId?: number;
    attribute?: string | undefined;
}

export class EmailReportListVm implements IEmailReportListVm {
    emailReportDtos?: EmailReportDto[] | undefined;
    page?: Page | undefined;

    constructor(data?: IEmailReportListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["emailReportDtos"])) {
                this.emailReportDtos = [] as any;
                for (let item of _data["emailReportDtos"])
                    this.emailReportDtos!.push(EmailReportDto.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailReportListVm {
        data = typeof data === 'object' ? data : {};
        let result = new EmailReportListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emailReportDtos)) {
            data["emailReportDtos"] = [];
            for (let item of this.emailReportDtos)
                data["emailReportDtos"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmailReportListVm {
    emailReportDtos?: EmailReportDto[] | undefined;
    page?: Page | undefined;
}

export class EmailReportDto implements IEmailReportDto {
    id?: number;
    name?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    day?: string | undefined;
    time?: string | undefined;
    reportDayRange?: string | undefined;
    senderName?: string | undefined;
    emailName?: string | undefined;
    emailSubject?: string | undefined;
    emailRecipients?: string | undefined;
    report?: string | undefined;
    template?: number;
    callFlow?: string | undefined;
    phoneNumber?: string | undefined;
    isDelete?: boolean;
    isDisable?: boolean;
    listFlow?: string | undefined;
    listReport?: string | undefined;
    reportTimeDisplay?: string | undefined;
    lastSend?: Date;

    constructor(data?: IEmailReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.typeName = _data["typeName"];
            this.day = _data["day"];
            this.time = _data["time"];
            this.reportDayRange = _data["reportDayRange"];
            this.senderName = _data["senderName"];
            this.emailName = _data["emailName"];
            this.emailSubject = _data["emailSubject"];
            this.emailRecipients = _data["emailRecipients"];
            this.report = _data["report"];
            this.template = _data["template"];
            this.callFlow = _data["callFlow"];
            this.phoneNumber = _data["phoneNumber"];
            this.isDelete = _data["isDelete"];
            this.isDisable = _data["isDisable"];
            this.listFlow = _data["listFlow"];
            this.listReport = _data["listReport"];
            this.reportTimeDisplay = _data["reportTimeDisplay"];
            this.lastSend = _data["lastSend"] ? new Date(_data["lastSend"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["typeName"] = this.typeName;
        data["day"] = this.day;
        data["time"] = this.time;
        data["reportDayRange"] = this.reportDayRange;
        data["senderName"] = this.senderName;
        data["emailName"] = this.emailName;
        data["emailSubject"] = this.emailSubject;
        data["emailRecipients"] = this.emailRecipients;
        data["report"] = this.report;
        data["template"] = this.template;
        data["callFlow"] = this.callFlow;
        data["phoneNumber"] = this.phoneNumber;
        data["isDelete"] = this.isDelete;
        data["isDisable"] = this.isDisable;
        data["listFlow"] = this.listFlow;
        data["listReport"] = this.listReport;
        data["reportTimeDisplay"] = this.reportTimeDisplay;
        data["lastSend"] = this.lastSend ? this.lastSend.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmailReportDto {
    id?: number;
    name?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    day?: string | undefined;
    time?: string | undefined;
    reportDayRange?: string | undefined;
    senderName?: string | undefined;
    emailName?: string | undefined;
    emailSubject?: string | undefined;
    emailRecipients?: string | undefined;
    report?: string | undefined;
    template?: number;
    callFlow?: string | undefined;
    phoneNumber?: string | undefined;
    isDelete?: boolean;
    isDisable?: boolean;
    listFlow?: string | undefined;
    listReport?: string | undefined;
    reportTimeDisplay?: string | undefined;
    lastSend?: Date;
}

export class GetListEmailReportQuery implements IGetListEmailReportQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetListEmailReportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetListEmailReportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetListEmailReportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["searchText"] = this.searchText;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetListEmailReportQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class UpdateEmailReportCommand implements IUpdateEmailReportCommand {
    emailReportDto?: EmailReportDto | undefined;

    constructor(data?: IUpdateEmailReportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailReportDto = _data["emailReportDto"] ? EmailReportDto.fromJS(_data["emailReportDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateEmailReportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmailReportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailReportDto"] = this.emailReportDto ? this.emailReportDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateEmailReportCommand {
    emailReportDto?: EmailReportDto | undefined;
}

export class MakeTestSendMailCommand implements IMakeTestSendMailCommand {
    emailReportDto?: EmailReportDto | undefined;
    email?: string | undefined;

    constructor(data?: IMakeTestSendMailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailReportDto = _data["emailReportDto"] ? EmailReportDto.fromJS(_data["emailReportDto"]) : <any>undefined;
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): MakeTestSendMailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MakeTestSendMailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailReportDto"] = this.emailReportDto ? this.emailReportDto.toJSON() : <any>undefined;
        data["email"] = this.email;
        return data;
    }
}

export interface IMakeTestSendMailCommand {
    emailReportDto?: EmailReportDto | undefined;
    email?: string | undefined;
}

export class SendMailHandlerCommand implements ISendMailHandlerCommand {
    templateVariable?: string | undefined;
    emailRecipients?: string | undefined;
    templateCustom?: string | undefined;
    emailAddress?: string | undefined;
    emailSubject?: string | undefined;
    template?: string | undefined;
    optionTemplate?: string | undefined;
    emailName?: string | undefined;

    constructor(data?: ISendMailHandlerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateVariable = _data["templateVariable"];
            this.emailRecipients = _data["emailRecipients"];
            this.templateCustom = _data["templateCustom"];
            this.emailAddress = _data["emailAddress"];
            this.emailSubject = _data["emailSubject"];
            this.template = _data["template"];
            this.optionTemplate = _data["optionTemplate"];
            this.emailName = _data["emailName"];
        }
    }

    static fromJS(data: any): SendMailHandlerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendMailHandlerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateVariable"] = this.templateVariable;
        data["emailRecipients"] = this.emailRecipients;
        data["templateCustom"] = this.templateCustom;
        data["emailAddress"] = this.emailAddress;
        data["emailSubject"] = this.emailSubject;
        data["template"] = this.template;
        data["optionTemplate"] = this.optionTemplate;
        data["emailName"] = this.emailName;
        return data;
    }
}

export interface ISendMailHandlerCommand {
    templateVariable?: string | undefined;
    emailRecipients?: string | undefined;
    templateCustom?: string | undefined;
    emailAddress?: string | undefined;
    emailSubject?: string | undefined;
    template?: string | undefined;
    optionTemplate?: string | undefined;
    emailName?: string | undefined;
}

export class DisableEmailReportCommand implements IDisableEmailReportCommand {
    id?: number;

    constructor(data?: IDisableEmailReportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DisableEmailReportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DisableEmailReportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDisableEmailReportCommand {
    id?: number;
}

export class DuplicateEmailReportCommand implements IDuplicateEmailReportCommand {
    id?: number;
    name?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    day?: string | undefined;
    time?: string | undefined;
    reportDayRange?: string | undefined;
    senderName?: string | undefined;
    emailName?: string | undefined;
    emailSubject?: string | undefined;
    emailRecipients?: string | undefined;
    report?: string | undefined;
    template?: number;
    callFlow?: string | undefined;
    phoneNumber?: string | undefined;
    isDelete?: boolean;
    isDisable?: boolean;
    listFlow?: string | undefined;
    listReport?: string | undefined;
    reportTimeDisplay?: string | undefined;
    emailLogs?: EmailLog[] | undefined;
    company?: Company | undefined;
    lastSend?: Date;

    constructor(data?: IDuplicateEmailReportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.typeName = _data["typeName"];
            this.day = _data["day"];
            this.time = _data["time"];
            this.reportDayRange = _data["reportDayRange"];
            this.senderName = _data["senderName"];
            this.emailName = _data["emailName"];
            this.emailSubject = _data["emailSubject"];
            this.emailRecipients = _data["emailRecipients"];
            this.report = _data["report"];
            this.template = _data["template"];
            this.callFlow = _data["callFlow"];
            this.phoneNumber = _data["phoneNumber"];
            this.isDelete = _data["isDelete"];
            this.isDisable = _data["isDisable"];
            this.listFlow = _data["listFlow"];
            this.listReport = _data["listReport"];
            this.reportTimeDisplay = _data["reportTimeDisplay"];
            if (Array.isArray(_data["emailLogs"])) {
                this.emailLogs = [] as any;
                for (let item of _data["emailLogs"])
                    this.emailLogs!.push(EmailLog.fromJS(item));
            }
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.lastSend = _data["lastSend"] ? new Date(_data["lastSend"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DuplicateEmailReportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateEmailReportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["typeName"] = this.typeName;
        data["day"] = this.day;
        data["time"] = this.time;
        data["reportDayRange"] = this.reportDayRange;
        data["senderName"] = this.senderName;
        data["emailName"] = this.emailName;
        data["emailSubject"] = this.emailSubject;
        data["emailRecipients"] = this.emailRecipients;
        data["report"] = this.report;
        data["template"] = this.template;
        data["callFlow"] = this.callFlow;
        data["phoneNumber"] = this.phoneNumber;
        data["isDelete"] = this.isDelete;
        data["isDisable"] = this.isDisable;
        data["listFlow"] = this.listFlow;
        data["listReport"] = this.listReport;
        data["reportTimeDisplay"] = this.reportTimeDisplay;
        if (Array.isArray(this.emailLogs)) {
            data["emailLogs"] = [];
            for (let item of this.emailLogs)
                data["emailLogs"].push(item.toJSON());
        }
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["lastSend"] = this.lastSend ? this.lastSend.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDuplicateEmailReportCommand {
    id?: number;
    name?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    day?: string | undefined;
    time?: string | undefined;
    reportDayRange?: string | undefined;
    senderName?: string | undefined;
    emailName?: string | undefined;
    emailSubject?: string | undefined;
    emailRecipients?: string | undefined;
    report?: string | undefined;
    template?: number;
    callFlow?: string | undefined;
    phoneNumber?: string | undefined;
    isDelete?: boolean;
    isDisable?: boolean;
    listFlow?: string | undefined;
    listReport?: string | undefined;
    reportTimeDisplay?: string | undefined;
    emailLogs?: EmailLog[] | undefined;
    company?: Company | undefined;
    lastSend?: Date;
}

export class EmailLogListVm implements IEmailLogListVm {
    emailLogDtos?: EmailLogDto[] | undefined;
    page?: Page | undefined;
    success?: number;
    failed?: number;

    constructor(data?: IEmailLogListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["emailLogDtos"])) {
                this.emailLogDtos = [] as any;
                for (let item of _data["emailLogDtos"])
                    this.emailLogDtos!.push(EmailLogDto.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.success = _data["success"];
            this.failed = _data["failed"];
        }
    }

    static fromJS(data: any): EmailLogListVm {
        data = typeof data === 'object' ? data : {};
        let result = new EmailLogListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emailLogDtos)) {
            data["emailLogDtos"] = [];
            for (let item of this.emailLogDtos)
                data["emailLogDtos"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["success"] = this.success;
        data["failed"] = this.failed;
        return data;
    }
}

export interface IEmailLogListVm {
    emailLogDtos?: EmailLogDto[] | undefined;
    page?: Page | undefined;
    success?: number;
    failed?: number;
}

export class EmailLogDto implements IEmailLogDto {
    id?: number;
    sendTo?: string | undefined;
    timeSent?: Date;
    message?: string | undefined;
    resolution?: string | undefined;
    reason?: string | undefined;
    status?: string | undefined;

    constructor(data?: IEmailLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sendTo = _data["sendTo"];
            this.timeSent = _data["timeSent"] ? new Date(_data["timeSent"].toString()) : <any>undefined;
            this.message = _data["message"];
            this.resolution = _data["resolution"];
            this.reason = _data["reason"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EmailLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sendTo"] = this.sendTo;
        data["timeSent"] = this.timeSent ? this.timeSent.toISOString() : <any>undefined;
        data["message"] = this.message;
        data["resolution"] = this.resolution;
        data["reason"] = this.reason;
        data["status"] = this.status;
        return data;
    }
}

export interface IEmailLogDto {
    id?: number;
    sendTo?: string | undefined;
    timeSent?: Date;
    message?: string | undefined;
    resolution?: string | undefined;
    reason?: string | undefined;
    status?: string | undefined;
}

export class EmailTemplateListVm implements IEmailTemplateListVm {
    emailTemplateDtos?: EmailTemplateDto[] | undefined;
    page?: Page | undefined;

    constructor(data?: IEmailTemplateListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["emailTemplateDtos"])) {
                this.emailTemplateDtos = [] as any;
                for (let item of _data["emailTemplateDtos"])
                    this.emailTemplateDtos!.push(EmailTemplateDto.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailTemplateListVm {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emailTemplateDtos)) {
            data["emailTemplateDtos"] = [];
            for (let item of this.emailTemplateDtos)
                data["emailTemplateDtos"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmailTemplateListVm {
    emailTemplateDtos?: EmailTemplateDto[] | undefined;
    page?: Page | undefined;
}

export class EmailTemplateDto implements IEmailTemplateDto {
    id?: number;
    name?: string | undefined;
    content?: string | undefined;
    design?: string | undefined;

    constructor(data?: IEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.design = _data["design"];
        }
    }

    static fromJS(data: any): EmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["content"] = this.content;
        data["design"] = this.design;
        return data;
    }
}

export interface IEmailTemplateDto {
    id?: number;
    name?: string | undefined;
    content?: string | undefined;
    design?: string | undefined;
}

export class GetAllEmailTemplateQuery implements IGetAllEmailTemplateQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetAllEmailTemplateQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllEmailTemplateQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllEmailTemplateQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["searchText"] = this.searchText;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllEmailTemplateQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class UpdateEmailTemplateCommand implements IUpdateEmailTemplateCommand {
    id?: number;
    name?: string | undefined;
    content?: string | undefined;
    design?: string | undefined;

    constructor(data?: IUpdateEmailTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.design = _data["design"];
        }
    }

    static fromJS(data: any): UpdateEmailTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmailTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["content"] = this.content;
        data["design"] = this.design;
        return data;
    }
}

export interface IUpdateEmailTemplateCommand {
    id?: number;
    name?: string | undefined;
    content?: string | undefined;
    design?: string | undefined;
}

export class DuplicateEmailTemplateCommand implements IDuplicateEmailTemplateCommand {
    name?: string | undefined;
    company?: Company | undefined;
    content?: string | undefined;
    design?: string | undefined;
    isDelete?: boolean;

    constructor(data?: IDuplicateEmailTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.content = _data["content"];
            this.design = _data["design"];
            this.isDelete = _data["isDelete"];
        }
    }

    static fromJS(data: any): DuplicateEmailTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateEmailTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["content"] = this.content;
        data["design"] = this.design;
        data["isDelete"] = this.isDelete;
        return data;
    }
}

export interface IDuplicateEmailTemplateCommand {
    name?: string | undefined;
    company?: Company | undefined;
    content?: string | undefined;
    design?: string | undefined;
    isDelete?: boolean;
}

export class ExportEmailTemplateCommand implements IExportEmailTemplateCommand {
    content?: string | undefined;

    constructor(data?: IExportEmailTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): ExportEmailTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportEmailTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        return data;
    }
}

export interface IExportEmailTemplateCommand {
    content?: string | undefined;
}

export class ExtensionListVm implements IExtensionListVm {
    extensions?: ExtensionDto[] | undefined;
    page?: Page | undefined;

    constructor(data?: IExtensionListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["extensions"])) {
                this.extensions = [] as any;
                for (let item of _data["extensions"])
                    this.extensions!.push(ExtensionDto.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtensionListVm {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.extensions)) {
            data["extensions"] = [];
            for (let item of this.extensions)
                data["extensions"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExtensionListVm {
    extensions?: ExtensionDto[] | undefined;
    page?: Page | undefined;
}

export class ExtensionDto implements IExtensionDto {
    id?: number;
    extension?: string | undefined;
    type?: string | undefined;
    disable?: boolean;

    constructor(data?: IExtensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.extension = _data["extension"];
            this.type = _data["type"];
            this.disable = _data["disable"];
        }
    }

    static fromJS(data: any): ExtensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["extension"] = this.extension;
        data["type"] = this.type;
        data["disable"] = this.disable;
        return data;
    }
}

export interface IExtensionDto {
    id?: number;
    extension?: string | undefined;
    type?: string | undefined;
    disable?: boolean;
}

export class GetExtensionListQuery implements IGetExtensionListQuery {
    companyId?: number;
    page?: Page | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetExtensionListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetExtensionListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetExtensionListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetExtensionListQuery {
    companyId?: number;
    page?: Page | undefined;
    filterData?: FilterData[] | undefined;
}

export class AllExtensionList implements IAllExtensionList {
    extensions?: AllExtensionDto[] | undefined;

    constructor(data?: IAllExtensionList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["extensions"])) {
                this.extensions = [] as any;
                for (let item of _data["extensions"])
                    this.extensions!.push(AllExtensionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllExtensionList {
        data = typeof data === 'object' ? data : {};
        let result = new AllExtensionList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.extensions)) {
            data["extensions"] = [];
            for (let item of this.extensions)
                data["extensions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAllExtensionList {
    extensions?: AllExtensionDto[] | undefined;
}

export class AllExtensionDto implements IAllExtensionDto {
    id?: number;
    extension?: string | undefined;
    type?: string | undefined;

    constructor(data?: IAllExtensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.extension = _data["extension"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AllExtensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllExtensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["extension"] = this.extension;
        data["type"] = this.type;
        return data;
    }
}

export interface IAllExtensionDto {
    id?: number;
    extension?: string | undefined;
    type?: string | undefined;
}

export class CreateExtensionCommand implements ICreateExtensionCommand {
    extension?: string | undefined;
    password?: string | undefined;
    type?: string | undefined;
    companyId?: number;

    constructor(data?: ICreateExtensionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extension = _data["extension"];
            this.password = _data["password"];
            this.type = _data["type"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): CreateExtensionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExtensionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extension"] = this.extension;
        data["password"] = this.password;
        data["type"] = this.type;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface ICreateExtensionCommand {
    extension?: string | undefined;
    password?: string | undefined;
    type?: string | undefined;
    companyId?: number;
}

export class UpdateExtensionCommand implements IUpdateExtensionCommand {
    extensionId?: number;
    extension?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    type?: string | undefined;
    companyId?: number;

    constructor(data?: IUpdateExtensionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extensionId = _data["extensionId"];
            this.extension = _data["extension"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.type = _data["type"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): UpdateExtensionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExtensionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extensionId"] = this.extensionId;
        data["extension"] = this.extension;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["type"] = this.type;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IUpdateExtensionCommand {
    extensionId?: number;
    extension?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    type?: string | undefined;
    companyId?: number;
}

export class DeleteExtensionCommand implements IDeleteExtensionCommand {
    companyId?: number;
    extensionId?: number;

    constructor(data?: IDeleteExtensionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.extensionId = _data["extensionId"];
        }
    }

    static fromJS(data: any): DeleteExtensionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteExtensionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["extensionId"] = this.extensionId;
        return data;
    }
}

export interface IDeleteExtensionCommand {
    companyId?: number;
    extensionId?: number;
}

export class DisableExtensionCommand implements IDisableExtensionCommand {
    companyId?: number;
    extensionId?: number;

    constructor(data?: IDisableExtensionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.extensionId = _data["extensionId"];
        }
    }

    static fromJS(data: any): DisableExtensionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DisableExtensionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["extensionId"] = this.extensionId;
        return data;
    }
}

export interface IDisableExtensionCommand {
    companyId?: number;
    extensionId?: number;
}

export class GrammarDtoList implements IGrammarDtoList {
    grammarDtos?: GrammarDto[] | undefined;

    constructor(data?: IGrammarDtoList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["grammarDtos"])) {
                this.grammarDtos = [] as any;
                for (let item of _data["grammarDtos"])
                    this.grammarDtos!.push(GrammarDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GrammarDtoList {
        data = typeof data === 'object' ? data : {};
        let result = new GrammarDtoList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.grammarDtos)) {
            data["grammarDtos"] = [];
            for (let item of this.grammarDtos)
                data["grammarDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGrammarDtoList {
    grammarDtos?: GrammarDto[] | undefined;
}

export class GrammarDto implements IGrammarDto {
    id?: number;
    name?: string | undefined;
    pattern?: string | undefined;
    type?: string | undefined;
    entity?: string | undefined;
    companyId?: number;
    engine?: boolean;
    engineType?: string | undefined;
    autoTranslate?: boolean;
    extenData?: string | undefined;
    status?: string | undefined;

    constructor(data?: IGrammarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pattern = _data["pattern"];
            this.type = _data["type"];
            this.entity = _data["entity"];
            this.companyId = _data["companyId"];
            this.engine = _data["engine"];
            this.engineType = _data["engineType"];
            this.autoTranslate = _data["autoTranslate"];
            this.extenData = _data["extenData"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GrammarDto {
        data = typeof data === 'object' ? data : {};
        let result = new GrammarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pattern"] = this.pattern;
        data["type"] = this.type;
        data["entity"] = this.entity;
        data["companyId"] = this.companyId;
        data["engine"] = this.engine;
        data["engineType"] = this.engineType;
        data["autoTranslate"] = this.autoTranslate;
        data["extenData"] = this.extenData;
        data["status"] = this.status;
        return data;
    }
}

export interface IGrammarDto {
    id?: number;
    name?: string | undefined;
    pattern?: string | undefined;
    type?: string | undefined;
    entity?: string | undefined;
    companyId?: number;
    engine?: boolean;
    engineType?: string | undefined;
    autoTranslate?: boolean;
    extenData?: string | undefined;
    status?: string | undefined;
}

export class GrammarFunctionDto implements IGrammarFunctionDto {
    id?: number;
    name?: string | undefined;
    type?: string | undefined;

    constructor(data?: IGrammarFunctionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GrammarFunctionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GrammarFunctionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IGrammarFunctionDto {
    id?: number;
    name?: string | undefined;
    type?: string | undefined;
}

export class IntentsDto implements IIntentsDto {
    intents?: string[] | undefined;

    constructor(data?: IIntentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["intents"])) {
                this.intents = [] as any;
                for (let item of _data["intents"])
                    this.intents!.push(item);
            }
        }
    }

    static fromJS(data: any): IntentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.intents)) {
            data["intents"] = [];
            for (let item of this.intents)
                data["intents"].push(item);
        }
        return data;
    }
}

export interface IIntentsDto {
    intents?: string[] | undefined;
}

export class GetAllIntentValueQuery implements IGetAllIntentValueQuery {
    grammarIdList?: number[] | undefined;

    constructor(data?: IGetAllIntentValueQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["grammarIdList"])) {
                this.grammarIdList = [] as any;
                for (let item of _data["grammarIdList"])
                    this.grammarIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAllIntentValueQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllIntentValueQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.grammarIdList)) {
            data["grammarIdList"] = [];
            for (let item of this.grammarIdList)
                data["grammarIdList"].push(item);
        }
        return data;
    }
}

export interface IGetAllIntentValueQuery {
    grammarIdList?: number[] | undefined;
}

export class CreateGrammarCommand implements ICreateGrammarCommand {
    id?: number | undefined;
    name?: string | undefined;
    pattern?: string | undefined;
    patternTrain?: string | undefined;
    type?: string | undefined;
    entity?: string | undefined;
    engine?: boolean;
    autoTranslate?: boolean;
    engineType?: string | undefined;

    constructor(data?: ICreateGrammarCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pattern = _data["pattern"];
            this.patternTrain = _data["patternTrain"];
            this.type = _data["type"];
            this.entity = _data["entity"];
            this.engine = _data["engine"];
            this.autoTranslate = _data["autoTranslate"];
            this.engineType = _data["engineType"];
        }
    }

    static fromJS(data: any): CreateGrammarCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGrammarCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pattern"] = this.pattern;
        data["patternTrain"] = this.patternTrain;
        data["type"] = this.type;
        data["entity"] = this.entity;
        data["engine"] = this.engine;
        data["autoTranslate"] = this.autoTranslate;
        data["engineType"] = this.engineType;
        return data;
    }
}

export interface ICreateGrammarCommand {
    id?: number | undefined;
    name?: string | undefined;
    pattern?: string | undefined;
    patternTrain?: string | undefined;
    type?: string | undefined;
    entity?: string | undefined;
    engine?: boolean;
    autoTranslate?: boolean;
    engineType?: string | undefined;
}

export class CheckGrammarQuery implements ICheckGrammarQuery {
    pattern?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;

    constructor(data?: ICheckGrammarQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pattern = _data["pattern"];
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CheckGrammarQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CheckGrammarQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pattern"] = this.pattern;
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface ICheckGrammarQuery {
    pattern?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
}

export class UpdateStatusGrammarCommand implements IUpdateStatusGrammarCommand {
    id?: number | undefined;
    ref_Id?: string | undefined;
    success?: boolean;

    constructor(data?: IUpdateStatusGrammarCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ref_Id = _data["ref_Id"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): UpdateStatusGrammarCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatusGrammarCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ref_Id"] = this.ref_Id;
        data["success"] = this.success;
        return data;
    }
}

export interface IUpdateStatusGrammarCommand {
    id?: number | undefined;
    ref_Id?: string | undefined;
    success?: boolean;
}

export class CheckGrammarNameCommand implements ICheckGrammarNameCommand {
    grammarName?: string | undefined;
    grammarType?: string | undefined;

    constructor(data?: ICheckGrammarNameCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grammarName = _data["grammarName"];
            this.grammarType = _data["grammarType"];
        }
    }

    static fromJS(data: any): CheckGrammarNameCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CheckGrammarNameCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grammarName"] = this.grammarName;
        data["grammarType"] = this.grammarType;
        return data;
    }
}

export interface ICheckGrammarNameCommand {
    grammarName?: string | undefined;
    grammarType?: string | undefined;
}

export class MediaDtoList implements IMediaDtoList {
    mediaDtos?: MediaDto[] | undefined;

    constructor(data?: IMediaDtoList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mediaDtos"])) {
                this.mediaDtos = [] as any;
                for (let item of _data["mediaDtos"])
                    this.mediaDtos!.push(MediaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MediaDtoList {
        data = typeof data === 'object' ? data : {};
        let result = new MediaDtoList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mediaDtos)) {
            data["mediaDtos"] = [];
            for (let item of this.mediaDtos)
                data["mediaDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMediaDtoList {
    mediaDtos?: MediaDto[] | undefined;
}

export class MediaDto implements IMediaDto {
    id?: number;
    name?: string | undefined;
    size?: number;
    length?: string | undefined;
    path?: string | undefined;
    type?: string | undefined;
    imageWidth?: number;
    imageHeight?: number;
    created?: Date;
    company?: Company | undefined;

    constructor(data?: IMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.size = _data["size"];
            this.length = _data["length"];
            this.path = _data["path"];
            this.type = _data["type"];
            this.imageWidth = _data["imageWidth"];
            this.imageHeight = _data["imageHeight"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["size"] = this.size;
        data["length"] = this.length;
        data["path"] = this.path;
        data["type"] = this.type;
        data["imageWidth"] = this.imageWidth;
        data["imageHeight"] = this.imageHeight;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMediaDto {
    id?: number;
    name?: string | undefined;
    size?: number;
    length?: string | undefined;
    path?: string | undefined;
    type?: string | undefined;
    imageWidth?: number;
    imageHeight?: number;
    created?: Date;
    company?: Company | undefined;
}

export class MusicOnHoldDtoList implements IMusicOnHoldDtoList {
    musicOnHoldDtos?: MusicOnHoldDto[] | undefined;

    constructor(data?: IMusicOnHoldDtoList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["musicOnHoldDtos"])) {
                this.musicOnHoldDtos = [] as any;
                for (let item of _data["musicOnHoldDtos"])
                    this.musicOnHoldDtos!.push(MusicOnHoldDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MusicOnHoldDtoList {
        data = typeof data === 'object' ? data : {};
        let result = new MusicOnHoldDtoList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.musicOnHoldDtos)) {
            data["musicOnHoldDtos"] = [];
            for (let item of this.musicOnHoldDtos)
                data["musicOnHoldDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMusicOnHoldDtoList {
    musicOnHoldDtos?: MusicOnHoldDto[] | undefined;
}

export class MusicOnHoldDto implements IMusicOnHoldDto {
    id?: number;
    name?: string | undefined;
    path?: string | undefined;
    pathAsterisk?: string | undefined;
    fileName?: string | undefined;
    company?: Company | undefined;
    content?: string | undefined;
    isUpload?: boolean;
    service?: ServiceTTS;
    language?: string | undefined;
    languageName?: string | undefined;
    voiceId?: string | undefined;
    gender?: string | undefined;

    constructor(data?: IMusicOnHoldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.path = _data["path"];
            this.pathAsterisk = _data["pathAsterisk"];
            this.fileName = _data["fileName"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.content = _data["content"];
            this.isUpload = _data["isUpload"];
            this.service = _data["service"];
            this.language = _data["language"];
            this.languageName = _data["languageName"];
            this.voiceId = _data["voiceId"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): MusicOnHoldDto {
        data = typeof data === 'object' ? data : {};
        let result = new MusicOnHoldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["path"] = this.path;
        data["pathAsterisk"] = this.pathAsterisk;
        data["fileName"] = this.fileName;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["content"] = this.content;
        data["isUpload"] = this.isUpload;
        data["service"] = this.service;
        data["language"] = this.language;
        data["languageName"] = this.languageName;
        data["voiceId"] = this.voiceId;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IMusicOnHoldDto {
    id?: number;
    name?: string | undefined;
    path?: string | undefined;
    pathAsterisk?: string | undefined;
    fileName?: string | undefined;
    company?: Company | undefined;
    content?: string | undefined;
    isUpload?: boolean;
    service?: ServiceTTS;
    language?: string | undefined;
    languageName?: string | undefined;
    voiceId?: string | undefined;
    gender?: string | undefined;
}

export class UploadMusicOnHoldCommand implements IUploadMusicOnHoldCommand {
    id?: number;
    name?: string | undefined;
    path?: string | undefined;
    pathAsterisk?: string | undefined;
    companyId?: number;
    musicFile?: string | undefined;
    fileName?: string | undefined;
    content?: string | undefined;
    isUpload?: boolean;
    service?: ServiceTTS;
    language?: string | undefined;
    languageName?: string | undefined;
    voiceId?: string | undefined;
    gender?: string | undefined;

    constructor(data?: IUploadMusicOnHoldCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.path = _data["path"];
            this.pathAsterisk = _data["pathAsterisk"];
            this.companyId = _data["companyId"];
            this.musicFile = _data["musicFile"];
            this.fileName = _data["fileName"];
            this.content = _data["content"];
            this.isUpload = _data["isUpload"];
            this.service = _data["service"];
            this.language = _data["language"];
            this.languageName = _data["languageName"];
            this.voiceId = _data["voiceId"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): UploadMusicOnHoldCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UploadMusicOnHoldCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["path"] = this.path;
        data["pathAsterisk"] = this.pathAsterisk;
        data["companyId"] = this.companyId;
        data["musicFile"] = this.musicFile;
        data["fileName"] = this.fileName;
        data["content"] = this.content;
        data["isUpload"] = this.isUpload;
        data["service"] = this.service;
        data["language"] = this.language;
        data["languageName"] = this.languageName;
        data["voiceId"] = this.voiceId;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IUploadMusicOnHoldCommand {
    id?: number;
    name?: string | undefined;
    path?: string | undefined;
    pathAsterisk?: string | undefined;
    companyId?: number;
    musicFile?: string | undefined;
    fileName?: string | undefined;
    content?: string | undefined;
    isUpload?: boolean;
    service?: ServiceTTS;
    language?: string | undefined;
    languageName?: string | undefined;
    voiceId?: string | undefined;
    gender?: string | undefined;
}

export class UpdateMusicOnHoldCommand implements IUpdateMusicOnHoldCommand {
    id?: number;
    name?: string | undefined;
    musicFile?: string | undefined;
    pathServer?: string | undefined;
    pathAsterisk?: string | undefined;
    companyId?: number;
    fileName?: string | undefined;
    content?: string | undefined;
    isUpload?: boolean;
    service?: ServiceTTS;
    language?: string | undefined;
    languageName?: string | undefined;
    voiceId?: string | undefined;
    gender?: string | undefined;

    constructor(data?: IUpdateMusicOnHoldCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.musicFile = _data["musicFile"];
            this.pathServer = _data["pathServer"];
            this.pathAsterisk = _data["pathAsterisk"];
            this.companyId = _data["companyId"];
            this.fileName = _data["fileName"];
            this.content = _data["content"];
            this.isUpload = _data["isUpload"];
            this.service = _data["service"];
            this.language = _data["language"];
            this.languageName = _data["languageName"];
            this.voiceId = _data["voiceId"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): UpdateMusicOnHoldCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMusicOnHoldCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["musicFile"] = this.musicFile;
        data["pathServer"] = this.pathServer;
        data["pathAsterisk"] = this.pathAsterisk;
        data["companyId"] = this.companyId;
        data["fileName"] = this.fileName;
        data["content"] = this.content;
        data["isUpload"] = this.isUpload;
        data["service"] = this.service;
        data["language"] = this.language;
        data["languageName"] = this.languageName;
        data["voiceId"] = this.voiceId;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IUpdateMusicOnHoldCommand {
    id?: number;
    name?: string | undefined;
    musicFile?: string | undefined;
    pathServer?: string | undefined;
    pathAsterisk?: string | undefined;
    companyId?: number;
    fileName?: string | undefined;
    content?: string | undefined;
    isUpload?: boolean;
    service?: ServiceTTS;
    language?: string | undefined;
    languageName?: string | undefined;
    voiceId?: string | undefined;
    gender?: string | undefined;
}

export class CheckMusicOnHoldCommand implements ICheckMusicOnHoldCommand {
    mohName?: string | undefined;

    constructor(data?: ICheckMusicOnHoldCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mohName = _data["mohName"];
        }
    }

    static fromJS(data: any): CheckMusicOnHoldCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CheckMusicOnHoldCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mohName"] = this.mohName;
        return data;
    }
}

export interface ICheckMusicOnHoldCommand {
    mohName?: string | undefined;
}

export class NumberDetailVm implements INumberDetailVm {
    id?: number;
    providerId?: number;
    trunkId?: number;
    number?: string | undefined;
    price?: number;
    companyId?: number;

    constructor(data?: INumberDetailVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.providerId = _data["providerId"];
            this.trunkId = _data["trunkId"];
            this.number = _data["number"];
            this.price = _data["price"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): NumberDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new NumberDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["providerId"] = this.providerId;
        data["trunkId"] = this.trunkId;
        data["number"] = this.number;
        data["price"] = this.price;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface INumberDetailVm {
    id?: number;
    providerId?: number;
    trunkId?: number;
    number?: string | undefined;
    price?: number;
    companyId?: number;
}

export class PhoneNumbersListVm implements IPhoneNumbersListVm {
    phoneNumbers?: NumberVm[] | undefined;
    phoneProviders?: PhoneNumberProviderDto[] | undefined;
    trunks?: TrunkFilter[] | undefined;
    page?: Page | undefined;

    constructor(data?: IPhoneNumbersListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(NumberVm.fromJS(item));
            }
            if (Array.isArray(_data["phoneProviders"])) {
                this.phoneProviders = [] as any;
                for (let item of _data["phoneProviders"])
                    this.phoneProviders!.push(PhoneNumberProviderDto.fromJS(item));
            }
            if (Array.isArray(_data["trunks"])) {
                this.trunks = [] as any;
                for (let item of _data["trunks"])
                    this.trunks!.push(TrunkFilter.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PhoneNumbersListVm {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneNumbersListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.phoneProviders)) {
            data["phoneProviders"] = [];
            for (let item of this.phoneProviders)
                data["phoneProviders"].push(item.toJSON());
        }
        if (Array.isArray(this.trunks)) {
            data["trunks"] = [];
            for (let item of this.trunks)
                data["trunks"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPhoneNumbersListVm {
    phoneNumbers?: NumberVm[] | undefined;
    phoneProviders?: PhoneNumberProviderDto[] | undefined;
    trunks?: TrunkFilter[] | undefined;
    page?: Page | undefined;
}

export class NumberVm implements INumberVm {
    id?: number;
    number?: string | undefined;
    providerName?: string | undefined;
    providerId?: number;
    trunkName?: string | undefined;
    trunkId?: number;
    callFlowId?: number;
    companyId?: number;
    company?: string | undefined;
    active?: boolean;
    price?: number;
    disable?: boolean;

    constructor(data?: INumberVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.providerName = _data["providerName"];
            this.providerId = _data["providerId"];
            this.trunkName = _data["trunkName"];
            this.trunkId = _data["trunkId"];
            this.callFlowId = _data["callFlowId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"];
            this.active = _data["active"];
            this.price = _data["price"];
            this.disable = _data["disable"];
        }
    }

    static fromJS(data: any): NumberVm {
        data = typeof data === 'object' ? data : {};
        let result = new NumberVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["providerName"] = this.providerName;
        data["providerId"] = this.providerId;
        data["trunkName"] = this.trunkName;
        data["trunkId"] = this.trunkId;
        data["callFlowId"] = this.callFlowId;
        data["companyId"] = this.companyId;
        data["company"] = this.company;
        data["active"] = this.active;
        data["price"] = this.price;
        data["disable"] = this.disable;
        return data;
    }
}

export interface INumberVm {
    id?: number;
    number?: string | undefined;
    providerName?: string | undefined;
    providerId?: number;
    trunkName?: string | undefined;
    trunkId?: number;
    callFlowId?: number;
    companyId?: number;
    company?: string | undefined;
    active?: boolean;
    price?: number;
    disable?: boolean;
}

export class GetAllNumberQuery implements IGetAllNumberQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    providerId?: string | undefined;
    trunkId?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetAllNumberQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.searchText = _data["searchText"];
            this.providerId = _data["providerId"];
            this.trunkId = _data["trunkId"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllNumberQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllNumberQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["searchText"] = this.searchText;
        data["providerId"] = this.providerId;
        data["trunkId"] = this.trunkId;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllNumberQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    providerId?: string | undefined;
    trunkId?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class GetAllNumbersListQuery implements IGetAllNumbersListQuery {
    companyId?: number;
    page?: Page | undefined;
    searchText?: string | undefined;
    providerId?: string | undefined;
    trunkId?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetAllNumbersListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.searchText = _data["searchText"];
            this.providerId = _data["providerId"];
            this.trunkId = _data["trunkId"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllNumbersListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllNumbersListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["searchText"] = this.searchText;
        data["providerId"] = this.providerId;
        data["trunkId"] = this.trunkId;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllNumbersListQuery {
    companyId?: number;
    page?: Page | undefined;
    searchText?: string | undefined;
    providerId?: string | undefined;
    trunkId?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class DisableNumberCommand implements IDisableNumberCommand {
    id?: number;
    disable?: boolean;

    constructor(data?: IDisableNumberCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.disable = _data["disable"];
        }
    }

    static fromJS(data: any): DisableNumberCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DisableNumberCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["disable"] = this.disable;
        return data;
    }
}

export interface IDisableNumberCommand {
    id?: number;
    disable?: boolean;
}

export class DeleteNumberCommand implements IDeleteNumberCommand {
    id?: number;

    constructor(data?: IDeleteNumberCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteNumberCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteNumberCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteNumberCommand {
    id?: number;
}

export class DisAllowNumberCommand implements IDisAllowNumberCommand {
    id?: number;
    disable?: boolean;

    constructor(data?: IDisAllowNumberCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.disable = _data["disable"];
        }
    }

    static fromJS(data: any): DisAllowNumberCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DisAllowNumberCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["disable"] = this.disable;
        return data;
    }
}

export interface IDisAllowNumberCommand {
    id?: number;
    disable?: boolean;
}

export class AssignCallFlowCommand implements IAssignCallFlowCommand {
    phoneNumbers?: string | undefined;
    callFlowId?: number;

    constructor(data?: IAssignCallFlowCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumbers = _data["phoneNumbers"];
            this.callFlowId = _data["callFlowId"];
        }
    }

    static fromJS(data: any): AssignCallFlowCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignCallFlowCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumbers"] = this.phoneNumbers;
        data["callFlowId"] = this.callFlowId;
        return data;
    }
}

export interface IAssignCallFlowCommand {
    phoneNumbers?: string | undefined;
    callFlowId?: number;
}

export class CancelNumberCommand implements ICancelNumberCommand {
    id?: number;

    constructor(data?: ICancelNumberCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CancelNumberCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CancelNumberCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICancelNumberCommand {
    id?: number;
}

export class UpdateNumberCommand implements IUpdateNumberCommand {
    id?: number;
    number?: string | undefined;
    price?: number;
    trunkId?: number;
    providerId?: number;
    companyId?: number;

    constructor(data?: IUpdateNumberCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.price = _data["price"];
            this.trunkId = _data["trunkId"];
            this.providerId = _data["providerId"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): UpdateNumberCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNumberCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["price"] = this.price;
        data["trunkId"] = this.trunkId;
        data["providerId"] = this.providerId;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IUpdateNumberCommand {
    id?: number;
    number?: string | undefined;
    price?: number;
    trunkId?: number;
    providerId?: number;
    companyId?: number;
}

export class ImportOtherPhoneNumber implements IImportOtherPhoneNumber {
    trunkId?: number;
    phoneNumberId?: number;
    providerId?: number;
    providerName?: string | undefined;
    name?: string | undefined;
    context?: string | undefined;
    config?: string | undefined;
    registerString?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IImportOtherPhoneNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trunkId = _data["trunkId"];
            this.phoneNumberId = _data["phoneNumberId"];
            this.providerId = _data["providerId"];
            this.providerName = _data["providerName"];
            this.name = _data["name"];
            this.context = _data["context"];
            this.config = _data["config"];
            this.registerString = _data["registerString"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): ImportOtherPhoneNumber {
        data = typeof data === 'object' ? data : {};
        let result = new ImportOtherPhoneNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trunkId"] = this.trunkId;
        data["phoneNumberId"] = this.phoneNumberId;
        data["providerId"] = this.providerId;
        data["providerName"] = this.providerName;
        data["name"] = this.name;
        data["context"] = this.context;
        data["config"] = this.config;
        data["registerString"] = this.registerString;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IImportOtherPhoneNumber {
    trunkId?: number;
    phoneNumberId?: number;
    providerId?: number;
    providerName?: string | undefined;
    name?: string | undefined;
    context?: string | undefined;
    config?: string | undefined;
    registerString?: string | undefined;
    phoneNumber?: string | undefined;
}

export class UpdateNumberSettingCommand implements IUpdateNumberSettingCommand {
    id?: number;
    patterns?: string[] | undefined;

    constructor(data?: IUpdateNumberSettingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["patterns"])) {
                this.patterns = [] as any;
                for (let item of _data["patterns"])
                    this.patterns!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateNumberSettingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNumberSettingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.patterns)) {
            data["patterns"] = [];
            for (let item of this.patterns)
                data["patterns"].push(item);
        }
        return data;
    }
}

export interface IUpdateNumberSettingCommand {
    id?: number;
    patterns?: string[] | undefined;
}

export class PhoneNumberUploadResult implements IPhoneNumberUploadResult {
    uploadSuccess?: number;
    uploadFailure?: number;
    phoneNumberList?: PhoneNumberUploadModel[] | undefined;

    constructor(data?: IPhoneNumberUploadResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadSuccess = _data["uploadSuccess"];
            this.uploadFailure = _data["uploadFailure"];
            if (Array.isArray(_data["phoneNumberList"])) {
                this.phoneNumberList = [] as any;
                for (let item of _data["phoneNumberList"])
                    this.phoneNumberList!.push(PhoneNumberUploadModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PhoneNumberUploadResult {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneNumberUploadResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadSuccess"] = this.uploadSuccess;
        data["uploadFailure"] = this.uploadFailure;
        if (Array.isArray(this.phoneNumberList)) {
            data["phoneNumberList"] = [];
            for (let item of this.phoneNumberList)
                data["phoneNumberList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPhoneNumberUploadResult {
    uploadSuccess?: number;
    uploadFailure?: number;
    phoneNumberList?: PhoneNumberUploadModel[] | undefined;
}

export class PhoneNumberUploadModel implements IPhoneNumberUploadModel {
    phoneNumber?: string | undefined;
    trunk?: string | undefined;
    company?: string | undefined;

    constructor(data?: IPhoneNumberUploadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.trunk = _data["trunk"];
            this.company = _data["company"];
        }
    }

    static fromJS(data: any): PhoneNumberUploadModel {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneNumberUploadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["trunk"] = this.trunk;
        data["company"] = this.company;
        return data;
    }
}

export interface IPhoneNumberUploadModel {
    phoneNumber?: string | undefined;
    trunk?: string | undefined;
    company?: string | undefined;
}

export class UploadPhoneNumberCommand implements IUploadPhoneNumberCommand {
    phoneNumberList?: PhoneNumberUploadModel[] | undefined;

    constructor(data?: IUploadPhoneNumberCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phoneNumberList"])) {
                this.phoneNumberList = [] as any;
                for (let item of _data["phoneNumberList"])
                    this.phoneNumberList!.push(PhoneNumberUploadModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UploadPhoneNumberCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UploadPhoneNumberCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phoneNumberList)) {
            data["phoneNumberList"] = [];
            for (let item of this.phoneNumberList)
                data["phoneNumberList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUploadPhoneNumberCommand {
    phoneNumberList?: PhoneNumberUploadModel[] | undefined;
}

export class ExportFileErrorPhoneNumber implements IExportFileErrorPhoneNumber {
    phoneNumberList?: PhoneNumberUploadModel[] | undefined;

    constructor(data?: IExportFileErrorPhoneNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phoneNumberList"])) {
                this.phoneNumberList = [] as any;
                for (let item of _data["phoneNumberList"])
                    this.phoneNumberList!.push(PhoneNumberUploadModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportFileErrorPhoneNumber {
        data = typeof data === 'object' ? data : {};
        let result = new ExportFileErrorPhoneNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phoneNumberList)) {
            data["phoneNumberList"] = [];
            for (let item of this.phoneNumberList)
                data["phoneNumberList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExportFileErrorPhoneNumber {
    phoneNumberList?: PhoneNumberUploadModel[] | undefined;
}

export class CheckNumberResult implements ICheckNumberResult {
    isExist?: boolean;
    isInvalid?: boolean;

    constructor(data?: ICheckNumberResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isExist = _data["isExist"];
            this.isInvalid = _data["isInvalid"];
        }
    }

    static fromJS(data: any): CheckNumberResult {
        data = typeof data === 'object' ? data : {};
        let result = new CheckNumberResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isExist"] = this.isExist;
        data["isInvalid"] = this.isInvalid;
        return data;
    }
}

export interface ICheckNumberResult {
    isExist?: boolean;
    isInvalid?: boolean;
}

export class CheckNumber implements ICheckNumber {
    phone?: string | undefined;

    constructor(data?: ICheckNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): CheckNumber {
        data = typeof data === 'object' ? data : {};
        let result = new CheckNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        return data;
    }
}

export interface ICheckNumber {
    phone?: string | undefined;
}

export class PermissionListVm implements IPermissionListVm {
    permissonDtos?: PermissionDto[] | undefined;

    constructor(data?: IPermissionListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissonDtos"])) {
                this.permissonDtos = [] as any;
                for (let item of _data["permissonDtos"])
                    this.permissonDtos!.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionListVm {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissonDtos)) {
            data["permissonDtos"] = [];
            for (let item of this.permissonDtos)
                data["permissonDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPermissionListVm {
    permissonDtos?: PermissionDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
    id?: number;
    displayName?: string | undefined;
    permission?: string | undefined;
    screen?: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.permission = _data["permission"];
            this.screen = _data["screen"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["permission"] = this.permission;
        data["screen"] = this.screen;
        return data;
    }
}

export interface IPermissionDto {
    id?: number;
    displayName?: string | undefined;
    permission?: string | undefined;
    screen?: string | undefined;
}

export class CreateQueueCommand implements ICreateQueueCommand {
    name?: string | undefined;
    strategy?: string | undefined;
    queueId?: string | undefined;
    companyId?: number;
    timeOut?: number;
    retry?: number;
    wrapUp?: number;
    priorityQueue?: string | undefined;
    announcePosition?: boolean;
    announceFrequency?: number;
    musicOnHold?: string | undefined;
    musicOnHoldAsterisk?: string | undefined;
    musicOnHoldData?: string | undefined;
    description?: string | undefined;
    joinEmpty?: boolean;
    leaveWhenEmpty?: boolean;
    ringInUse?: boolean;
    recording?: boolean;
    musicOnHoldId?: number;
    maxContacts?: string | undefined;
    agents?: AddAgentModel[] | undefined;
    periodicAnnounceId?: number;
    periodicAnnounce?: string | undefined;
    periodicAnnounceFrequency?: number;

    constructor(data?: ICreateQueueCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.strategy = _data["strategy"];
            this.queueId = _data["queueId"];
            this.companyId = _data["companyId"];
            this.timeOut = _data["timeOut"];
            this.retry = _data["retry"];
            this.wrapUp = _data["wrapUp"];
            this.priorityQueue = _data["priorityQueue"];
            this.announcePosition = _data["announcePosition"];
            this.announceFrequency = _data["announceFrequency"];
            this.musicOnHold = _data["musicOnHold"];
            this.musicOnHoldAsterisk = _data["musicOnHoldAsterisk"];
            this.musicOnHoldData = _data["musicOnHoldData"];
            this.description = _data["description"];
            this.joinEmpty = _data["joinEmpty"];
            this.leaveWhenEmpty = _data["leaveWhenEmpty"];
            this.ringInUse = _data["ringInUse"];
            this.recording = _data["recording"];
            this.musicOnHoldId = _data["musicOnHoldId"];
            this.maxContacts = _data["maxContacts"];
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(AddAgentModel.fromJS(item));
            }
            this.periodicAnnounceId = _data["periodicAnnounceId"];
            this.periodicAnnounce = _data["periodicAnnounce"];
            this.periodicAnnounceFrequency = _data["periodicAnnounceFrequency"];
        }
    }

    static fromJS(data: any): CreateQueueCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQueueCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["strategy"] = this.strategy;
        data["queueId"] = this.queueId;
        data["companyId"] = this.companyId;
        data["timeOut"] = this.timeOut;
        data["retry"] = this.retry;
        data["wrapUp"] = this.wrapUp;
        data["priorityQueue"] = this.priorityQueue;
        data["announcePosition"] = this.announcePosition;
        data["announceFrequency"] = this.announceFrequency;
        data["musicOnHold"] = this.musicOnHold;
        data["musicOnHoldAsterisk"] = this.musicOnHoldAsterisk;
        data["musicOnHoldData"] = this.musicOnHoldData;
        data["description"] = this.description;
        data["joinEmpty"] = this.joinEmpty;
        data["leaveWhenEmpty"] = this.leaveWhenEmpty;
        data["ringInUse"] = this.ringInUse;
        data["recording"] = this.recording;
        data["musicOnHoldId"] = this.musicOnHoldId;
        data["maxContacts"] = this.maxContacts;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        data["periodicAnnounceId"] = this.periodicAnnounceId;
        data["periodicAnnounce"] = this.periodicAnnounce;
        data["periodicAnnounceFrequency"] = this.periodicAnnounceFrequency;
        return data;
    }
}

export interface ICreateQueueCommand {
    name?: string | undefined;
    strategy?: string | undefined;
    queueId?: string | undefined;
    companyId?: number;
    timeOut?: number;
    retry?: number;
    wrapUp?: number;
    priorityQueue?: string | undefined;
    announcePosition?: boolean;
    announceFrequency?: number;
    musicOnHold?: string | undefined;
    musicOnHoldAsterisk?: string | undefined;
    musicOnHoldData?: string | undefined;
    description?: string | undefined;
    joinEmpty?: boolean;
    leaveWhenEmpty?: boolean;
    ringInUse?: boolean;
    recording?: boolean;
    musicOnHoldId?: number;
    maxContacts?: string | undefined;
    agents?: AddAgentModel[] | undefined;
    periodicAnnounceId?: number;
    periodicAnnounce?: string | undefined;
    periodicAnnounceFrequency?: number;
}

export class AddAgentModel implements IAddAgentModel {
    id?: number;
    extension?: string | undefined;
    priority?: boolean;
    followMe?: boolean;
    isOnline?: boolean;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    agentType?: string | undefined;

    constructor(data?: IAddAgentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.extension = _data["extension"];
            this.priority = _data["priority"];
            this.followMe = _data["followMe"];
            this.isOnline = _data["isOnline"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.agentType = _data["agentType"];
        }
    }

    static fromJS(data: any): AddAgentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddAgentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["extension"] = this.extension;
        data["priority"] = this.priority;
        data["followMe"] = this.followMe;
        data["isOnline"] = this.isOnline;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["agentType"] = this.agentType;
        return data;
    }
}

export interface IAddAgentModel {
    id?: number;
    extension?: string | undefined;
    priority?: boolean;
    followMe?: boolean;
    isOnline?: boolean;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    agentType?: string | undefined;
}

export class DisableQueueCommand implements IDisableQueueCommand {
    id?: number;
    disable?: boolean;

    constructor(data?: IDisableQueueCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.disable = _data["disable"];
        }
    }

    static fromJS(data: any): DisableQueueCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DisableQueueCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["disable"] = this.disable;
        return data;
    }
}

export interface IDisableQueueCommand {
    id?: number;
    disable?: boolean;
}

export class QueueDetailVm implements IQueueDetailVm {
    agentsInQueue?: AgentInQueueDto[] | undefined;
    queue?: QueueInformation | undefined;

    constructor(data?: IQueueDetailVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["agentsInQueue"])) {
                this.agentsInQueue = [] as any;
                for (let item of _data["agentsInQueue"])
                    this.agentsInQueue!.push(AgentInQueueDto.fromJS(item));
            }
            this.queue = _data["queue"] ? QueueInformation.fromJS(_data["queue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QueueDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new QueueDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.agentsInQueue)) {
            data["agentsInQueue"] = [];
            for (let item of this.agentsInQueue)
                data["agentsInQueue"].push(item.toJSON());
        }
        data["queue"] = this.queue ? this.queue.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQueueDetailVm {
    agentsInQueue?: AgentInQueueDto[] | undefined;
    queue?: QueueInformation | undefined;
}

export class AgentInQueueDto implements IAgentInQueueDto {
    agentId?: number;
    fullName?: string | undefined;
    priority?: boolean;
    avatar?: string | undefined;
    extension?: string | undefined;
    isOnline?: boolean;
    email?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IAgentInQueueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            this.fullName = _data["fullName"];
            this.priority = _data["priority"];
            this.avatar = _data["avatar"];
            this.extension = _data["extension"];
            this.isOnline = _data["isOnline"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): AgentInQueueDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentInQueueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["fullName"] = this.fullName;
        data["priority"] = this.priority;
        data["avatar"] = this.avatar;
        data["extension"] = this.extension;
        data["isOnline"] = this.isOnline;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IAgentInQueueDto {
    agentId?: number;
    fullName?: string | undefined;
    priority?: boolean;
    avatar?: string | undefined;
    extension?: string | undefined;
    isOnline?: boolean;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export class QueueInformation implements IQueueInformation {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    timeOut?: number;
    retry?: number;
    priorityQueue?: string | undefined;
    wrapUp?: number;
    announcePosition?: boolean;
    announceFrequency?: number;
    musicOnHold?: string | undefined;
    strategy?: string | undefined;
    joinEmpty?: boolean;
    leaveWhenEmpty?: boolean;
    ringInUse?: boolean;
    recording?: boolean;
    musicOnHoldId?: number;
    maxContacts?: string | undefined;
    periodicAnnounceId?: number;
    periodicAnnounce?: string | undefined;
    periodicAnnounceFrequency?: number;

    constructor(data?: IQueueInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.timeOut = _data["timeOut"];
            this.retry = _data["retry"];
            this.priorityQueue = _data["priorityQueue"];
            this.wrapUp = _data["wrapUp"];
            this.announcePosition = _data["announcePosition"];
            this.announceFrequency = _data["announceFrequency"];
            this.musicOnHold = _data["musicOnHold"];
            this.strategy = _data["strategy"];
            this.joinEmpty = _data["joinEmpty"];
            this.leaveWhenEmpty = _data["leaveWhenEmpty"];
            this.ringInUse = _data["ringInUse"];
            this.recording = _data["recording"];
            this.musicOnHoldId = _data["musicOnHoldId"];
            this.maxContacts = _data["maxContacts"];
            this.periodicAnnounceId = _data["periodicAnnounceId"];
            this.periodicAnnounce = _data["periodicAnnounce"];
            this.periodicAnnounceFrequency = _data["periodicAnnounceFrequency"];
        }
    }

    static fromJS(data: any): QueueInformation {
        data = typeof data === 'object' ? data : {};
        let result = new QueueInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["timeOut"] = this.timeOut;
        data["retry"] = this.retry;
        data["priorityQueue"] = this.priorityQueue;
        data["wrapUp"] = this.wrapUp;
        data["announcePosition"] = this.announcePosition;
        data["announceFrequency"] = this.announceFrequency;
        data["musicOnHold"] = this.musicOnHold;
        data["strategy"] = this.strategy;
        data["joinEmpty"] = this.joinEmpty;
        data["leaveWhenEmpty"] = this.leaveWhenEmpty;
        data["ringInUse"] = this.ringInUse;
        data["recording"] = this.recording;
        data["musicOnHoldId"] = this.musicOnHoldId;
        data["maxContacts"] = this.maxContacts;
        data["periodicAnnounceId"] = this.periodicAnnounceId;
        data["periodicAnnounce"] = this.periodicAnnounce;
        data["periodicAnnounceFrequency"] = this.periodicAnnounceFrequency;
        return data;
    }
}

export interface IQueueInformation {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    timeOut?: number;
    retry?: number;
    priorityQueue?: string | undefined;
    wrapUp?: number;
    announcePosition?: boolean;
    announceFrequency?: number;
    musicOnHold?: string | undefined;
    strategy?: string | undefined;
    joinEmpty?: boolean;
    leaveWhenEmpty?: boolean;
    ringInUse?: boolean;
    recording?: boolean;
    musicOnHoldId?: number;
    maxContacts?: string | undefined;
    periodicAnnounceId?: number;
    periodicAnnounce?: string | undefined;
    periodicAnnounceFrequency?: number;
}

export class RecordingQueueVm implements IRecordingQueueVm {
    recordingQueue?: RecordingQueue[] | undefined;
    page?: Page | undefined;

    constructor(data?: IRecordingQueueVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recordingQueue"])) {
                this.recordingQueue = [] as any;
                for (let item of _data["recordingQueue"])
                    this.recordingQueue!.push(RecordingQueue.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RecordingQueueVm {
        data = typeof data === 'object' ? data : {};
        let result = new RecordingQueueVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recordingQueue)) {
            data["recordingQueue"] = [];
            for (let item of this.recordingQueue)
                data["recordingQueue"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRecordingQueueVm {
    recordingQueue?: RecordingQueue[] | undefined;
    page?: Page | undefined;
}

export class RecordingQueue implements IRecordingQueue {
    id?: number;
    callDate?: Date;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    channel?: string | undefined;
    dstChannel?: string | undefined;
    serverRecording?: string | undefined;
    callFlowId?: string | undefined;
    uniqueId?: string | undefined;
    callFlowName?: string | undefined;
    callTranscription?: string | undefined;
    companyId?: number;

    constructor(data?: IRecordingQueue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.callDate = _data["callDate"] ? new Date(_data["callDate"].toString()) : <any>undefined;
            this.fromNumber = _data["fromNumber"];
            this.toNumber = _data["toNumber"];
            this.channel = _data["channel"];
            this.dstChannel = _data["dstChannel"];
            this.serverRecording = _data["serverRecording"];
            this.callFlowId = _data["callFlowId"];
            this.uniqueId = _data["uniqueId"];
            this.callFlowName = _data["callFlowName"];
            this.callTranscription = _data["callTranscription"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): RecordingQueue {
        data = typeof data === 'object' ? data : {};
        let result = new RecordingQueue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["callDate"] = this.callDate ? this.callDate.toISOString() : <any>undefined;
        data["fromNumber"] = this.fromNumber;
        data["toNumber"] = this.toNumber;
        data["channel"] = this.channel;
        data["dstChannel"] = this.dstChannel;
        data["serverRecording"] = this.serverRecording;
        data["callFlowId"] = this.callFlowId;
        data["uniqueId"] = this.uniqueId;
        data["callFlowName"] = this.callFlowName;
        data["callTranscription"] = this.callTranscription;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IRecordingQueue {
    id?: number;
    callDate?: Date;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    channel?: string | undefined;
    dstChannel?: string | undefined;
    serverRecording?: string | undefined;
    callFlowId?: string | undefined;
    uniqueId?: string | undefined;
    callFlowName?: string | undefined;
    callTranscription?: string | undefined;
    companyId?: number;
}

export class GetQueueRecordingQuery implements IGetQueueRecordingQuery {
    id?: number;
    page?: Page | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetQueueRecordingQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetQueueRecordingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueueRecordingQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetQueueRecordingQuery {
    id?: number;
    page?: Page | undefined;
    filterData?: FilterData[] | undefined;
}

export class QueuesListVm implements IQueuesListVm {
    queues?: QueueDto[] | undefined;
    page?: Page | undefined;

    constructor(data?: IQueuesListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["queues"])) {
                this.queues = [] as any;
                for (let item of _data["queues"])
                    this.queues!.push(QueueDto.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QueuesListVm {
        data = typeof data === 'object' ? data : {};
        let result = new QueuesListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.queues)) {
            data["queues"] = [];
            for (let item of this.queues)
                data["queues"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQueuesListVm {
    queues?: QueueDto[] | undefined;
    page?: Page | undefined;
}

export class QueueDto implements IQueueDto {
    id?: number;
    queueId?: string | undefined;
    name?: string | undefined;
    strategy?: string | undefined;
    strategyStatus?: string | undefined;
    description?: string | undefined;
    noAgent?: number;
    disable?: boolean;

    constructor(data?: IQueueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.queueId = _data["queueId"];
            this.name = _data["name"];
            this.strategy = _data["strategy"];
            this.strategyStatus = _data["strategyStatus"];
            this.description = _data["description"];
            this.noAgent = _data["noAgent"];
            this.disable = _data["disable"];
        }
    }

    static fromJS(data: any): QueueDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["queueId"] = this.queueId;
        data["name"] = this.name;
        data["strategy"] = this.strategy;
        data["strategyStatus"] = this.strategyStatus;
        data["description"] = this.description;
        data["noAgent"] = this.noAgent;
        data["disable"] = this.disable;
        return data;
    }
}

export interface IQueueDto {
    id?: number;
    queueId?: string | undefined;
    name?: string | undefined;
    strategy?: string | undefined;
    strategyStatus?: string | undefined;
    description?: string | undefined;
    noAgent?: number;
    disable?: boolean;
}

export class GetQueuesListQuery implements IGetQueuesListQuery {
    companyId?: number;
    page?: Page | undefined;
    searchText?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetQueuesListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetQueuesListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueuesListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["searchText"] = this.searchText;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetQueuesListQuery {
    companyId?: number;
    page?: Page | undefined;
    searchText?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class UpdateTranscriptionCommand implements IUpdateTranscriptionCommand {
    uniqueId?: string | undefined;
    data?: string | undefined;

    constructor(data?: IUpdateTranscriptionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): UpdateTranscriptionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTranscriptionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["data"] = this.data;
        return data;
    }
}

export interface IUpdateTranscriptionCommand {
    uniqueId?: string | undefined;
    data?: string | undefined;
}

export class UpdateQueueCommand implements IUpdateQueueCommand {
    id?: number;
    name?: string | undefined;
    strategy?: string | undefined;
    companyId?: number;
    musicOnHold?: string | undefined;
    musicOnHoldData?: string | undefined;
    musicOnHoldAsterisk?: string | undefined;
    timeOut?: number;
    wrapUp?: number;
    retry?: number;
    priorityQueue?: string | undefined;
    announcePosition?: boolean;
    announceFrequency?: number;
    joinEmpty?: boolean;
    leaveWhenEmpty?: boolean;
    ringInUse?: boolean;
    description?: string | undefined;
    musicOnHoldId?: number;
    recording?: boolean;
    maxContacts?: string | undefined;
    agents?: AddAgentModel[] | undefined;
    periodicAnnounceId?: number;
    periodicAnnounce?: string | undefined;
    periodicAnnounceFrequency?: number;

    constructor(data?: IUpdateQueueCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.strategy = _data["strategy"];
            this.companyId = _data["companyId"];
            this.musicOnHold = _data["musicOnHold"];
            this.musicOnHoldData = _data["musicOnHoldData"];
            this.musicOnHoldAsterisk = _data["musicOnHoldAsterisk"];
            this.timeOut = _data["timeOut"];
            this.wrapUp = _data["wrapUp"];
            this.retry = _data["retry"];
            this.priorityQueue = _data["priorityQueue"];
            this.announcePosition = _data["announcePosition"];
            this.announceFrequency = _data["announceFrequency"];
            this.joinEmpty = _data["joinEmpty"];
            this.leaveWhenEmpty = _data["leaveWhenEmpty"];
            this.ringInUse = _data["ringInUse"];
            this.description = _data["description"];
            this.musicOnHoldId = _data["musicOnHoldId"];
            this.recording = _data["recording"];
            this.maxContacts = _data["maxContacts"];
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(AddAgentModel.fromJS(item));
            }
            this.periodicAnnounceId = _data["periodicAnnounceId"];
            this.periodicAnnounce = _data["periodicAnnounce"];
            this.periodicAnnounceFrequency = _data["periodicAnnounceFrequency"];
        }
    }

    static fromJS(data: any): UpdateQueueCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQueueCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["strategy"] = this.strategy;
        data["companyId"] = this.companyId;
        data["musicOnHold"] = this.musicOnHold;
        data["musicOnHoldData"] = this.musicOnHoldData;
        data["musicOnHoldAsterisk"] = this.musicOnHoldAsterisk;
        data["timeOut"] = this.timeOut;
        data["wrapUp"] = this.wrapUp;
        data["retry"] = this.retry;
        data["priorityQueue"] = this.priorityQueue;
        data["announcePosition"] = this.announcePosition;
        data["announceFrequency"] = this.announceFrequency;
        data["joinEmpty"] = this.joinEmpty;
        data["leaveWhenEmpty"] = this.leaveWhenEmpty;
        data["ringInUse"] = this.ringInUse;
        data["description"] = this.description;
        data["musicOnHoldId"] = this.musicOnHoldId;
        data["recording"] = this.recording;
        data["maxContacts"] = this.maxContacts;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        data["periodicAnnounceId"] = this.periodicAnnounceId;
        data["periodicAnnounce"] = this.periodicAnnounce;
        data["periodicAnnounceFrequency"] = this.periodicAnnounceFrequency;
        return data;
    }
}

export interface IUpdateQueueCommand {
    id?: number;
    name?: string | undefined;
    strategy?: string | undefined;
    companyId?: number;
    musicOnHold?: string | undefined;
    musicOnHoldData?: string | undefined;
    musicOnHoldAsterisk?: string | undefined;
    timeOut?: number;
    wrapUp?: number;
    retry?: number;
    priorityQueue?: string | undefined;
    announcePosition?: boolean;
    announceFrequency?: number;
    joinEmpty?: boolean;
    leaveWhenEmpty?: boolean;
    ringInUse?: boolean;
    description?: string | undefined;
    musicOnHoldId?: number;
    recording?: boolean;
    maxContacts?: string | undefined;
    agents?: AddAgentModel[] | undefined;
    periodicAnnounceId?: number;
    periodicAnnounce?: string | undefined;
    periodicAnnounceFrequency?: number;
}

export class QueueSummary implements IQueueSummary {
    queues?: AgentInQueueSummary[] | undefined;

    constructor(data?: IQueueSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["queues"])) {
                this.queues = [] as any;
                for (let item of _data["queues"])
                    this.queues!.push(AgentInQueueSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueueSummary {
        data = typeof data === 'object' ? data : {};
        let result = new QueueSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.queues)) {
            data["queues"] = [];
            for (let item of this.queues)
                data["queues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueueSummary {
    queues?: AgentInQueueSummary[] | undefined;
}

export class CallVolumeData implements ICallVolumeData {
    totalCallByMonth?: CallVolumeGroup[] | undefined;
    totalCallByDayOfMonth?: CallVolumeGroup[] | undefined;
    totalCallByDayOfWeek?: CallVolumeGroup[] | undefined;
    totalCallHoursOfDay?: CallVolumeGroup[] | undefined;

    constructor(data?: ICallVolumeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totalCallByMonth"])) {
                this.totalCallByMonth = [] as any;
                for (let item of _data["totalCallByMonth"])
                    this.totalCallByMonth!.push(CallVolumeGroup.fromJS(item));
            }
            if (Array.isArray(_data["totalCallByDayOfMonth"])) {
                this.totalCallByDayOfMonth = [] as any;
                for (let item of _data["totalCallByDayOfMonth"])
                    this.totalCallByDayOfMonth!.push(CallVolumeGroup.fromJS(item));
            }
            if (Array.isArray(_data["totalCallByDayOfWeek"])) {
                this.totalCallByDayOfWeek = [] as any;
                for (let item of _data["totalCallByDayOfWeek"])
                    this.totalCallByDayOfWeek!.push(CallVolumeGroup.fromJS(item));
            }
            if (Array.isArray(_data["totalCallHoursOfDay"])) {
                this.totalCallHoursOfDay = [] as any;
                for (let item of _data["totalCallHoursOfDay"])
                    this.totalCallHoursOfDay!.push(CallVolumeGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CallVolumeData {
        data = typeof data === 'object' ? data : {};
        let result = new CallVolumeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totalCallByMonth)) {
            data["totalCallByMonth"] = [];
            for (let item of this.totalCallByMonth)
                data["totalCallByMonth"].push(item.toJSON());
        }
        if (Array.isArray(this.totalCallByDayOfMonth)) {
            data["totalCallByDayOfMonth"] = [];
            for (let item of this.totalCallByDayOfMonth)
                data["totalCallByDayOfMonth"].push(item.toJSON());
        }
        if (Array.isArray(this.totalCallByDayOfWeek)) {
            data["totalCallByDayOfWeek"] = [];
            for (let item of this.totalCallByDayOfWeek)
                data["totalCallByDayOfWeek"].push(item.toJSON());
        }
        if (Array.isArray(this.totalCallHoursOfDay)) {
            data["totalCallHoursOfDay"] = [];
            for (let item of this.totalCallHoursOfDay)
                data["totalCallHoursOfDay"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICallVolumeData {
    totalCallByMonth?: CallVolumeGroup[] | undefined;
    totalCallByDayOfMonth?: CallVolumeGroup[] | undefined;
    totalCallByDayOfWeek?: CallVolumeGroup[] | undefined;
    totalCallHoursOfDay?: CallVolumeGroup[] | undefined;
}

export class CallVolumeGroup implements ICallVolumeGroup {
    name?: string | undefined;
    totalCall?: number;
    callQueue?: number;
    callVoicemail?: number;
    callTransfer?: number;

    constructor(data?: ICallVolumeGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.totalCall = _data["totalCall"];
            this.callQueue = _data["callQueue"];
            this.callVoicemail = _data["callVoicemail"];
            this.callTransfer = _data["callTransfer"];
        }
    }

    static fromJS(data: any): CallVolumeGroup {
        data = typeof data === 'object' ? data : {};
        let result = new CallVolumeGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["totalCall"] = this.totalCall;
        data["callQueue"] = this.callQueue;
        data["callVoicemail"] = this.callVoicemail;
        data["callTransfer"] = this.callTransfer;
        return data;
    }
}

export interface ICallVolumeGroup {
    name?: string | undefined;
    totalCall?: number;
    callQueue?: number;
    callVoicemail?: number;
    callTransfer?: number;
}

export class QueueReportData implements IQueueReportData {
    callByQueues?: CallVolumeGroup[] | undefined;
    callInQueueStatus?: CallVolumeGroup[] | undefined;
    callInQueueOrNot?: CallVolumeGroup[] | undefined;

    constructor(data?: IQueueReportData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["callByQueues"])) {
                this.callByQueues = [] as any;
                for (let item of _data["callByQueues"])
                    this.callByQueues!.push(CallVolumeGroup.fromJS(item));
            }
            if (Array.isArray(_data["callInQueueStatus"])) {
                this.callInQueueStatus = [] as any;
                for (let item of _data["callInQueueStatus"])
                    this.callInQueueStatus!.push(CallVolumeGroup.fromJS(item));
            }
            if (Array.isArray(_data["callInQueueOrNot"])) {
                this.callInQueueOrNot = [] as any;
                for (let item of _data["callInQueueOrNot"])
                    this.callInQueueOrNot!.push(CallVolumeGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueueReportData {
        data = typeof data === 'object' ? data : {};
        let result = new QueueReportData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.callByQueues)) {
            data["callByQueues"] = [];
            for (let item of this.callByQueues)
                data["callByQueues"].push(item.toJSON());
        }
        if (Array.isArray(this.callInQueueStatus)) {
            data["callInQueueStatus"] = [];
            for (let item of this.callInQueueStatus)
                data["callInQueueStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.callInQueueOrNot)) {
            data["callInQueueOrNot"] = [];
            for (let item of this.callInQueueOrNot)
                data["callInQueueOrNot"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueueReportData {
    callByQueues?: CallVolumeGroup[] | undefined;
    callInQueueStatus?: CallVolumeGroup[] | undefined;
    callInQueueOrNot?: CallVolumeGroup[] | undefined;
}

export class RolesListVm implements IRolesListVm {
    roles?: RoleDto[] | undefined;
    page?: Page | undefined;

    constructor(data?: IRolesListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleDto.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RolesListVm {
        data = typeof data === 'object' ? data : {};
        let result = new RolesListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRolesListVm {
    roles?: RoleDto[] | undefined;
    page?: Page | undefined;
}

export class RoleDto implements IRoleDto {
    id?: string | undefined;
    name!: string;
    normalizedName?: string | undefined;
    nameDisplay?: string | undefined;
    permissionList?: number[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.normalizedName = _data["normalizedName"];
            this.nameDisplay = _data["nameDisplay"];
            if (Array.isArray(_data["permissionList"])) {
                this.permissionList = [] as any;
                for (let item of _data["permissionList"])
                    this.permissionList!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        data["nameDisplay"] = this.nameDisplay;
        if (Array.isArray(this.permissionList)) {
            data["permissionList"] = [];
            for (let item of this.permissionList)
                data["permissionList"].push(item);
        }
        return data;
    }
}

export interface IRoleDto {
    id?: string | undefined;
    name: string;
    normalizedName?: string | undefined;
    nameDisplay?: string | undefined;
    permissionList?: number[] | undefined;
}

export class GetAllRoleQuery implements IGetAllRoleQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    type?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetAllRoleQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.searchText = _data["searchText"];
            this.type = _data["type"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllRoleQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRoleQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["searchText"] = this.searchText;
        data["type"] = this.type;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllRoleQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    type?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class UpdateRoleCommand implements IUpdateRoleCommand {
    roleDto?: RoleDto | undefined;

    constructor(data?: IUpdateRoleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleDto = _data["roleDto"] ? RoleDto.fromJS(_data["roleDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateRoleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleDto"] = this.roleDto ? this.roleDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateRoleCommand {
    roleDto?: RoleDto | undefined;
}

export class SyncDevice implements ISyncDevice {
    vdn?: VDN[] | undefined;
    skill?: Skill[] | undefined;
    agent?: Agent2[] | undefined;
    extension?: Extension[] | undefined;
    option?: Option | undefined;

    constructor(data?: ISyncDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vdn"])) {
                this.vdn = [] as any;
                for (let item of _data["vdn"])
                    this.vdn!.push(VDN.fromJS(item));
            }
            if (Array.isArray(_data["skill"])) {
                this.skill = [] as any;
                for (let item of _data["skill"])
                    this.skill!.push(Skill.fromJS(item));
            }
            if (Array.isArray(_data["agent"])) {
                this.agent = [] as any;
                for (let item of _data["agent"])
                    this.agent!.push(Agent2.fromJS(item));
            }
            if (Array.isArray(_data["extension"])) {
                this.extension = [] as any;
                for (let item of _data["extension"])
                    this.extension!.push(Extension.fromJS(item));
            }
            this.option = _data["option"] ? Option.fromJS(_data["option"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SyncDevice {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vdn)) {
            data["vdn"] = [];
            for (let item of this.vdn)
                data["vdn"].push(item.toJSON());
        }
        if (Array.isArray(this.skill)) {
            data["skill"] = [];
            for (let item of this.skill)
                data["skill"].push(item.toJSON());
        }
        if (Array.isArray(this.agent)) {
            data["agent"] = [];
            for (let item of this.agent)
                data["agent"].push(item.toJSON());
        }
        if (Array.isArray(this.extension)) {
            data["extension"] = [];
            for (let item of this.extension)
                data["extension"].push(item.toJSON());
        }
        data["option"] = this.option ? this.option.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISyncDevice {
    vdn?: VDN[] | undefined;
    skill?: Skill[] | undefined;
    agent?: Agent2[] | undefined;
    extension?: Extension[] | undefined;
    option?: Option | undefined;
}

export class SyncDeviceCommand extends SyncDevice implements ISyncDeviceCommand {

    constructor(data?: ISyncDeviceCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SyncDeviceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDeviceCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDeviceCommand extends ISyncDevice {
}

export class VDN implements IVDN {
    id?: string | undefined;
    name?: string | undefined;
    relatedDevice?: string[] | undefined;

    constructor(data?: IVDN) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["relatedDevice"])) {
                this.relatedDevice = [] as any;
                for (let item of _data["relatedDevice"])
                    this.relatedDevice!.push(item);
            }
        }
    }

    static fromJS(data: any): VDN {
        data = typeof data === 'object' ? data : {};
        let result = new VDN();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.relatedDevice)) {
            data["relatedDevice"] = [];
            for (let item of this.relatedDevice)
                data["relatedDevice"].push(item);
        }
        return data;
    }
}

export interface IVDN {
    id?: string | undefined;
    name?: string | undefined;
    relatedDevice?: string[] | undefined;
}

export class Skill implements ISkill {
    id?: string | undefined;
    name?: string | undefined;
    relatedDevice?: string[] | undefined;

    constructor(data?: ISkill) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["relatedDevice"])) {
                this.relatedDevice = [] as any;
                for (let item of _data["relatedDevice"])
                    this.relatedDevice!.push(item);
            }
        }
    }

    static fromJS(data: any): Skill {
        data = typeof data === 'object' ? data : {};
        let result = new Skill();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.relatedDevice)) {
            data["relatedDevice"] = [];
            for (let item of this.relatedDevice)
                data["relatedDevice"].push(item);
        }
        return data;
    }
}

export interface ISkill {
    id?: string | undefined;
    name?: string | undefined;
    relatedDevice?: string[] | undefined;
}

export class Agent2 implements IAgent2 {
    id?: string | undefined;
    name?: string | undefined;
    relatedInfo?: RelatedInfo[] | undefined;

    constructor(data?: IAgent2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["relatedInfo"])) {
                this.relatedInfo = [] as any;
                for (let item of _data["relatedInfo"])
                    this.relatedInfo!.push(RelatedInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Agent2 {
        data = typeof data === 'object' ? data : {};
        let result = new Agent2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.relatedInfo)) {
            data["relatedInfo"] = [];
            for (let item of this.relatedInfo)
                data["relatedInfo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgent2 {
    id?: string | undefined;
    name?: string | undefined;
    relatedInfo?: RelatedInfo[] | undefined;
}

export class RelatedInfo implements IRelatedInfo {
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IRelatedInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RelatedInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RelatedInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IRelatedInfo {
    key?: string | undefined;
    value?: string | undefined;
}

export class Extension implements IExtension {
    id?: string | undefined;
    name?: string | undefined;
    relatedInfo?: RelatedInfo[] | undefined;

    constructor(data?: IExtension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["relatedInfo"])) {
                this.relatedInfo = [] as any;
                for (let item of _data["relatedInfo"])
                    this.relatedInfo!.push(RelatedInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Extension {
        data = typeof data === 'object' ? data : {};
        let result = new Extension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.relatedInfo)) {
            data["relatedInfo"] = [];
            for (let item of this.relatedInfo)
                data["relatedInfo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExtension {
    id?: string | undefined;
    name?: string | undefined;
    relatedInfo?: RelatedInfo[] | undefined;
}

export class Option implements IOption {
    deleteIfNotExist?: boolean;
    updateDeviceName?: boolean;
    addVDNForSkill?: boolean;
    addExtForAgent?: boolean;

    constructor(data?: IOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deleteIfNotExist = _data["deleteIfNotExist"];
            this.updateDeviceName = _data["updateDeviceName"];
            this.addVDNForSkill = _data["addVDNForSkill"];
            this.addExtForAgent = _data["addExtForAgent"];
        }
    }

    static fromJS(data: any): Option {
        data = typeof data === 'object' ? data : {};
        let result = new Option();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deleteIfNotExist"] = this.deleteIfNotExist;
        data["updateDeviceName"] = this.updateDeviceName;
        data["addVDNForSkill"] = this.addVDNForSkill;
        data["addExtForAgent"] = this.addExtForAgent;
        return data;
    }
}

export interface IOption {
    deleteIfNotExist?: boolean;
    updateDeviceName?: boolean;
    addVDNForSkill?: boolean;
    addExtForAgent?: boolean;
}

export class Common extends AuditableEntity implements ICommon {
    key?: string | undefined;
    value?: string | undefined;
    companyId?: number;
    company?: Company | undefined;

    constructor(data?: ICommon) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): Common {
        data = typeof data === 'object' ? data : {};
        let result = new Common();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICommon extends IAuditableEntity {
    key?: string | undefined;
    value?: string | undefined;
    companyId?: number;
    company?: Company | undefined;
}

export class GetSettingValuesCompanyQuery implements IGetSettingValuesCompanyQuery {
    companyId?: number;
    keys?: string[] | undefined;

    constructor(data?: IGetSettingValuesCompanyQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["keys"])) {
                this.keys = [] as any;
                for (let item of _data["keys"])
                    this.keys!.push(item);
            }
        }
    }

    static fromJS(data: any): GetSettingValuesCompanyQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSettingValuesCompanyQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.keys)) {
            data["keys"] = [];
            for (let item of this.keys)
                data["keys"].push(item);
        }
        return data;
    }
}

export interface IGetSettingValuesCompanyQuery {
    companyId?: number;
    keys?: string[] | undefined;
}

export class UpdateLogoCommand implements IUpdateLogoCommand {
    logo?: string | undefined;

    constructor(data?: IUpdateLogoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logo = _data["logo"];
        }
    }

    static fromJS(data: any): UpdateLogoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLogoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo;
        return data;
    }
}

export interface IUpdateLogoCommand {
    logo?: string | undefined;
}

export class SystemLogVm implements ISystemLogVm {
    systemLogs?: SystemLogDto[] | undefined;
    page?: Page | undefined;

    constructor(data?: ISystemLogVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["systemLogs"])) {
                this.systemLogs = [] as any;
                for (let item of _data["systemLogs"])
                    this.systemLogs!.push(SystemLogDto.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SystemLogVm {
        data = typeof data === 'object' ? data : {};
        let result = new SystemLogVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.systemLogs)) {
            data["systemLogs"] = [];
            for (let item of this.systemLogs)
                data["systemLogs"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISystemLogVm {
    systemLogs?: SystemLogDto[] | undefined;
    page?: Page | undefined;
}

export class SystemLogDto implements ISystemLogDto {
    id?: number;
    logLevel?: string | undefined;
    source?: string | undefined;
    sourceDisplay?: string | undefined;
    message?: string | undefined;
    resolution?: string | undefined;
    created?: Date;

    constructor(data?: ISystemLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.logLevel = _data["logLevel"];
            this.source = _data["source"];
            this.sourceDisplay = _data["sourceDisplay"];
            this.message = _data["message"];
            this.resolution = _data["resolution"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SystemLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["logLevel"] = this.logLevel;
        data["source"] = this.source;
        data["sourceDisplay"] = this.sourceDisplay;
        data["message"] = this.message;
        data["resolution"] = this.resolution;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISystemLogDto {
    id?: number;
    logLevel?: string | undefined;
    source?: string | undefined;
    sourceDisplay?: string | undefined;
    message?: string | undefined;
    resolution?: string | undefined;
    created?: Date;
}

export class GetAllSystemLogs implements IGetAllSystemLogs {
    page?: Page | undefined;
    start?: Date;
    end?: Date;
    source?: string | undefined;
    logLevel?: string | undefined;
    message?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetAllSystemLogs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.source = _data["source"];
            this.logLevel = _data["logLevel"];
            this.message = _data["message"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllSystemLogs {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSystemLogs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["source"] = this.source;
        data["logLevel"] = this.logLevel;
        data["message"] = this.message;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllSystemLogs {
    page?: Page | undefined;
    start?: Date;
    end?: Date;
    source?: string | undefined;
    logLevel?: string | undefined;
    message?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class CreateSystemLogsCommand implements ICreateSystemLogsCommand {
    logLevel?: string | undefined;
    source?: string | undefined;
    message?: string | undefined;
    resolution?: string | undefined;

    constructor(data?: ICreateSystemLogsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logLevel = _data["logLevel"];
            this.source = _data["source"];
            this.message = _data["message"];
            this.resolution = _data["resolution"];
        }
    }

    static fromJS(data: any): CreateSystemLogsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSystemLogsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logLevel"] = this.logLevel;
        data["source"] = this.source;
        data["message"] = this.message;
        data["resolution"] = this.resolution;
        return data;
    }
}

export interface ICreateSystemLogsCommand {
    logLevel?: string | undefined;
    source?: string | undefined;
    message?: string | undefined;
    resolution?: string | undefined;
}

export class TemplateFlowDto implements ITemplateFlowDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    introduction?: string | undefined;
    image?: string | undefined;
    version?: string | undefined;
    callFlowId?: number;
    flowType?: number;
    category?: string | undefined;
    fileName?: string | undefined;
    isDisable?: boolean;
    isPublish?: boolean;
    created?: Date;
    lastModified?: Date | undefined;

    constructor(data?: ITemplateFlowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.introduction = _data["introduction"];
            this.image = _data["image"];
            this.version = _data["version"];
            this.callFlowId = _data["callFlowId"];
            this.flowType = _data["flowType"];
            this.category = _data["category"];
            this.fileName = _data["fileName"];
            this.isDisable = _data["isDisable"];
            this.isPublish = _data["isPublish"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TemplateFlowDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateFlowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["introduction"] = this.introduction;
        data["image"] = this.image;
        data["version"] = this.version;
        data["callFlowId"] = this.callFlowId;
        data["flowType"] = this.flowType;
        data["category"] = this.category;
        data["fileName"] = this.fileName;
        data["isDisable"] = this.isDisable;
        data["isPublish"] = this.isPublish;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITemplateFlowDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    introduction?: string | undefined;
    image?: string | undefined;
    version?: string | undefined;
    callFlowId?: number;
    flowType?: number;
    category?: string | undefined;
    fileName?: string | undefined;
    isDisable?: boolean;
    isPublish?: boolean;
    created?: Date;
    lastModified?: Date | undefined;
}

export class GetAllTemplateFlow implements IGetAllTemplateFlow {
    searchText?: string | undefined;
    category?: string | undefined;

    constructor(data?: IGetAllTemplateFlow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): GetAllTemplateFlow {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTemplateFlow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["category"] = this.category;
        return data;
    }
}

export interface IGetAllTemplateFlow {
    searchText?: string | undefined;
    category?: string | undefined;
}

export class TemplateFlowPublishDto implements ITemplateFlowPublishDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    introduction?: string | undefined;
    image?: string | undefined;
    version?: string | undefined;
    flowType?: number;
    category?: string | undefined;
    created?: Date;
    lastModified?: Date | undefined;

    constructor(data?: ITemplateFlowPublishDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.introduction = _data["introduction"];
            this.image = _data["image"];
            this.version = _data["version"];
            this.flowType = _data["flowType"];
            this.category = _data["category"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TemplateFlowPublishDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateFlowPublishDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["introduction"] = this.introduction;
        data["image"] = this.image;
        data["version"] = this.version;
        data["flowType"] = this.flowType;
        data["category"] = this.category;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITemplateFlowPublishDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    introduction?: string | undefined;
    image?: string | undefined;
    version?: string | undefined;
    flowType?: number;
    category?: string | undefined;
    created?: Date;
    lastModified?: Date | undefined;
}

export class GetAllTemplateFlowPublish implements IGetAllTemplateFlowPublish {
    searchText?: string | undefined;
    category?: string | undefined;

    constructor(data?: IGetAllTemplateFlowPublish) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): GetAllTemplateFlowPublish {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTemplateFlowPublish();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["category"] = this.category;
        return data;
    }
}

export interface IGetAllTemplateFlowPublish {
    searchText?: string | undefined;
    category?: string | undefined;
}

export class UpdateTemplateFlowCommand implements IUpdateTemplateFlowCommand {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    introduction?: string | undefined;
    callFlowId?: number;
    image?: string | undefined;
    version?: string | undefined;
    category?: string | undefined;
    isPublish?: boolean;
    flowType?: number;

    constructor(data?: IUpdateTemplateFlowCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.introduction = _data["introduction"];
            this.callFlowId = _data["callFlowId"];
            this.image = _data["image"];
            this.version = _data["version"];
            this.category = _data["category"];
            this.isPublish = _data["isPublish"];
            this.flowType = _data["flowType"];
        }
    }

    static fromJS(data: any): UpdateTemplateFlowCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateFlowCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["introduction"] = this.introduction;
        data["callFlowId"] = this.callFlowId;
        data["image"] = this.image;
        data["version"] = this.version;
        data["category"] = this.category;
        data["isPublish"] = this.isPublish;
        data["flowType"] = this.flowType;
        return data;
    }
}

export interface IUpdateTemplateFlowCommand {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    introduction?: string | undefined;
    callFlowId?: number;
    image?: string | undefined;
    version?: string | undefined;
    category?: string | undefined;
    isPublish?: boolean;
    flowType?: number;
}

export class UseTemplateFlowCommand implements IUseTemplateFlowCommand {
    templateId?: number;
    tag?: string | undefined;

    constructor(data?: IUseTemplateFlowCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.tag = _data["tag"];
        }
    }

    static fromJS(data: any): UseTemplateFlowCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UseTemplateFlowCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["tag"] = this.tag;
        return data;
    }
}

export interface IUseTemplateFlowCommand {
    templateId?: number;
    tag?: string | undefined;
}

export class PreviewTemplateDto implements IPreviewTemplateDto {
    jsonFormat?: string | undefined;
    callSettings?: CallSettingDto | undefined;
    attribute?: string | undefined;
    chatUrl?: string | undefined;

    constructor(data?: IPreviewTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jsonFormat = _data["jsonFormat"];
            this.callSettings = _data["callSettings"] ? CallSettingDto.fromJS(_data["callSettings"]) : <any>undefined;
            this.attribute = _data["attribute"];
            this.chatUrl = _data["chatUrl"];
        }
    }

    static fromJS(data: any): PreviewTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jsonFormat"] = this.jsonFormat;
        data["callSettings"] = this.callSettings ? this.callSettings.toJSON() : <any>undefined;
        data["attribute"] = this.attribute;
        data["chatUrl"] = this.chatUrl;
        return data;
    }
}

export interface IPreviewTemplateDto {
    jsonFormat?: string | undefined;
    callSettings?: CallSettingDto | undefined;
    attribute?: string | undefined;
    chatUrl?: string | undefined;
}

export class PreviewTemplateFlow implements IPreviewTemplateFlow {
    templateId?: number;

    constructor(data?: IPreviewTemplateFlow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
        }
    }

    static fromJS(data: any): PreviewTemplateFlow {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewTemplateFlow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        return data;
    }
}

export interface IPreviewTemplateFlow {
    templateId?: number;
}

export class DisableTemplateFlow implements IDisableTemplateFlow {
    id?: number;

    constructor(data?: IDisableTemplateFlow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DisableTemplateFlow {
        data = typeof data === 'object' ? data : {};
        let result = new DisableTemplateFlow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDisableTemplateFlow {
    id?: number;
}

export class CallLogListVm implements ICallLogListVm {
    callLog?: CallLogVm[] | undefined;
    page?: Page | undefined;

    constructor(data?: ICallLogListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["callLog"])) {
                this.callLog = [] as any;
                for (let item of _data["callLog"])
                    this.callLog!.push(CallLogVm.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CallLogListVm {
        data = typeof data === 'object' ? data : {};
        let result = new CallLogListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.callLog)) {
            data["callLog"] = [];
            for (let item of this.callLog)
                data["callLog"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICallLogListVm {
    callLog?: CallLogVm[] | undefined;
    page?: Page | undefined;
}

export class CallLogVm implements ICallLogVm {
    id?: number;
    companyId?: number;
    callflowId?: number;
    callId?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    logContent?: string | undefined;
    type?: string | undefined;
    logType?: string | undefined;
    actionName?: string | undefined;
    actionKey?: string | undefined;
    currentFlowId?: number;
    currentFlowName?: string | undefined;
    jsonRefData?: string | undefined;
    created?: Date;

    constructor(data?: ICallLogVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.callflowId = _data["callflowId"];
            this.callId = _data["callId"];
            this.fromNumber = _data["fromNumber"];
            this.toNumber = _data["toNumber"];
            this.logContent = _data["logContent"];
            this.type = _data["type"];
            this.logType = _data["logType"];
            this.actionName = _data["actionName"];
            this.actionKey = _data["actionKey"];
            this.currentFlowId = _data["currentFlowId"];
            this.currentFlowName = _data["currentFlowName"];
            this.jsonRefData = _data["jsonRefData"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CallLogVm {
        data = typeof data === 'object' ? data : {};
        let result = new CallLogVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["callflowId"] = this.callflowId;
        data["callId"] = this.callId;
        data["fromNumber"] = this.fromNumber;
        data["toNumber"] = this.toNumber;
        data["logContent"] = this.logContent;
        data["type"] = this.type;
        data["logType"] = this.logType;
        data["actionName"] = this.actionName;
        data["actionKey"] = this.actionKey;
        data["currentFlowId"] = this.currentFlowId;
        data["currentFlowName"] = this.currentFlowName;
        data["jsonRefData"] = this.jsonRefData;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICallLogVm {
    id?: number;
    companyId?: number;
    callflowId?: number;
    callId?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    logContent?: string | undefined;
    type?: string | undefined;
    logType?: string | undefined;
    actionName?: string | undefined;
    actionKey?: string | undefined;
    currentFlowId?: number;
    currentFlowName?: string | undefined;
    jsonRefData?: string | undefined;
    created?: Date;
}

export class GetListCallLog implements IGetListCallLog {
    id?: number;
    page?: Page | undefined;
    callId?: string | undefined;
    searchText?: string | undefined;
    fromNumber?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetListCallLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.callId = _data["callId"];
            this.searchText = _data["searchText"];
            this.fromNumber = _data["fromNumber"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetListCallLog {
        data = typeof data === 'object' ? data : {};
        let result = new GetListCallLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["callId"] = this.callId;
        data["searchText"] = this.searchText;
        data["fromNumber"] = this.fromNumber;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetListCallLog {
    id?: number;
    page?: Page | undefined;
    callId?: string | undefined;
    searchText?: string | undefined;
    fromNumber?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class CallIdListVm implements ICallIdListVm {
    callId?: CallIdDto[] | undefined;

    constructor(data?: ICallIdListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["callId"])) {
                this.callId = [] as any;
                for (let item of _data["callId"])
                    this.callId!.push(CallIdDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CallIdListVm {
        data = typeof data === 'object' ? data : {};
        let result = new CallIdListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.callId)) {
            data["callId"] = [];
            for (let item of this.callId)
                data["callId"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICallIdListVm {
    callId?: CallIdDto[] | undefined;
}

export class CallIdDto implements ICallIdDto {
    callId?: string | undefined;
    created?: Date;

    constructor(data?: ICallIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callId = _data["callId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CallIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callId"] = this.callId;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICallIdDto {
    callId?: string | undefined;
    created?: Date;
}

export class InsertLogCommands implements IInsertLogCommands {
    companyId?: number;
    callId?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    logContent?: string | undefined;
    attribute?: string | undefined;
    callFlowId?: number;
    type?: string | undefined;
    logType?: string | undefined;
    actionName?: string | undefined;
    actionKey?: string | undefined;
    currentFlowId?: number;
    jsonRefData?: string | undefined;

    constructor(data?: IInsertLogCommands) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.callId = _data["callId"];
            this.fromNumber = _data["fromNumber"];
            this.toNumber = _data["toNumber"];
            this.logContent = _data["logContent"];
            this.attribute = _data["attribute"];
            this.callFlowId = _data["callFlowId"];
            this.type = _data["type"];
            this.logType = _data["logType"];
            this.actionName = _data["actionName"];
            this.actionKey = _data["actionKey"];
            this.currentFlowId = _data["currentFlowId"];
            this.jsonRefData = _data["jsonRefData"];
        }
    }

    static fromJS(data: any): InsertLogCommands {
        data = typeof data === 'object' ? data : {};
        let result = new InsertLogCommands();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["callId"] = this.callId;
        data["fromNumber"] = this.fromNumber;
        data["toNumber"] = this.toNumber;
        data["logContent"] = this.logContent;
        data["attribute"] = this.attribute;
        data["callFlowId"] = this.callFlowId;
        data["type"] = this.type;
        data["logType"] = this.logType;
        data["actionName"] = this.actionName;
        data["actionKey"] = this.actionKey;
        data["currentFlowId"] = this.currentFlowId;
        data["jsonRefData"] = this.jsonRefData;
        return data;
    }
}

export interface IInsertLogCommands {
    companyId?: number;
    callId?: string | undefined;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    logContent?: string | undefined;
    attribute?: string | undefined;
    callFlowId?: number;
    type?: string | undefined;
    logType?: string | undefined;
    actionName?: string | undefined;
    actionKey?: string | undefined;
    currentFlowId?: number;
    jsonRefData?: string | undefined;
}

export class ExportLogCommands implements IExportLogCommands {
    callLogList?: CallLogVm[] | undefined;

    constructor(data?: IExportLogCommands) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["callLogList"])) {
                this.callLogList = [] as any;
                for (let item of _data["callLogList"])
                    this.callLogList!.push(CallLogVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportLogCommands {
        data = typeof data === 'object' ? data : {};
        let result = new ExportLogCommands();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.callLogList)) {
            data["callLogList"] = [];
            for (let item of this.callLogList)
                data["callLogList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExportLogCommands {
    callLogList?: CallLogVm[] | undefined;
}

export enum ServiceTranscribe {
    Amazon = 0,
    Google = 1,
    Azure = 2,
}

export class TranslateCommand implements ITranslateCommand {
    service?: ServiceTranslate;
    sourceLanguage?: string | undefined;
    targetLanguage?: string | undefined;
    text?: string | undefined;

    constructor(data?: ITranslateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"];
            this.sourceLanguage = _data["sourceLanguage"];
            this.targetLanguage = _data["targetLanguage"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): TranslateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        data["sourceLanguage"] = this.sourceLanguage;
        data["targetLanguage"] = this.targetLanguage;
        data["text"] = this.text;
        return data;
    }
}

export interface ITranslateCommand {
    service?: ServiceTranslate;
    sourceLanguage?: string | undefined;
    targetLanguage?: string | undefined;
    text?: string | undefined;
}

export class TestTranslateCommand implements ITestTranslateCommand {
    text?: string | undefined;
    sourceLanguage?: string | undefined;
    targetLanguage?: string | undefined;
    google?: boolean;
    amazon?: boolean;
    azure?: boolean;

    constructor(data?: ITestTranslateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.sourceLanguage = _data["sourceLanguage"];
            this.targetLanguage = _data["targetLanguage"];
            this.google = _data["google"];
            this.amazon = _data["amazon"];
            this.azure = _data["azure"];
        }
    }

    static fromJS(data: any): TestTranslateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TestTranslateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["sourceLanguage"] = this.sourceLanguage;
        data["targetLanguage"] = this.targetLanguage;
        data["google"] = this.google;
        data["amazon"] = this.amazon;
        data["azure"] = this.azure;
        return data;
    }
}

export interface ITestTranslateCommand {
    text?: string | undefined;
    sourceLanguage?: string | undefined;
    targetLanguage?: string | undefined;
    google?: boolean;
    amazon?: boolean;
    azure?: boolean;
}

export class TrunkDetailVm implements ITrunkDetailVm {
    id?: number;
    name?: string | undefined;
    providerId?: number;
    config?: string | undefined;
    context?: string | undefined;
    registerString?: string | undefined;

    constructor(data?: ITrunkDetailVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.providerId = _data["providerId"];
            this.config = _data["config"];
            this.context = _data["context"];
            this.registerString = _data["registerString"];
        }
    }

    static fromJS(data: any): TrunkDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new TrunkDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["providerId"] = this.providerId;
        data["config"] = this.config;
        data["context"] = this.context;
        data["registerString"] = this.registerString;
        return data;
    }
}

export interface ITrunkDetailVm {
    id?: number;
    name?: string | undefined;
    providerId?: number;
    config?: string | undefined;
    context?: string | undefined;
    registerString?: string | undefined;
}

export class TrunkListVm implements ITrunkListVm {
    trunks?: TrunkVm[] | undefined;
    phoneProviders?: PhoneNumberProviderDto[] | undefined;
    page?: Page | undefined;

    constructor(data?: ITrunkListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["trunks"])) {
                this.trunks = [] as any;
                for (let item of _data["trunks"])
                    this.trunks!.push(TrunkVm.fromJS(item));
            }
            if (Array.isArray(_data["phoneProviders"])) {
                this.phoneProviders = [] as any;
                for (let item of _data["phoneProviders"])
                    this.phoneProviders!.push(PhoneNumberProviderDto.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TrunkListVm {
        data = typeof data === 'object' ? data : {};
        let result = new TrunkListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trunks)) {
            data["trunks"] = [];
            for (let item of this.trunks)
                data["trunks"].push(item.toJSON());
        }
        if (Array.isArray(this.phoneProviders)) {
            data["phoneProviders"] = [];
            for (let item of this.phoneProviders)
                data["phoneProviders"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITrunkListVm {
    trunks?: TrunkVm[] | undefined;
    phoneProviders?: PhoneNumberProviderDto[] | undefined;
    page?: Page | undefined;
}

export class TrunkVm implements ITrunkVm {
    id?: number;
    name?: string | undefined;
    status?: boolean;
    providerName?: string | undefined;
    providerId?: number;
    active?: boolean;
    disable?: boolean;

    constructor(data?: ITrunkVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.providerName = _data["providerName"];
            this.providerId = _data["providerId"];
            this.active = _data["active"];
            this.disable = _data["disable"];
        }
    }

    static fromJS(data: any): TrunkVm {
        data = typeof data === 'object' ? data : {};
        let result = new TrunkVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["providerName"] = this.providerName;
        data["providerId"] = this.providerId;
        data["active"] = this.active;
        data["disable"] = this.disable;
        return data;
    }
}

export interface ITrunkVm {
    id?: number;
    name?: string | undefined;
    status?: boolean;
    providerName?: string | undefined;
    providerId?: number;
    active?: boolean;
    disable?: boolean;
}

export class GetAllTrunkQuery implements IGetAllTrunkQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    providerId?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetAllTrunkQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.searchText = _data["searchText"];
            this.providerId = _data["providerId"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllTrunkQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTrunkQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["searchText"] = this.searchText;
        data["providerId"] = this.providerId;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllTrunkQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    providerId?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class TrunkProviderDto implements ITrunkProviderDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: ITrunkProviderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TrunkProviderDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrunkProviderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITrunkProviderDto {
    id?: number;
    name?: string | undefined;
}

export class DisableTrunkCommand implements IDisableTrunkCommand {
    id?: number;
    disable?: boolean;

    constructor(data?: IDisableTrunkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.disable = _data["disable"];
        }
    }

    static fromJS(data: any): DisableTrunkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DisableTrunkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["disable"] = this.disable;
        return data;
    }
}

export interface IDisableTrunkCommand {
    id?: number;
    disable?: boolean;
}

export class ReloadTrunkCommand implements IReloadTrunkCommand {
    id?: number;

    constructor(data?: IReloadTrunkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReloadTrunkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReloadTrunkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IReloadTrunkCommand {
    id?: number;
}

export class DeleteTrunkCommand implements IDeleteTrunkCommand {
    id?: number;

    constructor(data?: IDeleteTrunkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteTrunkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTrunkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteTrunkCommand {
    id?: number;
}

export class ResponseValue implements IResponseValue {
    id?: number;
    message?: string | undefined;

    constructor(data?: IResponseValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ResponseValue {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        return data;
    }
}

export interface IResponseValue {
    id?: number;
    message?: string | undefined;
}

export class UpdateTrunkCommand implements IUpdateTrunkCommand {
    id?: number;
    providerId?: number;
    providerName?: string | undefined;
    name?: string | undefined;
    context?: string | undefined;
    config?: string | undefined;
    registerString?: string | undefined;

    constructor(data?: IUpdateTrunkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.providerId = _data["providerId"];
            this.providerName = _data["providerName"];
            this.name = _data["name"];
            this.context = _data["context"];
            this.config = _data["config"];
            this.registerString = _data["registerString"];
        }
    }

    static fromJS(data: any): UpdateTrunkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTrunkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["providerId"] = this.providerId;
        data["providerName"] = this.providerName;
        data["name"] = this.name;
        data["context"] = this.context;
        data["config"] = this.config;
        data["registerString"] = this.registerString;
        return data;
    }
}

export interface IUpdateTrunkCommand {
    id?: number;
    providerId?: number;
    providerName?: string | undefined;
    name?: string | undefined;
    context?: string | undefined;
    config?: string | undefined;
    registerString?: string | undefined;
}

export class UserActionListVm implements IUserActionListVm {
    userActions?: UserActionDto[] | undefined;

    constructor(data?: IUserActionListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userActions"])) {
                this.userActions = [] as any;
                for (let item of _data["userActions"])
                    this.userActions!.push(UserActionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserActionListVm {
        data = typeof data === 'object' ? data : {};
        let result = new UserActionListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userActions)) {
            data["userActions"] = [];
            for (let item of this.userActions)
                data["userActions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserActionListVm {
    userActions?: UserActionDto[] | undefined;
}

export class UserActionDto implements IUserActionDto {
    id?: number;
    applicationId?: string | undefined;
    name?: string | undefined;
    iconImage?: string | undefined;
    data?: string | undefined;

    constructor(data?: IUserActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationId = _data["applicationId"];
            this.name = _data["name"];
            this.iconImage = _data["iconImage"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): UserActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationId"] = this.applicationId;
        data["name"] = this.name;
        data["iconImage"] = this.iconImage;
        data["data"] = this.data;
        return data;
    }
}

export interface IUserActionDto {
    id?: number;
    applicationId?: string | undefined;
    name?: string | undefined;
    iconImage?: string | undefined;
    data?: string | undefined;
}

export class CreateUserActionCommand implements ICreateUserActionCommand {
    id?: number;
    applicationId?: string | undefined;
    name?: string | undefined;
    iconImage?: string | undefined;
    data?: string | undefined;

    constructor(data?: ICreateUserActionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationId = _data["applicationId"];
            this.name = _data["name"];
            this.iconImage = _data["iconImage"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): CreateUserActionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserActionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationId"] = this.applicationId;
        data["name"] = this.name;
        data["iconImage"] = this.iconImage;
        data["data"] = this.data;
        return data;
    }
}

export interface ICreateUserActionCommand {
    id?: number;
    applicationId?: string | undefined;
    name?: string | undefined;
    iconImage?: string | undefined;
    data?: string | undefined;
}

export class UpdateUserActionCommand implements IUpdateUserActionCommand {
    id?: number;
    name?: string | undefined;

    constructor(data?: IUpdateUserActionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateUserActionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserActionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateUserActionCommand {
    id?: number;
    name?: string | undefined;
}

export class CheckExitsUserActionCommand implements ICheckExitsUserActionCommand {
    userActionName?: string | undefined;

    constructor(data?: ICheckExitsUserActionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userActionName = _data["userActionName"];
        }
    }

    static fromJS(data: any): CheckExitsUserActionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CheckExitsUserActionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userActionName"] = this.userActionName;
        return data;
    }
}

export interface ICheckExitsUserActionCommand {
    userActionName?: string | undefined;
}

export class UserInformation implements IUserInformation {
    companyVm?: CompanyLookup | undefined;
    email?: string | undefined;
    emailBilling?: string | undefined;
    phoneNumber?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: IUserInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyVm = _data["companyVm"] ? CompanyLookup.fromJS(_data["companyVm"]) : <any>undefined;
            this.email = _data["email"];
            this.emailBilling = _data["emailBilling"];
            this.phoneNumber = _data["phoneNumber"];
            this.avatar = _data["avatar"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): UserInformation {
        data = typeof data === 'object' ? data : {};
        let result = new UserInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyVm"] = this.companyVm ? this.companyVm.toJSON() : <any>undefined;
        data["email"] = this.email;
        data["emailBilling"] = this.emailBilling;
        data["phoneNumber"] = this.phoneNumber;
        data["avatar"] = this.avatar;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IUserInformation {
    companyVm?: CompanyLookup | undefined;
    email?: string | undefined;
    emailBilling?: string | undefined;
    phoneNumber?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
}

export class UpdateUserInformationCommand implements IUpdateUserInformationCommand {
    fullName!: string;
    phoneNumber?: string | undefined;
    avatar?: string | undefined;

    constructor(data?: IUpdateUserInformationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): UpdateUserInformationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserInformationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface IUpdateUserInformationCommand {
    fullName: string;
    phoneNumber?: string | undefined;
    avatar?: string | undefined;
}

export class UserSettingDto implements IUserSettingDto {
    chatbot_Url?: string | undefined;
    chatbotOutreach_Url?: string | undefined;
    contactConfig_Url?: string | undefined;

    constructor(data?: IUserSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chatbot_Url = _data["chatbot_Url"];
            this.chatbotOutreach_Url = _data["chatbotOutreach_Url"];
            this.contactConfig_Url = _data["contactConfig_Url"];
        }
    }

    static fromJS(data: any): UserSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatbot_Url"] = this.chatbot_Url;
        data["chatbotOutreach_Url"] = this.chatbotOutreach_Url;
        data["contactConfig_Url"] = this.contactConfig_Url;
        return data;
    }
}

export interface IUserSettingDto {
    chatbot_Url?: string | undefined;
    chatbotOutreach_Url?: string | undefined;
    contactConfig_Url?: string | undefined;
}

export class UpdateUserSettingCommand implements IUpdateUserSettingCommand {
    botUrl?: string | undefined;
    outreachUrl?: string | undefined;
    contactUrl?: string | undefined;

    constructor(data?: IUpdateUserSettingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.botUrl = _data["botUrl"];
            this.outreachUrl = _data["outreachUrl"];
            this.contactUrl = _data["contactUrl"];
        }
    }

    static fromJS(data: any): UpdateUserSettingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSettingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["botUrl"] = this.botUrl;
        data["outreachUrl"] = this.outreachUrl;
        data["contactUrl"] = this.contactUrl;
        return data;
    }
}

export interface IUpdateUserSettingCommand {
    botUrl?: string | undefined;
    outreachUrl?: string | undefined;
    contactUrl?: string | undefined;
}

export class ChangePasswordCommand implements IChangePasswordCommand {
    oldPassword!: string;
    newPassword!: string;
    confirmPassword!: string;

    constructor(data?: IChangePasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IChangePasswordCommand {
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
}

export class VoiceMailListVm2 implements IVoiceMailListVm2 {
    voiceMailVm?: VoiceMailVm2[] | undefined;
    page?: Page | undefined;

    constructor(data?: IVoiceMailListVm2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["voiceMailVm"])) {
                this.voiceMailVm = [] as any;
                for (let item of _data["voiceMailVm"])
                    this.voiceMailVm!.push(VoiceMailVm2.fromJS(item));
            }
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VoiceMailListVm2 {
        data = typeof data === 'object' ? data : {};
        let result = new VoiceMailListVm2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.voiceMailVm)) {
            data["voiceMailVm"] = [];
            for (let item of this.voiceMailVm)
                data["voiceMailVm"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVoiceMailListVm2 {
    voiceMailVm?: VoiceMailVm2[] | undefined;
    page?: Page | undefined;
}

export class VoiceMailVm2 implements IVoiceMailVm2 {
    id?: number;
    callId?: string | undefined;
    date?: Date;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    audioFile?: string | undefined;
    audioFileName?: string | undefined;
    audioFilePath?: string | undefined;
    status?: number;
    statusDisplay?: string | undefined;
    callFlowId?: number;
    callFlowName?: string | undefined;
    duration?: number;
    durationDisplay?: string | undefined;
    companyId?: number;
    server?: string | undefined;
    transcription?: string | undefined;

    constructor(data?: IVoiceMailVm2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.callId = _data["callId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.fromNumber = _data["fromNumber"];
            this.toNumber = _data["toNumber"];
            this.audioFile = _data["audioFile"];
            this.audioFileName = _data["audioFileName"];
            this.audioFilePath = _data["audioFilePath"];
            this.status = _data["status"];
            this.statusDisplay = _data["statusDisplay"];
            this.callFlowId = _data["callFlowId"];
            this.callFlowName = _data["callFlowName"];
            this.duration = _data["duration"];
            this.durationDisplay = _data["durationDisplay"];
            this.companyId = _data["companyId"];
            this.server = _data["server"];
            this.transcription = _data["transcription"];
        }
    }

    static fromJS(data: any): VoiceMailVm2 {
        data = typeof data === 'object' ? data : {};
        let result = new VoiceMailVm2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["callId"] = this.callId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["fromNumber"] = this.fromNumber;
        data["toNumber"] = this.toNumber;
        data["audioFile"] = this.audioFile;
        data["audioFileName"] = this.audioFileName;
        data["audioFilePath"] = this.audioFilePath;
        data["status"] = this.status;
        data["statusDisplay"] = this.statusDisplay;
        data["callFlowId"] = this.callFlowId;
        data["callFlowName"] = this.callFlowName;
        data["duration"] = this.duration;
        data["durationDisplay"] = this.durationDisplay;
        data["companyId"] = this.companyId;
        data["server"] = this.server;
        data["transcription"] = this.transcription;
        return data;
    }
}

export interface IVoiceMailVm2 {
    id?: number;
    callId?: string | undefined;
    date?: Date;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    audioFile?: string | undefined;
    audioFileName?: string | undefined;
    audioFilePath?: string | undefined;
    status?: number;
    statusDisplay?: string | undefined;
    callFlowId?: number;
    callFlowName?: string | undefined;
    duration?: number;
    durationDisplay?: string | undefined;
    companyId?: number;
    server?: string | undefined;
    transcription?: string | undefined;
}

export class GetVoiceMailListQuery implements IGetVoiceMailListQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IGetVoiceMailListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetVoiceMailListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoiceMailListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["searchText"] = this.searchText;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetVoiceMailListQuery {
    page?: Page | undefined;
    searchText?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class VoiceMailDetailVm implements IVoiceMailDetailVm {
    id?: number;
    callId?: string | undefined;
    date?: Date;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    audioFile?: string | undefined;
    audioFileName?: string | undefined;
    audioFilePath?: string | undefined;
    status?: number;
    callFlowId?: number;
    callFlowName?: string | undefined;
    duration?: number;
    durationDisplay?: string | undefined;
    server?: string | undefined;
    transcription?: string | undefined;
    companyId?: number;

    constructor(data?: IVoiceMailDetailVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.callId = _data["callId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.fromNumber = _data["fromNumber"];
            this.toNumber = _data["toNumber"];
            this.audioFile = _data["audioFile"];
            this.audioFileName = _data["audioFileName"];
            this.audioFilePath = _data["audioFilePath"];
            this.status = _data["status"];
            this.callFlowId = _data["callFlowId"];
            this.callFlowName = _data["callFlowName"];
            this.duration = _data["duration"];
            this.durationDisplay = _data["durationDisplay"];
            this.server = _data["server"];
            this.transcription = _data["transcription"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): VoiceMailDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new VoiceMailDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["callId"] = this.callId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["fromNumber"] = this.fromNumber;
        data["toNumber"] = this.toNumber;
        data["audioFile"] = this.audioFile;
        data["audioFileName"] = this.audioFileName;
        data["audioFilePath"] = this.audioFilePath;
        data["status"] = this.status;
        data["callFlowId"] = this.callFlowId;
        data["callFlowName"] = this.callFlowName;
        data["duration"] = this.duration;
        data["durationDisplay"] = this.durationDisplay;
        data["server"] = this.server;
        data["transcription"] = this.transcription;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IVoiceMailDetailVm {
    id?: number;
    callId?: string | undefined;
    date?: Date;
    fromNumber?: string | undefined;
    toNumber?: string | undefined;
    audioFile?: string | undefined;
    audioFileName?: string | undefined;
    audioFilePath?: string | undefined;
    status?: number;
    callFlowId?: number;
    callFlowName?: string | undefined;
    duration?: number;
    durationDisplay?: string | undefined;
    server?: string | undefined;
    transcription?: string | undefined;
    companyId?: number;
}

export class ExportVoicemailCommand implements IExportVoicemailCommand {
    page?: Page | undefined;
    searchText?: string | undefined;
    filterData?: FilterData[] | undefined;

    constructor(data?: IExportVoicemailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] ? Page.fromJS(_data["page"]) : <any>undefined;
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["filterData"])) {
                this.filterData = [] as any;
                for (let item of _data["filterData"])
                    this.filterData!.push(FilterData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportVoicemailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportVoicemailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["searchText"] = this.searchText;
        if (Array.isArray(this.filterData)) {
            data["filterData"] = [];
            for (let item of this.filterData)
                data["filterData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExportVoicemailCommand {
    page?: Page | undefined;
    searchText?: string | undefined;
    filterData?: FilterData[] | undefined;
}

export class UpdateVoicemailStatusCommand implements IUpdateVoicemailStatusCommand {
    id?: number;

    constructor(data?: IUpdateVoicemailStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateVoicemailStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVoicemailStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateVoicemailStatusCommand {
    id?: number;
}

export class UpdateVoicemailTranscriptionCommand implements IUpdateVoicemailTranscriptionCommand {
    id?: number;
    transcription?: string | undefined;

    constructor(data?: IUpdateVoicemailTranscriptionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transcription = _data["transcription"];
        }
    }

    static fromJS(data: any): UpdateVoicemailTranscriptionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVoicemailTranscriptionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transcription"] = this.transcription;
        return data;
    }
}

export interface IUpdateVoicemailTranscriptionCommand {
    id?: number;
    transcription?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}